export const dataCar = [
  {
    id: 'AC',
    name: 'AC',
    'cyrillic-name': 'АС',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '378_GT',
        name: '378 GT Zagato',
        'cyrillic-name': '378 ДжиТи Загато',
        class: 'S',
        'year-from': 2012,
        'year-to': 2012,
      },
      {
        id: 'ACE',
        name: 'Ace',
        'cyrillic-name': 'асе',
        class: 'S',
        'year-from': 1992,
        'year-to': 2000,
      },
      {
        id: 'ACECA',
        name: 'Aceca',
        'cyrillic-name': 'Асека',
        class: 'S',
        'year-from': 1998,
        'year-to': 2000,
      },
      {
        id: 'COBRA',
        name: 'Cobra',
        'cyrillic-name': 'Кобра',
        class: 'S',
        'year-from': 1965,
        'year-to': 2015,
      },
    ],
  },
  {
    id: 'ACURA',
    name: 'Acura',
    'cyrillic-name': 'Акура',
    popular: false,
    country: 'Япония',
    models: [
      {
        id: 'CL',
        name: 'CL',
        'cyrillic-name': 'сл',
        class: 'D',
        'year-from': 1996,
        'year-to': 2003,
      },
      {
        id: 'CSX',
        name: 'CSX',
        'cyrillic-name': 'цсх',
        class: 'C',
        'year-from': 2005,
        'year-to': 2011,
      },
      {
        id: 'EL',
        name: 'EL',
        'cyrillic-name': 'ЕЛ',
        class: 'C',
        'year-from': 1997,
        'year-to': 2005,
      },
      {
        id: 'ILX',
        name: 'ILX',
        'cyrillic-name': 'ИЛХ',
        class: 'D',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'INTEGRA',
        name: 'Integra',
        'cyrillic-name': 'интегра',
        class: 'C',
        'year-from': 1985,
        'year-to': null,
      },
      {
        id: 'LEGEND',
        name: 'Legend',
        'cyrillic-name': 'легенд',
        class: 'D',
        'year-from': 1986,
        'year-to': 1996,
      },
      {
        id: 'MDX',
        name: 'MDX',
        'cyrillic-name': 'мдх',
        class: 'E',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'NSX',
        name: 'NSX',
        'cyrillic-name': 'нсх',
        class: 'S',
        'year-from': 1990,
        'year-to': null,
      },
      {
        id: 'RDX',
        name: 'RDX',
        'cyrillic-name': 'РДХ',
        class: 'D',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'RL',
        name: 'RL',
        'cyrillic-name': 'рл',
        class: 'F',
        'year-from': 1995,
        'year-to': 2012,
      },
      {
        id: 'RLX',
        name: 'RLX',
        'cyrillic-name': 'рлх',
        class: 'E',
        'year-from': 2013,
        'year-to': 2020,
      },
      {
        id: 'RSX',
        name: 'RSX',
        'cyrillic-name': 'рсх',
        class: 'C',
        'year-from': 2001,
        'year-to': 2006,
      },
      {
        id: 'SLX',
        name: 'SLX',
        'cyrillic-name': 'слх',
        class: 'J',
        'year-from': 1995,
        'year-to': 1999,
      },
      {
        id: 'TL',
        name: 'TL',
        'cyrillic-name': 'тл',
        class: 'E',
        'year-from': 1995,
        'year-to': 2014,
      },
      {
        id: 'TLX',
        name: 'TLX',
        'cyrillic-name': 'тлх',
        class: 'E',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'TSX',
        name: 'TSX',
        'cyrillic-name': 'тсх',
        class: 'D',
        'year-from': 2003,
        'year-to': 2014,
      },
      {
        id: 'ZDX',
        name: 'ZDX',
        'cyrillic-name': 'здх',
        class: 'E',
        'year-from': 2009,
        'year-to': 2013,
      },
    ],
  },
  {
    id: 'ADLER',
    name: 'Adler',
    'cyrillic-name': 'Адлер',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'DIPLOMAT',
        name: 'Diplomat',
        'cyrillic-name': 'Дипломат',
        class: 'F',
        'year-from': 1934,
        'year-to': 1940,
      },
      {
        id: 'TRUMPF_JUNIOR',
        name: 'Trumpf Junior',
        'cyrillic-name': 'Трумф Джуниор',
        class: '',
        'year-from': 1934,
        'year-to': 1941,
      },
    ],
  },
  {
    id: 'AION',
    name: 'GAC Aion',
    'cyrillic-name': 'ГАК Аион',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'S',
        name: 'S',
        'cyrillic-name': 'С',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'S_PLUS',
        name: 'S Plus',
        'cyrillic-name': 'С Плюс',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'V',
        name: 'V',
        'cyrillic-name': 'Ви',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'Y',
        name: 'Y',
        'cyrillic-name': 'игрек',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'AITO',
    name: 'Aito',
    'cyrillic-name': 'Аито',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'M5',
        name: 'M5',
        'cyrillic-name': 'м5',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'M7',
        name: 'M7',
        'cyrillic-name': 'м7',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ALFA_ROMEO',
    name: 'Alfa Romeo',
    'cyrillic-name': 'Альфа Ромео',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: '105_115',
        name: '105/115',
        'cyrillic-name': '105/115',
        class: 'S',
        'year-from': 1965,
        'year-to': 1977,
      },
      {
        id: '145',
        name: '145',
        'cyrillic-name': '145',
        class: 'C',
        'year-from': 1994,
        'year-to': 2001,
      },
      {
        id: '146',
        name: '146',
        'cyrillic-name': '146',
        class: 'C',
        'year-from': 1994,
        'year-to': 2001,
      },
      {
        id: '147',
        name: '147',
        'cyrillic-name': '147',
        class: 'C',
        'year-from': 2000,
        'year-to': 2010,
      },
      {
        id: '155',
        name: '155',
        'cyrillic-name': '155',
        class: 'D',
        'year-from': 1992,
        'year-to': 1997,
      },
      {
        id: '156',
        name: '156',
        'cyrillic-name': '156',
        class: 'D',
        'year-from': 1997,
        'year-to': 2007,
      },
      {
        id: '159',
        name: '159',
        'cyrillic-name': '159',
        class: 'D',
        'year-from': 2005,
        'year-to': 2011,
      },
      {
        id: '164',
        name: '164',
        'cyrillic-name': '164',
        class: 'E',
        'year-from': 1987,
        'year-to': 1998,
      },
      {
        id: '166',
        name: '166',
        'cyrillic-name': '166',
        class: 'E',
        'year-from': 1998,
        'year-to': 2007,
      },
      {
        id: '1900',
        name: '1900',
        'cyrillic-name': '1900',
        class: 'C',
        'year-from': 1950,
        'year-to': 1959,
      },
      {
        id: '2600',
        name: '2600',
        'cyrillic-name': '2600',
        class: 'D',
        'year-from': 1961,
        'year-to': 1968,
      },
      {
        id: '33',
        name: '33',
        'cyrillic-name': '33',
        class: 'C',
        'year-from': 1983,
        'year-to': 1994,
      },
      {
        id: '4C',
        name: '4C',
        'cyrillic-name': '4с',
        class: 'S',
        'year-from': 2013,
        'year-to': 2016,
      },
      {
        id: '6',
        name: '6',
        'cyrillic-name': '6',
        class: 'E',
        'year-from': 1979,
        'year-to': 1988,
      },
      {
        id: '6C',
        name: '6C',
        'cyrillic-name': '6с',
        class: 'S',
        'year-from': 1927,
        'year-to': 1933,
      },
      {
        id: '75',
        name: '75',
        'cyrillic-name': '75',
        class: 'D',
        'year-from': 1985,
        'year-to': 1992,
      },
      {
        id: '8C_COMPETIZIONE',
        name: '8C Competizione',
        'cyrillic-name': '8с компетизион',
        class: 'C',
        'year-from': 2007,
        'year-to': 2010,
      },
      {
        id: '90',
        name: '90',
        'cyrillic-name': '90',
        class: 'E',
        'year-from': 1984,
        'year-to': 1987,
      },
      {
        id: 'ALFASUD',
        name: 'Alfasud',
        'cyrillic-name': 'Альфасуд',
        class: 'C',
        'year-from': 1971,
        'year-to': 1983,
      },
      {
        id: 'ALFETTA',
        name: 'Alfetta',
        'cyrillic-name': 'Альфетта',
        class: 'D',
        'year-from': 1972,
        'year-to': 1987,
      },
      {
        id: 'ARNA',
        name: 'Arna',
        'cyrillic-name': 'Арна',
        class: 'C',
        'year-from': 1983,
        'year-to': 1987,
      },
      {
        id: 'BRERA',
        name: 'Brera',
        'cyrillic-name': 'Брера',
        class: 'C',
        'year-from': 2006,
        'year-to': 2010,
      },
      {
        id: 'DISCO_VOLANTE',
        name: 'Disco Volante',
        'cyrillic-name': 'диско воланте',
        class: 'S',
        'year-from': 2013,
        'year-to': 2013,
      },
      {
        id: 'GIULIA',
        name: 'Giulia',
        'cyrillic-name': 'Джулия',
        class: 'D',
        'year-from': 1962,
        'year-to': null,
      },
      {
        id: 'GIULIETTA',
        name: 'Giulietta',
        'cyrillic-name': 'Джульетта',
        class: 'C',
        'year-from': 1954,
        'year-to': 2020,
      },
      {
        id: 'GT',
        name: 'GT',
        'cyrillic-name': 'гт',
        class: 'D',
        'year-from': 2003,
        'year-to': 2010,
      },
      {
        id: 'GTA',
        name: 'GTA Coupe',
        'cyrillic-name': 'гта купе',
        class: 'S',
        'year-from': 1965,
        'year-to': 1975,
      },
      {
        id: 'GTV',
        name: 'GTV',
        'cyrillic-name': 'гтв',
        class: 'C',
        'year-from': 1995,
        'year-to': 2006,
      },
      {
        id: 'MITO',
        name: 'MiTo',
        'cyrillic-name': 'Мито',
        class: 'B',
        'year-from': 2008,
        'year-to': 2018,
      },
      {
        id: 'MONTREAL',
        name: 'Montreal',
        'cyrillic-name': 'Монреаль',
        class: 'S',
        'year-from': 1970,
        'year-to': 1979,
      },
      {
        id: 'RZ',
        name: 'RZ',
        'cyrillic-name': 'рз',
        class: 'S',
        'year-from': 1992,
        'year-to': 1994,
      },
      {
        id: 'SPIDER',
        name: 'Spider',
        'cyrillic-name': 'Спайдер',
        class: 'C',
        'year-from': 1966,
        'year-to': 2010,
      },
      {
        id: 'SPRINT',
        name: 'Sprint',
        'cyrillic-name': 'Спринт',
        class: 'C',
        'year-from': 1983,
        'year-to': 1989,
      },
      {
        id: 'STELVIO',
        name: 'Stelvio',
        'cyrillic-name': 'Стелвио',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'SZ',
        name: 'SZ',
        'cyrillic-name': 'сз',
        class: 'S',
        'year-from': 1988,
        'year-to': 1994,
      },
      {
        id: 'TONALE',
        name: 'Tonale',
        'cyrillic-name': 'Тонале',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ALPINA',
    name: 'Alpina',
    'cyrillic-name': 'Альпина',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'B10',
        name: 'B10',
        'cyrillic-name': 'б10',
        class: 'E',
        'year-from': 1984,
        'year-to': 2004,
      },
      {
        id: 'B11',
        name: 'B11',
        'cyrillic-name': 'б11',
        class: 'F',
        'year-from': 1987,
        'year-to': 1994,
      },
      {
        id: 'B12',
        name: 'B12',
        'cyrillic-name': 'б12',
        class: 'F',
        'year-from': 1988,
        'year-to': 2001,
      },
      {
        id: 'B3',
        name: 'B3',
        'cyrillic-name': 'б3',
        class: 'D',
        'year-from': 1987,
        'year-to': null,
      },
      {
        id: 'B4',
        name: 'B4',
        'cyrillic-name': 'б4',
        class: 'D',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'B5',
        name: 'B5',
        'cyrillic-name': 'б5',
        class: 'E',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'B6',
        name: 'B6',
        'cyrillic-name': 'б6',
        class: 'E',
        'year-from': 1978,
        'year-to': 2017,
      },
      {
        id: 'B7',
        name: 'B7',
        'cyrillic-name': 'б7',
        class: 'F',
        'year-from': 1978,
        'year-to': null,
      },
      {
        id: 'B8',
        name: 'B8',
        'cyrillic-name': 'б8',
        class: 'S',
        'year-from': 1979,
        'year-to': null,
      },
      {
        id: 'B9',
        name: 'B9',
        'cyrillic-name': 'б9',
        class: 'E',
        'year-from': 1981,
        'year-to': 1985,
      },
      {
        id: 'C1',
        name: 'C1',
        'cyrillic-name': 'с1',
        class: 'D',
        'year-from': 1980,
        'year-to': 1987,
      },
      {
        id: 'C2',
        name: 'C2',
        'cyrillic-name': 'с2',
        class: 'D',
        'year-from': 1985,
        'year-to': 1987,
      },
      {
        id: 'D10',
        name: 'D10',
        'cyrillic-name': 'д10',
        class: 'E',
        'year-from': 1999,
        'year-to': 2003,
      },
      {
        id: 'D3',
        name: 'D3',
        'cyrillic-name': 'д3',
        class: 'D',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'D4',
        name: 'D4',
        'cyrillic-name': 'Д4',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'D5',
        name: 'D5',
        'cyrillic-name': 'д5',
        class: 'E',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'ROADSTER',
        name: 'Roadster',
        'cyrillic-name': 'родстер',
        class: 'S',
        'year-from': 1990,
        'year-to': 2005,
      },
      {
        id: 'XB7',
        name: 'XB7',
        'cyrillic-name': 'ИксБ7',
        class: 'F',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'XD3',
        name: 'XD3',
        'cyrillic-name': 'хд3',
        class: 'D',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'XD4',
        name: 'XD4',
        'cyrillic-name': 'хд4',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ALPINE',
    name: 'Alpine',
    'cyrillic-name': 'Альпин',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'A110',
        name: 'A110',
        'cyrillic-name': 'а110',
        class: 'S',
        'year-from': 1961,
        'year-to': null,
      },
      {
        id: 'A310',
        name: 'A310',
        'cyrillic-name': 'а310',
        class: 'S',
        'year-from': 1971,
        'year-to': 1985,
      },
      {
        id: 'A610',
        name: 'A610',
        'cyrillic-name': 'а610',
        class: 'S',
        'year-from': 1991,
        'year-to': 1995,
      },
      {
        id: 'GTA',
        name: 'GTA',
        'cyrillic-name': 'гта',
        class: 'S',
        'year-from': 1985,
        'year-to': 1990,
      },
    ],
  },
  {
    id: 'AMC',
    name: 'AMC',
    'cyrillic-name': 'АМС',
    popular: false,
    country: 'Северная Америка',
    models: [
      {
        id: 'EAGLE',
        name: 'Eagle',
        'cyrillic-name': 'Игл',
        class: 'D',
        'year-from': 1979,
        'year-to': 1987,
      },
      {
        id: 'HORNET',
        name: 'Hornet',
        'cyrillic-name': 'Хорнет',
        class: 'C',
        'year-from': 1974,
        'year-to': 1975,
      },
      {
        id: 'MATADOR',
        name: 'Matador',
        'cyrillic-name': 'Матадор',
        class: 'S',
        'year-from': 1974,
        'year-to': 1978,
      },
      {
        id: 'RAMBLER_AMBASSADOR',
        name: 'Rambler Ambassador',
        'cyrillic-name': 'Рамблер Амбассадор',
        class: 'E',
        'year-from': 1965,
        'year-to': 1972,
      },
      {
        id: 'RAMBLER_CLASSIC',
        name: 'Rambler Classic',
        'cyrillic-name': 'Рамблер Классик',
        class: 'E',
        'year-from': 1961,
        'year-to': 1966,
      },
    ],
  },
  {
    id: 'AM_GENERAL',
    name: 'AM General',
    'cyrillic-name': 'АМ Дженерал',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'HUMVEE',
        name: 'HMMWV (Humvee)',
        'cyrillic-name': 'Хамви',
        class: 'J',
        'year-from': 1984,
        'year-to': 2006,
      },
    ],
  },
  {
    id: 'APAL',
    name: 'Apal',
    'cyrillic-name': 'Апал',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: '21541',
        name: '21541 Stalker',
        'cyrillic-name': '21541 Сталкер',
        class: 'J',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ARCFOX',
    name: 'Arcfox',
    'cyrillic-name': 'Аркфокс',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'ALPHA_S',
        name: 'Alpha S',
        'cyrillic-name': 'Альфа С',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'ALPHA_T',
        name: 'Alpha T',
        'cyrillic-name': 'Альфа Т',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ARIEL',
    name: 'Ariel',
    'cyrillic-name': 'Ариэль',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'ATOM',
        name: 'Atom',
        'cyrillic-name': 'Атом',
        class: 'S',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'NOMAD',
        name: 'Nomad',
        'cyrillic-name': 'Номад',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ARO',
    name: 'Aro',
    'cyrillic-name': 'Аро',
    popular: false,
    country: 'Румыния',
    models: [
      {
        id: '10',
        name: '10',
        'cyrillic-name': '10',
        class: 'J',
        'year-from': 1984,
        'year-to': 2006,
      },
      {
        id: '24',
        name: '24',
        'cyrillic-name': '24',
        class: 'J',
        'year-from': 1972,
        'year-to': 2006,
      },
    ],
  },
  {
    id: 'ASIA',
    name: 'Asia',
    'cyrillic-name': 'Эйша',
    popular: false,
    country: 'Южная Корея',
    models: [
      {
        id: 'RETONA',
        name: 'Retona',
        'cyrillic-name': 'Ретона',
        class: 'J',
        'year-from': 1997,
        'year-to': 2003,
      },
      {
        id: 'ROCSTA',
        name: 'Rocsta',
        'cyrillic-name': 'Рокста',
        class: 'J',
        'year-from': 1989,
        'year-to': 1998,
      },
      {
        id: 'TOPIC',
        name: 'Topic',
        'cyrillic-name': 'Топик',
        class: 'M',
        'year-from': 1987,
        'year-to': 1999,
      },
      {
        id: 'TOWNER',
        name: 'Towner',
        'cyrillic-name': 'таунер',
        class: 'M',
        'year-from': 1992,
        'year-to': 1999,
      },
    ],
  },
  {
    id: 'ASTON_MARTIN',
    name: 'Aston Martin',
    'cyrillic-name': 'Астон Мартин',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'BULLDOG',
        name: 'Bulldog',
        'cyrillic-name': 'бульдог',
        class: 'S',
        'year-from': 1980,
        'year-to': 1982,
      },
      {
        id: 'CYGNET',
        name: 'Cygnet',
        'cyrillic-name': 'сигнет',
        class: 'A',
        'year-from': 2011,
        'year-to': 2013,
      },
      {
        id: 'DB_AR_1',
        name: 'DB AR1',
        'cyrillic-name': 'ДБ АР1',
        class: 'S',
        'year-from': 2003,
        'year-to': 2004,
      },
      {
        id: 'DB11',
        name: 'DB11',
        'cyrillic-name': 'дб11',
        class: 'S',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'DB5',
        name: 'DB5',
        'cyrillic-name': 'дб5',
        class: 'S',
        'year-from': 1963,
        'year-to': 1965,
      },
      {
        id: 'DB7',
        name: 'DB7',
        'cyrillic-name': 'дб7',
        class: 'S',
        'year-from': 1994,
        'year-to': 2003,
      },
      {
        id: 'DB9',
        name: 'DB9',
        'cyrillic-name': 'дб9',
        class: 'S',
        'year-from': 2003,
        'year-to': 2016,
      },
      {
        id: 'DBS',
        name: 'DBS',
        'cyrillic-name': 'дбс',
        class: 'S',
        'year-from': 1967,
        'year-to': null,
      },
      {
        id: 'DBX',
        name: 'DBX',
        'cyrillic-name': 'ДБХ',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'LAGONDA',
        name: 'Lagonda',
        'cyrillic-name': 'лагонда',
        class: 'F',
        'year-from': 1976,
        'year-to': 1997,
      },
      {
        id: 'ONE_77',
        name: 'One-77',
        'cyrillic-name': 'ван-77',
        class: 'S',
        'year-from': 2009,
        'year-to': 2012,
      },
      {
        id: 'RAPIDE',
        name: 'Rapide',
        'cyrillic-name': 'Рапиде',
        class: 'F',
        'year-from': 2010,
        'year-to': 2020,
      },
      {
        id: 'TICKFORD_CAPRI',
        name: 'Tickford Capri',
        'cyrillic-name': 'тикфорд капри',
        class: 'C',
        'year-from': 1982,
        'year-to': 1985,
      },
      {
        id: 'V12_VANTAGE',
        name: 'V12 Vantage',
        'cyrillic-name': 'в12 вантаж',
        class: 'S',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'V12_ZAGATO',
        name: 'V12 Zagato',
        'cyrillic-name': 'в12 загато',
        class: 'S',
        'year-from': 2011,
        'year-to': 2012,
      },
      {
        id: 'V8',
        name: 'V8 Vantage',
        'cyrillic-name': 'в8 вантаж',
        class: 'S',
        'year-from': 1969,
        'year-to': null,
      },
      {
        id: 'V8_ZAGATO',
        name: 'V8 Zagato',
        'cyrillic-name': 'в8 загато',
        class: 'S',
        'year-from': 1986,
        'year-to': 1989,
      },
      {
        id: 'V12',
        name: 'Vanquish',
        'cyrillic-name': 'ванквиш',
        class: 'S',
        'year-from': 2001,
        'year-to': 2018,
      },
      {
        id: 'VIRAGE',
        name: 'Virage',
        'cyrillic-name': 'Вираж',
        class: 'S',
        'year-from': 1988,
        'year-to': 2012,
      },
      {
        id: 'VULCAN',
        name: 'Vulcan',
        'cyrillic-name': 'Вулкан',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
    ],
  },
  {
    id: 'AUBURN',
    name: 'Auburn',
    'cyrillic-name': 'Оберн',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'SPEEDSTER',
        name: 'Speedster',
        'cyrillic-name': 'Спидстер',
        class: 'S',
        'year-from': 1935,
        'year-to': 1937,
      },
    ],
  },
  {
    id: 'AUDI',
    name: 'Audi',
    'cyrillic-name': 'Ауди',
    popular: true,
    country: 'Германия',
    models: [
      {
        id: '100',
        name: '100',
        'cyrillic-name': '100',
        class: 'E',
        'year-from': 1968,
        'year-to': 1994,
      },
      {
        id: '200',
        name: '200',
        'cyrillic-name': '200',
        class: 'E',
        'year-from': 1979,
        'year-to': 1991,
      },
      {
        id: '50',
        name: '50',
        'cyrillic-name': '50',
        class: 'B',
        'year-from': 1974,
        'year-to': 1978,
      },
      {
        id: '80',
        name: '80',
        'cyrillic-name': '80',
        class: 'D',
        'year-from': 1972,
        'year-to': 1996,
      },
      {
        id: '90',
        name: '90',
        'cyrillic-name': '90',
        class: 'D',
        'year-from': 1984,
        'year-to': 1995,
      },
      {
        id: '920',
        name: '920',
        'cyrillic-name': '920',
        class: '',
        'year-from': 1938,
        'year-to': 1940,
      },
      {
        id: 'A1',
        name: 'A1',
        'cyrillic-name': 'А1',
        class: 'B',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'A2',
        name: 'A2',
        'cyrillic-name': 'А2',
        class: 'B',
        'year-from': 2000,
        'year-to': 2007,
      },
      {
        id: 'A3',
        name: 'A3',
        'cyrillic-name': 'А3',
        class: 'C',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'A4',
        name: 'A4',
        'cyrillic-name': 'А4',
        class: 'D',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'A4_ALLROAD',
        name: 'A4 allroad',
        'cyrillic-name': 'А4 Олроуд',
        class: 'D',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'A5',
        name: 'A5',
        'cyrillic-name': 'А5',
        class: 'D',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'A6',
        name: 'A6',
        'cyrillic-name': 'А6',
        class: 'E',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'ALLROAD',
        name: 'A6 allroad',
        'cyrillic-name': 'А6 Олроуд',
        class: 'E',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'A7',
        name: 'A7',
        'cyrillic-name': 'А7',
        class: 'E',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'A8',
        name: 'A8',
        'cyrillic-name': 'А8',
        class: 'F',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'CABRIOLET',
        name: 'Cabriolet',
        'cyrillic-name': 'Кабриолет',
        class: 'D',
        'year-from': 1991,
        'year-to': 2000,
      },
      {
        id: 'COUPE',
        name: 'Coupe',
        'cyrillic-name': 'Купе',
        class: 'D',
        'year-from': 1980,
        'year-to': 1996,
      },
      {
        id: 'E_TRON',
        name: 'e-tron',
        'cyrillic-name': 'И-трон',
        class: 'E',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'E_TRON_GT',
        name: 'e-tron GT',
        'cyrillic-name': 'И-трон ГТ',
        class: 'F',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'E_TRON_S',
        name: 'e-tron S',
        'cyrillic-name': 'И-трон Эс',
        class: 'E',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'E_TRON_S_SPORTBACK',
        name: 'e-tron S Sportback',
        'cyrillic-name': 'И-трон Эс Спортбэк',
        class: 'E',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'E_TRON_SPORTBACK',
        name: 'e-tron Sportback',
        'cyrillic-name': 'И-трон Спортбэк',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'NSU_RO_80',
        name: 'NSU RO 80',
        'cyrillic-name': 'нсу ро 80',
        class: 'E',
        'year-from': 1967,
        'year-to': 1977,
      },
      {
        id: 'Q2',
        name: 'Q2',
        'cyrillic-name': 'Ку2',
        class: 'B',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'Q3',
        name: 'Q3',
        'cyrillic-name': 'Ку3',
        class: 'C',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'Q3_SPORTBACK',
        name: 'Q3 Sportback',
        'cyrillic-name': 'Ку3 Спортбек',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'Q4',
        name: 'Q4 e-tron',
        'cyrillic-name': 'Ку4',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'Q4_SPORTBACK',
        name: 'Q4 Sportback e-tron',
        'cyrillic-name': 'Ку4 Спортбек',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'Q5',
        name: 'Q5',
        'cyrillic-name': 'Ку5',
        class: 'D',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'Q5_E_TRON',
        name: 'Q5 e-tron',
        'cyrillic-name': 'Ку5 е-трон',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'Q5_SPORTBACK',
        name: 'Q5 Sportback',
        'cyrillic-name': 'Кью5 Спортбек',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'Q6',
        name: 'Q6',
        'cyrillic-name': 'Кью6',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'Q7',
        name: 'Q7',
        'cyrillic-name': 'Ку7',
        class: 'E',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'Q8',
        name: 'Q8',
        'cyrillic-name': 'Ку8',
        class: 'E',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'Q8_E_TRON',
        name: 'Q8 e-tron',
        'cyrillic-name': 'Ку8 е-трон',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'Q8_SPORTBACK_E_TRON',
        name: 'Q8 Sportback e-tron',
        'cyrillic-name': 'Ку8 Спортбек е-трон',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'QUATTRO',
        name: 'Quattro',
        'cyrillic-name': 'Кватро',
        class: 'S',
        'year-from': 1980,
        'year-to': 1991,
      },
      {
        id: 'R8',
        name: 'R8',
        'cyrillic-name': 'Р8',
        class: 'S',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'R8_LMP',
        name: 'R8 LMP',
        'cyrillic-name': 'ЭР8 ЛМП',
        class: 'S',
        'year-from': 2000,
        'year-to': 2005,
      },
      {
        id: 'RS2',
        name: 'RS 2',
        'cyrillic-name': 'рс 2',
        class: 'D',
        'year-from': 1993,
        'year-to': 1995,
      },
      {
        id: 'RS3',
        name: 'RS 3',
        'cyrillic-name': 'РС3',
        class: 'C',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'RS4',
        name: 'RS 4',
        'cyrillic-name': 'РС4',
        class: 'D',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'RS5',
        name: 'RS 5',
        'cyrillic-name': 'РС5',
        class: 'D',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'RS6',
        name: 'RS 6',
        'cyrillic-name': 'РС6',
        class: 'E',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'RS7',
        name: 'RS 7',
        'cyrillic-name': 'РС7',
        class: 'E',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'RS_E_TRON_GT',
        name: 'RS e-tron GT',
        'cyrillic-name': 'РС и-трон ГТ',
        class: 'F',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'RSQ3',
        name: 'RS Q3',
        'cyrillic-name': 'РС Ку3',
        class: 'C',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'RS_Q3_SPORTBACK',
        name: 'RS Q3 Sportback',
        'cyrillic-name': 'РС Ку3 Спортбек',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'RS_Q8',
        name: 'RS Q8',
        'cyrillic-name': 'РС Ку8',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'S1',
        name: 'S1',
        'cyrillic-name': 'с1',
        class: 'B',
        'year-from': 2014,
        'year-to': 2018,
      },
      {
        id: 'S2',
        name: 'S2',
        'cyrillic-name': 'с2',
        class: 'D',
        'year-from': 1990,
        'year-to': 1995,
      },
      {
        id: 'S3',
        name: 'S3',
        'cyrillic-name': 'с3',
        class: 'C',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'S4',
        name: 'S4',
        'cyrillic-name': 'с4',
        class: 'D',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'S5',
        name: 'S5',
        'cyrillic-name': 'с5',
        class: 'D',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'S6',
        name: 'S6',
        'cyrillic-name': 'с6',
        class: 'E',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'S7',
        name: 'S7',
        'cyrillic-name': 'с7',
        class: 'E',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'S8',
        name: 'S8',
        'cyrillic-name': 'с8',
        class: 'F',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'SQ2',
        name: 'SQ2',
        'cyrillic-name': 'ску2',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'SQ5',
        name: 'SQ5',
        'cyrillic-name': 'ску5',
        class: 'D',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'SQ5_SPORTBACK',
        name: 'SQ5 Sportback',
        'cyrillic-name': 'ЭсКью5 Спортбек',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'SQ7',
        name: 'SQ7',
        'cyrillic-name': 'ску7',
        class: 'E',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'SQ8',
        name: 'SQ8',
        'cyrillic-name': 'ску8',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'SQ8_E_TRON',
        name: 'SQ8 e-tron',
        'cyrillic-name': 'СКу8 е-трон',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'SQ8_SPORTBACK_E_TRON',
        name: 'SQ8 Sportback e-tron',
        'cyrillic-name': 'СКу8 Спортбек е-трон',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'TT',
        name: 'TT',
        'cyrillic-name': 'ТТ',
        class: 'S',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'TT_RS',
        name: 'TT RS',
        'cyrillic-name': 'ТТ РС',
        class: 'S',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'TTS',
        name: 'TTS',
        'cyrillic-name': 'ТТС',
        class: 'S',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'TYP_R',
        name: 'Typ R',
        'cyrillic-name': 'Тип-Р',
        class: '',
        'year-from': 1927,
        'year-to': 1929,
      },
      {
        id: 'V8',
        name: 'V8',
        'cyrillic-name': 'в8',
        class: 'F',
        'year-from': 1988,
        'year-to': 1994,
      },
    ],
  },
  {
    id: 'AURUS',
    name: 'Aurus',
    'cyrillic-name': 'Аурус',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'KOMENDANT',
        name: 'Komendant',
        'cyrillic-name': 'Комендант',
        class: 'F',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'SENAT',
        name: 'Senat',
        'cyrillic-name': 'Сенат',
        class: 'F',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'AUSTIN',
    name: 'Austin',
    'cyrillic-name': 'Остин',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'ALLEGRO',
        name: 'Allegro',
        'cyrillic-name': 'Аллегро',
        class: 'C',
        'year-from': 1973,
        'year-to': 1983,
      },
      {
        id: 'AMBASSADOR',
        name: 'Ambassador',
        'cyrillic-name': 'Амбассадор',
        class: 'D',
        'year-from': 1982,
        'year-to': 1984,
      },
      {
        id: 'FL2',
        name: 'FL2',
        'cyrillic-name': 'ФЛ2',
        class: 'D',
        'year-from': 1958,
        'year-to': 1978,
      },
      {
        id: 'FX',
        name: 'FX4',
        'cyrillic-name': 'ФХ',
        class: 'E',
        'year-from': 1958,
        'year-to': 1982,
      },
      {
        id: 'MAESTRO',
        name: 'Maestro',
        'cyrillic-name': 'Маэстро',
        class: 'C',
        'year-from': 1983,
        'year-to': 1997,
      },
      {
        id: 'MAXI',
        name: 'Maxi',
        'cyrillic-name': 'Макси',
        class: 'C',
        'year-from': 1969,
        'year-to': 1982,
      },
      {
        id: 'METRO',
        name: 'Metro',
        'cyrillic-name': 'метро',
        class: 'B',
        'year-from': 1980,
        'year-to': 1990,
      },
      {
        id: 'MINI',
        name: 'Mini',
        'cyrillic-name': 'Мини',
        class: 'B',
        'year-from': 1967,
        'year-to': 1993,
      },
      {
        id: 'MONTEGO',
        name: 'Montego',
        'cyrillic-name': 'Монтего',
        class: 'C',
        'year-from': 1984,
        'year-to': 1994,
      },
      {
        id: 'PRINCESS',
        name: 'Princess',
        'cyrillic-name': 'Принцес',
        class: 'D',
        'year-from': 1972,
        'year-to': 1982,
      },
      {
        id: 'SPRITE',
        name: 'Sprite',
        'cyrillic-name': 'Спрайт',
        class: 'S',
        'year-from': 1958,
        'year-to': 1971,
      },
    ],
  },
  {
    id: 'AUSTIN_HEALEY',
    name: 'Austin Healey',
    'cyrillic-name': 'Остин Хэйли',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '100',
        name: '100',
        'cyrillic-name': '100',
        class: 'S',
        'year-from': 1956,
        'year-to': 1959,
      },
      {
        id: '3000',
        name: '3000',
        'cyrillic-name': '3000',
        class: 'S',
        'year-from': 1959,
        'year-to': 1967,
      },
    ],
  },
  {
    id: 'AUTOBIANCHI',
    name: 'Autobianchi',
    'cyrillic-name': 'Аутобьянки',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'A_112',
        name: 'A 112',
        'cyrillic-name': 'а 112',
        class: 'A',
        'year-from': 1969,
        'year-to': 1986,
      },
    ],
  },
  {
    id: 'AUTO_UNION',
    name: 'Auto Union',
    'cyrillic-name': 'Авто Юнион',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: '1000_SP',
        name: '1000 Sp',
        'cyrillic-name': '1000 Сп',
        class: 'S',
        'year-from': 1958,
        'year-to': 1965,
      },
    ],
  },
  {
    id: 'AVATR',
    name: 'Avatr',
    'cyrillic-name': 'Аватр',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: '11',
        name: '11',
        'cyrillic-name': '11',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'AVTOKAM',
    name: 'Автокам',
    'cyrillic-name': 'Автокам',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: '2160',
        name: '2160',
        'cyrillic-name': '2160',
        class: 'J',
        'year-from': 1990,
        'year-to': 1999,
      },
      {
        id: '2163',
        name: '2163',
        'cyrillic-name': '2163',
        class: 'J',
        'year-from': 1990,
        'year-to': 1993,
      },
      {
        id: '3101',
        name: '3101',
        'cyrillic-name': '3101',
        class: 'J',
        'year-from': 1990,
        'year-to': 1993,
      },
    ],
  },
  {
    id: 'BAIC',
    name: 'BAIC',
    'cyrillic-name': 'БАИК',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'A1',
        name: 'A1',
        'cyrillic-name': 'А1',
        class: 'B',
        'year-from': 2012,
        'year-to': 2018,
      },
      {
        id: 'BJ_2020',
        name: 'BJ2020',
        'cyrillic-name': 'бж2020',
        class: 'J',
        'year-from': 1989,
        'year-to': 2005,
      },
      {
        id: 'BJ2021',
        name: 'BJ2021',
        'cyrillic-name': 'БЖ2021',
        class: 'J',
        'year-from': 1984,
        'year-to': 2005,
      },
      {
        id: 'BJ_2026',
        name: 'BJ2026',
        'cyrillic-name': 'бж2026',
        class: 'J',
        'year-from': 2011,
        'year-to': 2015,
      },
      {
        id: 'BJ_212',
        name: 'BJ212',
        'cyrillic-name': 'бж212',
        class: 'J',
        'year-from': 1964,
        'year-to': 1987,
      },
      {
        id: 'BJ40',
        name: 'BJ40',
        'cyrillic-name': 'бджей40',
        class: 'J',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'BJ60',
        name: 'BJ60',
        'cyrillic-name': 'БЖ60',
        class: 'J',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'BJ80',
        name: 'BJ80',
        'cyrillic-name': 'БЖ80',
        class: 'J',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'EU260',
        name: 'EU260',
        'cyrillic-name': 'эу260',
        class: 'C',
        'year-from': 2015,
        'year-to': 2017,
      },
      {
        id: 'EU5',
        name: 'EU5',
        'cyrillic-name': 'ЕУ5',
        class: 'C',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'EU7',
        name: 'EU7',
        'cyrillic-name': 'ЕУ7',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'EX3',
        name: 'EX3',
        'cyrillic-name': 'ЕИкс3',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'EX5',
        name: 'EX5',
        'cyrillic-name': 'Икс5',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'JEEP_CHEROKEE_2500',
        name: 'Jeep 2500',
        'cyrillic-name': 'джип чероки 2500',
        class: 'J',
        'year-from': 2003,
        'year-to': 2005,
      },
      {
        id: 'LUBA',
        name: 'Luba (XB624)',
        'cyrillic-name': 'луба (хб624)',
        class: 'J',
        'year-from': 2000,
        'year-to': 2017,
      },
      {
        id: 'U5',
        name: 'U5',
        'cyrillic-name': 'У5',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'U7',
        name: 'U7',
        'cyrillic-name': 'у7',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'X3',
        name: 'X3',
        'cyrillic-name': 'Икс3',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'X5',
        name: 'X5',
        'cyrillic-name': 'Икс5',
        class: 'C',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'X7',
        name: 'X7',
        'cyrillic-name': 'Икс7',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'BAJAJ',
    name: 'Bajaj',
    'cyrillic-name': 'Баджадж',
    popular: false,
    country: 'Индия',
    models: [
      {
        id: 'QUTE',
        name: 'Qute',
        'cyrillic-name': 'Кьют',
        class: 'A',
        'year-from': 2016,
        'year-to': null,
      },
    ],
  },
  {
    id: 'BALTIJAS_DZIPS',
    name: 'Baltijas Dzips',
    'cyrillic-name': 'Балтиас Джипс',
    popular: false,
    country: 'Латвия',
    models: [
      {
        id: 'BD_1322',
        name: 'BD-1322',
        'cyrillic-name': 'бд-1322',
        class: 'J',
        'year-from': 1998,
        'year-to': 2001,
      },
    ],
  },
  {
    id: 'BAOJUN',
    name: 'Baojun',
    'cyrillic-name': 'Баоджун',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'E300',
        name: 'E300',
        'cyrillic-name': 'Е300',
        class: 'A',
        'year-from': 2020,
        'year-to': 2021,
      },
      {
        id: 'KIWI_EV',
        name: 'Kiwi EV',
        'cyrillic-name': 'Киви ЕВ',
        class: 'A',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'BATMOBILE',
    name: 'Batmobile',
    'cyrillic-name': 'Бэтмобиль',
    popular: false,
    country: 'США',
    models: [
      {
        id: '1989',
        name: '1989',
        'cyrillic-name': '1989',
        class: '',
        'year-from': 1989,
        'year-to': 1992,
      },
      {
        id: '2018',
        name: '2018',
        'cyrillic-name': '2018',
        class: 'S',
        'year-from': 2018,
        'year-to': 2018,
      },
    ],
  },
  {
    id: 'BENTLEY',
    name: 'Bentley',
    'cyrillic-name': 'Бентли',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'ARNAGE',
        name: 'Arnage',
        'cyrillic-name': 'арнаж',
        class: 'F',
        'year-from': 1998,
        'year-to': 2009,
      },
      {
        id: 'AZURE',
        name: 'Azure',
        'cyrillic-name': 'азур',
        class: 'F',
        'year-from': 1995,
        'year-to': 2009,
      },
      {
        id: 'BENTAYGA',
        name: 'Bentayga',
        'cyrillic-name': 'бентайга',
        class: 'F',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'BROOKLANDS',
        name: 'Brooklands',
        'cyrillic-name': 'брукландс',
        class: 'F',
        'year-from': 1992,
        'year-to': 2011,
      },
      {
        id: 'CONTINENTAL',
        name: 'Continental',
        'cyrillic-name': 'Континенталь',
        class: 'F',
        'year-from': 1984,
        'year-to': 2003,
      },
      {
        id: 'CONTINENTAL_FLYING_SPUR',
        name: 'Continental Flying Spur',
        'cyrillic-name': 'континенталь флаинг спур',
        class: 'F',
        'year-from': 2005,
        'year-to': 2012,
      },
      {
        id: 'CONTINENTAL_GT',
        name: 'Continental GT',
        'cyrillic-name': 'континенталь гт',
        class: 'S',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'EIGHT',
        name: 'Eight',
        'cyrillic-name': 'Эйт',
        class: 'F',
        'year-from': 1984,
        'year-to': 1992,
      },
      {
        id: 'FLYING_SPUR',
        name: 'Flying Spur',
        'cyrillic-name': 'Флайн Спур',
        class: 'F',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'MARK_VI',
        name: 'Mark VI',
        'cyrillic-name': 'марк 6',
        class: '',
        'year-from': 1946,
        'year-to': 1952,
      },
      {
        id: 'MULSANNE',
        name: 'Mulsanne',
        'cyrillic-name': 'мульсан',
        class: 'F',
        'year-from': 1980,
        'year-to': 2020,
      },
      {
        id: 'R_TYPE',
        name: 'R Type',
        'cyrillic-name': 'р тайп',
        class: '',
        'year-from': 1952,
        'year-to': 1955,
      },
      {
        id: 'S',
        name: 'S',
        'cyrillic-name': 'с',
        class: 'F',
        'year-from': 1955,
        'year-to': 1965,
      },
      {
        id: 'T_SERIES',
        name: 'T-Series',
        'cyrillic-name': 'Т-Сериес',
        class: 'F',
        'year-from': 1965,
        'year-to': 1980,
      },
      {
        id: 'TURBO_R',
        name: 'Turbo R',
        'cyrillic-name': 'турбо р',
        class: 'F',
        'year-from': 1985,
        'year-to': 1999,
      },
    ],
  },
  {
    id: 'BERTONE',
    name: 'Bertone',
    'cyrillic-name': 'Бертоне',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'FREECLIMBER',
        name: 'Freeclimber',
        'cyrillic-name': 'Фриклаймбер',
        class: 'J',
        'year-from': 1989,
        'year-to': 1995,
      },
    ],
  },
  {
    id: 'BILENKIN',
    name: 'Bilenkin',
    'cyrillic-name': 'Биленкин',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'VINTAGE',
        name: 'Vintage',
        'cyrillic-name': 'винтаж',
        class: 'D',
        'year-from': 2015,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'BIO_AUTO',
    name: 'Bio auto',
    'cyrillic-name': 'Био авто',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'EVA_4',
        name: 'evA-4',
        'cyrillic-name': 'эвА-4',
        class: 'A',
        'year-from': 2009,
        'year-to': 2020,
      },
    ],
  },
  {
    id: 'BITTER',
    name: 'Bitter',
    'cyrillic-name': 'Биттер',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'CD',
        name: 'CD',
        'cyrillic-name': 'сд',
        class: 'S',
        'year-from': 1973,
        'year-to': 1979,
      },
      {
        id: 'TYPE_3',
        name: 'Type 3',
        'cyrillic-name': 'Тайп 3',
        class: 'S',
        'year-from': 1987,
        'year-to': 1988,
      },
    ],
  },
  {
    id: 'BLAVAL',
    name: 'Blaval',
    'cyrillic-name': 'блавал',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'FH_EQ',
        name: 'FH-EQ',
        'cyrillic-name': 'ФХ-ЕКУ',
        class: 'A',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'BMW',
    name: 'BMW',
    'cyrillic-name': 'БМВ',
    popular: true,
    country: 'Германия',
    models: [
      {
        id: '02',
        name: '02 (E10)',
        'cyrillic-name': '02',
        class: 'D',
        'year-from': 1966,
        'year-to': 1977,
      },
      {
        id: '1ER',
        name: '1 серии',
        'cyrillic-name': '1 серии',
        class: 'C',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: '1M',
        name: '1M',
        'cyrillic-name': '1М',
        class: 'C',
        'year-from': 2010,
        'year-to': 2012,
      },
      {
        id: '2ER',
        name: '2 серии',
        'cyrillic-name': '2 серии',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: '2ACTIVETOURER',
        name: '2 серии Active Tourer',
        'cyrillic-name': '2 серии Актив Турер',
        class: 'M',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: '2GRANDTOURER',
        name: '2 серии Gran Tourer',
        'cyrillic-name': '2 серии гран турер',
        class: 'M',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: '2000_C_CS',
        name: '2000 C/CS',
        'cyrillic-name': '2000 ц/цс',
        class: 'S',
        'year-from': 1965,
        'year-to': 1970,
      },
      {
        id: '3ER',
        name: '3 серии',
        'cyrillic-name': '3 серии',
        class: 'D',
        'year-from': 1975,
        'year-to': null,
      },
      {
        id: '3_15',
        name: '3/15',
        'cyrillic-name': '3/15',
        class: '',
        'year-from': 1927,
        'year-to': 1932,
      },
      {
        id: '315',
        name: '315',
        'cyrillic-name': '315',
        class: '',
        'year-from': 1934,
        'year-to': 1937,
      },
      {
        id: '3200',
        name: '3200',
        'cyrillic-name': '3200',
        class: 'S',
        'year-from': 1962,
        'year-to': 1965,
      },
      {
        id: '321',
        name: '321',
        'cyrillic-name': '321',
        class: '',
        'year-from': 1937,
        'year-to': 1950,
      },
      {
        id: '326',
        name: '326',
        'cyrillic-name': '326',
        class: '',
        'year-from': 1936,
        'year-to': 1946,
      },
      {
        id: '327',
        name: '327',
        'cyrillic-name': '327',
        class: 'S',
        'year-from': 1937,
        'year-to': 1941,
      },
      {
        id: '340',
        name: '340',
        'cyrillic-name': '340',
        class: '',
        'year-from': 1949,
        'year-to': 1953,
      },
      {
        id: '4',
        name: '4 серии',
        'cyrillic-name': '4 серии',
        class: 'D',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: '5ER',
        name: '5 серии',
        'cyrillic-name': '5 серии',
        class: 'E',
        'year-from': 1972,
        'year-to': null,
      },
      {
        id: '501',
        name: '501',
        'cyrillic-name': '501',
        class: '',
        'year-from': 1952,
        'year-to': 1958,
      },
      {
        id: '502',
        name: '502',
        'cyrillic-name': '502',
        class: '',
        'year-from': 1954,
        'year-to': 1961,
      },
      {
        id: '503',
        name: '503',
        'cyrillic-name': '503',
        class: 'S',
        'year-from': 1956,
        'year-to': 1959,
      },
      {
        id: '507',
        name: '507',
        'cyrillic-name': '507',
        class: 'S',
        'year-from': 1956,
        'year-to': 1959,
      },
      {
        id: '6ER',
        name: '6 серии',
        'cyrillic-name': '6 серии',
        class: 'E',
        'year-from': 1976,
        'year-to': null,
      },
      {
        id: '600',
        name: '600',
        'cyrillic-name': '600',
        class: 'A',
        'year-from': 1957,
        'year-to': 1959,
      },
      {
        id: '7ER',
        name: '7 серии',
        'cyrillic-name': '7 серии',
        class: 'F',
        'year-from': 1977,
        'year-to': null,
      },
      {
        id: '700',
        name: '700',
        'cyrillic-name': '700',
        class: 'A',
        'year-from': 1959,
        'year-to': 1965,
      },
      {
        id: '8ER',
        name: '8 серии',
        'cyrillic-name': '8 серии',
        class: 'S',
        'year-from': 1989,
        'year-to': null,
      },
      {
        id: 'E3',
        name: 'E3',
        'cyrillic-name': 'е3',
        class: 'E',
        'year-from': 1968,
        'year-to': 1977,
      },
      {
        id: 'E9',
        name: 'E9',
        'cyrillic-name': 'е9',
        class: 'S',
        'year-from': 1968,
        'year-to': 1975,
      },
      {
        id: 'I3',
        name: 'i3',
        'cyrillic-name': 'и3',
        class: 'D',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'I4',
        name: 'i4',
        'cyrillic-name': 'и4',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'I7',
        name: 'i7',
        'cyrillic-name': 'и7',
        class: 'F',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'I8',
        name: 'i8',
        'cyrillic-name': 'и8',
        class: 'S',
        'year-from': 2014,
        'year-to': 2020,
      },
      {
        id: 'IX',
        name: 'iX',
        'cyrillic-name': 'ИХ',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'IX1',
        name: 'iX1',
        'cyrillic-name': 'ИХ1',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'IX3',
        name: 'iX3',
        'cyrillic-name': 'ИХ3',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'M_1',
        name: 'M1',
        'cyrillic-name': 'м1',
        class: 'S',
        'year-from': 1978,
        'year-to': 1981,
      },
      {
        id: 'M2',
        name: 'M2',
        'cyrillic-name': 'М2',
        class: 'C',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'M3',
        name: 'M3',
        'cyrillic-name': 'М3',
        class: 'D',
        'year-from': 1986,
        'year-to': null,
      },
      {
        id: 'M4',
        name: 'M4',
        'cyrillic-name': 'М4',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'M5',
        name: 'M5',
        'cyrillic-name': 'М5',
        class: 'E',
        'year-from': 1985,
        'year-to': null,
      },
      {
        id: 'M6',
        name: 'M6',
        'cyrillic-name': 'М6',
        class: 'E',
        'year-from': 1984,
        'year-to': 2018,
      },
      {
        id: 'M8',
        name: 'M8',
        'cyrillic-name': 'М8',
        class: 'S',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'NEW_CLASS',
        name: 'New Class',
        'cyrillic-name': 'нью класс',
        class: 'C',
        'year-from': 1962,
        'year-to': 1972,
      },
      {
        id: 'X1',
        name: 'X1',
        'cyrillic-name': 'Х1',
        class: 'C',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'X2',
        name: 'X2',
        'cyrillic-name': 'Х2',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'X3',
        name: 'X3',
        'cyrillic-name': 'Х3',
        class: 'D',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'X3_M',
        name: 'X3 M',
        'cyrillic-name': 'Х3 М',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'X4',
        name: 'X4',
        'cyrillic-name': 'Х4',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'X4_M',
        name: 'X4 M',
        'cyrillic-name': 'Х4 М',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'X5',
        name: 'X5',
        'cyrillic-name': 'Х5',
        class: 'E',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'X5_M',
        name: 'X5 M',
        'cyrillic-name': 'Х5 М',
        class: 'E',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'X6',
        name: 'X6',
        'cyrillic-name': 'Х6',
        class: 'E',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'X6_M',
        name: 'X6 M',
        'cyrillic-name': 'Х6 М',
        class: 'E',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'X7',
        name: 'X7',
        'cyrillic-name': 'Х7',
        class: 'F',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'XM',
        name: 'XM',
        'cyrillic-name': 'ХМ',
        class: 'F',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'Z1',
        name: 'Z1',
        'cyrillic-name': 'з1',
        class: 'S',
        'year-from': 1988,
        'year-to': 1991,
      },
      {
        id: 'Z3',
        name: 'Z3',
        'cyrillic-name': 'з3',
        class: 'S',
        'year-from': 1995,
        'year-to': 2002,
      },
      {
        id: 'Z3M',
        name: 'Z3 M',
        'cyrillic-name': 'з3м',
        class: 'S',
        'year-from': 1997,
        'year-to': 2002,
      },
      {
        id: 'Z4',
        name: 'Z4',
        'cyrillic-name': 'З4',
        class: 'S',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'Z4_M',
        name: 'Z4 M',
        'cyrillic-name': 'з4м',
        class: 'C',
        'year-from': 2006,
        'year-to': 2009,
      },
      {
        id: 'Z8',
        name: 'Z8',
        'cyrillic-name': 'з8',
        class: 'S',
        'year-from': 2000,
        'year-to': 2003,
      },
    ],
  },
  {
    id: 'BORGWARD',
    name: 'Borgward',
    'cyrillic-name': 'Боргвард',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: '2000',
        name: '2000',
        'cyrillic-name': '2000',
        class: '',
        'year-from': 1939,
        'year-to': 1942,
      },
      {
        id: 'HANSA_1100',
        name: 'Hansa 1100',
        'cyrillic-name': 'ханса 1100',
        class: 'S',
        'year-from': 1934,
        'year-to': 1939,
      },
    ],
  },
  {
    id: 'BRABUS',
    name: 'Brabus',
    'cyrillic-name': 'Брабус',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: '73_S',
        name: '7.3S',
        'cyrillic-name': '7.3с',
        class: 'F',
        'year-from': 1991,
        'year-to': 1998,
      },
      {
        id: 'E_V12',
        name: 'E V12',
        'cyrillic-name': 'Е В12',
        class: 'E',
        'year-from': 1996,
        'year-to': 2013,
      },
      {
        id: 'M_V12',
        name: 'M V12',
        'cyrillic-name': 'м в12',
        class: 'E',
        'year-from': 1997,
        'year-to': 2001,
      },
      {
        id: 'ML_63_BITURBO',
        name: 'ML 63 Biturbo',
        'cyrillic-name': 'мл 63 битурбо',
        class: 'E',
        'year-from': 2009,
        'year-to': 2011,
      },
      {
        id: 'SV12',
        name: 'SV12',
        'cyrillic-name': 'св12',
        class: 'F',
        'year-from': 2009,
        'year-to': 2013,
      },
    ],
  },
  {
    id: 'BRILLIANCE',
    name: 'Brilliance',
    'cyrillic-name': 'Бриллианс',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'FRV_BS2',
        name: 'FRV (BS2)',
        'cyrillic-name': 'фрв (бс2)',
        class: 'C',
        'year-from': 2008,
        'year-to': 2013,
      },
      {
        id: 'H230',
        name: 'H230',
        'cyrillic-name': 'н230',
        class: 'B',
        'year-from': 2012,
        'year-to': 2017,
      },
      {
        id: 'H530',
        name: 'H530',
        'cyrillic-name': 'н530',
        class: 'D',
        'year-from': 2011,
        'year-to': 2020,
      },
      {
        id: 'M1',
        name: 'M1 (BS6)',
        'cyrillic-name': 'М1',
        class: 'E',
        'year-from': 2004,
        'year-to': 2012,
      },
      {
        id: 'M2_BS4',
        name: 'M2 (BS4)',
        'cyrillic-name': 'М2',
        class: 'D',
        'year-from': 2006,
        'year-to': 2012,
      },
      {
        id: 'M3_BC3',
        name: 'M3 (BC3)',
        'cyrillic-name': 'М3',
        class: 'C',
        'year-from': 2007,
        'year-to': 2011,
      },
      {
        id: 'V3',
        name: 'V3',
        'cyrillic-name': 'в3',
        class: 'B',
        'year-from': 2015,
        'year-to': 2020,
      },
      {
        id: 'V5',
        name: 'V5',
        'cyrillic-name': 'в5',
        class: 'C',
        'year-from': 2011,
        'year-to': 2020,
      },
    ],
  },
  {
    id: 'BRISTOL',
    name: 'Bristol',
    'cyrillic-name': 'Бристоль',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'BLENHEIM',
        name: 'Blenheim',
        'cyrillic-name': 'Бленхейм',
        class: 'S',
        'year-from': 1993,
        'year-to': 2011,
      },
      {
        id: 'BLENHEIM_SPEEDSTER',
        name: 'Blenheim Speedster',
        'cyrillic-name': 'Бленхейм Спидстер',
        class: 'S',
        'year-from': 2003,
        'year-to': 2011,
      },
      {
        id: 'FIGHTER',
        name: 'Fighter',
        'cyrillic-name': 'Файтер',
        class: 'S',
        'year-from': 2004,
        'year-to': 2011,
      },
    ],
  },
  {
    id: 'BUFORI',
    name: 'Bufori',
    'cyrillic-name': 'Буфори',
    popular: false,
    country: 'Малайзия',
    models: [
      {
        id: 'GENEVA',
        name: 'Geneva',
        'cyrillic-name': 'Женева',
        class: 'F',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'LA_JOYA',
        name: 'La Joya',
        'cyrillic-name': 'Ла Джойа',
        class: 'S',
        'year-from': 2004,
        'year-to': null,
      },
    ],
  },
  {
    id: 'BUGATTI',
    name: 'Bugatti',
    'cyrillic-name': 'Бугатти',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'CHIRON',
        name: 'Chiron',
        'cyrillic-name': 'Широн',
        class: 'S',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'EB_110',
        name: 'EB 110',
        'cyrillic-name': 'еб 110',
        class: 'S',
        'year-from': 1991,
        'year-to': 1995,
      },
      {
        id: 'EB_112',
        name: 'EB 112',
        'cyrillic-name': 'еб 112',
        class: 'F',
        'year-from': 1993,
        'year-to': 1998,
      },
      {
        id: 'EB_VEYRON',
        name: 'EB Veyron 16.4',
        'cyrillic-name': 'Вейрон',
        class: 'S',
        'year-from': 2003,
        'year-to': 2015,
      },
      {
        id: 'TYPE_55',
        name: 'Type 55',
        'cyrillic-name': 'тайп 55',
        class: 'S',
        'year-from': 1932,
        'year-to': 1935,
      },
    ],
  },
  {
    id: 'BUICK',
    name: 'Buick',
    'cyrillic-name': 'Бьюик',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'CASCADA',
        name: 'Cascada',
        'cyrillic-name': 'Каскада',
        class: 'C',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'CENTURY',
        name: 'Century',
        'cyrillic-name': 'сенчури',
        class: 'E',
        'year-from': 1973,
        'year-to': 2005,
      },
      {
        id: 'ELECTRA',
        name: 'Electra',
        'cyrillic-name': 'Электра',
        class: 'E',
        'year-from': 1959,
        'year-to': 1990,
      },
      {
        id: 'ENCLAVE',
        name: 'Enclave',
        'cyrillic-name': 'анклав',
        class: 'F',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'ENCORE',
        name: 'Encore',
        'cyrillic-name': 'Энкор',
        class: 'B',
        'year-from': 2012,
        'year-to': 2022,
      },
      {
        id: 'ENCORE_GX',
        name: 'Encore GX',
        'cyrillic-name': 'Энкор ДжиИкс',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'ENVISION',
        name: 'Envision',
        'cyrillic-name': 'энвижн',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'ESTATE_WAGON',
        name: 'Estate Wagon',
        'cyrillic-name': 'истейт вагон',
        class: 'E',
        'year-from': 1977,
        'year-to': 1990,
      },
      {
        id: 'EXCELLE',
        name: 'Excelle',
        'cyrillic-name': 'Эксель',
        class: 'C',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'GL8',
        name: 'GL8',
        'cyrillic-name': 'гл8',
        class: 'M',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'GS',
        name: 'GS',
        'cyrillic-name': 'ГС',
        class: 'S',
        'year-from': 1970,
        'year-to': 1972,
      },
      {
        id: 'LA_CROSSE',
        name: 'LaCrosse',
        'cyrillic-name': 'ЛаКросс',
        class: 'E',
        'year-from': 2004,
        'year-to': 2019,
      },
      {
        id: 'LE_SABRE',
        name: 'LeSabre',
        'cyrillic-name': 'лесабре',
        class: 'E',
        'year-from': 1959,
        'year-to': 2005,
      },
      {
        id: 'LIMITED',
        name: 'Limited',
        'cyrillic-name': 'лимитед',
        class: 'S',
        'year-from': 1958,
        'year-to': 1959,
      },
      {
        id: 'LUCERNE',
        name: 'Lucerne',
        'cyrillic-name': 'Люцерн',
        class: 'F',
        'year-from': 2005,
        'year-to': 2011,
      },
      {
        id: 'PARK_AVENUE',
        name: 'Park Avenue',
        'cyrillic-name': 'Парк Авеню',
        class: 'E',
        'year-from': 1991,
        'year-to': 2012,
      },
      {
        id: 'RAINER',
        name: 'Rainer',
        'cyrillic-name': 'Рейнер',
        class: 'J',
        'year-from': 2003,
        'year-to': 2007,
      },
      {
        id: 'REATTA',
        name: 'Reatta',
        'cyrillic-name': 'Риатта',
        class: 'S',
        'year-from': 1988,
        'year-to': 1991,
      },
      {
        id: 'REGAL',
        name: 'Regal',
        'cyrillic-name': 'Регал',
        class: 'D',
        'year-from': 1973,
        'year-to': 2020,
      },
      {
        id: 'RENDEZVOUS',
        name: 'Rendezvous',
        'cyrillic-name': 'Рандеву',
        class: 'E',
        'year-from': 2001,
        'year-to': 2007,
      },
      {
        id: 'RIVIERA',
        name: 'Riviera',
        'cyrillic-name': 'Ривьера',
        class: 'E',
        'year-from': 1966,
        'year-to': 1999,
      },
      {
        id: 'ROADMASTER',
        name: 'Roadmaster',
        'cyrillic-name': 'Роадмастер',
        class: 'E',
        'year-from': 1942,
        'year-to': 1996,
      },
      {
        id: 'SKYHAWK',
        name: 'Skyhawk',
        'cyrillic-name': 'скайхок',
        class: 'C',
        'year-from': 1974,
        'year-to': 1980,
      },
      {
        id: 'SKYLARK',
        name: 'Skylark',
        'cyrillic-name': 'Скайларк',
        class: 'D',
        'year-from': 1975,
        'year-to': 1998,
      },
      {
        id: 'SPECIAL',
        name: 'Special',
        'cyrillic-name': 'спешиал',
        class: '',
        'year-from': 1936,
        'year-to': 1958,
      },
      {
        id: 'SUPER',
        name: 'Super',
        'cyrillic-name': 'супер',
        class: '',
        'year-from': 1942,
        'year-to': 1953,
      },
      {
        id: 'TERRAZA',
        name: 'Terraza',
        'cyrillic-name': 'Терраза',
        class: 'M',
        'year-from': 2005,
        'year-to': 2007,
      },
      {
        id: 'VELITE_6',
        name: 'Velite 6',
        'cyrillic-name': 'Велит 6',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'VERANO',
        name: 'Verano',
        'cyrillic-name': 'Верано',
        class: 'C',
        'year-from': 2011,
        'year-to': 2020,
      },
      {
        id: 'WILDCAT',
        name: 'Wildcat',
        'cyrillic-name': 'вайлдкэт',
        class: 'F',
        'year-from': 1963,
        'year-to': 1970,
      },
    ],
  },
  {
    id: 'BYD',
    name: 'BYD',
    'cyrillic-name': 'БИД',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'DOLPHIN',
        name: 'Dolphin',
        'cyrillic-name': 'Дельфин',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'E1',
        name: 'E1',
        'cyrillic-name': 'е1',
        class: 'A',
        'year-from': 2019,
        'year-to': 2021,
      },
      {
        id: 'E2',
        name: 'e2',
        'cyrillic-name': 'Е2',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'E5',
        name: 'E5',
        'cyrillic-name': 'е5',
        class: 'C',
        'year-from': 2015,
        'year-to': 2020,
      },
      {
        id: 'E6',
        name: 'E6',
        'cyrillic-name': 'е6',
        class: 'C',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'F0',
        name: 'F0',
        'cyrillic-name': 'ф0',
        class: 'A',
        'year-from': 2008,
        'year-to': 2015,
      },
      {
        id: 'F3',
        name: 'F3',
        'cyrillic-name': 'ф3',
        class: 'C',
        'year-from': 2005,
        'year-to': 2018,
      },
      {
        id: 'F5',
        name: 'F5',
        'cyrillic-name': 'ф5',
        class: 'D',
        'year-from': 2014,
        'year-to': 2018,
      },
      {
        id: 'F6',
        name: 'F6',
        'cyrillic-name': 'ф6',
        class: 'D',
        'year-from': 2007,
        'year-to': 2012,
      },
      {
        id: 'F8',
        name: 'F8 (S8)',
        'cyrillic-name': 'Ф8',
        class: 'C',
        'year-from': 2009,
        'year-to': 2010,
      },
      {
        id: 'FLYER',
        name: 'Flyer',
        'cyrillic-name': 'Флаер',
        class: 'A',
        'year-from': 2005,
        'year-to': 2008,
      },
      {
        id: 'G3',
        name: 'G3',
        'cyrillic-name': 'Г3',
        class: 'C',
        'year-from': 2009,
        'year-to': 2014,
      },
      {
        id: 'G6',
        name: 'G6',
        'cyrillic-name': 'г6',
        class: 'D',
        'year-from': 2011,
        'year-to': 2013,
      },
      {
        id: 'HAN',
        name: 'Han',
        'cyrillic-name': 'Хан',
        class: 'E',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'L3',
        name: 'L3',
        'cyrillic-name': 'л3',
        class: 'C',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'M6',
        name: 'M6',
        'cyrillic-name': 'М6',
        class: 'M',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'QIN',
        name: 'Qin',
        'cyrillic-name': 'Чин',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'S6',
        name: 'S6',
        'cyrillic-name': 'С6',
        class: 'D',
        'year-from': 2011,
        'year-to': 2015,
      },
      {
        id: 'SEAL',
        name: 'Seal',
        'cyrillic-name': 'Сил',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'SONG_EV',
        name: 'Song EV',
        'cyrillic-name': 'Сонг ЕВ',
        class: 'C',
        'year-from': 2016,
        'year-to': 2019,
      },
      {
        id: 'SONG_MAX',
        name: 'Song Max',
        'cyrillic-name': 'сонг макс',
        class: 'M',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'SONG_PLUS',
        name: 'Song Plus',
        'cyrillic-name': 'Сонг Плюс',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'SONG_PRO',
        name: 'Song Pro',
        'cyrillic-name': 'Сонг Про',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'TANG',
        name: 'Tang',
        'cyrillic-name': 'Тэнг',
        class: 'D',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'YUAN',
        name: 'Yuan',
        'cyrillic-name': 'Юан',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
    ],
  },
  {
    id: 'BYVIN',
    name: 'Byvin',
    'cyrillic-name': 'Бивин',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'BD_132J',
        name: 'BD132J (CoCo)',
        'cyrillic-name': 'бд132ж (сосо)',
        class: 'A',
        'year-from': 2011,
        'year-to': 2016,
      },
      {
        id: 'BD_326J',
        name: 'BD326J (Moca)',
        'cyrillic-name': 'бд326ж (мока)',
        class: 'A',
        'year-from': 2011,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'CADILLAC',
    name: 'Cadillac',
    'cyrillic-name': 'Кадиллак',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'ALLANTE',
        name: 'Allante',
        'cyrillic-name': 'Аланте',
        class: 'E',
        'year-from': 1989,
        'year-to': 1996,
      },
      {
        id: 'ATS',
        name: 'ATS',
        'cyrillic-name': 'АТС',
        class: 'D',
        'year-from': 2012,
        'year-to': 2019,
      },
      {
        id: 'ATS_V',
        name: 'ATS-V',
        'cyrillic-name': 'атс-в',
        class: 'D',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'BLS',
        name: 'BLS',
        'cyrillic-name': 'блс',
        class: 'D',
        'year-from': 2006,
        'year-to': 2009,
      },
      {
        id: 'BROUGHAM',
        name: 'Brougham',
        'cyrillic-name': 'Броугхэм',
        class: 'F',
        'year-from': 1987,
        'year-to': 1992,
      },
      {
        id: 'CATERA',
        name: 'Catera',
        'cyrillic-name': 'Катера',
        class: 'E',
        'year-from': 1996,
        'year-to': 2001,
      },
      {
        id: 'CT4',
        name: 'CT4',
        'cyrillic-name': 'СТ4',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'CT4_V',
        name: 'CT4-V',
        'cyrillic-name': 'СТ4-В',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'CT5',
        name: 'CT5',
        'cyrillic-name': 'СТ5',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'CT5_V',
        name: 'CT5-V',
        'cyrillic-name': 'СТ5-В',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'CT6',
        name: 'CT6',
        'cyrillic-name': 'СТ6',
        class: 'F',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'CTS',
        name: 'CTS',
        'cyrillic-name': 'цтс',
        class: 'E',
        'year-from': 2002,
        'year-to': 2019,
      },
      {
        id: 'CTS_V',
        name: 'CTS-V',
        'cyrillic-name': 'Си-Ти-Эс-Вэ',
        class: 'E',
        'year-from': 2004,
        'year-to': 2019,
      },
      {
        id: 'DE_VILLE',
        name: 'DeVille',
        'cyrillic-name': 'Девиль',
        class: 'F',
        'year-from': 1958,
        'year-to': 2005,
      },
      {
        id: 'DTS',
        name: 'DTS',
        'cyrillic-name': 'дтс',
        class: 'F',
        'year-from': 2005,
        'year-to': 2011,
      },
      {
        id: 'ELDORADO',
        name: 'Eldorado',
        'cyrillic-name': 'Эльдорадо',
        class: 'F',
        'year-from': 1953,
        'year-to': 2002,
      },
      {
        id: 'ELR',
        name: 'ELR',
        'cyrillic-name': 'елр',
        class: 'D',
        'year-from': 2013,
        'year-to': 2016,
      },
      {
        id: 'ESCALADE',
        name: 'Escalade',
        'cyrillic-name': 'Эскалейд',
        class: 'J',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'ESCALADE_V',
        name: 'Escalade-V',
        'cyrillic-name': 'Эскалейд-В',
        class: 'J',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'FLEETWOOD',
        name: 'Fleetwood',
        'cyrillic-name': 'флитвуд',
        class: 'F',
        'year-from': 1956,
        'year-to': 1996,
      },
      {
        id: 'LSE',
        name: 'LSE',
        'cyrillic-name': 'лсе',
        class: 'E',
        'year-from': 1993,
        'year-to': 1996,
      },
      {
        id: 'LYRIQ',
        name: 'Lyriq',
        'cyrillic-name': 'Лирик',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'SERIES_62',
        name: 'Series 62',
        'cyrillic-name': 'серия 62',
        class: 'S',
        'year-from': 1940,
        'year-to': 1956,
      },
      {
        id: 'SEVILLE',
        name: 'Seville',
        'cyrillic-name': 'Севиль',
        class: 'F',
        'year-from': 1975,
        'year-to': 2004,
      },
      {
        id: 'SIXTY_SPECIAL',
        name: 'Sixty Special',
        'cyrillic-name': 'Сиксти Спешл',
        class: 'E',
        'year-from': 1971,
        'year-to': 1976,
      },
      {
        id: 'SRX',
        name: 'SRX',
        'cyrillic-name': 'срх',
        class: 'D',
        'year-from': 2003,
        'year-to': 2016,
      },
      {
        id: 'STS',
        name: 'STS',
        'cyrillic-name': 'стс',
        class: 'F',
        'year-from': 2004,
        'year-to': 2011,
      },
      {
        id: 'XLR',
        name: 'XLR',
        'cyrillic-name': 'хлр',
        class: 'D',
        'year-from': 2003,
        'year-to': 2009,
      },
      {
        id: 'XT4',
        name: 'XT4',
        'cyrillic-name': 'ХТ4',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'XT5',
        name: 'XT5',
        'cyrillic-name': 'ХТ5',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'XT6',
        name: 'XT6',
        'cyrillic-name': 'ХТ6',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'XTS',
        name: 'XTS',
        'cyrillic-name': 'хтс',
        class: 'F',
        'year-from': 2012,
        'year-to': 2019,
      },
    ],
  },
  {
    id: 'CALLAWAY',
    name: 'Callaway',
    'cyrillic-name': 'Каллавей',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'C12',
        name: 'C12',
        'cyrillic-name': 'с12',
        class: 'S',
        'year-from': 1998,
        'year-to': 2003,
      },
    ],
  },
  {
    id: 'CARBODIES',
    name: 'Carbodies',
    'cyrillic-name': 'Карбодис',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'FX4',
        name: 'FX4',
        'cyrillic-name': 'фх4',
        class: 'E',
        'year-from': 1982,
        'year-to': 1995,
      },
    ],
  },
  {
    id: 'CATERHAM',
    name: 'Caterham',
    'cyrillic-name': 'Катерхем',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'C21',
        name: '21',
        'cyrillic-name': '21',
        class: 'S',
        'year-from': 1994,
        'year-to': 2000,
      },
      {
        id: 'CSR',
        name: 'CSR',
        'cyrillic-name': 'цср',
        class: 'S',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'SEVEN',
        name: 'Seven',
        'cyrillic-name': 'Севен',
        class: 'S',
        'year-from': 1992,
        'year-to': null,
      },
    ],
  },
  {
    id: 'CHANA',
    name: 'Chana',
    'cyrillic-name': 'Чана',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'BENNI',
        name: 'Benni',
        'cyrillic-name': 'бенни',
        class: 'A',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'SC_6390',
        name: 'SC6390',
        'cyrillic-name': 'СЦ6390',
        class: 'M',
        'year-from': 2006,
        'year-to': 2011,
      },
    ],
  },
  {
    id: 'CHANGAN',
    name: 'Changan',
    'cyrillic-name': 'Чанган',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'ALSVIN_V7',
        name: 'Alsvin V7',
        'cyrillic-name': 'Алсвин В7',
        class: 'B',
        'year-from': 2014,
        'year-to': 2018,
      },
      {
        id: 'CHANGAN_A600EV',
        name: 'Auchan A600 EV',
        'cyrillic-name': 'Ашан А600 ЕВ',
        class: 'M',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'BENNI',
        name: 'Benni',
        'cyrillic-name': 'Бенни',
        class: 'B',
        'year-from': 2006,
        'year-to': 2014,
      },
      {
        id: 'BENNI_EC_EV',
        name: 'Benni EC/EV',
        'cyrillic-name': 'Бэнни ЕЦ/ЕВ',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'CM_8',
        name: 'CM-8',
        'cyrillic-name': 'см-8',
        class: 'M',
        'year-from': 2008,
        'year-to': 2015,
      },
      {
        id: 'CS15',
        name: 'CS15',
        'cyrillic-name': 'цс15',
        class: 'B',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'CS35',
        name: 'CS35',
        'cyrillic-name': 'цс35',
        class: 'B',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'CS35PLUS',
        name: 'CS35PLUS',
        'cyrillic-name': 'ЦС 35 плюс',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'CS55',
        name: 'CS55',
        'cyrillic-name': 'цс55',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'CS55PLUS',
        name: 'CS55PLUS',
        'cyrillic-name': 'ЦС55ПЛЮС',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'CS75',
        name: 'CS75',
        'cyrillic-name': 'ЦС75',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'CS75PLUS',
        name: 'CS75PLUS',
        'cyrillic-name': 'ЦС75Плюс',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'CS85',
        name: 'CS85',
        'cyrillic-name': 'ЦС85',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'CS95',
        name: 'CS95',
        'cyrillic-name': 'ЦС95',
        class: 'E',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'CX20',
        name: 'CX20',
        'cyrillic-name': 'сх20',
        class: 'B',
        'year-from': 2011,
        'year-to': 2016,
      },
      {
        id: 'EADO',
        name: 'Eado',
        'cyrillic-name': 'Еадо',
        class: 'C',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'LINMAX',
        name: 'Linmax',
        'cyrillic-name': 'линмакс',
        class: 'M',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'RAETON',
        name: 'Raeton',
        'cyrillic-name': 'Раетон',
        class: 'E',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'SHENLAN_SL03',
        name: 'Shenlan SL03',
        'cyrillic-name': 'Шенлан СЛ03',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'UNI_K',
        name: 'UNI-K',
        'cyrillic-name': 'УНИ-К',
        class: 'E',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'UNI_T',
        name: 'UNI-T',
        'cyrillic-name': 'Уни-Т',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'UNI_V',
        name: 'UNI-V',
        'cyrillic-name': 'Уни-В',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'Z_SHINE',
        name: 'Z-Shine',
        'cyrillic-name': 'зет-шайн',
        class: 'C',
        'year-from': 2008,
        'year-to': 2010,
      },
    ],
  },
  {
    id: 'CHANGFENG',
    name: 'ChangFeng',
    'cyrillic-name': 'Чанфэн',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'FLYING',
        name: 'Flying',
        'cyrillic-name': 'Флаинг',
        class: 'J',
        'year-from': 2005,
        'year-to': 2014,
      },
      {
        id: 'CS6',
        name: 'SUV (CS6)',
        'cyrillic-name': 'СУВ',
        class: 'J',
        'year-from': 2007,
        'year-to': 2009,
      },
    ],
  },
  {
    id: 'CHANGHE',
    name: 'Changhe',
    'cyrillic-name': 'Чанхэ',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'IDEAL',
        name: 'Ideal',
        'cyrillic-name': 'Идеал',
        class: 'A',
        'year-from': 2003,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'CHERY',
    name: 'Chery',
    'cyrillic-name': 'Чери',
    popular: true,
    country: 'Китай',
    models: [
      {
        id: 'AMULET',
        name: 'Amulet (A15)',
        'cyrillic-name': 'Амулет',
        class: 'C',
        'year-from': 2003,
        'year-to': 2012,
      },
      {
        id: 'ARRIZO_3',
        name: 'Arrizo 3',
        'cyrillic-name': 'арризо 3',
        class: 'B',
        'year-from': 2014,
        'year-to': 2018,
      },
      {
        id: 'ARRIZO6',
        name: 'Arrizo 6',
        'cyrillic-name': 'Арризо 6',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'ARRIZO7',
        name: 'Arrizo 7',
        'cyrillic-name': 'Арризо 7',
        class: 'C',
        'year-from': 2013,
        'year-to': 2018,
      },
      {
        id: 'B13',
        name: 'B13',
        'cyrillic-name': 'Б13',
        class: 'M',
        'year-from': 2006,
        'year-to': 2008,
      },
      {
        id: 'BONUS',
        name: 'Bonus (A13)',
        'cyrillic-name': 'Бонус',
        class: 'B',
        'year-from': 2011,
        'year-to': 2014,
      },
      {
        id: 'BONUS_3',
        name: 'Bonus 3 (E3/A19)',
        'cyrillic-name': 'Бонус 3',
        class: 'B',
        'year-from': 2014,
        'year-to': 2017,
      },
      {
        id: 'CROSS_EASTAR',
        name: 'CrossEastar (B14)',
        'cyrillic-name': 'Кросс Эстар',
        class: 'D',
        'year-from': 2006,
        'year-to': 2014,
      },
      {
        id: 'E5',
        name: 'E5',
        'cyrillic-name': 'Е5',
        class: 'C',
        'year-from': 2011,
        'year-to': 2016,
      },
      {
        id: 'EQ5',
        name: 'eQ5',
        'cyrillic-name': 'еКу5',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'FORA',
        name: 'Fora (A21)',
        'cyrillic-name': 'Фора',
        class: 'C',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'INDIS',
        name: 'IndiS (S18D)',
        'cyrillic-name': 'Индис',
        class: 'B',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'KARRY',
        name: 'Karry',
        'cyrillic-name': 'Кари',
        class: 'M',
        'year-from': 2007,
        'year-to': 2010,
      },
      {
        id: 'KIMO',
        name: 'Kimo (A1)',
        'cyrillic-name': 'Кимо',
        class: 'A',
        'year-from': 2007,
        'year-to': 2014,
      },
      {
        id: 'M11',
        name: 'M11 (A3)',
        'cyrillic-name': 'м11 (а3)',
        class: 'C',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'ORIENTAL_SON',
        name: 'Oriental Son (B11)',
        'cyrillic-name': 'Ориентал Сон',
        class: 'D',
        'year-from': 2003,
        'year-to': 2012,
      },
      {
        id: 'QQ6',
        name: 'QQ6 (S21)',
        'cyrillic-name': 'кк6 (с21)',
        class: 'B',
        'year-from': 2006,
        'year-to': 2010,
      },
      {
        id: 'QQME',
        name: 'QQme',
        'cyrillic-name': 'КьюКьюМи',
        class: 'A',
        'year-from': 2009,
        'year-to': 2011,
      },
      {
        id: 'QQ',
        name: 'Sweet (QQ)',
        'cyrillic-name': 'Свит',
        class: 'A',
        'year-from': 2003,
        'year-to': 2015,
      },
      {
        id: 'TIGGO',
        name: 'Tiggo (T11)',
        'cyrillic-name': 'Тиго',
        class: 'C',
        'year-from': 2005,
        'year-to': 2016,
      },
      {
        id: 'TIGGO_2',
        name: 'Tiggo 2',
        'cyrillic-name': 'Тиго 2',
        class: 'B',
        'year-from': 2016,
        'year-to': 2020,
      },
      {
        id: 'TIGGO_2_PRO',
        name: 'Tiggo 2 Pro',
        'cyrillic-name': 'Тигго 2 Про',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'TIGGO_3',
        name: 'Tiggo 3',
        'cyrillic-name': 'Тигго 3',
        class: 'C',
        'year-from': 2014,
        'year-to': 2020,
      },
      {
        id: 'TIGGO_3X',
        name: 'Tiggo 3x',
        'cyrillic-name': 'Тигго 3Х',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'TIGGO_3XE',
        name: 'Tiggo 3xe',
        'cyrillic-name': 'Тигго 3ИксЕ',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'TIGGO_4',
        name: 'Tiggo 4',
        'cyrillic-name': 'Тигго 4',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'TIGGO_4_PRO',
        name: 'Tiggo 4 Pro',
        'cyrillic-name': 'тигго 4 про',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'TIGGO_5',
        name: 'Tiggo 5',
        'cyrillic-name': 'Тигго 5',
        class: 'C',
        'year-from': 2014,
        'year-to': 2020,
      },
      {
        id: 'TIGGO_7',
        name: 'Tiggo 7',
        'cyrillic-name': 'Тигго 7',
        class: 'C',
        'year-from': 2016,
        'year-to': 2020,
      },
      {
        id: 'TIGGO_7_PRO',
        name: 'Tiggo 7 Pro',
        'cyrillic-name': 'Тигго 7 Про',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'TIGGO_7_PRO_MAX',
        name: 'Tiggo 7 Pro Max',
        'cyrillic-name': 'Тигго 7 Про Макс',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'TIGGO_8',
        name: 'Tiggo 8',
        'cyrillic-name': 'Тигго Восемь',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'TIGGO_8_PRO',
        name: 'Tiggo 8 Pro',
        'cyrillic-name': 'Тигго 8 Про',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'TIGGO_8_PRO_MAX',
        name: 'Tiggo 8 Pro Max',
        'cyrillic-name': 'Тигго 8 Про Макс',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'VERY',
        name: 'Very (A13)',
        'cyrillic-name': 'Вери',
        class: 'B',
        'year-from': 2011,
        'year-to': 2014,
      },
      {
        id: 'WINDCLOUD',
        name: 'Windcloud (A11)',
        'cyrillic-name': 'Виндклауд',
        class: 'C',
        'year-from': 1999,
        'year-to': 2006,
      },
    ],
  },
  {
    id: 'CHERYEXEED',
    name: 'EXEED',
    'cyrillic-name': 'Эксид',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'ATLANTIX',
        name: 'AtlantiX',
        'cyrillic-name': 'Атлантикс',
        class: 'D',
        'year-from': 2023,
        'year-to': null,
      },
      {
        id: 'LX',
        name: 'LX',
        'cyrillic-name': 'ЛХ',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'TXL',
        name: 'TXL',
        'cyrillic-name': 'ТХЛ',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'VX',
        name: 'VX',
        'cyrillic-name': 'ВХ',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'CHEVROLET',
    name: 'Chevrolet',
    'cyrillic-name': 'Шевроле',
    popular: true,
    country: 'США',
    models: [
      {
        id: '3000_SERIES',
        name: '3000-Series',
        'cyrillic-name': '3000 серия',
        class: 'J',
        'year-from': 1947,
        'year-to': 1955,
      },
      {
        id: 'ALERO',
        name: 'Alero',
        'cyrillic-name': 'Алеро',
        class: 'D',
        'year-from': 1999,
        'year-to': 2004,
      },
      {
        id: 'APACHE',
        name: 'Apache',
        'cyrillic-name': 'Апачи',
        class: 'J',
        'year-from': 1955,
        'year-to': 1960,
      },
      {
        id: 'ASTRA',
        name: 'Astra',
        'cyrillic-name': 'Астра',
        class: 'C',
        'year-from': 1998,
        'year-to': 2011,
      },
      {
        id: 'ASTRO',
        name: 'Astro',
        'cyrillic-name': 'Астро',
        class: 'M',
        'year-from': 1985,
        'year-to': 2005,
      },
      {
        id: 'AVALANCHE',
        name: 'Avalanche',
        'cyrillic-name': 'Аваланч',
        class: 'J',
        'year-from': 2001,
        'year-to': 2013,
      },
      {
        id: 'AVEO',
        name: 'Aveo',
        'cyrillic-name': 'Авео',
        class: 'B',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'BEL_AIR',
        name: 'Bel Air',
        'cyrillic-name': 'Бел Эйр',
        class: '',
        'year-from': 1949,
        'year-to': 1957,
      },
      {
        id: 'BERETTA',
        name: 'Beretta',
        'cyrillic-name': 'Беретта',
        class: 'C',
        'year-from': 1987,
        'year-to': 1996,
      },
      {
        id: 'BLAZER',
        name: 'Blazer',
        'cyrillic-name': 'Блейзер',
        class: 'E',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'K5_BLAZER',
        name: 'Blazer K5',
        'cyrillic-name': 'блазер к5',
        class: 'J',
        'year-from': 1972,
        'year-to': 1994,
      },
      {
        id: 'BOLT',
        name: 'Bolt',
        'cyrillic-name': 'болт',
        class: 'B',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'BOLT_EUV',
        name: 'Bolt EUV',
        'cyrillic-name': 'Болт ЭУВ',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'C_10',
        name: 'C-10',
        'cyrillic-name': 'ц-10',
        class: 'J',
        'year-from': 1960,
        'year-to': 1988,
      },
      {
        id: 'CK',
        name: 'C/K',
        'cyrillic-name': 'Си/Кей',
        class: 'J',
        'year-from': 1967,
        'year-to': 2000,
      },
      {
        id: 'CAMARO',
        name: 'Camaro',
        'cyrillic-name': 'Камаро',
        class: 'S',
        'year-from': 1967,
        'year-to': null,
      },
      {
        id: 'CAPRICE',
        name: 'Caprice',
        'cyrillic-name': 'Каприз',
        class: 'D',
        'year-from': 1965,
        'year-to': 2017,
      },
      {
        id: 'CAPTIVA',
        name: 'Captiva',
        'cyrillic-name': 'Каптива',
        class: 'D',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'CAPTIVA_SPORT',
        name: 'Captiva Sport',
        'cyrillic-name': 'Каптива Спорт',
        class: 'D',
        'year-from': 2008,
        'year-to': 2016,
      },
      {
        id: 'CAVALIER',
        name: 'Cavalier',
        'cyrillic-name': 'Кавалер',
        class: 'C',
        'year-from': 1982,
        'year-to': 2005,
      },
      {
        id: 'CELEBRITY',
        name: 'Celebrity',
        'cyrillic-name': 'Селебрити',
        class: 'D',
        'year-from': 1982,
        'year-to': 1990,
      },
      {
        id: 'CELTA',
        name: 'Celta',
        'cyrillic-name': 'Сельта',
        class: 'B',
        'year-from': 2000,
        'year-to': 2006,
      },
      {
        id: 'CHEVELLE',
        name: 'Chevelle',
        'cyrillic-name': 'чевелле',
        class: 'S',
        'year-from': 1963,
        'year-to': 1977,
      },
      {
        id: 'CHEVETTE',
        name: 'Chevette',
        'cyrillic-name': 'Шевет',
        class: 'C',
        'year-from': 1975,
        'year-to': 1987,
      },
      {
        id: 'CITATION',
        name: 'Citation',
        'cyrillic-name': 'сайтейшн',
        class: 'C',
        'year-from': 1980,
        'year-to': 1985,
      },
      {
        id: 'COBALT',
        name: 'Cobalt',
        'cyrillic-name': 'Кобальт',
        class: 'B',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'COLORADO',
        name: 'Colorado',
        'cyrillic-name': 'Колорадо',
        class: 'J',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'CORSA',
        name: 'Corsa',
        'cyrillic-name': 'Корса',
        class: 'B',
        'year-from': 1994,
        'year-to': 2001,
      },
      {
        id: 'CORSICA',
        name: 'Corsica',
        'cyrillic-name': 'Корсика',
        class: 'D',
        'year-from': 1987,
        'year-to': 1996,
      },
      {
        id: 'CORVAIR',
        name: 'Corvair',
        'cyrillic-name': 'Корвейр',
        class: 'C',
        'year-from': 1959,
        'year-to': 1969,
      },
      {
        id: 'CORVETTE',
        name: 'Corvette',
        'cyrillic-name': 'Корвет',
        class: 'S',
        'year-from': 1953,
        'year-to': null,
      },
      {
        id: 'CRUZE',
        name: 'Cruze',
        'cyrillic-name': 'Круз',
        class: 'C',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'CRUZE_HR',
        name: 'Cruze (HR)',
        'cyrillic-name': 'круз (эйчар)',
        class: 'B',
        'year-from': 2001,
        'year-to': 2008,
      },
      {
        id: 'CSV_CR8',
        name: 'CSV CR8',
        'cyrillic-name': 'ЦСВ-ЦР8',
        class: 'D',
        'year-from': 2008,
        'year-to': 2009,
      },
      {
        id: 'DAMAS',
        name: 'Damas',
        'cyrillic-name': 'Дамас',
        class: 'M',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'DELUXE',
        name: 'Deluxe',
        'cyrillic-name': 'Делюкс',
        class: '',
        'year-from': 1949,
        'year-to': 1952,
      },
      {
        id: 'EL_CAMINO',
        name: 'El Camino',
        'cyrillic-name': 'эль камино',
        class: 'J',
        'year-from': 1959,
        'year-to': 1987,
      },
      {
        id: 'EPICA',
        name: 'Epica',
        'cyrillic-name': 'Эпика',
        class: 'D',
        'year-from': 2003,
        'year-to': 2012,
      },
      {
        id: 'EQUINOX',
        name: 'Equinox',
        'cyrillic-name': 'Эквинокс',
        class: 'D',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'EVANDA',
        name: 'Evanda',
        'cyrillic-name': 'Эванда',
        class: 'D',
        'year-from': 2000,
        'year-to': 2006,
      },
      {
        id: 'EXPRESS',
        name: 'Express',
        'cyrillic-name': 'Экспресс',
        class: 'M',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'FLEETMASTER',
        name: 'Fleetmaster',
        'cyrillic-name': 'флитмастер',
        class: 'E',
        'year-from': 1946,
        'year-to': 1948,
      },
      {
        id: 'GROOVE',
        name: 'Groove',
        'cyrillic-name': 'Грув',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'HHR',
        name: 'HHR',
        'cyrillic-name': 'ххр',
        class: 'D',
        'year-from': 2005,
        'year-to': 2011,
      },
      {
        id: 'IMPALA',
        name: 'Impala',
        'cyrillic-name': 'Импала',
        class: 'F',
        'year-from': 1958,
        'year-to': 2020,
      },
      {
        id: 'KALOS',
        name: 'Kalos',
        'cyrillic-name': 'калос',
        class: 'B',
        'year-from': 2003,
        'year-to': 2008,
      },
      {
        id: 'LACETTI',
        name: 'Lacetti',
        'cyrillic-name': 'Лачетти',
        class: 'C',
        'year-from': 2004,
        'year-to': 2013,
      },
      {
        id: 'LANOS',
        name: 'Lanos',
        'cyrillic-name': 'Ланос',
        class: 'B',
        'year-from': 2002,
        'year-to': 2009,
      },
      {
        id: 'LUMINA',
        name: 'Lumina',
        'cyrillic-name': 'Люмина',
        class: 'D',
        'year-from': 1989,
        'year-to': 2001,
      },
      {
        id: 'LUMINA_APV',
        name: 'Lumina APV',
        'cyrillic-name': 'люмина апв',
        class: 'M',
        'year-from': 1989,
        'year-to': 1996,
      },
      {
        id: 'LUV_DMAX',
        name: 'LUV D-MAX',
        'cyrillic-name': 'Лув Д-Макс',
        class: 'J',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'MALIBU',
        name: 'Malibu',
        'cyrillic-name': 'Малибу',
        class: 'D',
        'year-from': 1978,
        'year-to': null,
      },
      {
        id: 'MASTER',
        name: 'Master',
        'cyrillic-name': 'мастер',
        class: '',
        'year-from': 1933,
        'year-to': 1940,
      },
      {
        id: 'CMATIZ',
        name: 'Matiz',
        'cyrillic-name': 'Матиз',
        class: 'A',
        'year-from': 2004,
        'year-to': 2010,
      },
      {
        id: 'MENLO',
        name: 'Menlo',
        'cyrillic-name': 'Менло',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'METRO',
        name: 'Metro',
        'cyrillic-name': 'Метро',
        class: 'B',
        'year-from': 1997,
        'year-to': 2001,
      },
      {
        id: 'MONTE_CARLO',
        name: 'Monte Carlo',
        'cyrillic-name': 'Монте Карло',
        class: 'D',
        'year-from': 1970,
        'year-to': 2007,
      },
      {
        id: 'MONZA',
        name: 'Monza',
        'cyrillic-name': 'Монца',
        class: 'C',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'MW',
        name: 'MW',
        'cyrillic-name': 'мв',
        class: 'B',
        'year-from': 2001,
        'year-to': 2010,
      },
      {
        id: 'NEXIA',
        name: 'Nexia',
        'cyrillic-name': 'Нексия',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'NIVA',
        name: 'Niva',
        'cyrillic-name': 'Нива',
        class: 'J',
        'year-from': 2002,
        'year-to': 2020,
      },
      {
        id: 'NOVA',
        name: 'Nova',
        'cyrillic-name': 'Нова',
        class: 'B',
        'year-from': 1967,
        'year-to': 1988,
      },
      {
        id: 'NUBIRA',
        name: 'Nubira',
        'cyrillic-name': 'Нубира',
        class: 'C',
        'year-from': 2003,
        'year-to': 2010,
      },
      {
        id: 'OMEGA',
        name: 'Omega',
        'cyrillic-name': 'Омега',
        class: 'E',
        'year-from': 1992,
        'year-to': 2007,
      },
      {
        id: 'ONIX',
        name: 'Onix',
        'cyrillic-name': 'Оникс',
        class: 'C',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'ORLANDO',
        name: 'Orlando',
        'cyrillic-name': 'Орландо',
        class: 'M',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'PRIZM',
        name: 'Prizm',
        'cyrillic-name': 'Призм',
        class: 'C',
        'year-from': 1997,
        'year-to': 2002,
      },
      {
        id: 'REZZO',
        name: 'Rezzo',
        'cyrillic-name': 'Реззо',
        class: 'M',
        'year-from': 2000,
        'year-to': 2008,
      },
      {
        id: 'S_10',
        name: 'S-10 Pickup',
        'cyrillic-name': 'С-10 Пикап',
        class: 'J',
        'year-from': 1982,
        'year-to': 2012,
      },
      {
        id: 'SAIL',
        name: 'Sail',
        'cyrillic-name': 'Сейл',
        class: 'B',
        'year-from': 2010,
        'year-to': 2014,
      },
      {
        id: 'SEEKER',
        name: 'Seeker',
        'cyrillic-name': 'Сикер',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'SILVERADO',
        name: 'Silverado',
        'cyrillic-name': 'сильверадо',
        class: 'J',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'SONIC',
        name: 'Sonic',
        'cyrillic-name': 'Соник',
        class: 'B',
        'year-from': 2011,
        'year-to': 2020,
      },
      {
        id: 'SPARK',
        name: 'Spark',
        'cyrillic-name': 'Спарк',
        class: 'A',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'SPECIAL_DELUXE',
        name: 'Special DeLuxe',
        'cyrillic-name': 'спешиал делюкс',
        class: '',
        'year-from': 1941,
        'year-to': 1948,
      },
      {
        id: 'SPIN',
        name: 'Spin',
        'cyrillic-name': 'Спин',
        class: 'M',
        'year-from': 2012,
        'year-to': 2018,
      },
      {
        id: 'SS',
        name: 'SS',
        'cyrillic-name': 'СС',
        class: 'E',
        'year-from': 2013,
        'year-to': 2017,
      },
      {
        id: 'SSR',
        name: 'SSR',
        'cyrillic-name': 'сср',
        class: 'J',
        'year-from': 2003,
        'year-to': 2006,
      },
      {
        id: 'STARCRAFT',
        name: 'Starcraft',
        'cyrillic-name': 'Старкрафт',
        class: 'M',
        'year-from': 1992,
        'year-to': 1996,
      },
      {
        id: 'SUBURBAN',
        name: 'Suburban',
        'cyrillic-name': 'Субурбан',
        class: 'J',
        'year-from': 1973,
        'year-to': null,
      },
      {
        id: 'TACUMA',
        name: 'Tacuma',
        'cyrillic-name': 'Такума',
        class: 'M',
        'year-from': 2000,
        'year-to': 2008,
      },
      {
        id: 'TAHOE',
        name: 'Tahoe',
        'cyrillic-name': 'Тахо',
        class: 'J',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'TAVERA',
        name: 'Tavera',
        'cyrillic-name': 'Тавера',
        class: 'M',
        'year-from': 2002,
        'year-to': 2017,
      },
      {
        id: 'TRACKER',
        name: 'Tracker',
        'cyrillic-name': 'Трекер',
        class: 'B',
        'year-from': 1989,
        'year-to': null,
      },
      {
        id: 'TRAILBLAZER',
        name: 'TrailBlazer',
        'cyrillic-name': 'Трейл блейзер',
        class: 'C',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'TRANSSPORT',
        name: 'Trans Sport',
        'cyrillic-name': 'Транс Спорт',
        class: 'M',
        'year-from': 1996,
        'year-to': 2005,
      },
      {
        id: 'TRAVERSE',
        name: 'Traverse',
        'cyrillic-name': 'Траверс',
        class: 'F',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'TRAX',
        name: 'Trax',
        'cyrillic-name': 'Тракс',
        class: 'B',
        'year-from': 2013,
        'year-to': 2022,
      },
      {
        id: 'UPLANDER',
        name: 'Uplander',
        'cyrillic-name': 'Аплендер',
        class: 'M',
        'year-from': 2004,
        'year-to': 2008,
      },
      {
        id: 'VAN',
        name: 'Van',
        'cyrillic-name': 'Ван',
        class: 'M',
        'year-from': 1971,
        'year-to': 1996,
      },
      {
        id: 'VECTRA',
        name: 'Vectra',
        'cyrillic-name': 'Вектра',
        class: 'D',
        'year-from': 1993,
        'year-to': 2002,
      },
      {
        id: 'VENTURE',
        name: 'Venture',
        'cyrillic-name': 'Вентура',
        class: 'M',
        'year-from': 1996,
        'year-to': 2005,
      },
      {
        id: 'VIVA',
        name: 'Viva',
        'cyrillic-name': 'Вива',
        class: 'C',
        'year-from': 2004,
        'year-to': 2008,
      },
      {
        id: 'VOLT',
        name: 'Volt',
        'cyrillic-name': 'Вольт',
        class: 'C',
        'year-from': 2010,
        'year-to': 2019,
      },
      {
        id: 'ZAFIRA',
        name: 'Zafira',
        'cyrillic-name': 'Зафира',
        class: 'M',
        'year-from': 2001,
        'year-to': 2012,
      },
    ],
  },
  {
    id: 'CHRYSLER',
    name: 'Chrysler',
    'cyrillic-name': 'Крайслер',
    popular: false,
    country: 'США',
    models: [
      {
        id: '180',
        name: '180',
        'cyrillic-name': '180',
        class: 'C',
        'year-from': 1970,
        'year-to': 1982,
      },
      {
        id: '200',
        name: '200',
        'cyrillic-name': '200',
        class: 'D',
        'year-from': 2010,
        'year-to': 2017,
      },
      {
        id: '300',
        name: '300',
        'cyrillic-name': '300',
        class: 'S',
        'year-from': 1969,
        'year-to': 1971,
      },
      {
        id: '300_LETTER_SERIES',
        name: '300 Letter Series',
        'cyrillic-name': '300 Леттер Сериес',
        class: 'S',
        'year-from': 1955,
        'year-to': 1957,
      },
      {
        id: '300C',
        name: '300C',
        'cyrillic-name': '300Ц',
        class: 'E',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: '300M',
        name: '300M',
        'cyrillic-name': '300М',
        class: 'F',
        'year-from': 1998,
        'year-to': 2004,
      },
      {
        id: 'ASPEN',
        name: 'Aspen',
        'cyrillic-name': 'Аспен',
        class: 'J',
        'year-from': 2006,
        'year-to': 2008,
      },
      {
        id: 'CIRRUS',
        name: 'Cirrus',
        'cyrillic-name': 'Цирус',
        class: 'D',
        'year-from': 1994,
        'year-to': 2000,
      },
      {
        id: 'CONCORDE',
        name: 'Concorde',
        'cyrillic-name': 'Конкорд',
        class: 'F',
        'year-from': 1992,
        'year-to': 2004,
      },
      {
        id: 'CORDOBA',
        name: 'Cordoba',
        'cyrillic-name': 'кордоба',
        class: 'S',
        'year-from': 1975,
        'year-to': 1983,
      },
      {
        id: 'CROSSFIRE',
        name: 'Crossfire',
        'cyrillic-name': 'Кроссфаер',
        class: 'S',
        'year-from': 2003,
        'year-to': 2007,
      },
      {
        id: 'DAYTONA',
        name: 'Daytona',
        'cyrillic-name': 'Дайтона',
        class: 'C',
        'year-from': 1986,
        'year-to': 1993,
      },
      {
        id: 'DYNASTY',
        name: 'Dynasty',
        'cyrillic-name': 'династия',
        class: 'D',
        'year-from': 1988,
        'year-to': 1993,
      },
      {
        id: 'ES',
        name: 'ES',
        'cyrillic-name': 'ЕС',
        class: 'C',
        'year-from': 1988,
        'year-to': 1991,
      },
      {
        id: 'FIFTH_AVENUE',
        name: 'Fifth Avenue',
        'cyrillic-name': '5-е Авеню',
        class: 'E',
        'year-from': 1982,
        'year-to': 1993,
      },
      {
        id: 'IMPERIAL',
        name: 'Imperial',
        'cyrillic-name': 'Империал',
        class: 'E',
        'year-from': 1926,
        'year-to': 1993,
      },
      {
        id: 'IMPERIAL_CROWN',
        name: 'Imperial Crown',
        'cyrillic-name': 'Империал Краун',
        class: 'S',
        'year-from': 1963,
        'year-to': 1975,
      },
      {
        id: 'INTREPID',
        name: 'Intrepid',
        'cyrillic-name': 'Интерпид',
        class: 'E',
        'year-from': 1993,
        'year-to': 2004,
      },
      {
        id: 'LE_BARON',
        name: 'LeBaron',
        'cyrillic-name': 'Ле Барон',
        class: 'E',
        'year-from': 1977,
        'year-to': 1995,
      },
      {
        id: 'LHS',
        name: 'LHS',
        'cyrillic-name': 'лхс',
        class: 'E',
        'year-from': 1993,
        'year-to': 2001,
      },
      {
        id: 'NASSAU',
        name: 'Nassau',
        'cyrillic-name': 'Нассау',
        class: 'E',
        'year-from': 2007,
        'year-to': 2007,
      },
      {
        id: 'NEON',
        name: 'Neon',
        'cyrillic-name': 'Неон',
        class: 'C',
        'year-from': 1994,
        'year-to': 2004,
      },
      {
        id: 'NEW_YORKER',
        name: 'New Yorker',
        'cyrillic-name': 'Нью Йоркер',
        class: 'E',
        'year-from': 1949,
        'year-to': 1996,
      },
      {
        id: 'NEWPORT',
        name: 'Newport',
        'cyrillic-name': 'Ньюпорт',
        class: 'F',
        'year-from': 1968,
        'year-to': 1978,
      },
      {
        id: 'PACIFICA',
        name: 'Pacifica',
        'cyrillic-name': 'Пацифика',
        class: 'M',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'PROWLER',
        name: 'Prowler',
        'cyrillic-name': 'Праулер',
        class: 'S',
        'year-from': 2001,
        'year-to': 2002,
      },
      {
        id: 'PT_CRUISER',
        name: 'PT Cruiser',
        'cyrillic-name': 'ПТ Крузер',
        class: 'C',
        'year-from': 2000,
        'year-to': 2010,
      },
      {
        id: 'SARATOGA',
        name: 'Saratoga',
        'cyrillic-name': 'Саратога',
        class: 'D',
        'year-from': 1989,
        'year-to': 1995,
      },
      {
        id: 'SEBRING',
        name: 'Sebring',
        'cyrillic-name': 'Себринг',
        class: 'D',
        'year-from': 1994,
        'year-to': 2010,
      },
      {
        id: 'SIX',
        name: 'Six',
        'cyrillic-name': 'сикс',
        class: 'E',
        'year-from': 1924,
        'year-to': 1935,
      },
      {
        id: 'STRATUS',
        name: 'Stratus',
        'cyrillic-name': 'Стратус',
        class: 'D',
        'year-from': 1994,
        'year-to': 2000,
      },
      {
        id: 'TC_BY_MASERATI',
        name: 'TC by Maserati',
        'cyrillic-name': 'ТЦ бай Мазерати',
        class: 'S',
        'year-from': 1989,
        'year-to': 1991,
      },
      {
        id: 'TOWN_AND_COUNTRY',
        name: 'Town & Country',
        'cyrillic-name': 'Таун Кантри',
        class: 'M',
        'year-from': 1941,
        'year-to': 2016,
      },
      {
        id: 'VIPER',
        name: 'Viper',
        'cyrillic-name': 'Вайпер',
        class: 'S',
        'year-from': 1992,
        'year-to': 2002,
      },
      {
        id: 'VISION',
        name: 'Vision',
        'cyrillic-name': 'Вижн',
        class: 'E',
        'year-from': 1992,
        'year-to': 1997,
      },
      {
        id: 'VOYAGER',
        name: 'Voyager',
        'cyrillic-name': 'Вояджер',
        class: 'M',
        'year-from': 1984,
        'year-to': null,
      },
      {
        id: 'WINDSOR',
        name: 'Windsor',
        'cyrillic-name': 'виндсор',
        class: '',
        'year-from': 1953,
        'year-to': 1954,
      },
    ],
  },
  {
    id: 'CIIMO',
    name: 'Ciimo (DongFeng-Honda)',
    'cyrillic-name': 'Циимо',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'M_NV',
        name: 'M-NV',
        'cyrillic-name': 'М-НВ',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'X_NV',
        name: 'X-NV',
        'cyrillic-name': 'кс-нв',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'CITROEN',
    name: 'Citroen',
    'cyrillic-name': 'Ситроен',
    popular: true,
    country: 'Франция',
    models: [
      {
        id: '2CV',
        name: '2 CV',
        'cyrillic-name': 'Де Шво',
        class: 'B',
        'year-from': 1963,
        'year-to': 1990,
      },
      {
        id: 'AMI',
        name: 'AMI',
        'cyrillic-name': 'ами',
        class: 'B',
        'year-from': 1961,
        'year-to': 1978,
      },
      {
        id: 'AX',
        name: 'AX',
        'cyrillic-name': 'акс',
        class: 'B',
        'year-from': 1986,
        'year-to': 1998,
      },
      {
        id: 'BERLINGO',
        name: 'Berlingo',
        'cyrillic-name': 'Берлинго',
        class: 'M',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'BX',
        name: 'BX',
        'cyrillic-name': 'бкс',
        class: 'D',
        'year-from': 1982,
        'year-to': 1994,
      },
      {
        id: 'C_CROSSER',
        name: 'C-Crosser',
        'cyrillic-name': 'Си кроссер',
        class: 'D',
        'year-from': 2007,
        'year-to': 2013,
      },
      {
        id: 'C_ELYSEE',
        name: 'C-Elysee',
        'cyrillic-name': 'Си Элизи',
        class: 'B',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'C_QUATRE',
        name: 'C-Quatre',
        'cyrillic-name': 'ц-куатре',
        class: 'C',
        'year-from': 2008,
        'year-to': 2016,
      },
      {
        id: 'C_TRIOMPHE',
        name: 'C-Triomphe',
        'cyrillic-name': 'ц-триомфе',
        class: 'D',
        'year-from': 2006,
        'year-to': 2010,
      },
      {
        id: 'C_ZERO',
        name: 'C-ZERO',
        'cyrillic-name': 'ц-зеро',
        class: 'A',
        'year-from': 2010,
        'year-to': 2012,
      },
      {
        id: 'C1',
        name: 'C1',
        'cyrillic-name': 'ц1',
        class: 'A',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'C2',
        name: 'C2',
        'cyrillic-name': 'ц2',
        class: 'B',
        'year-from': 2003,
        'year-to': 2009,
      },
      {
        id: 'C3',
        name: 'C3',
        'cyrillic-name': 'ц3',
        class: 'B',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'C3_AIRCROSS',
        name: 'C3 Aircross',
        'cyrillic-name': 'ц3 аирцросс',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'C3_PICASSO',
        name: 'C3 Picasso',
        'cyrillic-name': 'ц3 пицассо',
        class: 'M',
        'year-from': 2008,
        'year-to': 2017,
      },
      {
        id: 'C4',
        name: 'C4',
        'cyrillic-name': 'ц4',
        class: 'C',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'C4_AIRCROSS',
        name: 'C4 Aircross',
        'cyrillic-name': 'с4 аиркросс',
        class: 'C',
        'year-from': 2012,
        'year-to': 2017,
      },
      {
        id: 'C4_CACTUS',
        name: 'C4 Cactus',
        'cyrillic-name': 'ц4 цацтус',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'C4_PICASSO',
        name: 'C4 Picasso',
        'cyrillic-name': 'ц4 пицассо',
        class: 'M',
        'year-from': 2006,
        'year-to': 2018,
      },
      {
        id: 'C4_SPACETOURER',
        name: 'C4 SpaceTourer',
        'cyrillic-name': 'С4 Спейстурер',
        class: 'M',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'C5',
        name: 'C5',
        'cyrillic-name': 'ц5',
        class: 'D',
        'year-from': 2000,
        'year-to': 2017,
      },
      {
        id: 'C5_AIRCROSS',
        name: 'C5 Aircross',
        'cyrillic-name': 'ц5 аирцросс',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'C5_X',
        name: 'C5 X',
        'cyrillic-name': 'ц5 кс',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'C6',
        name: 'C6',
        'cyrillic-name': 'ц6',
        class: 'F',
        'year-from': 2004,
        'year-to': 2012,
      },
      {
        id: 'C8',
        name: 'C8',
        'cyrillic-name': 'ц8',
        class: 'M',
        'year-from': 2002,
        'year-to': 2014,
      },
      {
        id: 'CX',
        name: 'CX',
        'cyrillic-name': 'цкс',
        class: 'D',
        'year-from': 1974,
        'year-to': 1991,
      },
      {
        id: 'DS',
        name: 'DS',
        'cyrillic-name': 'дс',
        class: 'E',
        'year-from': 1955,
        'year-to': 1976,
      },
      {
        id: 'DS3',
        name: 'DS3',
        'cyrillic-name': 'дс3',
        class: 'B',
        'year-from': 2009,
        'year-to': 2015,
      },
      {
        id: 'DS4',
        name: 'DS4',
        'cyrillic-name': 'дс4',
        class: 'C',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'DS5',
        name: 'DS5',
        'cyrillic-name': 'дс5',
        class: 'D',
        'year-from': 2012,
        'year-to': 2015,
      },
      {
        id: 'DYANE',
        name: 'Dyane',
        'cyrillic-name': 'Дайан',
        class: 'B',
        'year-from': 1967,
        'year-to': 1984,
      },
      {
        id: 'E_MEHARI',
        name: 'E-Mehari',
        'cyrillic-name': 'Е-Мехари',
        class: 'B',
        'year-from': 2016,
        'year-to': 2019,
      },
      {
        id: 'EVASION',
        name: 'Evasion',
        'cyrillic-name': 'Эвазион',
        class: 'M',
        'year-from': 1994,
        'year-to': 2002,
      },
      {
        id: 'GS',
        name: 'GS',
        'cyrillic-name': 'гс',
        class: 'C',
        'year-from': 1971,
        'year-to': 1986,
      },
      {
        id: 'JUMPY',
        name: 'Jumpy',
        'cyrillic-name': 'Джампи',
        class: 'M',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'LN',
        name: 'LN',
        'cyrillic-name': 'лн',
        class: 'A',
        'year-from': 1976,
        'year-to': 1986,
      },
      {
        id: 'NEMO',
        name: 'Nemo',
        'cyrillic-name': 'немо',
        class: 'M',
        'year-from': 2007,
        'year-to': 2017,
      },
      {
        id: 'SAXO',
        name: 'Saxo',
        'cyrillic-name': 'Саксо',
        class: 'B',
        'year-from': 1996,
        'year-to': 2003,
      },
      {
        id: 'SM',
        name: 'SM',
        'cyrillic-name': 'см',
        class: 'S',
        'year-from': 1970,
        'year-to': 1975,
      },
      {
        id: 'SPACETOURER',
        name: 'SpaceTourer',
        'cyrillic-name': 'Спейс турер',
        class: 'M',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'TRACTION_AVANT',
        name: 'Traction Avant',
        'cyrillic-name': 'трекшн авант',
        class: '',
        'year-from': 1934,
        'year-to': 1957,
      },
      {
        id: 'VISA',
        name: 'Visa',
        'cyrillic-name': 'Виза',
        class: 'B',
        'year-from': 1978,
        'year-to': 1991,
      },
      {
        id: 'XANTIA',
        name: 'Xantia',
        'cyrillic-name': 'Ксантия',
        class: 'D',
        'year-from': 1992,
        'year-to': 2002,
      },
      {
        id: 'XM',
        name: 'XM',
        'cyrillic-name': 'ксм',
        class: 'E',
        'year-from': 1989,
        'year-to': 2000,
      },
      {
        id: 'XSARA',
        name: 'Xsara',
        'cyrillic-name': 'Ксара',
        class: 'C',
        'year-from': 1997,
        'year-to': 2006,
      },
      {
        id: 'XSARA_PICASSO',
        name: 'Xsara Picasso',
        'cyrillic-name': 'Ксара Пикассо',
        class: 'M',
        'year-from': 1999,
        'year-to': 2012,
      },
      {
        id: 'ZX',
        name: 'ZX',
        'cyrillic-name': 'зкс',
        class: 'C',
        'year-from': 1991,
        'year-to': 1998,
      },
    ],
  },
  {
    id: 'CIZETA',
    name: 'Cizeta',
    'cyrillic-name': 'Чизета',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'V16T',
        name: 'V16t',
        'cyrillic-name': 'в16т',
        class: 'S',
        'year-from': 1991,
        'year-to': 1995,
      },
    ],
  },
  {
    id: 'COGGIOLA',
    name: 'Coggiola',
    'cyrillic-name': 'Коджиола',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'T_REX',
        name: 'T Rex',
        'cyrillic-name': 'т рекс',
        class: 'J',
        'year-from': 2000,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'CORD',
    name: 'Cord',
    'cyrillic-name': 'Корд',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'L_29',
        name: 'L-29',
        'cyrillic-name': 'Л-29',
        class: 'F',
        'year-from': 1929,
        'year-to': 1932,
      },
    ],
  },
  {
    id: 'CUPRA',
    name: 'Cupra',
    'cyrillic-name': 'Купра',
    popular: false,
    country: 'Испания',
    models: [
      {
        id: 'ATECA',
        name: 'Ateca',
        'cyrillic-name': 'Атека',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'BORN',
        name: 'Born',
        'cyrillic-name': 'борн',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'FORMENTOR',
        name: 'Formentor',
        'cyrillic-name': 'Форментор',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'LEON',
        name: 'Leon',
        'cyrillic-name': 'леон',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'DACIA',
    name: 'Dacia',
    'cyrillic-name': 'Дачия',
    popular: false,
    country: 'Румыния',
    models: [
      {
        id: '1300',
        name: '1300',
        'cyrillic-name': '1300',
        class: 'C',
        'year-from': 1969,
        'year-to': 1978,
      },
      {
        id: '1310',
        name: '1310',
        'cyrillic-name': '1310',
        class: 'C',
        'year-from': 1979,
        'year-to': 2004,
      },
      {
        id: '1410',
        name: '1410',
        'cyrillic-name': '1410',
        class: 'C',
        'year-from': 1984,
        'year-to': 2004,
      },
      {
        id: 'DOKKER',
        name: 'Dokker',
        'cyrillic-name': 'Доккер',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'DUSTER',
        name: 'Duster',
        'cyrillic-name': 'Дастер',
        class: 'B',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'JOGGER',
        name: 'Jogger',
        'cyrillic-name': 'Джоггер',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'LODGY',
        name: 'Lodgy',
        'cyrillic-name': 'Лоджи',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'LOGAN',
        name: 'Logan',
        'cyrillic-name': 'Логан',
        class: 'B',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'NOVA',
        name: 'Nova',
        'cyrillic-name': 'Нова',
        class: 'B',
        'year-from': 1995,
        'year-to': 2000,
      },
      {
        id: 'PICK_UP',
        name: 'Pick-Up',
        'cyrillic-name': 'Пик-Ап',
        class: 'J',
        'year-from': 1975,
        'year-to': 2006,
      },
      {
        id: 'SANDERO',
        name: 'Sandero',
        'cyrillic-name': 'Сандэро',
        class: 'B',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'SOLENZA',
        name: 'Solenza',
        'cyrillic-name': 'Соленза',
        class: 'B',
        'year-from': 2003,
        'year-to': 2005,
      },
      {
        id: 'SPRING',
        name: 'Spring',
        'cyrillic-name': 'Спринг',
        class: 'A',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'SUPERNOVA',
        name: 'SuperNova',
        'cyrillic-name': 'СуперНова',
        class: 'B',
        'year-from': 2000,
        'year-to': 2003,
      },
    ],
  },
  {
    id: 'DADI',
    name: 'Dadi',
    'cyrillic-name': 'Дади',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'CITY_LEADING',
        name: 'City Leading',
        'cyrillic-name': 'Сити Лидин',
        class: 'J',
        'year-from': 2004,
        'year-to': 2007,
      },
      {
        id: 'SHUTTLE',
        name: 'Shuttle',
        'cyrillic-name': 'Шаттл',
        class: 'J',
        'year-from': 2005,
        'year-to': 2007,
      },
      {
        id: 'SMOOTHING',
        name: 'Smoothing',
        'cyrillic-name': 'Смуфин',
        class: 'J',
        'year-from': 2006,
        'year-to': 2007,
      },
    ],
  },
  {
    id: 'DAEWOO',
    name: 'Daewoo',
    'cyrillic-name': 'Дэу',
    popular: true,
    country: 'Южная Корея',
    models: [
      {
        id: 'ALPHEON',
        name: 'Alpheon',
        'cyrillic-name': 'Алфеон',
        class: 'E',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'ARCADIA',
        name: 'Arcadia',
        'cyrillic-name': 'Аркадия',
        class: 'E',
        'year-from': 1994,
        'year-to': 1999,
      },
      {
        id: 'CHAIRMAN',
        name: 'Chairman',
        'cyrillic-name': 'Чаирман',
        class: 'F',
        'year-from': 1999,
        'year-to': 2002,
      },
      {
        id: 'DAMAS',
        name: 'Damas',
        'cyrillic-name': 'Дамас',
        class: '',
        'year-from': 1991,
        'year-to': 2011,
      },
      {
        id: 'ESPERO',
        name: 'Espero',
        'cyrillic-name': 'Эсперо',
        class: 'D',
        'year-from': 1990,
        'year-to': 1999,
      },
      {
        id: 'EVANDA',
        name: 'Evanda',
        'cyrillic-name': 'Эванда',
        class: 'D',
        'year-from': 2002,
        'year-to': 2005,
      },
      {
        id: 'G2X',
        name: 'G2X',
        'cyrillic-name': 'г2кс',
        class: 'S',
        'year-from': 2007,
        'year-to': 2008,
      },
      {
        id: 'GENTRA',
        name: 'Gentra',
        'cyrillic-name': 'Джентра',
        class: 'C',
        'year-from': 2005,
        'year-to': 2015,
      },
      {
        id: 'KALOS',
        name: 'Kalos',
        'cyrillic-name': 'Калос',
        class: 'B',
        'year-from': 2002,
        'year-to': 2007,
      },
      {
        id: 'KORANDO',
        name: 'Korando',
        'cyrillic-name': 'Корандо',
        class: 'J',
        'year-from': 1999,
        'year-to': 2001,
      },
      {
        id: 'LACETTI',
        name: 'Lacetti',
        'cyrillic-name': 'Лачетти',
        class: 'C',
        'year-from': 2002,
        'year-to': 2010,
      },
      {
        id: 'LACETTI_PREMIERE',
        name: 'Lacetti Premiere',
        'cyrillic-name': 'Лачетти Премьер',
        class: 'C',
        'year-from': 2008,
        'year-to': 2011,
      },
      {
        id: 'LANOS',
        name: 'Lanos',
        'cyrillic-name': 'Ланос',
        class: 'B',
        'year-from': 1997,
        'year-to': 2008,
      },
      {
        id: 'LEGANZA',
        name: 'Leganza',
        'cyrillic-name': 'Леганза',
        class: 'E',
        'year-from': 1997,
        'year-to': 2008,
      },
      {
        id: 'LE_MANS',
        name: 'LeMans',
        'cyrillic-name': 'Леманс',
        class: 'C',
        'year-from': 1986,
        'year-to': 1994,
      },
      {
        id: 'MAGNUS',
        name: 'Magnus',
        'cyrillic-name': 'Магнус',
        class: 'D',
        'year-from': 2000,
        'year-to': 2006,
      },
      {
        id: 'MATIZ',
        name: 'Matiz',
        'cyrillic-name': 'Матиз',
        class: 'A',
        'year-from': 1998,
        'year-to': 2016,
      },
      {
        id: 'MATIZ_CREATIVE',
        name: 'Matiz Creative',
        'cyrillic-name': 'Матиз Криэйтив',
        class: 'A',
        'year-from': 2009,
        'year-to': 2011,
      },
      {
        id: 'MUSSO',
        name: 'Musso',
        'cyrillic-name': 'Муссо',
        class: 'J',
        'year-from': 1999,
        'year-to': 2002,
      },
      {
        id: 'NEXIA',
        name: 'Nexia',
        'cyrillic-name': 'Нексия',
        class: 'C',
        'year-from': 1994,
        'year-to': 2016,
      },
      {
        id: 'NUBIRA',
        name: 'Nubira',
        'cyrillic-name': 'Нубира',
        class: 'C',
        'year-from': 1997,
        'year-to': 2004,
      },
      {
        id: 'PRINCE',
        name: 'Prince',
        'cyrillic-name': 'Принц',
        class: 'D',
        'year-from': 1991,
        'year-to': 1999,
      },
      {
        id: 'RACER',
        name: 'Racer',
        'cyrillic-name': 'Рейсер',
        class: 'C',
        'year-from': 1986,
        'year-to': 1997,
      },
      {
        id: 'REZZO',
        name: 'Rezzo',
        'cyrillic-name': 'Реззо',
        class: 'M',
        'year-from': 2000,
        'year-to': 2008,
      },
      {
        id: 'ROYALE',
        name: 'Royale',
        'cyrillic-name': 'Роял',
        class: 'D',
        'year-from': 1981,
        'year-to': 1992,
      },
      {
        id: 'SENS',
        name: 'Sens',
        'cyrillic-name': 'Сенс',
        class: 'B',
        'year-from': 2002,
        'year-to': 2009,
      },
      {
        id: 'TACUMA',
        name: 'Tacuma',
        'cyrillic-name': 'Такума',
        class: 'M',
        'year-from': 2000,
        'year-to': 2011,
      },
      {
        id: 'TICO',
        name: 'Tico',
        'cyrillic-name': 'Тико',
        class: 'A',
        'year-from': 1991,
        'year-to': 2001,
      },
      {
        id: 'TOSCA',
        name: 'Tosca',
        'cyrillic-name': 'Тоска',
        class: 'D',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'WINDSTORM',
        name: 'Winstorm',
        'cyrillic-name': 'Винсторм',
        class: 'D',
        'year-from': 2006,
        'year-to': 2011,
      },
    ],
  },
  {
    id: 'DAIHATSU',
    name: 'Daihatsu',
    'cyrillic-name': 'Дайхатсу',
    popular: false,
    country: 'Япония',
    models: [
      {
        id: 'ALTIS',
        name: 'Altis',
        'cyrillic-name': 'Алтис',
        class: 'E',
        'year-from': 2000,
        'year-to': 2021,
      },
      {
        id: 'APPLAUSE',
        name: 'Applause',
        'cyrillic-name': 'Апплаус',
        class: 'C',
        'year-from': 1989,
        'year-to': 2000,
      },
      {
        id: 'ATRAI',
        name: 'Atrai',
        'cyrillic-name': 'Атрай',
        class: 'M',
        'year-from': 1981,
        'year-to': null,
      },
      {
        id: 'BE_GO',
        name: 'Be-go',
        'cyrillic-name': 'Бе-го',
        class: 'B',
        'year-from': 2006,
        'year-to': 2016,
      },
      {
        id: 'BEE',
        name: 'Bee',
        'cyrillic-name': 'би',
        class: 'A',
        'year-from': 1951,
        'year-to': 1952,
      },
      {
        id: 'BOON',
        name: 'Boon',
        'cyrillic-name': 'Бун',
        class: 'B',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'BOON_LUMINAS',
        name: 'Boon Luminas',
        'cyrillic-name': 'Бун Луминас',
        class: 'M',
        'year-from': 2008,
        'year-to': 2012,
      },
      {
        id: 'CAST',
        name: 'Cast',
        'cyrillic-name': 'Каст',
        class: 'A',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'CERIA',
        name: 'Ceria',
        'cyrillic-name': 'Цериа',
        class: 'A',
        'year-from': 2001,
        'year-to': 2006,
      },
      {
        id: 'CHARADE',
        name: 'Charade',
        'cyrillic-name': 'Шарад',
        class: 'B',
        'year-from': 1977,
        'year-to': 2000,
      },
      {
        id: 'CHARMANT',
        name: 'Charmant',
        'cyrillic-name': 'Шармант',
        class: 'C',
        'year-from': 1981,
        'year-to': 1987,
      },
      {
        id: 'COO',
        name: 'Coo',
        'cyrillic-name': 'Ку',
        class: 'M',
        'year-from': 2006,
        'year-to': 2013,
      },
      {
        id: 'COPEN',
        name: 'Copen',
        'cyrillic-name': 'Копен',
        class: 'A',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'CUORE',
        name: 'Cuore',
        'cyrillic-name': 'Куоре',
        class: 'A',
        'year-from': 1980,
        'year-to': 2013,
      },
      {
        id: 'DELTA_WAGON',
        name: 'Delta Wagon',
        'cyrillic-name': 'дельта вагон',
        class: 'M',
        'year-from': 1986,
        'year-to': 2001,
      },
      {
        id: 'ESSE',
        name: 'Esse',
        'cyrillic-name': 'Эссе',
        class: 'A',
        'year-from': 2005,
        'year-to': 2011,
      },
      {
        id: 'EXTOL',
        name: 'Extol',
        'cyrillic-name': 'Экстол',
        class: 'M',
        'year-from': 1999,
        'year-to': 2004,
      },
      {
        id: 'FELLOW',
        name: 'Fellow',
        'cyrillic-name': 'феллов',
        class: 'A',
        'year-from': 1966,
        'year-to': 1976,
      },
      {
        id: 'FEROZA',
        name: 'Feroza',
        'cyrillic-name': 'Фероза',
        class: 'J',
        'year-from': 1989,
        'year-to': 1999,
      },
      {
        id: 'GRAN_MOVE',
        name: 'Gran Move',
        'cyrillic-name': 'Гран Мув',
        class: 'M',
        'year-from': 1996,
        'year-to': 2002,
      },
      {
        id: 'HIJET',
        name: 'Hijet',
        'cyrillic-name': 'Хайджет',
        class: 'M',
        'year-from': 1990,
        'year-to': null,
      },
      {
        id: 'HIJET_CADDIE',
        name: 'Hijet Caddie',
        'cyrillic-name': 'хайджет кадди',
        class: '',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'LEEZA',
        name: 'Leeza',
        'cyrillic-name': 'Лиза',
        class: 'A',
        'year-from': 1986,
        'year-to': 1993,
      },
      {
        id: 'MATERIA',
        name: 'Materia',
        'cyrillic-name': 'Материя',
        class: 'B',
        'year-from': 2006,
        'year-to': 2013,
      },
      {
        id: 'MAX',
        name: 'MAX',
        'cyrillic-name': 'МАКС',
        class: 'A',
        'year-from': 2000,
        'year-to': 2005,
      },
      {
        id: 'MEBIUS',
        name: 'Mebius',
        'cyrillic-name': 'Мебиус',
        class: 'M',
        'year-from': 2013,
        'year-to': 2021,
      },
      {
        id: 'MIDGET_II',
        name: 'Midget',
        'cyrillic-name': 'Миджет',
        class: 'M',
        'year-from': 1996,
        'year-to': 2002,
      },
      {
        id: 'MIRA',
        name: 'Mira',
        'cyrillic-name': 'Мира',
        class: 'A',
        'year-from': 1994,
        'year-to': 2018,
      },
      {
        id: 'MIRA_COCOA',
        name: 'Mira Cocoa',
        'cyrillic-name': 'Мира Кокоа',
        class: 'A',
        'year-from': 2009,
        'year-to': 2018,
      },
      {
        id: 'MIRA_E_S',
        name: 'Mira e:S',
        'cyrillic-name': 'Мира е:С',
        class: 'A',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'MIRA_GINO',
        name: 'Mira Gino',
        'cyrillic-name': 'мира джино',
        class: 'A',
        'year-from': 1999,
        'year-to': 2009,
      },
      {
        id: 'MOVE',
        name: 'Move',
        'cyrillic-name': 'Мув',
        class: 'M',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'MOVE_CANBUS',
        name: 'Move Canbus',
        'cyrillic-name': 'Мове Канбус',
        class: 'A',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'MOVE_CONTE',
        name: 'Move Conte',
        'cyrillic-name': 'Мове Конте',
        class: 'B',
        'year-from': 2008,
        'year-to': 2017,
      },
      {
        id: 'MOVE_LATTE',
        name: 'Move Latte',
        'cyrillic-name': 'мове латте',
        class: 'M',
        'year-from': 2004,
        'year-to': 2009,
      },
      {
        id: 'NAKED',
        name: 'Naked',
        'cyrillic-name': 'нейкед',
        class: 'M',
        'year-from': 2000,
        'year-to': 2004,
      },
      {
        id: 'OPTI',
        name: 'Opti',
        'cyrillic-name': 'Опти',
        class: 'A',
        'year-from': 1992,
        'year-to': 2002,
      },
      {
        id: 'PYZAR',
        name: 'Pyzar',
        'cyrillic-name': 'Пизар',
        class: 'M',
        'year-from': 1996,
        'year-to': 2002,
      },
      {
        id: 'ROCKY',
        name: 'Rocky',
        'cyrillic-name': 'Роки',
        class: 'J',
        'year-from': 1989,
        'year-to': 1998,
      },
      {
        id: 'RUGGER',
        name: 'Rugger',
        'cyrillic-name': 'Раггер',
        class: 'J',
        'year-from': 1984,
        'year-to': 2002,
      },
      {
        id: 'SIRION',
        name: 'Sirion',
        'cyrillic-name': 'Сирион',
        class: 'B',
        'year-from': 1998,
        'year-to': 2015,
      },
      {
        id: 'SONICA',
        name: 'Sonica',
        'cyrillic-name': 'Соника',
        class: 'A',
        'year-from': 2006,
        'year-to': 2009,
      },
      {
        id: 'STORIA',
        name: 'Storia',
        'cyrillic-name': 'Стория',
        class: 'B',
        'year-from': 1998,
        'year-to': 2004,
      },
      {
        id: 'TAFT',
        name: 'Taft',
        'cyrillic-name': 'Тафт',
        class: 'A',
        'year-from': 1974,
        'year-to': null,
      },
      {
        id: 'TANTO',
        name: 'Tanto',
        'cyrillic-name': 'Танто',
        class: 'A',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'TANTO_EXE',
        name: 'Tanto Exe',
        'cyrillic-name': 'Танто Экзе',
        class: 'A',
        'year-from': 2009,
        'year-to': 2014,
      },
      {
        id: 'TERIOS',
        name: 'Terios',
        'cyrillic-name': 'Териос',
        class: 'B',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'THOR',
        name: 'Thor',
        'cyrillic-name': 'Тор',
        class: 'M',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'TREVIS',
        name: 'Trevis',
        'cyrillic-name': 'Тревис',
        class: 'A',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'WAKE',
        name: 'Wake',
        'cyrillic-name': 'Вэйк',
        class: 'M',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'WILDCAT',
        name: 'Wildcat',
        'cyrillic-name': 'Вайлдкет',
        class: 'J',
        'year-from': 1985,
        'year-to': 1987,
      },
      {
        id: 'XENIA',
        name: 'Xenia',
        'cyrillic-name': 'Ксения',
        class: 'M',
        'year-from': 2003,
        'year-to': 2011,
      },
      {
        id: 'YRV',
        name: 'YRV',
        'cyrillic-name': 'ЮРВ',
        class: 'M',
        'year-from': 2000,
        'year-to': 2005,
      },
    ],
  },
  {
    id: 'DAIMLER',
    name: 'Daimler',
    'cyrillic-name': 'Даймлер',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'DS_420',
        name: 'DS420',
        'cyrillic-name': 'дс420',
        class: 'F',
        'year-from': 1968,
        'year-to': 1992,
      },
      {
        id: 'SOVEREIGN',
        name: 'Sovereign (XJ6)',
        'cyrillic-name': 'соврин (хж6)',
        class: 'F',
        'year-from': 1969,
        'year-to': 1993,
      },
      {
        id: 'SP250',
        name: 'SP250',
        'cyrillic-name': 'сп250',
        class: 'S',
        'year-from': 1959,
        'year-to': 1964,
      },
      {
        id: 'X_300',
        name: 'X300',
        'cyrillic-name': 'х300',
        class: 'F',
        'year-from': 1993,
        'year-to': 1997,
      },
      {
        id: 'X_308',
        name: 'X308',
        'cyrillic-name': 'х308',
        class: 'F',
        'year-from': 1997,
        'year-to': 2003,
      },
      {
        id: 'X_350',
        name: 'X350',
        'cyrillic-name': 'х350',
        class: 'F',
        'year-from': 2005,
        'year-to': 2009,
      },
      {
        id: 'XJ40',
        name: 'XJ40',
        'cyrillic-name': 'хж40',
        class: 'F',
        'year-from': 1986,
        'year-to': 1994,
      },
      {
        id: 'XJS',
        name: 'XJS',
        'cyrillic-name': 'хжс',
        class: 'S',
        'year-from': 1973,
        'year-to': 1977,
      },
    ],
  },
  {
    id: 'DALLARA',
    name: 'Dallara',
    'cyrillic-name': 'Даллара',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'STRADALE',
        name: 'Stradale',
        'cyrillic-name': 'Страдале',
        class: 'S',
        'year-from': 2017,
        'year-to': null,
      },
    ],
  },
  {
    id: 'DATSUN',
    name: 'Datsun',
    'cyrillic-name': 'Датсун',
    popular: false,
    country: 'Япония',
    models: [
      {
        id: '240Z',
        name: '240Z',
        'cyrillic-name': '240з',
        class: 'S',
        'year-from': 1970,
        'year-to': 1973,
      },
      {
        id: '280Z',
        name: '280Z',
        'cyrillic-name': '280з',
        class: 'S',
        'year-from': 1975,
        'year-to': 1979,
      },
      {
        id: '280ZX',
        name: '280ZX',
        'cyrillic-name': '280зх',
        class: 'S',
        'year-from': 1978,
        'year-to': 1983,
      },
      {
        id: '720',
        name: '720',
        'cyrillic-name': '720',
        class: 'J',
        'year-from': 1980,
        'year-to': 1986,
      },
      {
        id: 'BLUEBIRD',
        name: 'Bluebird',
        'cyrillic-name': 'Блюбёрд',
        class: 'D',
        'year-from': 1976,
        'year-to': 1981,
      },
      {
        id: 'CHERRY',
        name: 'Cherry',
        'cyrillic-name': 'Черри',
        class: 'C',
        'year-from': 1970,
        'year-to': 1978,
      },
      {
        id: 'GO',
        name: 'GO',
        'cyrillic-name': 'Го',
        class: 'B',
        'year-from': 2014,
        'year-to': 2020,
      },
      {
        id: 'GO_PLUS',
        name: 'GO+',
        'cyrillic-name': 'Го+',
        class: 'M',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'LAUREL',
        name: 'Laurel',
        'cyrillic-name': 'Лаурель',
        class: 'E',
        'year-from': 1977,
        'year-to': 1984,
      },
      {
        id: 'MI_DO',
        name: 'mi-DO',
        'cyrillic-name': 'ми-ДО',
        class: 'B',
        'year-from': 2015,
        'year-to': 2020,
      },
      {
        id: 'ON_DO',
        name: 'on-DO',
        'cyrillic-name': 'он-ДО',
        class: 'B',
        'year-from': 2014,
        'year-to': 2020,
      },
      {
        id: 'STANZA',
        name: 'Stanza',
        'cyrillic-name': 'Станза',
        class: 'C',
        'year-from': 1977,
        'year-to': 1986,
      },
      {
        id: 'SUNNY',
        name: 'Sunny',
        'cyrillic-name': 'Санни',
        class: 'C',
        'year-from': 1973,
        'year-to': 1983,
      },
      {
        id: 'URVAN',
        name: 'Urvan',
        'cyrillic-name': 'урван',
        class: 'M',
        'year-from': 1982,
        'year-to': 1988,
      },
      {
        id: 'VIOLET',
        name: 'Violet',
        'cyrillic-name': 'Виолет',
        class: 'C',
        'year-from': 1973,
        'year-to': 1979,
      },
    ],
  },
  {
    id: 'DECO_RIDES',
    name: 'Deco Rides',
    'cyrillic-name': 'Деко Райдс',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'ZEPHYR',
        name: 'Zephyr',
        'cyrillic-name': 'Зефир',
        class: 'S',
        'year-from': 1999,
        'year-to': null,
      },
    ],
  },
  {
    id: 'DELAGE',
    name: 'Delage',
    'cyrillic-name': 'Делаж',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'D12',
        name: 'D12',
        'cyrillic-name': 'Д12',
        class: 'S',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'D6',
        name: 'D6',
        'cyrillic-name': 'Д6',
        class: 'F',
        'year-from': 1930,
        'year-to': 1940,
      },
    ],
  },
  {
    id: 'DELOREAN',
    name: 'DeLorean',
    'cyrillic-name': 'ДеЛориан',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'DMC_12',
        name: 'DMC-12',
        'cyrillic-name': 'дмс-12',
        class: 'S',
        'year-from': 1981,
        'year-to': 1982,
      },
    ],
  },
  {
    id: 'DENZA',
    name: 'Denza',
    'cyrillic-name': 'Денза',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'X',
        name: 'X',
        'cyrillic-name': 'Икс',
        class: 'E',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'DERWAYS',
    name: 'Derways',
    'cyrillic-name': 'Дервейс',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'ANTELOPE',
        name: 'Antelope',
        'cyrillic-name': 'Антилопа',
        class: 'J',
        'year-from': 2007,
        'year-to': 2007,
      },
      {
        id: 'AURORA',
        name: 'Aurora',
        'cyrillic-name': 'Аврора',
        class: 'J',
        'year-from': 2006,
        'year-to': 2008,
      },
      {
        id: 'COWBOY',
        name: 'Cowboy',
        'cyrillic-name': 'Ковбой',
        class: 'J',
        'year-from': 2004,
        'year-to': 2006,
      },
      {
        id: 'LAND_CROWN',
        name: 'Land Crown',
        'cyrillic-name': 'Ленд Краун',
        class: 'J',
        'year-from': 2006,
        'year-to': 2007,
      },
      {
        id: 'PLUTUS',
        name: 'Plutus',
        'cyrillic-name': 'Плутус',
        class: 'J',
        'year-from': 2007,
        'year-to': 2008,
      },
      {
        id: 'SALADIN',
        name: 'Saladin',
        'cyrillic-name': 'Саладин',
        class: 'J',
        'year-from': 2006,
        'year-to': 2008,
      },
      {
        id: 'SHUTTLE',
        name: 'Shuttle',
        'cyrillic-name': 'Шатл',
        class: 'J',
        'year-from': 2005,
        'year-to': 2008,
      },
    ],
  },
  {
    id: 'DESOTO',
    name: 'DeSoto',
    'cyrillic-name': 'Десото',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'CUSTOM',
        name: 'Custom',
        'cyrillic-name': 'кастом',
        class: 'F',
        'year-from': 1949,
        'year-to': 1952,
      },
      {
        id: 'FIREDOME',
        name: 'Firedome',
        'cyrillic-name': 'Файрдом',
        class: '',
        'year-from': 1952,
        'year-to': 1959,
      },
      {
        id: 'FIREFLITE',
        name: 'Fireflite',
        'cyrillic-name': 'Файрфлит',
        class: 'F',
        'year-from': 1955,
        'year-to': 1960,
      },
    ],
  },
  {
    id: 'DE_TOMASO',
    name: 'De Tomaso',
    'cyrillic-name': 'Де Томазо',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'BIGUA',
        name: 'Bigua',
        'cyrillic-name': 'бигуа',
        class: 'S',
        'year-from': 2000,
        'year-to': 2002,
      },
      {
        id: 'GUARA',
        name: 'Guara',
        'cyrillic-name': 'Гуара',
        class: 'S',
        'year-from': 1993,
        'year-to': 2001,
      },
      {
        id: 'LONGCHAMP',
        name: 'Longchamp',
        'cyrillic-name': 'Лоншан',
        class: 'S',
        'year-from': 1972,
        'year-to': 1989,
      },
      {
        id: 'MANGUSTA',
        name: 'Mangusta',
        'cyrillic-name': 'Мангуста',
        class: 'S',
        'year-from': 1967,
        'year-to': 2001,
      },
      {
        id: 'PANTERA',
        name: 'Pantera',
        'cyrillic-name': 'Пантера',
        class: 'S',
        'year-from': 1970,
        'year-to': 1991,
      },
      {
        id: 'VALLELUNGA',
        name: 'Vallelunga',
        'cyrillic-name': 'Валлелунга',
        class: 'S',
        'year-from': 1964,
        'year-to': 1968,
      },
    ],
  },
  {
    id: 'DKW',
    name: 'DKW',
    'cyrillic-name': 'ДКВ',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: '3_6',
        name: '3=6',
        'cyrillic-name': '3=6',
        class: 'C',
        'year-from': 1953,
        'year-to': 1955,
      },
    ],
  },
  {
    id: 'DODGE',
    name: 'Dodge',
    'cyrillic-name': 'Додж',
    popular: false,
    country: 'США',
    models: [
      {
        id: '600',
        name: '600',
        'cyrillic-name': '600',
        class: 'D',
        'year-from': 1983,
        'year-to': 1988,
      },
      {
        id: 'ARIES',
        name: 'Aries',
        'cyrillic-name': 'Ариес',
        class: 'D',
        'year-from': 1981,
        'year-to': 1989,
      },
      {
        id: 'AVENGER',
        name: 'Avenger',
        'cyrillic-name': 'Авенджер',
        class: 'E',
        'year-from': 1994,
        'year-to': 2014,
      },
      {
        id: 'CALIBER',
        name: 'Caliber',
        'cyrillic-name': 'Калибр',
        class: 'D',
        'year-from': 2006,
        'year-to': 2013,
      },
      {
        id: 'CARAVAN',
        name: 'Caravan',
        'cyrillic-name': 'Караван',
        class: 'M',
        'year-from': 1984,
        'year-to': 2020,
      },
      {
        id: 'CHALLENGER',
        name: 'Challenger',
        'cyrillic-name': 'Челленджер',
        class: 'D',
        'year-from': 1969,
        'year-to': null,
      },
      {
        id: 'CHARGER',
        name: 'Charger',
        'cyrillic-name': 'Чарджер',
        class: 'F',
        'year-from': 1968,
        'year-to': null,
      },
      {
        id: 'CHARGER_DAYTONA',
        name: 'Charger Daytona',
        'cyrillic-name': 'Чарджер Дайтона',
        class: 'S',
        'year-from': 1969,
        'year-to': 1970,
      },
      {
        id: 'COLT',
        name: 'Colt',
        'cyrillic-name': 'Кольт',
        class: 'C',
        'year-from': 1992,
        'year-to': 1994,
      },
      {
        id: 'CUSTOM_ROYAL',
        name: 'Custom Royal',
        'cyrillic-name': 'Кастом Роял',
        class: 'E',
        'year-from': 1955,
        'year-to': 1959,
      },
      {
        id: 'DW_SERIES',
        name: 'D/W Series',
        'cyrillic-name': 'д/в серия',
        class: 'J',
        'year-from': 1972,
        'year-to': 1980,
      },
      {
        id: 'D8',
        name: 'D8',
        'cyrillic-name': 'Д8',
        class: '',
        'year-from': 1937,
        'year-to': 1938,
      },
      {
        id: 'DAKOTA',
        name: 'Dakota',
        'cyrillic-name': 'Дакота',
        class: 'J',
        'year-from': 1987,
        'year-to': 2011,
      },
      {
        id: 'DART',
        name: 'Dart',
        'cyrillic-name': 'дарт',
        class: 'C',
        'year-from': 1967,
        'year-to': 2016,
      },
      {
        id: 'DAYTONA',
        name: 'Daytona',
        'cyrillic-name': 'Дайтона',
        class: 'C',
        'year-from': 1984,
        'year-to': 1993,
      },
      {
        id: 'DIPLOMAT',
        name: 'Diplomat',
        'cyrillic-name': 'Дипломат',
        class: 'E',
        'year-from': 1977,
        'year-to': 1989,
      },
      {
        id: 'DURANGO',
        name: 'Durango',
        'cyrillic-name': 'Дуранго',
        class: 'E',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'DYNASTY',
        name: 'Dynasty',
        'cyrillic-name': 'династия',
        class: 'D',
        'year-from': 1987,
        'year-to': 1993,
      },
      {
        id: 'HORNET',
        name: 'Hornet',
        'cyrillic-name': 'Хорнет',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'INTREPID',
        name: 'Intrepid',
        'cyrillic-name': 'Интерпид',
        class: 'F',
        'year-from': 1992,
        'year-to': 2004,
      },
      {
        id: 'JOURNEY',
        name: 'Journey',
        'cyrillic-name': 'Джорней',
        class: 'E',
        'year-from': 2007,
        'year-to': 2020,
      },
      {
        id: 'LANCER',
        name: 'Lancer',
        'cyrillic-name': 'Лансер',
        class: 'D',
        'year-from': 1985,
        'year-to': 1989,
      },
      {
        id: 'MAGNUM',
        name: 'Magnum',
        'cyrillic-name': 'Магнум',
        class: 'F',
        'year-from': 1977,
        'year-to': 2008,
      },
      {
        id: 'MAYFAIR',
        name: 'Mayfair',
        'cyrillic-name': 'майфер',
        class: 'D',
        'year-from': 1953,
        'year-to': 1959,
      },
      {
        id: 'MONACO',
        name: 'Monaco',
        'cyrillic-name': 'Монако',
        class: 'E',
        'year-from': 1990,
        'year-to': 1993,
      },
      {
        id: 'NEON',
        name: 'Neon',
        'cyrillic-name': 'Неон',
        class: 'C',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'NITRO',
        name: 'Nitro',
        'cyrillic-name': 'Нитро',
        class: 'D',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'OMNI',
        name: 'Omni',
        'cyrillic-name': 'Омни',
        class: 'B',
        'year-from': 1978,
        'year-to': 1990,
      },
      {
        id: 'POLARA',
        name: 'Polara',
        'cyrillic-name': 'Полара',
        class: 'E',
        'year-from': 1965,
        'year-to': 1973,
      },
      {
        id: 'RAIDER',
        name: 'Raider',
        'cyrillic-name': 'райдер',
        class: 'J',
        'year-from': 1987,
        'year-to': 1989,
      },
      {
        id: 'RAM',
        name: 'RAM',
        'cyrillic-name': 'РАМ',
        class: 'J',
        'year-from': 1980,
        'year-to': null,
      },
      {
        id: 'RAM_VAN',
        name: 'RAM Van',
        'cyrillic-name': 'РАМ Ван',
        class: 'M',
        'year-from': 1979,
        'year-to': 2003,
      },
      {
        id: 'RAMCHARGER',
        name: 'Ramcharger',
        'cyrillic-name': 'Рамчарджер',
        class: 'J',
        'year-from': 1974,
        'year-to': 2001,
      },
      {
        id: 'SHADOW',
        name: 'Shadow',
        'cyrillic-name': 'Шадоу',
        class: 'C',
        'year-from': 1986,
        'year-to': 1994,
      },
      {
        id: 'SPIRIT',
        name: 'Spirit',
        'cyrillic-name': 'Спирит',
        class: 'D',
        'year-from': 1988,
        'year-to': 1995,
      },
      {
        id: 'STEALTH',
        name: 'Stealth',
        'cyrillic-name': 'Стелс',
        class: 'S',
        'year-from': 1990,
        'year-to': 1996,
      },
      {
        id: 'STRATUS',
        name: 'Stratus',
        'cyrillic-name': 'Стратус',
        class: 'E',
        'year-from': 1995,
        'year-to': 2006,
      },
      {
        id: 'SUPER_BEE',
        name: 'Super Bee',
        'cyrillic-name': 'Супер Би',
        class: 'S',
        'year-from': 1968,
        'year-to': 1970,
      },
      {
        id: 'VIPER',
        name: 'Viper',
        'cyrillic-name': 'Вайпер',
        class: 'S',
        'year-from': 1992,
        'year-to': 2017,
      },
      {
        id: 'WC',
        name: 'WC series',
        'cyrillic-name': 'вс',
        class: 'J',
        'year-from': 1941,
        'year-to': 1945,
      },
    ],
  },
  {
    id: 'DONGFENG',
    name: 'DongFeng',
    'cyrillic-name': 'ДонгФенг',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: '370',
        name: '370',
        'cyrillic-name': '370',
        class: 'C',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: '580',
        name: '580',
        'cyrillic-name': '580',
        class: 'D',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'A30',
        name: 'A30',
        'cyrillic-name': 'А30',
        class: 'C',
        'year-from': 2014,
        'year-to': 2019,
      },
      {
        id: 'A9',
        name: 'A9',
        'cyrillic-name': 'а9',
        class: 'E',
        'year-from': 2016,
        'year-to': 2019,
      },
      {
        id: 'YIXUAN_GS',
        name: 'Aeolus Yixuan GS',
        'cyrillic-name': 'Исюань ГС',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'AX4',
        name: 'AX4',
        'cyrillic-name': 'АХ4',
        class: 'B',
        'year-from': 2017,
        'year-to': 2021,
      },
      {
        id: 'AX7',
        name: 'AX7',
        'cyrillic-name': 'АХ7',
        class: 'D',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'DF6',
        name: 'DF6',
        'cyrillic-name': 'дф6',
        class: 'J',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'E11K',
        name: 'E11K',
        'cyrillic-name': 'Е11К',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'H30_CROSS',
        name: 'H30 Cross',
        'cyrillic-name': 'Н30 Кросс',
        class: 'B',
        'year-from': 2011,
        'year-to': 2018,
      },
      {
        id: 'IX5',
        name: 'iX5',
        'cyrillic-name': 'АйИкс5',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'MPV',
        name: 'MPV',
        'cyrillic-name': 'мпв',
        class: 'M',
        'year-from': 2007,
        'year-to': 2009,
      },
      {
        id: 'OTING',
        name: 'Oting',
        'cyrillic-name': 'Отинг',
        class: 'J',
        'year-from': 2007,
        'year-to': 2013,
      },
      {
        id: 'RICH',
        name: 'Rich',
        'cyrillic-name': 'Рич',
        class: 'J',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'S30',
        name: 'S30',
        'cyrillic-name': 'С30',
        class: 'C',
        'year-from': 2013,
        'year-to': 2017,
      },
      {
        id: 'T5L',
        name: 'T5L',
        'cyrillic-name': 'Т5Л',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'DONINVEST',
    name: 'Doninvest',
    'cyrillic-name': 'Донинвест',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'ASSOL',
        name: 'Assol',
        'cyrillic-name': 'Ассоль',
        class: 'B',
        'year-from': 1998,
        'year-to': 2002,
      },
      {
        id: 'KONDOR',
        name: 'Kondor',
        'cyrillic-name': 'Кондор',
        class: 'D',
        'year-from': 1998,
        'year-to': 2002,
      },
      {
        id: 'ORION',
        name: 'Orion',
        'cyrillic-name': 'Орион',
        class: 'C',
        'year-from': 1998,
        'year-to': 2002,
      },
    ],
  },
  {
    id: 'DONKERVOORT',
    name: 'Donkervoort',
    'cyrillic-name': 'Донкервурт',
    popular: false,
    country: 'Нидерланды',
    models: [
      {
        id: 'D8',
        name: 'D8',
        'cyrillic-name': 'д8',
        class: 'S',
        'year-from': 2001,
        'year-to': 2007,
      },
      {
        id: 'D8_COSWORTH',
        name: 'D8 Cosworth',
        'cyrillic-name': 'д8 косворт',
        class: 'S',
        'year-from': 1994,
        'year-to': 1998,
      },
      {
        id: 'D8_GT',
        name: 'D8 GT',
        'cyrillic-name': 'Д8 ГТ',
        class: 'S',
        'year-from': 2007,
        'year-to': 2012,
      },
      {
        id: 'D8_GTO',
        name: 'D8 GTO',
        'cyrillic-name': 'д8 гто',
        class: 'S',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'D8_ZETEC',
        name: 'D8 Zetec',
        'cyrillic-name': 'д8 зетек',
        class: 'S',
        'year-from': 1993,
        'year-to': 1998,
      },
    ],
  },
  {
    id: 'DS',
    name: 'DS',
    'cyrillic-name': 'ДС',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: '3',
        name: '3',
        'cyrillic-name': '3',
        class: 'B',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: '3_CROSSBACK',
        name: '3 Crossback',
        'cyrillic-name': '3 Кроссбэк',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: '4',
        name: '4',
        'cyrillic-name': '4',
        class: 'C',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: '5',
        name: '5',
        'cyrillic-name': '5',
        class: 'D',
        'year-from': 2015,
        'year-to': 2018,
      },
      {
        id: '7_CROSSBACK',
        name: '7 Crossback',
        'cyrillic-name': '7 Кроссбэк',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: '9',
        name: '9',
        'cyrillic-name': '9',
        class: 'E',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'DW_HOWER',
    name: 'DW Hower',
    'cyrillic-name': 'ДВ Ховер',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'H3',
        name: 'H3',
        'cyrillic-name': 'Х3',
        class: 'J',
        'year-from': 2017,
        'year-to': 2019,
      },
      {
        id: 'H5',
        name: 'H5',
        'cyrillic-name': 'н5',
        class: 'J',
        'year-from': 2017,
        'year-to': 2019,
      },
    ],
  },
  {
    id: 'EAGLE',
    name: 'Eagle',
    'cyrillic-name': 'Игл',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'PREMIER',
        name: 'Premier',
        'cyrillic-name': 'Премьер',
        class: 'E',
        'year-from': 1987,
        'year-to': 1992,
      },
      {
        id: 'SUMMIT',
        name: 'Summit',
        'cyrillic-name': 'Саммит',
        class: 'C',
        'year-from': 1989,
        'year-to': 1996,
      },
      {
        id: 'TALON',
        name: 'Talon',
        'cyrillic-name': 'Тэлон',
        class: 'S',
        'year-from': 1989,
        'year-to': 1999,
      },
      {
        id: 'VISION',
        name: 'Vision',
        'cyrillic-name': 'Вижн',
        class: 'F',
        'year-from': 1992,
        'year-to': 1997,
      },
      {
        id: 'VISTA',
        name: 'Vista',
        'cyrillic-name': 'Виста',
        class: 'M',
        'year-from': 1988,
        'year-to': 1992,
      },
    ],
  },
  {
    id: 'EAGLE_CARS',
    name: 'Eagle Cars',
    'cyrillic-name': 'Игл Карс',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'SS',
        name: 'SS',
        'cyrillic-name': 'СС',
        class: 'S',
        'year-from': 1982,
        'year-to': 1998,
      },
    ],
  },
  {
    id: 'EVERUS',
    name: 'Everus',
    'cyrillic-name': 'Эверус',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'VE_1',
        name: 'VE-1',
        'cyrillic-name': 'ВЕ-1',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'EVOLUTE',
    name: 'Evolute',
    'cyrillic-name': 'Эволют',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'I_JET',
        name: 'i-JET',
        'cyrillic-name': 'ай-ДЖЕТ',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'I_JOY',
        name: 'i-JOY',
        'cyrillic-name': 'ай-ДЖОЙ',
        class: 'B',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'I_PRO',
        name: 'i-PRO',
        'cyrillic-name': 'ай-ПРО',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'I_VAN',
        name: 'i-VAN',
        'cyrillic-name': 'ай-ВЭН',
        class: 'M',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'EXCALIBUR',
    name: 'Excalibur',
    'cyrillic-name': 'Экскалибур',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'SERIES_IV',
        name: 'Series IV',
        'cyrillic-name': 'серия 4',
        class: 'S',
        'year-from': 1980,
        'year-to': 1985,
      },
      {
        id: 'SERIES_V',
        name: 'Series V',
        'cyrillic-name': 'серия 5',
        class: 'S',
        'year-from': 1985,
        'year-to': 1997,
      },
    ],
  },
  {
    id: 'E_CAR',
    name: 'E-Car',
    'cyrillic-name': 'Е-Кар',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'GD04B',
        name: 'GD04B',
        'cyrillic-name': 'гд04б',
        class: 'A',
        'year-from': 2012,
        'year-to': 2014,
      },
    ],
  },
  {
    id: 'E_MOBIL',
    name: 'Ё-мобиль',
    'cyrillic-name': 'Ё-мобиль',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'E_CROSSOVER',
        name: 'Ё-Кроссовер',
        'cyrillic-name': 'Ё-Кроссовер',
        class: 'B',
        'year-from': 2013,
        'year-to': 2013,
      },
    ],
  },
  {
    id: 'FACEL_VEGA',
    name: 'Facel Vega',
    'cyrillic-name': 'Фэйсл Вега',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'FV',
        name: 'FV',
        'cyrillic-name': 'ФВ',
        class: '',
        'year-from': 1954,
        'year-to': 1958,
      },
    ],
  },
  {
    id: 'FAW',
    name: 'FAW',
    'cyrillic-name': 'ФАВ',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'BESTUNE_B70',
        name: 'Bestune B70',
        'cyrillic-name': 'Бестюн Б70',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'BESTUNE_B70S',
        name: 'Bestune B70S',
        'cyrillic-name': 'Бестюн Б70С',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'BESTUNE_NAT',
        name: 'Bestune NAT',
        'cyrillic-name': 'Бестюн НАТ',
        class: 'M',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'BESTUNE_T55',
        name: 'Bestune T55',
        'cyrillic-name': 'Бестюн Т55',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'BESTUNE_T77',
        name: 'Bestune T77',
        'cyrillic-name': 'Бестюн Т77',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'BESTUNE_T99',
        name: 'Bestune T99',
        'cyrillic-name': 'Бестюн Т99',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'BESTURN_B30',
        name: 'Besturn B30',
        'cyrillic-name': 'Бестёрн Б30',
        class: 'C',
        'year-from': 2015,
        'year-to': 2020,
      },
      {
        id: 'BESTURN_B50',
        name: 'Besturn B50',
        'cyrillic-name': 'Бестёрн Б50',
        class: 'C',
        'year-from': 2009,
        'year-to': 2016,
      },
      {
        id: 'BESTURN_B70',
        name: 'Besturn B70',
        'cyrillic-name': 'Бестёрн Б70',
        class: 'D',
        'year-from': 2006,
        'year-to': 2018,
      },
      {
        id: 'BESTURN_X40',
        name: 'Besturn X40',
        'cyrillic-name': 'Бестурн Х40',
        class: 'B',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'X80',
        name: 'Besturn X80',
        'cyrillic-name': 'Бестёрн Икс80',
        class: 'C',
        'year-from': 2013,
        'year-to': 2022,
      },
      {
        id: 'D60',
        name: 'D60',
        'cyrillic-name': 'Д60',
        class: 'B',
        'year-from': 2014,
        'year-to': 2017,
      },
      {
        id: 'JINN',
        name: 'Jinn',
        'cyrillic-name': 'Джин',
        class: 'A',
        'year-from': 2005,
        'year-to': 2009,
      },
      {
        id: 'OLEY',
        name: 'Oley',
        'cyrillic-name': 'Оли',
        class: 'B',
        'year-from': 2012,
        'year-to': 2015,
      },
      {
        id: 'V2',
        name: 'V2',
        'cyrillic-name': 'в2',
        class: 'B',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'V5',
        name: 'V5',
        'cyrillic-name': 'в5',
        class: 'B',
        'year-from': 2012,
        'year-to': 2017,
      },
      {
        id: 'VITA',
        name: 'Vita',
        'cyrillic-name': 'вита',
        class: 'B',
        'year-from': 2007,
        'year-to': 2010,
      },
    ],
  },
  {
    id: 'FERRARI',
    name: 'Ferrari',
    'cyrillic-name': 'Феррари',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: '250_GTO',
        name: '250 GTO',
        'cyrillic-name': '250 гто',
        class: 'S',
        'year-from': 1962,
        'year-to': 1964,
      },
      {
        id: '296_GTB',
        name: '296',
        'cyrillic-name': '296',
        class: 'S',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: '328',
        name: '328',
        'cyrillic-name': '328',
        class: 'S',
        'year-from': 1985,
        'year-to': 1989,
      },
      {
        id: '348',
        name: '348',
        'cyrillic-name': '348',
        class: 'S',
        'year-from': 1989,
        'year-to': 1995,
      },
      {
        id: '360_MODENA',
        name: '360',
        'cyrillic-name': '360',
        class: 'S',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: '400',
        name: '400',
        'cyrillic-name': '400',
        class: 'S',
        'year-from': 1976,
        'year-to': 1985,
      },
      {
        id: '412',
        name: '412',
        'cyrillic-name': '412',
        class: 'S',
        'year-from': 1985,
        'year-to': 1988,
      },
      {
        id: '456',
        name: '456',
        'cyrillic-name': '456',
        class: 'S',
        'year-from': 1992,
        'year-to': 2003,
      },
      {
        id: '458_ITALIA',
        name: '458',
        'cyrillic-name': '458',
        class: 'S',
        'year-from': 2009,
        'year-to': 2015,
      },
      {
        id: '488',
        name: '488',
        'cyrillic-name': '488',
        class: 'S',
        'year-from': 2018,
        'year-to': 2019,
      },
      {
        id: '512_BB',
        name: '512 BB',
        'cyrillic-name': '512 бб',
        class: 'S',
        'year-from': 1976,
        'year-to': 1984,
      },
      {
        id: '512M',
        name: '512 M',
        'cyrillic-name': '512 М',
        class: 'S',
        'year-from': 1994,
        'year-to': 1996,
      },
      {
        id: '512_TR',
        name: '512 TR',
        'cyrillic-name': '512 тр',
        class: 'S',
        'year-from': 1991,
        'year-to': 1994,
      },
      {
        id: '550',
        name: '550',
        'cyrillic-name': '550',
        class: 'S',
        'year-from': 1996,
        'year-to': 2001,
      },
      {
        id: '575_MARANELLO',
        name: '575M',
        'cyrillic-name': '575М',
        class: 'S',
        'year-from': 2002,
        'year-to': 2006,
      },
      {
        id: '599',
        name: '599',
        'cyrillic-name': '599',
        class: 'S',
        'year-from': 2006,
        'year-to': 2012,
      },
      {
        id: '612_SCAGLIETTI',
        name: '612',
        'cyrillic-name': '612',
        class: 'F',
        'year-from': 2004,
        'year-to': 2011,
      },
      {
        id: '812_SUPERFAST',
        name: '812',
        'cyrillic-name': '812',
        class: 'S',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'CALIFORNIA',
        name: 'California',
        'cyrillic-name': 'калифорния',
        class: 'S',
        'year-from': 2008,
        'year-to': 2017,
      },
      {
        id: 'DAYTONA_SP3',
        name: 'Daytona SP3',
        'cyrillic-name': 'Дайтона СП3',
        class: 'S',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'DINO_206_GT',
        name: 'Dino 206 GT',
        'cyrillic-name': 'Дино 206 ГТ',
        class: 'S',
        'year-from': 1967,
        'year-to': 1969,
      },
      {
        id: '208_308',
        name: 'Dino 208/308 GT4',
        'cyrillic-name': 'дино 208/308 гт4',
        class: 'S',
        'year-from': 1974,
        'year-to': 1989,
      },
      {
        id: 'DINO_246_GT',
        name: 'Dino 246 GT',
        'cyrillic-name': 'Дино 246 ГТ',
        class: 'S',
        'year-from': 1969,
        'year-to': 1974,
      },
      {
        id: 'ENZO',
        name: 'Enzo',
        'cyrillic-name': 'Энцо',
        class: 'S',
        'year-from': 2002,
        'year-to': 2004,
      },
      {
        id: 'F12BERLINETTA',
        name: 'F12berlinetta',
        'cyrillic-name': 'Ф12берлинетта',
        class: 'S',
        'year-from': 2012,
        'year-to': 2017,
      },
      {
        id: 'F355',
        name: 'F355',
        'cyrillic-name': 'ф355',
        class: 'S',
        'year-from': 1994,
        'year-to': 1999,
      },
      {
        id: 'F40',
        name: 'F40',
        'cyrillic-name': 'ф40',
        class: 'S',
        'year-from': 1987,
        'year-to': 1992,
      },
      {
        id: 'F430',
        name: 'F430',
        'cyrillic-name': 'ф430',
        class: 'S',
        'year-from': 2004,
        'year-to': 2009,
      },
      {
        id: 'F50',
        name: 'F50',
        'cyrillic-name': 'ф50',
        class: 'S',
        'year-from': 1995,
        'year-to': 1997,
      },
      {
        id: 'F8_TRIBUTO',
        name: 'F8',
        'cyrillic-name': 'Ф8',
        class: 'S',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'FF',
        name: 'FF',
        'cyrillic-name': 'фф',
        class: 'S',
        'year-from': 2011,
        'year-to': 2016,
      },
      {
        id: 'FXX_K',
        name: 'FXX K',
        'cyrillic-name': 'фхх к',
        class: 'S',
        'year-from': 2015,
        'year-to': 2017,
      },
      {
        id: 'GTC4LUSSO',
        name: 'GTC4Lusso',
        'cyrillic-name': 'гтц4люссо',
        class: 'S',
        'year-from': 2016,
        'year-to': 2020,
      },
      {
        id: 'LAFERRARI',
        name: 'LaFerrari',
        'cyrillic-name': 'ЛаФеррари',
        class: 'S',
        'year-from': 2013,
        'year-to': 2017,
      },
      {
        id: 'MONDIAL',
        name: 'Mondial',
        'cyrillic-name': 'Мондиаль',
        class: 'S',
        'year-from': 1980,
        'year-to': 1993,
      },
      {
        id: 'MONZA_SP',
        name: 'Monza SP',
        'cyrillic-name': 'Монза СП',
        class: 'S',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'PORTOFINO',
        name: 'Portofino',
        'cyrillic-name': 'Портофино',
        class: 'S',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'PUROSANGUE',
        name: 'Purosangue',
        'cyrillic-name': 'Пуросанг',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'ROMA',
        name: 'Roma',
        'cyrillic-name': 'Рома',
        class: 'S',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'SF90_STRADALE',
        name: 'SF90 Stradale',
        'cyrillic-name': 'СФ90 Штрадале',
        class: 'S',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'TESTAROSSA',
        name: 'Testarossa',
        'cyrillic-name': 'Теста Росса',
        class: 'S',
        'year-from': 1984,
        'year-to': 1991,
      },
    ],
  },
  {
    id: 'FIAT',
    name: 'Fiat',
    'cyrillic-name': 'Фиат',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: '124',
        name: '124',
        'cyrillic-name': '124',
        class: 'C',
        'year-from': 1966,
        'year-to': 1976,
      },
      {
        id: '124_SPIDER',
        name: '124 Spider',
        'cyrillic-name': '124 спайдер',
        class: 'S',
        'year-from': 2016,
        'year-to': 2020,
      },
      {
        id: '124_SPORT_SPIDER',
        name: '124 Sport Spider',
        'cyrillic-name': '124 Спорт Спайдер',
        class: 'S',
        'year-from': 1966,
        'year-to': 1985,
      },
      {
        id: '125',
        name: '125',
        'cyrillic-name': '125',
        class: 'B',
        'year-from': 1967,
        'year-to': 1982,
      },
      {
        id: '126',
        name: '126',
        'cyrillic-name': '126',
        class: 'A',
        'year-from': 1972,
        'year-to': 1996,
      },
      {
        id: '127',
        name: '127',
        'cyrillic-name': '127',
        class: 'B',
        'year-from': 1971,
        'year-to': 1987,
      },
      {
        id: '128',
        name: '128',
        'cyrillic-name': '128',
        class: 'B',
        'year-from': 1969,
        'year-to': 1985,
      },
      {
        id: '130',
        name: '130',
        'cyrillic-name': '130',
        class: 'D',
        'year-from': 1969,
        'year-to': 1978,
      },
      {
        id: '131',
        name: '131',
        'cyrillic-name': '131',
        class: 'C',
        'year-from': 1974,
        'year-to': 1985,
      },
      {
        id: '132',
        name: '132',
        'cyrillic-name': '132',
        class: 'D',
        'year-from': 1972,
        'year-to': 1982,
      },
      {
        id: '2300',
        name: '2300',
        'cyrillic-name': '2300',
        class: 'C',
        'year-from': 1961,
        'year-to': 1969,
      },
      {
        id: '238',
        name: '238',
        'cyrillic-name': '238',
        class: 'M',
        'year-from': 1966,
        'year-to': 1982,
      },
      {
        id: '500',
        name: '500',
        'cyrillic-name': '500',
        class: 'A',
        'year-from': 1957,
        'year-to': null,
      },
      {
        id: '500L',
        name: '500L',
        'cyrillic-name': '500Л',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: '500X',
        name: '500X',
        'cyrillic-name': '500Х',
        class: 'B',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: '508',
        name: '508',
        'cyrillic-name': '508',
        class: '',
        'year-from': 1932,
        'year-to': 1939,
      },
      {
        id: '600',
        name: '600',
        'cyrillic-name': '600',
        class: 'B',
        'year-from': 2005,
        'year-to': 2010,
      },
      {
        id: '900T',
        name: '900T',
        'cyrillic-name': '900т',
        class: 'M',
        'year-from': 1976,
        'year-to': 1985,
      },
      {
        id: 'ALBEA',
        name: 'Albea',
        'cyrillic-name': 'Альбеа',
        class: 'B',
        'year-from': 2002,
        'year-to': 2012,
      },
      {
        id: 'ARGENTA',
        name: 'Argenta',
        'cyrillic-name': 'Аргента',
        class: 'C',
        'year-from': 1978,
        'year-to': 1986,
      },
      {
        id: 'BARCHETTA',
        name: 'Barchetta',
        'cyrillic-name': 'Барчетта',
        class: 'C',
        'year-from': 1995,
        'year-to': 2005,
      },
      {
        id: 'BRAVA',
        name: 'Brava',
        'cyrillic-name': 'Брава',
        class: 'C',
        'year-from': 1995,
        'year-to': 2001,
      },
      {
        id: 'BRAVO',
        name: 'Bravo',
        'cyrillic-name': 'Браво',
        class: 'C',
        'year-from': 1995,
        'year-to': 2014,
      },
      {
        id: 'CINQUECENTO',
        name: 'Cinquecento',
        'cyrillic-name': 'Чинквеченто',
        class: 'A',
        'year-from': 1991,
        'year-to': 1998,
      },
      {
        id: 'COUPE',
        name: 'Coupe',
        'cyrillic-name': 'Купе',
        class: 'C',
        'year-from': 1993,
        'year-to': 2001,
      },
      {
        id: 'CROMA',
        name: 'Croma',
        'cyrillic-name': 'Крома',
        class: 'E',
        'year-from': 1985,
        'year-to': 2011,
      },
      {
        id: 'DOBLO',
        name: 'Doblo',
        'cyrillic-name': 'Добло',
        class: 'M',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'DUNA',
        name: 'Duna',
        'cyrillic-name': 'Дюна',
        class: 'B',
        'year-from': 1987,
        'year-to': 1991,
      },
      {
        id: 'EGEA',
        name: 'Egea',
        'cyrillic-name': 'Егеа',
        class: 'C',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'FIORINO',
        name: 'Fiorino',
        'cyrillic-name': 'Фиорино',
        class: 'M',
        'year-from': 1977,
        'year-to': null,
      },
      {
        id: 'FREEMONT',
        name: 'Freemont',
        'cyrillic-name': 'Фримонт',
        class: 'M',
        'year-from': 2011,
        'year-to': 2016,
      },
      {
        id: 'FULLBACK',
        name: 'Fullback',
        'cyrillic-name': 'Фулбек',
        class: 'J',
        'year-from': 2016,
        'year-to': 2020,
      },
      {
        id: 'IDEA',
        name: 'Idea',
        'cyrillic-name': 'Идеа',
        class: 'M',
        'year-from': 2003,
        'year-to': 2016,
      },
      {
        id: 'LINEA',
        name: 'Linea',
        'cyrillic-name': 'Линеа',
        class: 'C',
        'year-from': 2006,
        'year-to': 2018,
      },
      {
        id: 'MAREA',
        name: 'Marea',
        'cyrillic-name': 'Мареа',
        class: 'C',
        'year-from': 1996,
        'year-to': 2002,
      },
      {
        id: 'MULTIPLA',
        name: 'Multipla',
        'cyrillic-name': 'Мультипла',
        class: 'M',
        'year-from': 1998,
        'year-to': 2010,
      },
      {
        id: 'PALIO',
        name: 'Palio',
        'cyrillic-name': 'Палио',
        class: 'B',
        'year-from': 1996,
        'year-to': 2017,
      },
      {
        id: 'PANDA',
        name: 'Panda',
        'cyrillic-name': 'Панда',
        class: 'A',
        'year-from': 1981,
        'year-to': null,
      },
      {
        id: 'PUNTO',
        name: 'Punto',
        'cyrillic-name': 'Пунто',
        class: 'C',
        'year-from': 1993,
        'year-to': 2018,
      },
      {
        id: 'QUBO',
        name: 'Qubo',
        'cyrillic-name': 'Кубо',
        class: 'M',
        'year-from': 2007,
        'year-to': 2019,
      },
      {
        id: 'REGATA',
        name: 'Regata',
        'cyrillic-name': 'Регата',
        class: 'C',
        'year-from': 1983,
        'year-to': 1990,
      },
      {
        id: 'RITMO',
        name: 'Ritmo',
        'cyrillic-name': 'Ритмо',
        class: 'B',
        'year-from': 1978,
        'year-to': 1989,
      },
      {
        id: 'SCUDO',
        name: 'Scudo',
        'cyrillic-name': 'Скудо',
        class: 'M',
        'year-from': 1995,
        'year-to': 2016,
      },
      {
        id: 'SEDICI',
        name: 'Sedici',
        'cyrillic-name': 'Седичи',
        class: 'C',
        'year-from': 2005,
        'year-to': 2014,
      },
      {
        id: 'SEICENTO',
        name: 'Seicento',
        'cyrillic-name': 'Сейеченто',
        class: 'B',
        'year-from': 1998,
        'year-to': 2010,
      },
      {
        id: 'SIENA',
        name: 'Siena',
        'cyrillic-name': 'Сиена',
        class: 'B',
        'year-from': 1996,
        'year-to': 2017,
      },
      {
        id: 'STILO',
        name: 'Stilo',
        'cyrillic-name': 'Стило',
        class: 'C',
        'year-from': 2001,
        'year-to': 2007,
      },
      {
        id: 'STRADA',
        name: 'Strada',
        'cyrillic-name': 'Страда',
        class: 'J',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'TEMPRA',
        name: 'Tempra',
        'cyrillic-name': 'Темпра',
        class: 'C',
        'year-from': 1990,
        'year-to': 1999,
      },
      {
        id: 'TIPO',
        name: 'Tipo',
        'cyrillic-name': 'Типо',
        class: 'C',
        'year-from': 1987,
        'year-to': null,
      },
      {
        id: 'ULYSSE',
        name: 'Ulysse',
        'cyrillic-name': 'Улисс',
        class: 'M',
        'year-from': 1994,
        'year-to': 2010,
      },
      {
        id: 'UNO',
        name: 'Uno',
        'cyrillic-name': 'Уно',
        class: 'B',
        'year-from': 1983,
        'year-to': 2002,
      },
      {
        id: 'X_1_9',
        name: 'X 1/9',
        'cyrillic-name': 'кс 1/9',
        class: 'S',
        'year-from': 1972,
        'year-to': 1982,
      },
    ],
  },
  {
    id: 'FISKER',
    name: 'Fisker',
    'cyrillic-name': 'Фискер',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'KARMA',
        name: 'Karma',
        'cyrillic-name': 'Карма',
        class: 'F',
        'year-from': 2009,
        'year-to': 2012,
      },
    ],
  },
  {
    id: 'FLANKER',
    name: 'Flanker',
    'cyrillic-name': 'Фланкер',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'F',
        name: 'F',
        'cyrillic-name': 'Ф',
        class: 'S',
        'year-from': 2018,
        'year-to': 2018,
      },
    ],
  },
  {
    id: 'FORD',
    name: 'Ford',
    'cyrillic-name': 'Форд',
    popular: true,
    country: 'США',
    models: [
      {
        id: 'AEROSTAR',
        name: 'Aerostar',
        'cyrillic-name': 'Аэростар',
        class: 'M',
        'year-from': 1986,
        'year-to': 1997,
      },
      {
        id: 'ASPIRE',
        name: 'Aspire',
        'cyrillic-name': 'Эспайр',
        class: 'C',
        'year-from': 1993,
        'year-to': 1997,
      },
      {
        id: 'B_MAX',
        name: 'B-MAX',
        'cyrillic-name': 'Б-МАКС',
        class: 'M',
        'year-from': 2012,
        'year-to': 2018,
      },
      {
        id: 'BRONCO',
        name: 'Bronco',
        'cyrillic-name': 'Бронко',
        class: 'J',
        'year-from': 1966,
        'year-to': null,
      },
      {
        id: 'BRONCO_SPORT',
        name: 'Bronco Sport',
        'cyrillic-name': 'Бронко Спорт',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'BRONCO_II',
        name: 'Bronco-II',
        'cyrillic-name': 'Бронко-2',
        class: 'J',
        'year-from': 1984,
        'year-to': 1990,
      },
      {
        id: 'C_MAX',
        name: 'C-MAX',
        'cyrillic-name': 'ц-макс',
        class: 'M',
        'year-from': 2003,
        'year-to': 2019,
      },
      {
        id: 'CAPRI',
        name: 'Capri',
        'cyrillic-name': 'Капри',
        class: 'D',
        'year-from': 1969,
        'year-to': 1987,
      },
      {
        id: 'CONSUL',
        name: 'Consul',
        'cyrillic-name': 'Консул',
        class: 'E',
        'year-from': 1972,
        'year-to': 1976,
      },
      {
        id: 'CONTOUR',
        name: 'Contour',
        'cyrillic-name': 'Контур',
        class: 'D',
        'year-from': 1994,
        'year-to': 2000,
      },
      {
        id: 'CORTINA',
        name: 'Cortina',
        'cyrillic-name': 'Кортина',
        class: 'D',
        'year-from': 1970,
        'year-to': 1976,
      },
      {
        id: 'COUGAR',
        name: 'Cougar',
        'cyrillic-name': 'Кугар',
        class: 'D',
        'year-from': 1998,
        'year-to': 2002,
      },
      {
        id: 'COUNTRY_SQUIRE',
        name: 'Country Squire',
        'cyrillic-name': 'Кантри Сквайр',
        class: 'E',
        'year-from': 1950,
        'year-to': 1968,
      },
      {
        id: 'CROWN_VICTORIA',
        name: 'Crown Victoria',
        'cyrillic-name': 'Краун Виктория',
        class: 'F',
        'year-from': 1992,
        'year-to': 2011,
      },
      {
        id: 'CUSTOM',
        name: 'Custom',
        'cyrillic-name': 'Кастом',
        class: '',
        'year-from': 1949,
        'year-to': 1955,
      },
      {
        id: 'ECONOLINE',
        name: 'Econoline',
        'cyrillic-name': 'Эконолайн',
        class: 'M',
        'year-from': 1968,
        'year-to': 2013,
      },
      {
        id: 'ECONOVAN',
        name: 'Econovan',
        'cyrillic-name': 'Эконован',
        class: 'M',
        'year-from': 1979,
        'year-to': 1996,
      },
      {
        id: 'ECOSPORT',
        name: 'EcoSport',
        'cyrillic-name': 'ЭкоСпорт',
        class: 'B',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'EDGE',
        name: 'Edge',
        'cyrillic-name': 'Эйдж',
        class: 'D',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'EQUATOR',
        name: 'Equator',
        'cyrillic-name': 'Экватор',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'ESCAPE',
        name: 'Escape',
        'cyrillic-name': 'Эскейп',
        class: 'C',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'ESCORT',
        name: 'Escort',
        'cyrillic-name': 'Эскорт',
        class: 'C',
        'year-from': 1968,
        'year-to': 2000,
      },
      {
        id: 'ESCORT_NA',
        name: 'Escort (North America)',
        'cyrillic-name': 'Эскорт',
        class: 'C',
        'year-from': 1990,
        'year-to': 2003,
      },
      {
        id: 'EVEREST',
        name: 'Everest',
        'cyrillic-name': 'Эверест',
        class: 'J',
        'year-from': 2003,
        'year-to': 2009,
      },
      {
        id: 'EVOS',
        name: 'Evos',
        'cyrillic-name': 'Эвос',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'EXCURSION',
        name: 'Excursion',
        'cyrillic-name': 'Экскьюршн',
        class: 'J',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: 'EXPEDITION',
        name: 'Expedition',
        'cyrillic-name': 'Экспедишн',
        class: 'J',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'EXPLORER',
        name: 'Explorer',
        'cyrillic-name': 'Эксплорер',
        class: 'E',
        'year-from': 1990,
        'year-to': null,
      },
      {
        id: 'EXPLORER_SPORT_TRAC',
        name: 'Explorer Sport Trac',
        'cyrillic-name': 'Эксплорер Спорт Трак',
        class: 'J',
        'year-from': 2000,
        'year-to': 2010,
      },
      {
        id: 'F_150',
        name: 'F-150',
        'cyrillic-name': 'ф-150',
        class: 'J',
        'year-from': 1979,
        'year-to': null,
      },
      {
        id: 'F_2',
        name: 'F-2',
        'cyrillic-name': 'Ф-2',
        class: 'J',
        'year-from': 1948,
        'year-to': 1952,
      },
      {
        id: 'FAIRLANE',
        name: 'Fairlane',
        'cyrillic-name': 'Фейрлайн',
        class: 'F',
        'year-from': 1957,
        'year-to': 1981,
      },
      {
        id: 'FAIRMONT',
        name: 'Fairmont',
        'cyrillic-name': 'Фейрмонт',
        class: 'D',
        'year-from': 1978,
        'year-to': 1983,
      },
      {
        id: 'FALCON',
        name: 'Falcon',
        'cyrillic-name': 'Фалкон',
        class: 'E',
        'year-from': 1960,
        'year-to': 1979,
      },
      {
        id: 'FESTIVA',
        name: 'Festiva',
        'cyrillic-name': 'Фестива',
        class: 'B',
        'year-from': 1986,
        'year-to': 2003,
      },
      {
        id: 'FIESTA',
        name: 'Fiesta',
        'cyrillic-name': 'Фиеста',
        class: 'B',
        'year-from': 1976,
        'year-to': null,
      },
      {
        id: 'FIESTA_ST',
        name: 'Fiesta ST',
        'cyrillic-name': 'Фиеста СТ',
        class: 'B',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'FIVE_HUNDRED',
        name: 'Five Hundred',
        'cyrillic-name': 'файв хандред',
        class: 'E',
        'year-from': 2004,
        'year-to': 2007,
      },
      {
        id: 'FLEX',
        name: 'Flex',
        'cyrillic-name': 'Флекс',
        class: 'E',
        'year-from': 2008,
        'year-to': 2019,
      },
      {
        id: 'FOCUS',
        name: 'Focus',
        'cyrillic-name': 'Фокус',
        class: 'C',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'FOCUS_RS',
        name: 'Focus RS',
        'cyrillic-name': 'Фокус РС',
        class: 'C',
        'year-from': 2002,
        'year-to': 2018,
      },
      {
        id: 'FOCUS_ST',
        name: 'Focus ST',
        'cyrillic-name': 'Фокус СТ',
        class: 'C',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'FREDA',
        name: 'Freda',
        'cyrillic-name': 'фреда',
        class: 'M',
        'year-from': 1995,
        'year-to': 1999,
      },
      {
        id: 'FREESTAR',
        name: 'Freestar',
        'cyrillic-name': 'Фристар',
        class: 'M',
        'year-from': 2003,
        'year-to': 2007,
      },
      {
        id: 'FREESTYLE',
        name: 'Freestyle',
        'cyrillic-name': 'Фристайл',
        class: 'E',
        'year-from': 2004,
        'year-to': 2009,
      },
      {
        id: 'FUSION',
        name: 'Fusion',
        'cyrillic-name': 'Фьюжн',
        class: 'B',
        'year-from': 2002,
        'year-to': 2012,
      },
      {
        id: 'FUSION_NA',
        name: 'Fusion (North America)',
        'cyrillic-name': 'фьюжн (северная америка)',
        class: 'D',
        'year-from': 2005,
        'year-to': 2020,
      },
      {
        id: 'GALAXIE',
        name: 'Galaxie',
        'cyrillic-name': 'Гэлаксье',
        class: 'F',
        'year-from': 1960,
        'year-to': 1974,
      },
      {
        id: 'GALAXY',
        name: 'Galaxy',
        'cyrillic-name': 'Гэлакси',
        class: 'M',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'GPA',
        name: 'GPA',
        'cyrillic-name': 'ГПА',
        class: 'J',
        'year-from': 1942,
        'year-to': 1943,
      },
      {
        id: 'GRANADA',
        name: 'Granada',
        'cyrillic-name': 'Гранада',
        class: 'E',
        'year-from': 1972,
        'year-to': 1985,
      },
      {
        id: 'GRANADA_NA',
        name: 'Granada (North America)',
        'cyrillic-name': 'Гранада',
        class: 'D',
        'year-from': 1975,
        'year-to': 1982,
      },
      {
        id: 'GT',
        name: 'GT',
        'cyrillic-name': 'гт',
        class: 'S',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'GT40',
        name: 'GT40',
        'cyrillic-name': 'гт40',
        class: 'S',
        'year-from': 1964,
        'year-to': 1969,
      },
      {
        id: 'IKON',
        name: 'Ikon',
        'cyrillic-name': 'икон',
        class: 'B',
        'year-from': 1999,
        'year-to': 2015,
      },
      {
        id: 'IXION',
        name: 'Ixion',
        'cyrillic-name': 'Иксион',
        class: 'M',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: 'KA',
        name: 'KA',
        'cyrillic-name': 'Ка',
        class: 'A',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'KUGA',
        name: 'Kuga',
        'cyrillic-name': 'Куга',
        class: 'C',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'LASER',
        name: 'Laser',
        'cyrillic-name': 'Лазер',
        class: 'C',
        'year-from': 1981,
        'year-to': 2003,
      },
      {
        id: 'LTD_COUNTRY_SQUIRE',
        name: 'LTD Country Squire',
        'cyrillic-name': 'ЛТД Кантри Сквайр',
        class: 'E',
        'year-from': 1969,
        'year-to': 1991,
      },
      {
        id: 'LTD_CROWN_VICTORIA',
        name: 'LTD Crown Victoria',
        'cyrillic-name': 'лтд цровн вицториа',
        class: 'E',
        'year-from': 1983,
        'year-to': 1991,
      },
      {
        id: 'M151',
        name: 'M151',
        'cyrillic-name': 'М151',
        class: 'J',
        'year-from': 1959,
        'year-to': 1982,
      },
      {
        id: 'MAINLINE',
        name: 'Mainline',
        'cyrillic-name': 'Майнлайн',
        class: 'F',
        'year-from': 1952,
        'year-to': 1956,
      },
      {
        id: 'MAVERICK',
        name: 'Maverick',
        'cyrillic-name': 'Маверик',
        class: 'J',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'MODEL_A',
        name: 'Model A',
        'cyrillic-name': 'Модель А',
        class: '',
        'year-from': 1927,
        'year-to': 1931,
      },
      {
        id: 'MODEL_T',
        name: 'Model T',
        'cyrillic-name': 'Модель Т',
        class: 'S',
        'year-from': 1908,
        'year-to': 1927,
      },
      {
        id: 'MONDEO',
        name: 'Mondeo',
        'cyrillic-name': 'Мондео',
        class: 'E',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'MONDEO_ST',
        name: 'Mondeo ST',
        'cyrillic-name': 'Мондео СТ',
        class: 'D',
        'year-from': 1999,
        'year-to': 2007,
      },
      {
        id: 'MUSTANG',
        name: 'Mustang',
        'cyrillic-name': 'Мустанг',
        class: 'S',
        'year-from': 1964,
        'year-to': null,
      },
      {
        id: 'MUSTANG_MACH_E',
        name: 'Mustang Mach-E',
        'cyrillic-name': 'Мустанг Мач-Е',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'ORION',
        name: 'Orion',
        'cyrillic-name': 'Орион',
        class: 'C',
        'year-from': 1983,
        'year-to': 1993,
      },
      {
        id: 'PROBE',
        name: 'Probe',
        'cyrillic-name': 'Проб',
        class: 'S',
        'year-from': 1988,
        'year-to': 1997,
      },
      {
        id: 'PUMA',
        name: 'Puma',
        'cyrillic-name': 'Пума',
        class: 'B',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'PUMA_ST',
        name: 'Puma ST',
        'cyrillic-name': 'Пума СТ',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'RANCHERO',
        name: 'Ranchero',
        'cyrillic-name': 'Ранчеро',
        class: 'J',
        'year-from': 1957,
        'year-to': 1976,
      },
      {
        id: 'RANGER',
        name: 'Ranger',
        'cyrillic-name': 'Рейнджер',
        class: 'J',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'RANGER_NA',
        name: 'Ranger (North America)',
        'cyrillic-name': 'Рейнджер',
        class: 'J',
        'year-from': 1983,
        'year-to': 2012,
      },
      {
        id: 'S_MAX',
        name: 'S-MAX',
        'cyrillic-name': 'с-макс',
        class: 'M',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'SCORPIO',
        name: 'Scorpio',
        'cyrillic-name': 'Скорпио',
        class: 'E',
        'year-from': 1985,
        'year-to': 1998,
      },
      {
        id: 'SIERRA',
        name: 'Sierra',
        'cyrillic-name': 'Сиерра',
        class: 'D',
        'year-from': 1982,
        'year-to': 1993,
      },
      {
        id: 'SPECTRON',
        name: 'Spectron',
        'cyrillic-name': 'спектрон',
        class: 'M',
        'year-from': 1983,
        'year-to': 1995,
      },
      {
        id: 'TAUNUS',
        name: 'Taunus',
        'cyrillic-name': 'Таунус',
        class: 'D',
        'year-from': 1964,
        'year-to': 1982,
      },
      {
        id: 'TAURUS',
        name: 'Taurus',
        'cyrillic-name': 'Таурус',
        class: 'E',
        'year-from': 1985,
        'year-to': 2019,
      },
      {
        id: 'TAURUS_X',
        name: 'Taurus X',
        'cyrillic-name': 'таурус кс',
        class: 'E',
        'year-from': 2007,
        'year-to': 2009,
      },
      {
        id: 'TELSTAR',
        name: 'Telstar',
        'cyrillic-name': 'тельстар',
        class: 'D',
        'year-from': 1987,
        'year-to': 1999,
      },
      {
        id: 'TEMPO',
        name: 'Tempo',
        'cyrillic-name': 'Темпо',
        class: 'C',
        'year-from': 1983,
        'year-to': 1994,
      },
      {
        id: 'TERRITORY',
        name: 'Territory',
        'cyrillic-name': 'территори',
        class: 'C',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'THUNDERBIRD',
        name: 'Thunderbird',
        'cyrillic-name': 'Тандербёрд',
        class: 'S',
        'year-from': 1955,
        'year-to': 2005,
      },
      {
        id: 'TORINO',
        name: 'Torino',
        'cyrillic-name': 'Торино',
        class: 'E',
        'year-from': 1968,
        'year-to': 1976,
      },
      {
        id: 'TOURNEO_CONNECT',
        name: 'Tourneo Connect',
        'cyrillic-name': 'Турнео Коннект',
        class: 'M',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'TOURNEO_COURIER',
        name: 'Tourneo Courier',
        'cyrillic-name': 'турнео курьер',
        class: 'M',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'TOURNEO_CUSTOM',
        name: 'Tourneo Custom',
        'cyrillic-name': 'Турнео Кастом',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'TRANSIT_CONNECT',
        name: 'Transit Connect',
        'cyrillic-name': 'Транзит Коннект',
        class: 'M',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'TRANSIT_CUSTOM',
        name: 'Transit Custom',
        'cyrillic-name': 'Транзит Кастом',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'V8',
        name: 'V8',
        'cyrillic-name': 'в8',
        class: 'F',
        'year-from': 1932,
        'year-to': 1939,
      },
      {
        id: 'WINDSTAR',
        name: 'Windstar',
        'cyrillic-name': 'Виндстар',
        class: 'M',
        'year-from': 1994,
        'year-to': 2003,
      },
      {
        id: 'ZEPHYR',
        name: 'Zephyr',
        'cyrillic-name': 'Зефир',
        class: '',
        'year-from': 1956,
        'year-to': 1962,
      },
    ],
  },
  {
    id: 'FORTHING',
    name: 'Dongfeng Forthing',
    'cyrillic-name': 'Донгфенг Форфинг',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'T5_EVO',
        name: 'T5 EVO',
        'cyrillic-name': 'Т5 ЭВО',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'FOTON',
    name: 'Foton',
    'cyrillic-name': 'Фотон',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'MIDI',
        name: 'Midi',
        'cyrillic-name': 'Миди',
        class: 'M',
        'year-from': 2007,
        'year-to': 2014,
      },
      {
        id: 'SAUVANA',
        name: 'Sauvana',
        'cyrillic-name': 'Савана',
        class: 'J',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'TUNLAND',
        name: 'Tunland',
        'cyrillic-name': 'Тунланд',
        class: 'J',
        'year-from': 2011,
        'year-to': 2018,
      },
    ],
  },
  {
    id: 'FSO',
    name: 'FSO',
    'cyrillic-name': 'ФСО',
    popular: false,
    country: 'Польша',
    models: [
      {
        id: '125_P',
        name: '125p',
        'cyrillic-name': '125р',
        class: 'C',
        'year-from': 1967,
        'year-to': 1992,
      },
      {
        id: '126P',
        name: '126p',
        'cyrillic-name': '126р',
        class: 'A',
        'year-from': 1973,
        'year-to': 1991,
      },
      {
        id: '127P',
        name: '127p',
        'cyrillic-name': '127р',
        class: 'B',
        'year-from': 1971,
        'year-to': 1976,
      },
      {
        id: '132P',
        name: '132p',
        'cyrillic-name': '132р',
        class: 'C',
        'year-from': 1974,
        'year-to': 1978,
      },
      {
        id: 'LANOS',
        name: 'Lanos',
        'cyrillic-name': 'Ланос',
        class: 'B',
        'year-from': 2004,
        'year-to': 2008,
      },
      {
        id: 'POLONEZ',
        name: 'Polonez',
        'cyrillic-name': 'Полонез',
        class: 'C',
        'year-from': 1977,
        'year-to': 2002,
      },
      {
        id: 'WARSZAWA',
        name: 'Warszawa',
        'cyrillic-name': 'Варшава',
        class: 'E',
        'year-from': 1964,
        'year-to': 1973,
      },
    ],
  },
  {
    id: 'FUQI',
    name: 'Fuqi',
    'cyrillic-name': 'Фуки',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'LAND_KING',
        name: '6500 (Land King)',
        'cyrillic-name': '6500',
        class: 'J',
        'year-from': 2005,
        'year-to': 2005,
      },
    ],
  },
  {
    id: 'GAC',
    name: 'GAC',
    'cyrillic-name': 'ГАК',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'GE3',
        name: 'GE3',
        'cyrillic-name': 'ГЕ3',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'GN8',
        name: 'GN8',
        'cyrillic-name': 'ГН8',
        class: 'M',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'GS5',
        name: 'GS5',
        'cyrillic-name': 'ГС5',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'GS8',
        name: 'GS8',
        'cyrillic-name': 'ГС8',
        class: 'E',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'IA5',
        name: 'iA5',
        'cyrillic-name': 'иА5',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'GAZ',
    name: 'ГАЗ',
    'cyrillic-name': 'ГАЗ',
    popular: true,
    country: 'Россия',
    models: [
      {
        id: '12',
        name: '12 ЗИМ',
        'cyrillic-name': '12 ЗИМ',
        class: 'F',
        'year-from': 1948,
        'year-to': 1960,
      },
      {
        id: '13',
        name: '13 «Чайка»',
        'cyrillic-name': '13 «Чайка»',
        class: 'F',
        'year-from': 1959,
        'year-to': 1981,
      },
      {
        id: '14',
        name: '14 «Чайка»',
        'cyrillic-name': '14 «Чайка»',
        class: 'F',
        'year-from': 1977,
        'year-to': 1989,
      },
      {
        id: '18',
        name: '18',
        'cyrillic-name': '18',
        class: 'A',
        'year-from': 1955,
        'year-to': 1958,
      },
      {
        id: '21',
        name: '21 «Волга»',
        'cyrillic-name': '21 «Волга»',
        class: 'D',
        'year-from': 1956,
        'year-to': 1970,
      },
      {
        id: '22',
        name: '22 «Волга»',
        'cyrillic-name': '22 «Волга»',
        class: 'D',
        'year-from': 1962,
        'year-to': 1970,
      },
      {
        id: '2308_ATAMAN',
        name: '2308 «Атаман»',
        'cyrillic-name': '2308 Атаман',
        class: 'J',
        'year-from': 1999,
        'year-to': 2000,
      },
      {
        id: '2330_TIGR',
        name: '2330 «Тигр»',
        'cyrillic-name': '2330 Тигр',
        class: 'J',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: '24',
        name: '24 «Волга»',
        'cyrillic-name': '24 «Волга»',
        class: 'D',
        'year-from': 1968,
        'year-to': 1992,
      },
      {
        id: '25',
        name: '25',
        'cyrillic-name': '25',
        class: 'S',
        'year-from': 1939,
        'year-to': 1939,
      },
      {
        id: '3102',
        name: '3102 «Волга»',
        'cyrillic-name': '3102 Волга',
        class: 'D',
        'year-from': 1982,
        'year-to': 2009,
      },
      {
        id: '31022',
        name: '31022 «Волга»',
        'cyrillic-name': '31022 Волга',
        class: 'D',
        'year-from': 1992,
        'year-to': 1998,
      },
      {
        id: '310221',
        name: '310221 «Волга»',
        'cyrillic-name': '310221 Волга',
        class: 'D',
        'year-from': 1997,
        'year-to': 2008,
      },
      {
        id: '31029',
        name: '31029 «Волга»',
        'cyrillic-name': '31029 Волга',
        class: 'D',
        'year-from': 1992,
        'year-to': 1998,
      },
      {
        id: '3103_VOLGA',
        name: '3103 «Волга»',
        'cyrillic-name': '3103 Волга',
        class: 'E',
        'year-from': 1997,
        'year-to': 1997,
      },
      {
        id: '3105',
        name: '3105 «Волга»',
        'cyrillic-name': '3105 Волга',
        class: 'E',
        'year-from': 1992,
        'year-to': 1996,
      },
      {
        id: '3110',
        name: '3110 «Волга»',
        'cyrillic-name': '31 10 Волга',
        class: 'D',
        'year-from': 1997,
        'year-to': 2008,
      },
      {
        id: '31105',
        name: '31105 «Волга»',
        'cyrillic-name': '31 10 5 Волга',
        class: 'E',
        'year-from': 2003,
        'year-to': 2009,
      },
      {
        id: '3111',
        name: '3111 «Волга»',
        'cyrillic-name': '3111 Волга',
        class: 'E',
        'year-from': 2000,
        'year-to': 2004,
      },
      {
        id: '46',
        name: '46',
        'cyrillic-name': '46',
        class: 'J',
        'year-from': 1953,
        'year-to': 1958,
      },
      {
        id: '61',
        name: '61',
        'cyrillic-name': '61',
        class: '',
        'year-from': 1941,
        'year-to': 1948,
      },
      {
        id: '64',
        name: '64',
        'cyrillic-name': '64',
        class: 'J',
        'year-from': 1941,
        'year-to': 1943,
      },
      {
        id: '69',
        name: '69',
        'cyrillic-name': '69',
        class: 'J',
        'year-from': 1953,
        'year-to': 1972,
      },
      {
        id: 'VOLGA_SIBER',
        name: 'Volga Siber',
        'cyrillic-name': 'Волга Сайбер',
        class: 'D',
        'year-from': 2008,
        'year-to': 2010,
      },
      {
        id: 'A',
        name: 'А',
        'cyrillic-name': 'А',
        class: 'S',
        'year-from': 1932,
        'year-to': 1936,
      },
      {
        id: '67',
        name: 'ГАЗ 67',
        'cyrillic-name': '67',
        class: 'J',
        'year-from': 1943,
        'year-to': 1953,
      },
      {
        id: 'M_20',
        name: 'М-20 «Победа»',
        'cyrillic-name': 'М-20 «Победа»',
        class: 'D',
        'year-from': 1946,
        'year-to': 1958,
      },
      {
        id: 'M_72',
        name: 'М-72',
        'cyrillic-name': 'М-72',
        class: 'D',
        'year-from': 1955,
        'year-to': 1958,
      },
      {
        id: 'M1',
        name: 'М1',
        'cyrillic-name': 'М1',
        class: '',
        'year-from': 1934,
        'year-to': 1948,
      },
    ],
  },
  {
    id: 'GEELY',
    name: 'Geely',
    'cyrillic-name': 'Джили',
    popular: true,
    country: 'Китай',
    models: [
      {
        id: 'ATLAS',
        name: 'Atlas',
        'cyrillic-name': 'Атлас',
        class: 'C',
        'year-from': 2016,
        'year-to': 2022,
      },
      {
        id: 'ATLAS_PRO',
        name: 'Atlas Pro',
        'cyrillic-name': 'Атлас Про',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'BEAUTY_LEOPARD',
        name: 'Beauty Leopard',
        'cyrillic-name': 'бьюти леопард',
        class: 'S',
        'year-from': 2005,
        'year-to': 2006,
      },
      {
        id: 'BINYUE_COOL',
        name: 'Binyue Cool',
        'cyrillic-name': 'Биную Кул',
        class: 'B',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'BOYUE',
        name: 'Boyue',
        'cyrillic-name': 'Боую',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'CK',
        name: 'CK (Otaka)',
        'cyrillic-name': 'ЦК Отака',
        class: 'B',
        'year-from': 2005,
        'year-to': 2016,
      },
      {
        id: 'COOLRAY',
        name: 'Coolray',
        'cyrillic-name': 'Кулрей',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'EMGRAND_7',
        name: 'Emgrand 7',
        'cyrillic-name': 'Эмгранд 7',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'EMGRAND',
        name: 'Emgrand EC7',
        'cyrillic-name': 'емгранд ец7',
        class: 'D',
        'year-from': 2009,
        'year-to': 2016,
      },
      {
        id: 'EMGRAND_8',
        name: 'Emgrand EC8',
        'cyrillic-name': 'емгранд ец8',
        class: 'D',
        'year-from': 2012,
        'year-to': 2015,
      },
      {
        id: 'EMGRAND_GT',
        name: 'Emgrand GT',
        'cyrillic-name': 'Эмгранд ГТ',
        class: 'D',
        'year-from': 2015,
        'year-to': 2020,
      },
      {
        id: 'EMGRAND_X7',
        name: 'Emgrand X7',
        'cyrillic-name': 'емгранд кс7',
        class: 'C',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'VISION',
        name: 'FC (Vision)',
        'cyrillic-name': 'фс (вижн)',
        class: 'D',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'GC6',
        name: 'GC6',
        'cyrillic-name': 'гс6',
        class: 'B',
        'year-from': 2014,
        'year-to': 2016,
      },
      {
        id: 'GC9',
        name: 'GC9',
        'cyrillic-name': 'гс9',
        class: 'E',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'GEOMETRY_A',
        name: 'Geometry A',
        'cyrillic-name': 'Геометрия А',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'GEOMETRY_C',
        name: 'Geometry C',
        'cyrillic-name': 'Геометрия Ц',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'GS',
        name: 'GS',
        'cyrillic-name': 'ГС',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'HAOQING',
        name: 'Haoqing',
        'cyrillic-name': 'хаокинг',
        class: 'B',
        'year-from': 1998,
        'year-to': 2006,
      },
      {
        id: 'JIAJI',
        name: 'Jiaji',
        'cyrillic-name': 'Джиаджи',
        class: 'M',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'KANDI_EX3',
        name: 'Kandi EX3',
        'cyrillic-name': 'Канди ЕИкс3',
        class: 'B',
        'year-from': 2018,
        'year-to': 2018,
      },
      {
        id: 'LC',
        name: 'LC (Panda)',
        'cyrillic-name': 'лц (панда)',
        class: 'A',
        'year-from': 2008,
        'year-to': 2016,
      },
      {
        id: 'LC_CROSS',
        name: 'LC (Panda) Cross',
        'cyrillic-name': 'лц (панда) цросс',
        class: 'B',
        'year-from': 2008,
        'year-to': 2016,
      },
      {
        id: 'MK',
        name: 'MK',
        'cyrillic-name': 'МК',
        class: 'C',
        'year-from': 2006,
        'year-to': 2015,
      },
      {
        id: 'MK_CROSS',
        name: 'MK Cross',
        'cyrillic-name': 'МК Кросс',
        class: 'B',
        'year-from': 2010,
        'year-to': 2016,
      },
      {
        id: 'MONJARO',
        name: 'Monjaro',
        'cyrillic-name': 'Монжаро',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'MR',
        name: 'MR',
        'cyrillic-name': 'мр',
        class: 'B',
        'year-from': 2003,
        'year-to': 2009,
      },
      {
        id: 'OKAVANGO',
        name: 'Okavango',
        'cyrillic-name': 'Окаванго',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'PREFACE',
        name: 'Preface',
        'cyrillic-name': 'Префейс',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'SC7',
        name: 'SC7',
        'cyrillic-name': 'сц7',
        class: 'C',
        'year-from': 2011,
        'year-to': 2015,
      },
      {
        id: 'TUGELLA',
        name: 'Tugella',
        'cyrillic-name': 'Тугелла',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'TX4',
        name: 'TX4',
        'cyrillic-name': 'ТХ4',
        class: 'C',
        'year-from': 2008,
        'year-to': 2017,
      },
      {
        id: 'VISION_X6',
        name: 'Vision X6',
        'cyrillic-name': 'Вижн Икс 6',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'VISION_X6_PRO',
        name: 'Vision X6 Pro',
        'cyrillic-name': 'Вижн Икс 6 Про',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'GENESIS',
    name: 'Genesis',
    'cyrillic-name': 'Генезис',
    popular: false,
    country: 'Южная Корея',
    models: [
      {
        id: 'G70',
        name: 'G70',
        'cyrillic-name': 'Г70',
        class: 'D',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'G80',
        name: 'G80',
        'cyrillic-name': 'Г80',
        class: 'E',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'G90',
        name: 'G90',
        'cyrillic-name': 'Г90',
        class: 'F',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'GV60',
        name: 'GV60',
        'cyrillic-name': 'ГВ60',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'GV70',
        name: 'GV70',
        'cyrillic-name': 'ГВ70',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'GV80',
        name: 'GV80',
        'cyrillic-name': 'ГВ80',
        class: 'E',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'GEO',
    name: 'Geo',
    'cyrillic-name': 'Гео',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'METRO',
        name: 'Metro',
        'cyrillic-name': 'метро',
        class: 'B',
        'year-from': 1989,
        'year-to': 1997,
      },
      {
        id: 'PRIZM',
        name: 'Prizm',
        'cyrillic-name': 'призм',
        class: 'C',
        'year-from': 1992,
        'year-to': 2002,
      },
      {
        id: 'SPECTRUM',
        name: 'Spectrum',
        'cyrillic-name': 'спектрум',
        class: 'B',
        'year-from': 1990,
        'year-to': 1993,
      },
      {
        id: 'STORM',
        name: 'Storm',
        'cyrillic-name': 'шторм',
        class: 'C',
        'year-from': 1990,
        'year-to': 1993,
      },
      {
        id: 'TRACKER',
        name: 'Tracker',
        'cyrillic-name': 'трекер',
        class: 'J',
        'year-from': 1989,
        'year-to': 1998,
      },
    ],
  },
  {
    id: 'GMC',
    name: 'GMC',
    'cyrillic-name': 'Джи-Эм-Си',
    popular: false,
    country: 'США',
    models: [
      {
        id: '100',
        name: '100',
        'cyrillic-name': '100',
        class: 'J',
        'year-from': 1957,
        'year-to': 1957,
      },
      {
        id: 'ACADIA',
        name: 'Acadia',
        'cyrillic-name': 'акадия',
        class: 'E',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'CANYON',
        name: 'Canyon',
        'cyrillic-name': 'Каньон',
        class: 'J',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'ENVOY',
        name: 'Envoy',
        'cyrillic-name': 'Энвой',
        class: 'J',
        'year-from': 1997,
        'year-to': 2009,
      },
      {
        id: 'HUMMER_EV',
        name: 'Hummer EV',
        'cyrillic-name': 'Хаммер ЕВ',
        class: 'J',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'JIMMY',
        name: 'Jimmy',
        'cyrillic-name': 'Джимми',
        class: 'J',
        'year-from': 1982,
        'year-to': 2005,
      },
      {
        id: 'SAFARI',
        name: 'Safari',
        'cyrillic-name': 'Сафари',
        class: 'M',
        'year-from': 1985,
        'year-to': 2005,
      },
      {
        id: 'SAVANA',
        name: 'Savana',
        'cyrillic-name': 'Савана',
        class: 'M',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'SIERRA',
        name: 'Sierra',
        'cyrillic-name': 'Сьерра',
        class: 'J',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'SONOMA',
        name: 'Sonoma',
        'cyrillic-name': 'Сонома',
        class: 'J',
        'year-from': 1991,
        'year-to': 2004,
      },
      {
        id: 'SUBURBAN',
        name: 'Suburban',
        'cyrillic-name': 'Субурбан',
        class: 'J',
        'year-from': 1992,
        'year-to': 1999,
      },
      {
        id: 'SYCLONE',
        name: 'Syclone',
        'cyrillic-name': 'Циклон',
        class: 'J',
        'year-from': 1991,
        'year-to': 1991,
      },
      {
        id: 'TERRAIN',
        name: 'Terrain',
        'cyrillic-name': 'Террейн',
        class: 'C',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'TYPHOON',
        name: 'Typhoon',
        'cyrillic-name': 'Тайфун',
        class: 'J',
        'year-from': 1991,
        'year-to': 1993,
      },
      {
        id: 'VANDURA',
        name: 'Vandura',
        'cyrillic-name': 'Вандура',
        class: 'M',
        'year-from': 1970,
        'year-to': 1996,
      },
      {
        id: 'YUKON',
        name: 'Yukon',
        'cyrillic-name': 'Юкон',
        class: 'J',
        'year-from': 1991,
        'year-to': null,
      },
    ],
  },
  {
    id: 'GOGGOMOBIL',
    name: 'Goggomobil',
    'cyrillic-name': 'Гоггомобил',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'T',
        name: 'T',
        'cyrillic-name': 'Т',
        class: 'A',
        'year-from': 1955,
        'year-to': 1969,
      },
      {
        id: 'TS',
        name: 'TS',
        'cyrillic-name': 'ТС',
        class: 'A',
        'year-from': 1955,
        'year-to': 1969,
      },
    ],
  },
  {
    id: 'GONOW',
    name: 'Gonow',
    'cyrillic-name': 'Гонов',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'TROY',
        name: 'Troy',
        'cyrillic-name': 'Трой',
        class: 'J',
        'year-from': 2008,
        'year-to': 2012,
      },
    ],
  },
  {
    id: 'GORDON',
    name: 'Gordon',
    'cyrillic-name': 'Гордон',
    popular: false,
    country: 'Чехия',
    models: [
      {
        id: 'ROADSTER',
        name: 'Roadster',
        'cyrillic-name': 'Родстер',
        class: 'S',
        'year-from': 1997,
        'year-to': null,
      },
    ],
  },
  {
    id: 'GP',
    name: 'GP',
    'cyrillic-name': 'ГП',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'MADISON',
        name: 'Madison',
        'cyrillic-name': 'Мейдисон',
        class: 'S',
        'year-from': 1980,
        'year-to': 1999,
      },
    ],
  },
  {
    id: 'GREAT_WALL',
    name: 'Great Wall',
    'cyrillic-name': 'Грейт Вол',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'COOLBEAR',
        name: 'Coolbear',
        'cyrillic-name': 'Кулбир',
        class: 'B',
        'year-from': 2009,
        'year-to': 2013,
      },
      {
        id: 'COWRY',
        name: 'Cowry (V80)',
        'cyrillic-name': 'Каури',
        class: 'M',
        'year-from': 2007,
        'year-to': 2014,
      },
      {
        id: 'DEER',
        name: 'Deer',
        'cyrillic-name': 'Дир',
        class: 'J',
        'year-from': 1996,
        'year-to': 2013,
      },
      {
        id: 'FLORID',
        name: 'Florid',
        'cyrillic-name': 'Флорид',
        class: 'B',
        'year-from': 2008,
        'year-to': 2013,
      },
      {
        id: 'HOVER_2005',
        name: 'Hover',
        'cyrillic-name': 'Ховер',
        class: 'J',
        'year-from': 2005,
        'year-to': 2010,
      },
      {
        id: 'HOVERH3',
        name: 'Hover H3',
        'cyrillic-name': 'ховер х3',
        class: 'J',
        'year-from': 2010,
        'year-to': 2016,
      },
      {
        id: 'HOVERH5',
        name: 'Hover H5',
        'cyrillic-name': 'ховер х5',
        class: 'J',
        'year-from': 2010,
        'year-to': 2017,
      },
      {
        id: 'HOVERH6',
        name: 'Hover H6',
        'cyrillic-name': 'ховер х6',
        class: 'C',
        'year-from': 2011,
        'year-to': 2017,
      },
      {
        id: 'HOVER_M1',
        name: 'Hover M1 (Peri 4x4)',
        'cyrillic-name': 'Ховер М1',
        class: 'A',
        'year-from': 2008,
        'year-to': 2010,
      },
      {
        id: 'HOVER_M2',
        name: 'Hover M2',
        'cyrillic-name': 'Ховер М2',
        class: 'B',
        'year-from': 2010,
        'year-to': 2014,
      },
      {
        id: 'HOVER_M4',
        name: 'Hover M4',
        'cyrillic-name': 'Ховер М4',
        class: 'B',
        'year-from': 2012,
        'year-to': 2017,
      },
      {
        id: 'HOVER_PI',
        name: 'Hover Pi',
        'cyrillic-name': 'Ховер Пи',
        class: 'J',
        'year-from': 2006,
        'year-to': 2010,
      },
      {
        id: 'PEGASUS',
        name: 'Pegasus',
        'cyrillic-name': 'Пегасус',
        class: 'J',
        'year-from': 2006,
        'year-to': 2008,
      },
      {
        id: 'PERI',
        name: 'Peri',
        'cyrillic-name': 'Пери',
        class: 'A',
        'year-from': 2008,
        'year-to': 2010,
      },
      {
        id: 'POER',
        name: 'Poer',
        'cyrillic-name': 'Поер',
        class: 'F',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'SAFE',
        name: 'Safe',
        'cyrillic-name': 'Сэйф',
        class: 'J',
        'year-from': 2001,
        'year-to': 2010,
      },
      {
        id: 'SAILOR',
        name: 'Sailor',
        'cyrillic-name': 'Сейлор',
        class: 'J',
        'year-from': 2003,
        'year-to': 2010,
      },
      {
        id: 'SING',
        name: 'Sing RUV',
        'cyrillic-name': 'Синг',
        class: 'J',
        'year-from': 2005,
        'year-to': 2010,
      },
      {
        id: 'SOCOOL',
        name: 'Socool',
        'cyrillic-name': 'Сокул',
        class: 'J',
        'year-from': 2005,
        'year-to': 2008,
      },
      {
        id: 'VOLEEXC10',
        name: 'Voleex C10 (Phenom)',
        'cyrillic-name': 'волеекс ц10 (пхеном)',
        class: 'B',
        'year-from': 2010,
        'year-to': 2013,
      },
      {
        id: 'VOLEEXC30',
        name: 'Voleex C30',
        'cyrillic-name': 'волеекс ц30',
        class: 'C',
        'year-from': 2010,
        'year-to': 2014,
      },
      {
        id: 'WINGLE_UP',
        name: 'Wingle',
        'cyrillic-name': 'Вингл',
        class: 'J',
        'year-from': 2006,
        'year-to': 2015,
      },
      {
        id: 'WINGLE_7',
        name: 'Wingle 7',
        'cyrillic-name': 'Вингл 7',
        class: 'F',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'HAFEI',
    name: 'Hafei',
    'cyrillic-name': 'Хафэй',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'BRIO',
        name: 'Brio',
        'cyrillic-name': 'брио',
        class: 'A',
        'year-from': 2002,
        'year-to': 2010,
      },
      {
        id: 'MINYI',
        name: 'Minyi',
        'cyrillic-name': 'Миньи',
        class: 'M',
        'year-from': 2003,
        'year-to': 2018,
      },
      {
        id: 'PRINCIP',
        name: 'Princip',
        'cyrillic-name': 'принцип',
        class: 'C',
        'year-from': 2004,
        'year-to': 2010,
      },
      {
        id: 'SAIBAO',
        name: 'Saibao',
        'cyrillic-name': 'сайбао',
        class: 'B',
        'year-from': 2004,
        'year-to': 2008,
      },
      {
        id: 'SIGMA',
        name: 'Sigma',
        'cyrillic-name': 'сигма',
        class: 'B',
        'year-from': 2005,
        'year-to': 2008,
      },
      {
        id: 'SIMBO',
        name: 'Simbo',
        'cyrillic-name': 'симбо',
        class: 'B',
        'year-from': 2006,
        'year-to': 2008,
      },
    ],
  },
  {
    id: 'HAIMA',
    name: 'Haima',
    'cyrillic-name': 'Хайма',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: '2',
        name: '2',
        'cyrillic-name': '2',
        class: 'B',
        'year-from': 2009,
        'year-to': 2015,
      },
      {
        id: '3',
        name: '3',
        'cyrillic-name': '3',
        class: 'C',
        'year-from': 2010,
        'year-to': 2013,
      },
      {
        id: '6P',
        name: '6P',
        'cyrillic-name': '6Пи',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: '7',
        name: '7',
        'cyrillic-name': '7',
        class: 'C',
        'year-from': 2013,
        'year-to': 2016,
      },
      {
        id: '7X',
        name: '7X',
        'cyrillic-name': '7Икс',
        class: 'M',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: '8S',
        name: '8S',
        'cyrillic-name': '8С',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'AISHANG_EV',
        name: 'Aishang EV',
        'cyrillic-name': 'Аишанг ЕВ',
        class: 'A',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'E3',
        name: 'E3',
        'cyrillic-name': 'Е3',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'FAMILY',
        name: 'Family',
        'cyrillic-name': 'фемели',
        class: 'C',
        'year-from': 2000,
        'year-to': 2012,
      },
      {
        id: 'FAMILY_F7',
        name: 'Family F7',
        'cyrillic-name': 'фемели-ф7',
        class: 'M',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'FREEMA',
        name: 'Freema',
        'cyrillic-name': 'фрима',
        class: 'M',
        'year-from': 2006,
        'year-to': 2017,
      },
      {
        id: 'M3',
        name: 'M3',
        'cyrillic-name': 'М3',
        class: 'C',
        'year-from': 2014,
        'year-to': 2017,
      },
      {
        id: 'S5',
        name: 'S5',
        'cyrillic-name': 'С5',
        class: 'C',
        'year-from': 2014,
        'year-to': 2019,
      },
      {
        id: 'S5_YOUNG',
        name: 'S5 Young',
        'cyrillic-name': 'С5 Янг',
        class: 'A',
        'year-from': 2018,
        'year-to': 2018,
      },
    ],
  },
  {
    id: 'HANOMAG',
    name: 'Hanomag',
    'cyrillic-name': 'Ханомаг',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'REKORD',
        name: 'Rekord',
        'cyrillic-name': 'Рекорд',
        class: 'D',
        'year-from': 1934,
        'year-to': 1940,
      },
      {
        id: 'TYP_13',
        name: 'Typ 13',
        'cyrillic-name': 'Тип 13',
        class: 'C',
        'year-from': 1939,
        'year-to': 1941,
      },
    ],
  },
  {
    id: 'HAVAL',
    name: 'Haval',
    'cyrillic-name': 'Хавэйл',
    popular: true,
    country: 'Китай',
    models: [
      {
        id: 'CHITU',
        name: 'Chitu',
        'cyrillic-name': 'Читу',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'DAGOU',
        name: 'DaGou (Big Dog)',
        'cyrillic-name': 'Дагоу (Биг Дог)',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'DARGO',
        name: 'Dargo',
        'cyrillic-name': 'Дарго',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'F7',
        name: 'F7',
        'cyrillic-name': 'Ф7',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'F7X',
        name: 'F7x',
        'cyrillic-name': 'Ф7х',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'H2',
        name: 'H2',
        'cyrillic-name': 'Н2',
        class: 'B',
        'year-from': 2014,
        'year-to': 2021,
      },
      {
        id: 'H5',
        name: 'H5',
        'cyrillic-name': 'Х5',
        class: 'J',
        'year-from': 2020,
        'year-to': 2021,
      },
      {
        id: 'H6',
        name: 'H6',
        'cyrillic-name': 'Н6',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'H6_COUPE',
        name: 'H6 Coupe',
        'cyrillic-name': 'Н6 Купе',
        class: 'C',
        'year-from': 2015,
        'year-to': 2021,
      },
      {
        id: 'H6S',
        name: 'H6S',
        'cyrillic-name': 'Х6С',
        class: 'J',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'H8',
        name: 'H8',
        'cyrillic-name': 'Н8',
        class: 'D',
        'year-from': 2014,
        'year-to': 2017,
      },
      {
        id: 'H9',
        name: 'H9',
        'cyrillic-name': 'Н9',
        class: 'J',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'JOLION',
        name: 'Jolion',
        'cyrillic-name': 'Джолион',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'KUGOU',
        name: 'KuGou',
        'cyrillic-name': 'КуГоу',
        class: 'J',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'HAWTAI',
    name: 'Hawtai',
    'cyrillic-name': 'Хаутай',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'B_21',
        name: 'B21',
        'cyrillic-name': 'б21',
        class: 'C',
        'year-from': 2013,
        'year-to': 2017,
      },
      {
        id: 'BOLIGER',
        name: 'Boliger',
        'cyrillic-name': 'Болигер',
        class: 'C',
        'year-from': 2011,
        'year-to': 2020,
      },
      {
        id: 'LAVILLE',
        name: 'Laville',
        'cyrillic-name': 'Лавиль',
        class: 'C',
        'year-from': 2016,
        'year-to': 2020,
      },
    ],
  },
  {
    id: 'HEINKEL',
    name: 'Heinkel',
    'cyrillic-name': 'Хейнкель',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'TYP_154',
        name: 'Typ 154',
        'cyrillic-name': 'Тип 154',
        class: 'A',
        'year-from': 1956,
        'year-to': 1958,
      },
    ],
  },
  {
    id: 'HENNESSEY',
    name: 'Hennessey',
    'cyrillic-name': 'Хеннесси',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'VENOM_F5',
        name: 'Venom F5',
        'cyrillic-name': 'Веном Ф5',
        class: 'S',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'VENOM_GT',
        name: 'Venom GT',
        'cyrillic-name': 'Веном ГТ',
        class: 'S',
        'year-from': 2011,
        'year-to': 2017,
      },
    ],
  },
  {
    id: 'HINDUSTAN',
    name: 'Hindustan',
    'cyrillic-name': 'Хиндустан',
    popular: false,
    country: 'Индия',
    models: [
      {
        id: 'AMBASSADOR',
        name: 'Ambassador',
        'cyrillic-name': 'Амбассадор',
        class: 'C',
        'year-from': 1979,
        'year-to': 2014,
      },
      {
        id: 'CONTESSA',
        name: 'Contessa',
        'cyrillic-name': 'Контесса',
        class: 'D',
        'year-from': 1984,
        'year-to': 2002,
      },
    ],
  },
  {
    id: 'HIPHI',
    name: 'HiPhi',
    'cyrillic-name': 'Хипхи',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'X',
        name: 'X',
        'cyrillic-name': 'Х',
        class: 'F',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'Z',
        name: 'Z',
        'cyrillic-name': 'З',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'HISPANO_SUIZA',
    name: 'Hispano-Suiza',
    'cyrillic-name': 'Испано-Сюиза',
    popular: false,
    country: 'Испания',
    models: [
      {
        id: 'K6',
        name: 'K6',
        'cyrillic-name': 'К6',
        class: 'F',
        'year-from': 1934,
        'year-to': 1937,
      },
    ],
  },
  {
    id: 'HOLDEN',
    name: 'Holden',
    'cyrillic-name': 'Холден',
    popular: false,
    country: 'Австралия',
    models: [
      {
        id: 'APOLLO',
        name: 'Apollo',
        'cyrillic-name': 'Аполло',
        class: 'D',
        'year-from': 1991,
        'year-to': 1996,
      },
      {
        id: 'ASTRA',
        name: 'Astra',
        'cyrillic-name': 'Астра',
        class: 'C',
        'year-from': 1999,
        'year-to': 2004,
      },
      {
        id: 'BARINA',
        name: 'Barina',
        'cyrillic-name': 'Барина',
        class: 'B',
        'year-from': 1997,
        'year-to': 2005,
      },
      {
        id: 'CALAIS',
        name: 'Calais',
        'cyrillic-name': 'Кале',
        class: 'E',
        'year-from': 1988,
        'year-to': 2006,
      },
      {
        id: 'CAPRICE',
        name: 'Caprice',
        'cyrillic-name': 'Каприс',
        class: 'E',
        'year-from': 1990,
        'year-to': 2006,
      },
      {
        id: 'COMMODORE',
        name: 'Commodore',
        'cyrillic-name': 'Коммодор',
        class: 'D',
        'year-from': 1990,
        'year-to': 2002,
      },
      {
        id: 'CRUZE',
        name: 'Cruze',
        'cyrillic-name': 'круз',
        class: 'B',
        'year-from': 2002,
        'year-to': 2006,
      },
      {
        id: 'FRONTERA',
        name: 'Frontera',
        'cyrillic-name': 'Фронтера',
        class: 'J',
        'year-from': 1998,
        'year-to': 2003,
      },
      {
        id: 'JACKAROO',
        name: 'Jackaroo',
        'cyrillic-name': 'Джакару',
        class: 'J',
        'year-from': 1998,
        'year-to': 2003,
      },
      {
        id: 'MONARO',
        name: 'Monaro',
        'cyrillic-name': 'Монаро',
        class: 'D',
        'year-from': 2001,
        'year-to': 2005,
      },
      {
        id: 'RODEO',
        name: 'Rodeo',
        'cyrillic-name': 'Родео',
        class: 'J',
        'year-from': 1998,
        'year-to': 2003,
      },
      {
        id: 'STATESMAN',
        name: 'Statesman',
        'cyrillic-name': 'Стэйтсман',
        class: 'E',
        'year-from': 1990,
        'year-to': 2006,
      },
      {
        id: 'UTE',
        name: 'UTE',
        'cyrillic-name': 'Ю Т Е',
        class: 'J',
        'year-from': 2000,
        'year-to': 2013,
      },
      {
        id: 'VECTRA',
        name: 'Vectra',
        'cyrillic-name': 'Вектра',
        class: 'D',
        'year-from': 1998,
        'year-to': 2001,
      },
      {
        id: 'ZAFIRA',
        name: 'Zafira',
        'cyrillic-name': 'Зафира',
        class: 'M',
        'year-from': 2001,
        'year-to': 2005,
      },
    ],
  },
  {
    id: 'HONDA',
    name: 'Honda',
    'cyrillic-name': 'Хонда',
    popular: true,
    country: 'Япония',
    models: [
      {
        id: '145',
        name: '145',
        'cyrillic-name': '145',
        class: 'B',
        'year-from': 1972,
        'year-to': 1974,
      },
      {
        id: 'ACCORD',
        name: 'Accord',
        'cyrillic-name': 'Аккорд',
        class: 'D',
        'year-from': 1976,
        'year-to': null,
      },
      {
        id: 'ACTY',
        name: 'Acty',
        'cyrillic-name': 'акти',
        class: 'M',
        'year-from': 1999,
        'year-to': 2018,
      },
      {
        id: 'AIRWAVE',
        name: 'Airwave',
        'cyrillic-name': 'Эйрвэйв',
        class: 'B',
        'year-from': 2005,
        'year-to': 2010,
      },
      {
        id: 'ASCOT',
        name: 'Ascot',
        'cyrillic-name': 'Аскот',
        class: 'D',
        'year-from': 1989,
        'year-to': 1997,
      },
      {
        id: 'ASCOT_INNOVA',
        name: 'Ascot Innova',
        'cyrillic-name': 'Аскот Иннова',
        class: 'C',
        'year-from': 1992,
        'year-to': 1996,
      },
      {
        id: 'AVANCIER',
        name: 'Avancier',
        'cyrillic-name': 'Авансьер',
        class: 'D',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'BALLADE',
        name: 'Ballade',
        'cyrillic-name': 'баллада',
        class: 'B',
        'year-from': 1980,
        'year-to': 1987,
      },
      {
        id: 'BEAT',
        name: 'Beat',
        'cyrillic-name': 'Бит',
        class: 'A',
        'year-from': 1991,
        'year-to': 1996,
      },
      {
        id: 'BREEZE',
        name: 'Breeze',
        'cyrillic-name': 'Бриз',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'BRIO',
        name: 'Brio',
        'cyrillic-name': 'Брио',
        class: 'A',
        'year-from': 2011,
        'year-to': 2018,
      },
      {
        id: 'CAPA',
        name: 'Capa',
        'cyrillic-name': 'Капа',
        class: 'M',
        'year-from': 1998,
        'year-to': 2002,
      },
      {
        id: 'CITY',
        name: 'City',
        'cyrillic-name': 'Сити',
        class: 'B',
        'year-from': 1981,
        'year-to': 2014,
      },
      {
        id: 'CIVIC',
        name: 'Civic',
        'cyrillic-name': 'Цивик',
        class: 'C',
        'year-from': 1972,
        'year-to': null,
      },
      {
        id: 'CIVIC_FERIO',
        name: 'Civic Ferio',
        'cyrillic-name': 'Цивик Ферио',
        class: 'C',
        'year-from': 1991,
        'year-to': 2006,
      },
      {
        id: 'CIVIC_TYPE_R',
        name: 'Civic Type R',
        'cyrillic-name': 'Сивик Тайп Р',
        class: 'C',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'FCX_CLARITY',
        name: 'Clarity',
        'cyrillic-name': 'Кларити',
        class: 'E',
        'year-from': 2008,
        'year-to': 2021,
      },
      {
        id: 'CONCERTO',
        name: 'Concerto',
        'cyrillic-name': 'Концерто',
        class: 'C',
        'year-from': 1988,
        'year-to': 1994,
      },
      {
        id: 'CR_V',
        name: 'CR-V',
        'cyrillic-name': 'цр-в',
        class: 'C',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'CR_X',
        name: 'CR-X',
        'cyrillic-name': 'цр-кс',
        class: 'B',
        'year-from': 1983,
        'year-to': 1998,
      },
      {
        id: 'CR_Z',
        name: 'CR-Z',
        'cyrillic-name': 'цр-з',
        class: 'C',
        'year-from': 2010,
        'year-to': 2016,
      },
      {
        id: 'CRIDER',
        name: 'Crider',
        'cyrillic-name': 'Кридер',
        class: 'C',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'CROSSROAD',
        name: 'Crossroad',
        'cyrillic-name': 'Кроссроуд',
        class: 'C',
        'year-from': 2007,
        'year-to': 2010,
      },
      {
        id: 'CROSSTOUR',
        name: 'Crosstour',
        'cyrillic-name': 'Кросстур',
        class: 'E',
        'year-from': 2009,
        'year-to': 2015,
      },
      {
        id: 'DOMANI',
        name: 'Domani',
        'cyrillic-name': 'Домани',
        class: 'C',
        'year-from': 1992,
        'year-to': 2000,
      },
      {
        id: 'E',
        name: 'e',
        'cyrillic-name': 'е',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'E_NP1',
        name: 'e:NP1',
        'cyrillic-name': 'И:НП1',
        class: 'B',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'E_NS1',
        name: 'e:NS1',
        'cyrillic-name': 'Е:НС1',
        class: 'B',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'EDIX',
        name: 'Edix',
        'cyrillic-name': 'Эдикс',
        class: 'M',
        'year-from': 2004,
        'year-to': 2009,
      },
      {
        id: 'ELEMENT',
        name: 'Element',
        'cyrillic-name': 'Элемент',
        class: 'C',
        'year-from': 2002,
        'year-to': 2011,
      },
      {
        id: 'ELYSION',
        name: 'Elysion',
        'cyrillic-name': 'Элюзион',
        class: 'M',
        'year-from': 2004,
        'year-to': 2013,
      },
      {
        id: 'ENVIX',
        name: 'Envix',
        'cyrillic-name': 'Енвикс',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'FIT',
        name: 'Fit',
        'cyrillic-name': 'Фит',
        class: 'B',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'FIT_ARIA',
        name: 'Fit Aria',
        'cyrillic-name': 'Фит Ариа',
        class: 'B',
        'year-from': 2002,
        'year-to': 2009,
      },
      {
        id: 'FIT_SHUTTLE',
        name: 'Fit Shuttle',
        'cyrillic-name': 'Фит Шатл',
        class: 'B',
        'year-from': 2011,
        'year-to': 2015,
      },
      {
        id: 'FR_V',
        name: 'FR-V',
        'cyrillic-name': 'фр-в',
        class: 'M',
        'year-from': 2004,
        'year-to': 2009,
      },
      {
        id: 'FREED',
        name: 'Freed',
        'cyrillic-name': 'Фрид',
        class: 'M',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'GRACE',
        name: 'Grace',
        'cyrillic-name': 'Грейс',
        class: 'B',
        'year-from': 2014,
        'year-to': 2020,
      },
      {
        id: 'HORIZON',
        name: 'Horizon',
        'cyrillic-name': 'хорайзон',
        class: 'J',
        'year-from': 1994,
        'year-to': 1999,
      },
      {
        id: 'HR_V',
        name: 'HR-V',
        'cyrillic-name': 'хр-в',
        class: 'B',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'INSIGHT',
        name: 'Insight',
        'cyrillic-name': 'Инсайт',
        class: 'C',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'INSPIRE',
        name: 'Inspire',
        'cyrillic-name': 'инспаер',
        class: 'D',
        'year-from': 1989,
        'year-to': 2012,
      },
      {
        id: 'INTEGRA',
        name: 'Integra',
        'cyrillic-name': 'Интегра',
        class: 'S',
        'year-from': 1985,
        'year-to': 2006,
      },
      {
        id: 'INTEGRA_SJ',
        name: 'Integra SJ',
        'cyrillic-name': 'интегра сй',
        class: 'C',
        'year-from': 1996,
        'year-to': 2001,
      },
      {
        id: 'JADE',
        name: 'Jade',
        'cyrillic-name': 'джейд',
        class: 'C',
        'year-from': 2015,
        'year-to': 2020,
      },
      {
        id: 'JAZZ',
        name: 'Jazz',
        'cyrillic-name': 'Джаз',
        class: 'B',
        'year-from': 1983,
        'year-to': null,
      },
      {
        id: 'LAGREAT',
        name: 'Lagreat',
        'cyrillic-name': 'Лагрейт',
        class: 'M',
        'year-from': 1998,
        'year-to': 2005,
      },
      {
        id: 'LEGEND',
        name: 'Legend',
        'cyrillic-name': 'Легенд',
        class: 'D',
        'year-from': 1985,
        'year-to': null,
      },
      {
        id: 'LIFE',
        name: 'Life',
        'cyrillic-name': 'Лайф',
        class: 'A',
        'year-from': 1997,
        'year-to': 2014,
      },
      {
        id: 'LOGO',
        name: 'Logo',
        'cyrillic-name': 'Лого',
        class: 'B',
        'year-from': 1996,
        'year-to': 2001,
      },
      {
        id: 'MDX',
        name: 'MDX',
        'cyrillic-name': 'мдкс',
        class: 'E',
        'year-from': 2003,
        'year-to': 2006,
      },
      {
        id: 'MOBILIO',
        name: 'Mobilio',
        'cyrillic-name': 'Мобилио',
        class: 'M',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'MOBILIO_SPIKE',
        name: 'Mobilio Spike',
        'cyrillic-name': 'Мобилио Спайк',
        class: 'M',
        'year-from': 2002,
        'year-to': 2008,
      },
      {
        id: 'N_BOX',
        name: 'N-BOX',
        'cyrillic-name': 'н-бокс',
        class: 'A',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'N_BOX_SLASH',
        name: 'N-BOX Slash',
        'cyrillic-name': 'Н-БОКС Слэш',
        class: 'A',
        'year-from': 2014,
        'year-to': 2020,
      },
      {
        id: 'N_ONE',
        name: 'N-One',
        'cyrillic-name': 'Н-Уан',
        class: 'A',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'N_VAN',
        name: 'N-VAN',
        'cyrillic-name': 'Н-ВЭН',
        class: 'M',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'N_WGN',
        name: 'N-WGN',
        'cyrillic-name': 'Н-Вгн',
        class: 'A',
        'year-from': 2013,
        'year-to': 2022,
      },
      {
        id: 'N360',
        name: 'N360',
        'cyrillic-name': 'н360',
        class: 'A',
        'year-from': 1969,
        'year-to': 1970,
      },
      {
        id: 'NSX',
        name: 'NSX',
        'cyrillic-name': 'нскс',
        class: 'S',
        'year-from': 1990,
        'year-to': null,
      },
      {
        id: 'ODYSSEY',
        name: 'Odyssey',
        'cyrillic-name': 'Одисей',
        class: 'M',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'ODYSSEY_NA',
        name: 'Odyssey (North America)',
        'cyrillic-name': 'Одиссей (Северная Америка)',
        class: 'M',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'ORTHIA',
        name: 'Orthia',
        'cyrillic-name': 'ортхия',
        class: 'C',
        'year-from': 1996,
        'year-to': 2002,
      },
      {
        id: 'PARTNER',
        name: 'Partner',
        'cyrillic-name': 'Партнер',
        class: 'C',
        'year-from': 1996,
        'year-to': 2010,
      },
      {
        id: 'PASSPORT',
        name: 'Passport',
        'cyrillic-name': 'Пасспорт',
        class: 'D',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'PILOT',
        name: 'Pilot',
        'cyrillic-name': 'Пилот',
        class: 'E',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'PRELUDE',
        name: 'Prelude',
        'cyrillic-name': 'Прелюд',
        class: 'C',
        'year-from': 1978,
        'year-to': 2001,
      },
      {
        id: 'QUINT',
        name: 'Quint',
        'cyrillic-name': 'Квинт',
        class: 'C',
        'year-from': 1980,
        'year-to': 1989,
      },
      {
        id: 'RAFAGA',
        name: 'Rafaga',
        'cyrillic-name': 'Рафага',
        class: 'C',
        'year-from': 1993,
        'year-to': 1997,
      },
      {
        id: 'RIDGELINE',
        name: 'Ridgeline',
        'cyrillic-name': 'Риджлайн',
        class: 'J',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'S_MX',
        name: 'S-MX',
        'cyrillic-name': 'СМИкс',
        class: 'M',
        'year-from': 1996,
        'year-to': 2002,
      },
      {
        id: 'S2000',
        name: 'S2000',
        'cyrillic-name': 'с2000',
        class: 'S',
        'year-from': 1999,
        'year-to': 2009,
      },
      {
        id: 'S500',
        name: 'S500',
        'cyrillic-name': 'с500',
        class: 'A',
        'year-from': 1963,
        'year-to': 1964,
      },
      {
        id: 'S600',
        name: 'S600',
        'cyrillic-name': 'с600',
        class: 'A',
        'year-from': 1964,
        'year-to': 1966,
      },
      {
        id: 'S660',
        name: 'S660',
        'cyrillic-name': 'С660',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'SABER',
        name: 'Saber',
        'cyrillic-name': 'Сабер',
        class: 'D',
        'year-from': 1995,
        'year-to': 2003,
      },
      {
        id: 'SHUTTLE',
        name: 'Shuttle',
        'cyrillic-name': 'Шатл',
        class: 'B',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'STEPWAGON',
        name: 'Stepwgn',
        'cyrillic-name': 'Степвагон',
        class: 'M',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'STREAM',
        name: 'Stream',
        'cyrillic-name': 'Стрим',
        class: 'M',
        'year-from': 2000,
        'year-to': 2014,
      },
      {
        id: 'STREET',
        name: 'Street',
        'cyrillic-name': 'Стрит',
        class: 'M',
        'year-from': 1988,
        'year-to': 1998,
      },
      {
        id: 'THATS',
        name: "That'S",
        'cyrillic-name': "тхат'с",
        class: 'A',
        'year-from': 2002,
        'year-to': 2007,
      },
      {
        id: 'TODAY',
        name: 'Today',
        'cyrillic-name': 'Тудей',
        class: 'A',
        'year-from': 1985,
        'year-to': 1998,
      },
      {
        id: 'TORNEO',
        name: 'Torneo',
        'cyrillic-name': 'Торнео',
        class: 'D',
        'year-from': 1997,
        'year-to': 2002,
      },
      {
        id: 'UR_V',
        name: 'UR-V',
        'cyrillic-name': 'ЮР-В',
        class: 'J',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'VAMOS',
        name: 'Vamos',
        'cyrillic-name': 'Вамос',
        class: 'M',
        'year-from': 1999,
        'year-to': 2018,
      },
      {
        id: 'VEZEL',
        name: 'Vezel',
        'cyrillic-name': 'Везел',
        class: 'B',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'VIGOR',
        name: 'Vigor',
        'cyrillic-name': 'Вигор',
        class: 'D',
        'year-from': 1989,
        'year-to': 1998,
      },
      {
        id: 'XR_V',
        name: 'XR-V',
        'cyrillic-name': 'ХР-В',
        class: 'B',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'Z',
        name: 'Z',
        'cyrillic-name': 'з',
        class: 'A',
        'year-from': 1998,
        'year-to': 2002,
      },
      {
        id: 'ZEST',
        name: 'Zest',
        'cyrillic-name': 'Зест',
        class: 'A',
        'year-from': 2006,
        'year-to': 2012,
      },
      {
        id: 'ZR_V',
        name: 'ZR-V',
        'cyrillic-name': 'ЗР-В',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'HONGQI',
    name: 'Hongqi',
    'cyrillic-name': 'Хонгки',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'E_HS3',
        name: 'E-HS3',
        'cyrillic-name': 'Е-ХС3',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'E_HS9',
        name: 'E-HS9',
        'cyrillic-name': 'Е-ХС9',
        class: 'F',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'E_QM5',
        name: 'E-QM5',
        'cyrillic-name': 'Е-КьюМ5',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'H5',
        name: 'H5',
        'cyrillic-name': 'Х5',
        class: 'D',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'H7',
        name: 'H7',
        'cyrillic-name': 'Х7',
        class: 'E',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'H9',
        name: 'H9',
        'cyrillic-name': 'АШ9',
        class: 'F',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'HQ9',
        name: 'HQ9',
        'cyrillic-name': 'ЭйчКью 9',
        class: 'M',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'HS5',
        name: 'HS5',
        'cyrillic-name': 'ХС5',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'HS7',
        name: 'HS7',
        'cyrillic-name': 'хс7',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'L5',
        name: 'L5',
        'cyrillic-name': 'Л5',
        class: 'F',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'LS7',
        name: 'LS7',
        'cyrillic-name': 'ЛС7',
        class: 'F',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'HORCH',
    name: 'Horch',
    'cyrillic-name': 'Хорьх',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: '830',
        name: '830',
        'cyrillic-name': '830',
        class: 'E',
        'year-from': 1933,
        'year-to': 1940,
      },
      {
        id: '853',
        name: '853',
        'cyrillic-name': '853',
        class: 'S',
        'year-from': 1935,
        'year-to': 1939,
      },
    ],
  },
  {
    id: 'HOZON',
    name: 'Hozon',
    'cyrillic-name': 'Хозон',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'NETA_U',
        name: 'Neta U',
        'cyrillic-name': 'Нета Ю',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'HSV',
    name: 'HSV',
    'cyrillic-name': 'ХСВ',
    popular: false,
    country: 'Австралия',
    models: [
      {
        id: 'MALOO',
        name: 'Maloo',
        'cyrillic-name': 'Малу',
        class: 'J',
        'year-from': 2013,
        'year-to': 2017,
      },
    ],
  },
  {
    id: 'HUANGHAI',
    name: 'HuangHai',
    'cyrillic-name': 'ХуангХай',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'ANTELOPE',
        name: 'Antelope',
        'cyrillic-name': 'Антелоп',
        class: 'J',
        'year-from': 2006,
        'year-to': 2009,
      },
      {
        id: 'LANDSCAPE',
        name: 'Landscape',
        'cyrillic-name': 'лендскейп',
        class: 'D',
        'year-from': 2007,
        'year-to': 2011,
      },
      {
        id: 'PLUTUS',
        name: 'Plutus',
        'cyrillic-name': 'плютус',
        class: 'J',
        'year-from': 2007,
        'year-to': 2011,
      },
    ],
  },
  {
    id: 'HUDSON',
    name: 'Hudson',
    'cyrillic-name': 'Хадсон',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'DELUXE_EIGHT',
        name: 'Deluxe Eight',
        'cyrillic-name': 'Делюкс Эйт',
        class: '',
        'year-from': 1936,
        'year-to': 1937,
      },
      {
        id: 'SUPER_SIX',
        name: 'Super Six',
        'cyrillic-name': 'супер сикс',
        class: '',
        'year-from': 1916,
        'year-to': 1928,
      },
    ],
  },
  {
    id: 'HUMMER',
    name: 'Hummer',
    'cyrillic-name': 'Хаммер',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'H1',
        name: 'H1',
        'cyrillic-name': 'н1',
        class: 'J',
        'year-from': 1992,
        'year-to': 2006,
      },
      {
        id: 'H2',
        name: 'H2',
        'cyrillic-name': 'н2',
        class: 'J',
        'year-from': 2002,
        'year-to': 2009,
      },
      {
        id: 'H3',
        name: 'H3',
        'cyrillic-name': 'н3',
        class: 'J',
        'year-from': 2005,
        'year-to': 2010,
      },
    ],
  },
  {
    id: 'HYUNDAI',
    name: 'Hyundai',
    'cyrillic-name': 'Хендай',
    popular: true,
    country: 'Южная Корея',
    models: [
      {
        id: 'ACCENT',
        name: 'Accent',
        'cyrillic-name': 'Акцент',
        class: 'B',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'ASLAN',
        name: 'Aslan',
        'cyrillic-name': 'Аслан',
        class: 'E',
        'year-from': 2014,
        'year-to': 2018,
      },
      {
        id: 'ATOS',
        name: 'Atos',
        'cyrillic-name': 'Атос',
        class: 'A',
        'year-from': 1997,
        'year-to': 2008,
      },
      {
        id: 'AVANTE',
        name: 'Avante',
        'cyrillic-name': 'Авант',
        class: 'C',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'AVANTE_N',
        name: 'Avante N',
        'cyrillic-name': 'Аванте Н',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'AZERA',
        name: 'Azera',
        'cyrillic-name': 'азера',
        class: 'E',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'BAYON',
        name: 'Bayon',
        'cyrillic-name': 'Байон',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'CASPER',
        name: 'Casper',
        'cyrillic-name': 'Каспер',
        class: 'A',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'CELESTA',
        name: 'Celesta',
        'cyrillic-name': 'Селеста',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'CENTENNIAL',
        name: 'Centennial',
        'cyrillic-name': 'Сентенниал',
        class: 'F',
        'year-from': 1999,
        'year-to': 2008,
      },
      {
        id: 'CLICK',
        name: 'Click',
        'cyrillic-name': 'Клик',
        class: 'B',
        'year-from': 2002,
        'year-to': 2011,
      },
      {
        id: 'COUPE',
        name: 'Coupe',
        'cyrillic-name': 'Купе',
        class: 'C',
        'year-from': 1996,
        'year-to': 2009,
      },
      {
        id: 'CRETA',
        name: 'Creta',
        'cyrillic-name': 'Крета',
        class: 'B',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'CUSTO',
        name: 'Custo',
        'cyrillic-name': 'Касто',
        class: 'M',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'DYNASTY',
        name: 'Dynasty',
        'cyrillic-name': 'Династи',
        class: 'E',
        'year-from': 1996,
        'year-to': 2005,
      },
      {
        id: 'ELANTRA',
        name: 'Elantra',
        'cyrillic-name': 'Элантра',
        class: 'C',
        'year-from': 1990,
        'year-to': null,
      },
      {
        id: 'ELANTRA_N',
        name: 'Elantra N',
        'cyrillic-name': 'Элантра Н',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'ENCINO',
        name: 'Encino',
        'cyrillic-name': 'Инсино',
        class: 'B',
        'year-from': 2018,
        'year-to': 2020,
      },
      {
        id: 'ENTOURAGE',
        name: 'Entourage',
        'cyrillic-name': 'Энтураж',
        class: 'M',
        'year-from': 2006,
        'year-to': 2009,
      },
      {
        id: 'EON',
        name: 'EON',
        'cyrillic-name': 'еон',
        class: 'A',
        'year-from': 2011,
        'year-to': 2019,
      },
      {
        id: 'EQUUS',
        name: 'Equus',
        'cyrillic-name': 'Экус',
        class: 'F',
        'year-from': 1999,
        'year-to': 2016,
      },
      {
        id: 'EXCEL',
        name: 'Excel',
        'cyrillic-name': 'Эксель',
        class: 'C',
        'year-from': 1985,
        'year-to': 1998,
      },
      {
        id: 'GALLOPER',
        name: 'Galloper',
        'cyrillic-name': 'Галлопер',
        class: 'J',
        'year-from': 1991,
        'year-to': 2003,
      },
      {
        id: 'GENESIS',
        name: 'Genesis',
        'cyrillic-name': 'Дженесис',
        class: 'E',
        'year-from': 2008,
        'year-to': 2016,
      },
      {
        id: 'GENESIS_COUPE',
        name: 'Genesis Coupe',
        'cyrillic-name': 'Дженесис Купе',
        class: 'D',
        'year-from': 2009,
        'year-to': 2016,
      },
      {
        id: 'GETZ',
        name: 'Getz',
        'cyrillic-name': 'Гетц',
        class: 'B',
        'year-from': 2002,
        'year-to': 2011,
      },
      {
        id: 'GRACE',
        name: 'Grace',
        'cyrillic-name': 'Грейс',
        class: 'M',
        'year-from': 1986,
        'year-to': 2004,
      },
      {
        id: 'GRAND_STAREX',
        name: 'Grand Starex',
        'cyrillic-name': 'Гранд Старекс',
        class: 'M',
        'year-from': 2007,
        'year-to': 2021,
      },
      {
        id: 'GRANDEUR',
        name: 'Grandeur',
        'cyrillic-name': 'Грандер',
        class: 'E',
        'year-from': 1986,
        'year-to': null,
      },
      {
        id: 'H_1_STAREX',
        name: 'H-1',
        'cyrillic-name': 'Н-1',
        class: 'M',
        'year-from': 1997,
        'year-to': 2021,
      },
      {
        id: 'H200',
        name: 'H200',
        'cyrillic-name': 'н200',
        class: 'M',
        'year-from': 1997,
        'year-to': 2007,
      },
      {
        id: 'HB20',
        name: 'HB20',
        'cyrillic-name': 'ЭйчБ20',
        class: 'B',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'I10',
        name: 'i10',
        'cyrillic-name': 'и10',
        class: 'A',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'I20',
        name: 'i20',
        'cyrillic-name': 'и20',
        class: 'B',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'I20_N',
        name: 'i20 N',
        'cyrillic-name': 'Ай20 Н',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'I30',
        name: 'i30',
        'cyrillic-name': 'и30',
        class: 'C',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'I30_N',
        name: 'i30 N',
        'cyrillic-name': 'и30 н',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'I40',
        name: 'i40',
        'cyrillic-name': 'и40',
        class: 'D',
        'year-from': 2011,
        'year-to': 2019,
      },
      {
        id: 'IONIQ',
        name: 'IONIQ',
        'cyrillic-name': 'Ионик',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'IONIQ_5',
        name: 'IONIQ 5',
        'cyrillic-name': 'ИОНИК 5',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'IONIQ_6',
        name: 'IONIQ 6',
        'cyrillic-name': 'ИОНИК 6',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'IX20',
        name: 'ix20',
        'cyrillic-name': 'икс20',
        class: 'B',
        'year-from': 2010,
        'year-to': 2019,
      },
      {
        id: 'IX35',
        name: 'ix35',
        'cyrillic-name': 'икс35',
        class: 'C',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'IX55',
        name: 'ix55',
        'cyrillic-name': 'икс55',
        class: 'E',
        'year-from': 2008,
        'year-to': 2013,
      },
      {
        id: 'KONA',
        name: 'Kona',
        'cyrillic-name': 'Кона',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'KONA_N',
        name: 'Kona N',
        'cyrillic-name': 'Кона Н',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'LANTRA',
        name: 'Lantra',
        'cyrillic-name': 'Лантра',
        class: 'C',
        'year-from': 1990,
        'year-to': 2000,
      },
      {
        id: 'LAVITA',
        name: 'Lavita',
        'cyrillic-name': 'Лавита',
        class: 'M',
        'year-from': 2001,
        'year-to': 2007,
      },
      {
        id: 'MARCIA',
        name: 'Marcia',
        'cyrillic-name': 'Марсиа',
        class: 'D',
        'year-from': 1995,
        'year-to': 1998,
      },
      {
        id: 'MATRIX',
        name: 'Matrix',
        'cyrillic-name': 'Матрикс',
        class: 'M',
        'year-from': 2001,
        'year-to': 2010,
      },
      {
        id: 'MAXCRUZ',
        name: 'Maxcruz',
        'cyrillic-name': 'Макскруз',
        class: 'D',
        'year-from': 2012,
        'year-to': 2020,
      },
      {
        id: 'MISTRA',
        name: 'Mistra',
        'cyrillic-name': 'Мистра',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'PALISADE',
        name: 'Palisade',
        'cyrillic-name': 'Палисад',
        class: 'E',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'PONY',
        name: 'Pony',
        'cyrillic-name': 'Пони',
        class: 'C',
        'year-from': 1975,
        'year-to': 1994,
      },
      {
        id: 'SANTA_CRUZ',
        name: 'Santa Cruz',
        'cyrillic-name': 'Санта Круз',
        class: 'J',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'SANTA_FE',
        name: 'Santa Fe',
        'cyrillic-name': 'Санта Фе',
        class: 'D',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'SANTAMO',
        name: 'Santamo',
        'cyrillic-name': 'Сантамо',
        class: 'M',
        'year-from': 1995,
        'year-to': 2002,
      },
      {
        id: 'SCOUPE',
        name: 'Scoupe',
        'cyrillic-name': 'С купе',
        class: 'C',
        'year-from': 1988,
        'year-to': 1996,
      },
      {
        id: 'SOLARIS',
        name: 'Solaris',
        'cyrillic-name': 'Солярис',
        class: 'B',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'SONATA',
        name: 'Sonata',
        'cyrillic-name': 'Соната',
        class: 'D',
        'year-from': 1988,
        'year-to': null,
      },
      {
        id: 'STAREX',
        name: 'Starex',
        'cyrillic-name': 'Старекс',
        class: 'M',
        'year-from': 1996,
        'year-to': 2007,
      },
      {
        id: 'STARIA',
        name: 'Staria',
        'cyrillic-name': 'Стария',
        class: 'M',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'STELLAR',
        name: 'Stellar',
        'cyrillic-name': 'Стеллар',
        class: 'D',
        'year-from': 1983,
        'year-to': 1993,
      },
      {
        id: 'TERRACAN',
        name: 'Terracan',
        'cyrillic-name': 'Терракан',
        class: 'J',
        'year-from': 2001,
        'year-to': 2007,
      },
      {
        id: 'TIBURON',
        name: 'Tiburon',
        'cyrillic-name': 'Тибурон',
        class: 'S',
        'year-from': 1996,
        'year-to': 2009,
      },
      {
        id: 'TRAJET',
        name: 'Trajet',
        'cyrillic-name': 'Траджет',
        class: 'M',
        'year-from': 1999,
        'year-to': 2008,
      },
      {
        id: 'TUCSON',
        name: 'Tucson',
        'cyrillic-name': 'Туксон',
        class: 'C',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'TUSCANI',
        name: 'Tuscani',
        'cyrillic-name': 'Тускани',
        class: 'C',
        'year-from': 2001,
        'year-to': 2009,
      },
      {
        id: 'VELOSTER',
        name: 'Veloster',
        'cyrillic-name': 'Велостер',
        class: 'C',
        'year-from': 2011,
        'year-to': 2022,
      },
      {
        id: 'VENUE',
        name: 'Venue',
        'cyrillic-name': 'Венуе',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'VERACRUZ',
        name: 'Veracruz',
        'cyrillic-name': 'Веракруз',
        class: 'E',
        'year-from': 2006,
        'year-to': 2015,
      },
      {
        id: 'VERNA',
        name: 'Verna',
        'cyrillic-name': 'Верна',
        class: 'B',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'XG',
        name: 'XG',
        'cyrillic-name': 'ксг',
        class: 'E',
        'year-from': 1998,
        'year-to': 2005,
      },
    ],
  },
  {
    id: 'IG',
    name: 'ИЖ',
    'cyrillic-name': 'ИЖ',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: '2125',
        name: '2125 «Комби»',
        'cyrillic-name': '2125 Комби',
        class: 'C',
        'year-from': 1973,
        'year-to': 1997,
      },
      {
        id: '2126',
        name: '2126 «Ода»',
        'cyrillic-name': '2126 Ода',
        class: 'B',
        'year-from': 1990,
        'year-to': 2005,
      },
      {
        id: '21261_FABULA',
        name: '21261 «Фабула»',
        'cyrillic-name': '21261 Фабула',
        class: 'B',
        'year-from': 2004,
        'year-to': 2005,
      },
      {
        id: '2715',
        name: '2715',
        'cyrillic-name': '2715',
        class: 'B',
        'year-from': 1972,
        'year-to': 2001,
      },
      {
        id: '2717',
        name: '2717',
        'cyrillic-name': '2717',
        class: 'B',
        'year-from': 1997,
        'year-to': 2005,
      },
      {
        id: '27175',
        name: '27175',
        'cyrillic-name': '27175',
        class: 'B',
        'year-from': 2005,
        'year-to': 2012,
      },
      {
        id: '412',
        name: 'Москвич-412',
        'cyrillic-name': '412',
        class: 'C',
        'year-from': 1967,
        'year-to': 1998,
      },
    ],
  },
  {
    id: 'INFINITI',
    name: 'Infiniti',
    'cyrillic-name': 'Инфинити',
    popular: false,
    country: 'Япония',
    models: [
      {
        id: 'EX',
        name: 'EX',
        'cyrillic-name': 'екс',
        class: 'D',
        'year-from': 2007,
        'year-to': 2013,
      },
      {
        id: 'FX',
        name: 'FX',
        'cyrillic-name': 'фкс',
        class: 'E',
        'year-from': 2002,
        'year-to': 2013,
      },
      {
        id: 'G35',
        name: 'G',
        'cyrillic-name': 'г',
        class: 'D',
        'year-from': 1991,
        'year-to': 2013,
      },
      {
        id: 'I',
        name: 'I',
        'cyrillic-name': 'и',
        class: 'E',
        'year-from': 1995,
        'year-to': 2004,
      },
      {
        id: 'J30',
        name: 'J',
        'cyrillic-name': 'й',
        class: 'E',
        'year-from': 1992,
        'year-to': 1997,
      },
      {
        id: 'JX',
        name: 'JX',
        'cyrillic-name': 'джей икс',
        class: 'E',
        'year-from': 2012,
        'year-to': 2014,
      },
      {
        id: 'M',
        name: 'M',
        'cyrillic-name': 'м',
        class: 'E',
        'year-from': 1989,
        'year-to': 2013,
      },
      {
        id: 'Q',
        name: 'Q',
        'cyrillic-name': 'к',
        class: 'F',
        'year-from': 1989,
        'year-to': 2006,
      },
      {
        id: 'Q30',
        name: 'Q30',
        'cyrillic-name': 'ку 30',
        class: 'C',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'Q40',
        name: 'Q40',
        'cyrillic-name': 'ку 40',
        class: 'E',
        'year-from': 2014,
        'year-to': 2015,
      },
      {
        id: 'Q50',
        name: 'Q50',
        'cyrillic-name': 'к50',
        class: 'D',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'Q60',
        name: 'Q60',
        'cyrillic-name': 'ку 60',
        class: 'D',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'Q70',
        name: 'Q70',
        'cyrillic-name': 'ку 70',
        class: 'E',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'QX30',
        name: 'QX30',
        'cyrillic-name': 'ку икс 30',
        class: 'C',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'QX4',
        name: 'QX4',
        'cyrillic-name': 'Ку Икс 4',
        class: 'J',
        'year-from': 1996,
        'year-to': 2003,
      },
      {
        id: 'QX50',
        name: 'QX50',
        'cyrillic-name': 'ку икс 50',
        class: 'D',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'QX55',
        name: 'QX55',
        'cyrillic-name': 'КуИкс55',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'QX56',
        name: 'QX56',
        'cyrillic-name': 'ккс56',
        class: 'J',
        'year-from': 2004,
        'year-to': 2013,
      },
      {
        id: 'QX60',
        name: 'QX60',
        'cyrillic-name': 'ку икс 60',
        class: 'E',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'QX70',
        name: 'QX70',
        'cyrillic-name': 'ку икс 70',
        class: 'E',
        'year-from': 2013,
        'year-to': 2017,
      },
      {
        id: 'QX80',
        name: 'QX80',
        'cyrillic-name': 'ку икс 80',
        class: 'J',
        'year-from': 2013,
        'year-to': null,
      },
    ],
  },
  {
    id: 'INNOCENTI',
    name: 'Innocenti',
    'cyrillic-name': 'Инноченти',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'ELBA',
        name: 'Elba',
        'cyrillic-name': 'ельба',
        class: 'B',
        'year-from': 1991,
        'year-to': 1997,
      },
      {
        id: 'MILLE',
        name: 'Mille',
        'cyrillic-name': 'милле',
        class: 'B',
        'year-from': 1994,
        'year-to': 1997,
      },
      {
        id: 'MINI',
        name: 'Mini',
        'cyrillic-name': 'мини',
        class: 'A',
        'year-from': 1965,
        'year-to': 1993,
      },
    ],
  },
  {
    id: 'INTERNATIONAL',
    name: 'International',
    'cyrillic-name': 'Интернейшионал',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'TRAVELALL',
        name: 'Travelall',
        'cyrillic-name': 'Трэйвелолл',
        class: 'J',
        'year-from': 1969,
        'year-to': 1975,
      },
    ],
  },
  {
    id: 'INVICTA',
    name: 'Invicta',
    'cyrillic-name': 'Инвикта',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'S1',
        name: 'S1',
        'cyrillic-name': 'с1',
        class: 'S',
        'year-from': 2004,
        'year-to': 2012,
      },
    ],
  },
  {
    id: 'IRAN_KHODRO',
    name: 'Iran Khodro',
    'cyrillic-name': 'Иран Ходро',
    popular: false,
    country: 'Иран',
    models: [
      {
        id: 'ARISUN',
        name: 'Arisun',
        'cyrillic-name': 'арисун',
        class: 'C',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'DENA',
        name: 'Dena',
        'cyrillic-name': 'дена',
        class: 'C',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'PAYKAN',
        name: 'Paykan',
        'cyrillic-name': 'Пайкан',
        class: 'C',
        'year-from': 1985,
        'year-to': 2005,
      },
      {
        id: 'RUNNA',
        name: 'Runna',
        'cyrillic-name': 'рунна',
        class: 'B',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'SAHRA',
        name: 'Sahra',
        'cyrillic-name': 'Сахра',
        class: 'J',
        'year-from': 1989,
        'year-to': 2001,
      },
      {
        id: 'SAMAND',
        name: 'Samand',
        'cyrillic-name': 'саманд',
        class: 'C',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'SARIR',
        name: 'Sarir',
        'cyrillic-name': 'сарир',
        class: 'D',
        'year-from': 2006,
        'year-to': 2017,
      },
      {
        id: 'SOREN',
        name: 'Soren',
        'cyrillic-name': 'сорен',
        class: 'C',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'TARA',
        name: 'Tara',
        'cyrillic-name': 'Тара',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ISDERA',
    name: 'Isdera',
    'cyrillic-name': 'Исдера',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'COMMENDATORE_112I',
        name: 'Commendatore 112i',
        'cyrillic-name': 'цоммендаторе 112и',
        class: 'S',
        'year-from': 1993,
        'year-to': 1993,
      },
      {
        id: 'IMPERATOR_108I',
        name: 'Imperator 108i',
        'cyrillic-name': 'император 108и',
        class: 'S',
        'year-from': 1984,
        'year-to': 1993,
      },
      {
        id: 'SPYDER',
        name: 'Spyder',
        'cyrillic-name': 'спайдер',
        class: 'S',
        'year-from': 1983,
        'year-to': 1993,
      },
    ],
  },
  {
    id: 'ISUZU',
    name: 'Isuzu',
    'cyrillic-name': 'Исузу',
    popular: false,
    country: 'Япония',
    models: [
      {
        id: '117',
        name: '117',
        'cyrillic-name': '117',
        class: 'S',
        'year-from': 1968,
        'year-to': 1981,
      },
      {
        id: 'AMIGO',
        name: 'Amigo',
        'cyrillic-name': 'амиго',
        class: 'J',
        'year-from': 1989,
        'year-to': 2000,
      },
      {
        id: 'ASCENDER',
        name: 'Ascender',
        'cyrillic-name': 'Асендер',
        class: 'J',
        'year-from': 2003,
        'year-to': 2008,
      },
      {
        id: 'ASKA',
        name: 'Aska',
        'cyrillic-name': 'Аска',
        class: 'C',
        'year-from': 1983,
        'year-to': 2002,
      },
      {
        id: 'AXIOM',
        name: 'Axiom',
        'cyrillic-name': 'аксиом',
        class: 'J',
        'year-from': 2002,
        'year-to': 2004,
      },
      {
        id: 'BELLETT',
        name: 'Bellett',
        'cyrillic-name': 'Беллетт',
        class: 'C',
        'year-from': 1963,
        'year-to': 1973,
      },
      {
        id: 'BIGHORN',
        name: 'Bighorn',
        'cyrillic-name': 'Бигхорн',
        class: 'J',
        'year-from': 1981,
        'year-to': 2002,
      },
      {
        id: 'D_MAX',
        name: 'D-Max',
        'cyrillic-name': 'Д-Макс',
        class: 'J',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'FARGO',
        name: 'Fargo',
        'cyrillic-name': 'Фарго',
        class: 'M',
        'year-from': 1980,
        'year-to': 2002,
      },
      {
        id: 'FARGO_FILLY',
        name: 'Fargo Filly',
        'cyrillic-name': 'Фарго Филли',
        class: 'M',
        'year-from': 1997,
        'year-to': 2005,
      },
      {
        id: 'FLORIAN',
        name: 'Florian',
        'cyrillic-name': 'Флориан',
        class: 'C',
        'year-from': 1967,
        'year-to': 1983,
      },
      {
        id: 'GEMINI',
        name: 'Gemini',
        'cyrillic-name': 'Джемини',
        class: 'B',
        'year-from': 1974,
        'year-to': 2000,
      },
      {
        id: 'HOMBRE',
        name: 'Hombre',
        'cyrillic-name': 'Хомбрэ',
        class: 'J',
        'year-from': 1995,
        'year-to': 2000,
      },
      {
        id: 'IMPULSE',
        name: 'Impulse',
        'cyrillic-name': 'Импульс',
        class: 'C',
        'year-from': 1983,
        'year-to': 1993,
      },
      {
        id: 'KB',
        name: 'KB',
        'cyrillic-name': 'КБ',
        class: 'J',
        'year-from': 1980,
        'year-to': 2003,
      },
      {
        id: 'MIDI',
        name: 'Midi',
        'cyrillic-name': 'Миди',
        class: 'M',
        'year-from': 1986,
        'year-to': 1996,
      },
      {
        id: 'MU',
        name: 'MU',
        'cyrillic-name': 'му',
        class: 'J',
        'year-from': 1989,
        'year-to': 2004,
      },
      {
        id: 'MU_7',
        name: 'MU-7',
        'cyrillic-name': 'му-7',
        class: 'J',
        'year-from': 2004,
        'year-to': 2013,
      },
      {
        id: 'MU_X',
        name: 'MU-X',
        'cyrillic-name': 'му-х',
        class: 'J',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'OASIS',
        name: 'Oasis',
        'cyrillic-name': 'Оазис',
        class: 'M',
        'year-from': 1995,
        'year-to': 1999,
      },
      {
        id: 'PIAZZA',
        name: 'Piazza',
        'cyrillic-name': 'пиаза',
        class: 'C',
        'year-from': 1980,
        'year-to': 1993,
      },
      {
        id: 'RODEO',
        name: 'Rodeo',
        'cyrillic-name': 'родео',
        class: 'J',
        'year-from': 1989,
        'year-to': 2004,
      },
      {
        id: 'STYLUS',
        name: 'Stylus',
        'cyrillic-name': 'Стилус',
        class: 'C',
        'year-from': 1990,
        'year-to': 1993,
      },
      {
        id: 'TF',
        name: 'TF (Pickup)',
        'cyrillic-name': 'ТФ',
        class: 'J',
        'year-from': 1988,
        'year-to': 2002,
      },
      {
        id: 'TROOPER',
        name: 'Trooper',
        'cyrillic-name': 'Трупер',
        class: 'J',
        'year-from': 1981,
        'year-to': 2002,
      },
      {
        id: 'VEHI_CROSS',
        name: 'VehiCross',
        'cyrillic-name': 'Викросс',
        class: 'J',
        'year-from': 1997,
        'year-to': 2001,
      },
      {
        id: 'WIZARD',
        name: 'Wizard',
        'cyrillic-name': 'Визард',
        class: 'J',
        'year-from': 1990,
        'year-to': 2004,
      },
    ],
  },
  {
    id: 'IVECO',
    name: 'IVECO',
    'cyrillic-name': 'Ивеко',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'MASSIF',
        name: 'Massif',
        'cyrillic-name': 'Массиф',
        class: 'J',
        'year-from': 2007,
        'year-to': 2011,
      },
    ],
  },
  {
    id: 'JAC',
    name: 'JAC',
    'cyrillic-name': 'Джак',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'IEV7L',
        name: 'iEV7L',
        'cyrillic-name': 'Айев7л',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'IEV7S',
        name: 'iEV7S',
        'cyrillic-name': 'иев7с',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'IEVA50',
        name: 'iEVA50',
        'cyrillic-name': 'Айева50',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'IEVS4',
        name: 'iEVS4',
        'cyrillic-name': 'ИЕВС4',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'J2',
        name: 'J2 (Yueyue)',
        'cyrillic-name': 'й2 (юеюе)',
        class: 'A',
        'year-from': 2010,
        'year-to': 2016,
      },
      {
        id: 'J3',
        name: 'J3 (Tongyue,Tojoy)',
        'cyrillic-name': 'й3 (тонгюе,тойоы)',
        class: 'B',
        'year-from': 2009,
        'year-to': 2017,
      },
      {
        id: 'J4',
        name: 'J4 (Heyue A30)',
        'cyrillic-name': 'й4 (хеюе а30)',
        class: 'B',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'J5',
        name: 'J5 (Heyue)',
        'cyrillic-name': 'й5 (хеюе)',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'J6',
        name: 'J6 (Heyue RS)',
        'cyrillic-name': 'й6 (хеюе рс)',
        class: 'M',
        'year-from': 2009,
        'year-to': 2015,
      },
      {
        id: 'J7',
        name: 'J7',
        'cyrillic-name': 'й7',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'J7_BINYUE',
        name: 'J7 (Binyue)',
        'cyrillic-name': 'й7 (бинюе)',
        class: 'D',
        'year-from': 2007,
        'year-to': 2015,
      },
      {
        id: 'JS4',
        name: 'JS4',
        'cyrillic-name': 'ДжиЭс4',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'JS6',
        name: 'JS6',
        'cyrillic-name': 'ДжиЭс6',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'REFINE',
        name: 'M1 (Refine)',
        'cyrillic-name': 'м1 (рефине)',
        class: 'M',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'M5',
        name: 'M5',
        'cyrillic-name': 'м5',
        class: 'M',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'S1_REIN',
        name: 'S1 (Rein)',
        'cyrillic-name': 'С1 (Рейн)',
        class: 'J',
        'year-from': 2007,
        'year-to': 2013,
      },
      {
        id: 'S_3',
        name: 'S3',
        'cyrillic-name': 'с3',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'S5',
        name: 'S5 (Eagle)',
        'cyrillic-name': 'С5 (Игл)',
        class: 'C',
        'year-from': 2013,
        'year-to': 2021,
      },
      {
        id: 'S7',
        name: 'S7',
        'cyrillic-name': 'с7',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'SEHOL_A5_PLUS',
        name: 'Sehol A5 Plus',
        'cyrillic-name': 'Сехол А5 Плюс',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'SEHOL_AIPAO',
        name: 'Sehol Aipao',
        'cyrillic-name': 'Сехол Айпао',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'SEHOL_E20X',
        name: 'Sehol E20X',
        'cyrillic-name': 'Сехол Е20Х',
        class: 'B',
        'year-from': 2018,
        'year-to': 2021,
      },
      {
        id: 'SEHOL_X8',
        name: 'Sehol X8',
        'cyrillic-name': 'Сехол Икс8',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'SEHOL_X8_PLUS',
        name: 'Sehol X8 Plus',
        'cyrillic-name': 'Сехол Икс8 плюс',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'T6',
        name: 'T6',
        'cyrillic-name': 'Т6',
        class: 'J',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'T8_PRO',
        name: 'T8 Pro',
        'cyrillic-name': 'т8 про',
        class: 'J',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'JAGUAR',
    name: 'Jaguar',
    'cyrillic-name': 'Ягуар',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'E_PACE',
        name: 'E-Pace',
        'cyrillic-name': 'Е-Пейс',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'E_TYPE',
        name: 'E-type',
        'cyrillic-name': 'Е-Тайп',
        class: 'S',
        'year-from': 1961,
        'year-to': 1975,
      },
      {
        id: 'F_PACE',
        name: 'F-Pace',
        'cyrillic-name': 'ф-паце',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'F_TYPE',
        name: 'F-Type',
        'cyrillic-name': 'Ф-Тайп',
        class: 'S',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'I_PACE',
        name: 'I-Pace',
        'cyrillic-name': 'Ай-Пейс',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'MARK_2',
        name: 'Mark 2',
        'cyrillic-name': 'Марк 2',
        class: 'E',
        'year-from': 1959,
        'year-to': 1967,
      },
      {
        id: 'MARK_IX',
        name: 'Mark IX',
        'cyrillic-name': 'Марк 9',
        class: 'F',
        'year-from': 1958,
        'year-to': 1961,
      },
      {
        id: 'S_TYPE',
        name: 'S-Type',
        'cyrillic-name': 'с-тыпе',
        class: 'F',
        'year-from': 1998,
        'year-to': 2008,
      },
      {
        id: 'X_TYPE',
        name: 'X-Type',
        'cyrillic-name': 'кс-тыпе',
        class: 'D',
        'year-from': 2001,
        'year-to': 2009,
      },
      {
        id: 'XE',
        name: 'XE',
        'cyrillic-name': 'ксе',
        class: 'D',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'XF',
        name: 'XF',
        'cyrillic-name': 'ксф',
        class: 'E',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'XFR',
        name: 'XFR',
        'cyrillic-name': 'ксфр',
        class: 'E',
        'year-from': 2009,
        'year-to': 2015,
      },
      {
        id: 'XJ',
        name: 'XJ',
        'cyrillic-name': 'ксй',
        class: 'F',
        'year-from': 1968,
        'year-to': 2019,
      },
      {
        id: 'XJ220',
        name: 'XJ220',
        'cyrillic-name': 'ксй220',
        class: 'S',
        'year-from': 1992,
        'year-to': 1994,
      },
      {
        id: 'XJR',
        name: 'XJR',
        'cyrillic-name': 'ксйр',
        class: 'F',
        'year-from': 1994,
        'year-to': 2019,
      },
      {
        id: 'XJS',
        name: 'XJS',
        'cyrillic-name': 'ксйс',
        class: 'S',
        'year-from': 1975,
        'year-to': 1996,
      },
      {
        id: 'XK',
        name: 'XK',
        'cyrillic-name': 'кск',
        class: 'S',
        'year-from': 1948,
        'year-to': 2014,
      },
      {
        id: 'XKR',
        name: 'XKR',
        'cyrillic-name': 'кскр',
        class: 'S',
        'year-from': 1998,
        'year-to': 2014,
      },
    ],
  },
  {
    id: 'JEEP',
    name: 'Jeep',
    'cyrillic-name': 'Джип',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'CHEROKEE',
        name: 'Cherokee',
        'cyrillic-name': 'Чероки',
        class: 'C',
        'year-from': 1983,
        'year-to': null,
      },
      {
        id: 'CJ',
        name: 'CJ',
        'cyrillic-name': 'цй',
        class: 'J',
        'year-from': 1966,
        'year-to': 1987,
      },
      {
        id: 'COMANCHE',
        name: 'Comanche',
        'cyrillic-name': 'Команч',
        class: 'J',
        'year-from': 1985,
        'year-to': 1992,
      },
      {
        id: 'COMMANDER',
        name: 'Commander',
        'cyrillic-name': 'Коммандер',
        class: 'J',
        'year-from': 2005,
        'year-to': 2010,
      },
      {
        id: 'COMPASS',
        name: 'Compass',
        'cyrillic-name': 'Компас',
        class: 'C',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'GLADIATOR',
        name: 'Gladiator',
        'cyrillic-name': 'Гладиатор',
        class: 'J',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'GRAND_CHEROKEE',
        name: 'Grand Cherokee',
        'cyrillic-name': 'Гранд Чероки',
        class: 'J',
        'year-from': 1992,
        'year-to': null,
      },
      {
        id: 'LIBETY_NA',
        name: 'Liberty (North America)',
        'cyrillic-name': 'Либерти',
        class: 'J',
        'year-from': 2001,
        'year-to': 2012,
      },
      {
        id: 'PATRIOT',
        name: 'Liberty (Patriot)',
        'cyrillic-name': 'Патриот',
        class: 'C',
        'year-from': 2006,
        'year-to': 2016,
      },
      {
        id: 'RENEGADE',
        name: 'Renegade',
        'cyrillic-name': 'Ренегейд',
        class: 'B',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'GRAND_WAGONEER',
        name: 'Wagoneer',
        'cyrillic-name': 'Вагонер',
        class: 'J',
        'year-from': 1984,
        'year-to': null,
      },
      {
        id: 'WRANGLER',
        name: 'Wrangler',
        'cyrillic-name': 'Рэнглер',
        class: 'J',
        'year-from': 1986,
        'year-to': null,
      },
    ],
  },
  {
    id: 'JENSEN',
    name: 'Jensen',
    'cyrillic-name': 'Дженсен',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'INTERCEPTOR',
        name: 'Interceptor',
        'cyrillic-name': 'Интерцептор',
        class: 'S',
        'year-from': 1966,
        'year-to': 1976,
      },
      {
        id: 'S_V8',
        name: 'S-V8',
        'cyrillic-name': 'с-в8',
        class: 'S',
        'year-from': 2001,
        'year-to': 2003,
      },
    ],
  },
  {
    id: 'JETOUR',
    name: 'Jetour',
    'cyrillic-name': 'Джитур',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'X70_PLUS',
        name: 'X70 PLUS',
        'cyrillic-name': 'Х70 Плюс',
        class: 'J',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'X90',
        name: 'X90',
        'cyrillic-name': 'Икс90',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'JETTA',
    name: 'Jetta',
    'cyrillic-name': 'Джетта',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'VA3',
        name: 'VA3',
        'cyrillic-name': 'ВА3',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'VS5',
        name: 'VS5',
        'cyrillic-name': 'ВС5',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'VS7',
        name: 'VS7',
        'cyrillic-name': 'ВС7',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'JINBEI',
    name: 'Jinbei',
    'cyrillic-name': 'джинбей',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'HAISE',
        name: 'Haise',
        'cyrillic-name': 'хайс',
        class: 'M',
        'year-from': 2000,
        'year-to': null,
      },
    ],
  },
  {
    id: 'JMC',
    name: 'JMC',
    'cyrillic-name': 'Джей Эм Си',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'BAODIAN',
        name: 'Baodian',
        'cyrillic-name': 'баодиан',
        class: 'J',
        'year-from': 2006,
        'year-to': 2009,
      },
    ],
  },
  {
    id: 'KAIYI',
    name: 'Kaiyi',
    'cyrillic-name': 'Каи',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'E5',
        name: 'E5',
        'cyrillic-name': 'е5',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'X3_PRO',
        name: 'X3 Pro',
        'cyrillic-name': 'Икс3 Про',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'KANONIR',
    name: 'Канонир',
    'cyrillic-name': 'Канонир',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: '2317',
        name: '2317',
        'cyrillic-name': '2317',
        class: 'J',
        'year-from': 1999,
        'year-to': 2001,
      },
    ],
  },
  {
    id: 'KIA',
    name: 'Kia',
    'cyrillic-name': 'Киа',
    popular: true,
    country: 'Южная Корея',
    models: [
      {
        id: 'AVELLA',
        name: 'Avella',
        'cyrillic-name': 'Авелла',
        class: 'B',
        'year-from': 1994,
        'year-to': 2000,
      },
      {
        id: 'BORREGO',
        name: 'Borrego',
        'cyrillic-name': 'Боррего',
        class: 'E',
        'year-from': 2008,
        'year-to': 2011,
      },
      {
        id: 'CADENZA',
        name: 'Cadenza',
        'cyrillic-name': 'Каденза',
        class: 'E',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'CAPITAL',
        name: 'Capital',
        'cyrillic-name': 'Капитал',
        class: 'C',
        'year-from': 1989,
        'year-to': 1996,
      },
      {
        id: 'CARENS',
        name: 'Carens',
        'cyrillic-name': 'Каренс',
        class: 'C',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'CARNIVAL',
        name: 'Carnival',
        'cyrillic-name': 'Карнивал',
        class: 'M',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'CARSTAR',
        name: 'Carstar',
        'cyrillic-name': 'Карстар',
        class: 'M',
        'year-from': 1999,
        'year-to': 2003,
      },
      {
        id: 'CEED',
        name: 'Ceed',
        'cyrillic-name': 'Сид',
        class: 'C',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'CEED_GT',
        name: 'Ceed GT',
        'cyrillic-name': 'цеед гт',
        class: 'C',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'CERATO',
        name: 'Cerato',
        'cyrillic-name': 'Церато',
        class: 'C',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'CLARUS',
        name: 'Clarus',
        'cyrillic-name': 'Кларус',
        class: 'E',
        'year-from': 1996,
        'year-to': 2001,
      },
      {
        id: 'CONCORD',
        name: 'Concord',
        'cyrillic-name': 'Конкорд',
        class: 'D',
        'year-from': 1987,
        'year-to': 1995,
      },
      {
        id: 'ELAN',
        name: 'Elan',
        'cyrillic-name': 'Элан',
        class: 'S',
        'year-from': 1996,
        'year-to': 1999,
      },
      {
        id: 'ENTERPRISE',
        name: 'Enterprise',
        'cyrillic-name': 'Энтерпрайз',
        class: 'E',
        'year-from': 1997,
        'year-to': 2002,
      },
      {
        id: 'EV6',
        name: 'EV6',
        'cyrillic-name': 'ЕВ6',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'FORTE',
        name: 'Forte',
        'cyrillic-name': 'Форте',
        class: 'C',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'JOICE',
        name: 'Joice',
        'cyrillic-name': 'Джойс',
        class: 'M',
        'year-from': 1999,
        'year-to': 2004,
      },
      {
        id: 'K3',
        name: 'K3',
        'cyrillic-name': 'к3',
        class: 'C',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'K5',
        name: 'K5',
        'cyrillic-name': 'к5',
        class: 'D',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'K7',
        name: 'K7',
        'cyrillic-name': 'к7',
        class: 'D',
        'year-from': 2009,
        'year-to': 2021,
      },
      {
        id: 'K8',
        name: 'K8',
        'cyrillic-name': 'К8',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'K9',
        name: 'K9',
        'cyrillic-name': 'К9',
        class: 'F',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'K900',
        name: 'K900',
        'cyrillic-name': 'К900',
        class: 'F',
        'year-from': 2014,
        'year-to': 2022,
      },
      {
        id: 'KX3',
        name: 'KX3',
        'cyrillic-name': 'КаИкс3',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'LOTZE',
        name: 'Lotze',
        'cyrillic-name': 'Лотз',
        class: 'D',
        'year-from': 2005,
        'year-to': 2010,
      },
      {
        id: 'MAGENTIS',
        name: 'Magentis',
        'cyrillic-name': 'Маджентис',
        class: 'E',
        'year-from': 2000,
        'year-to': 2010,
      },
      {
        id: 'MENTOR',
        name: 'Mentor',
        'cyrillic-name': 'ментор',
        class: 'B',
        'year-from': 1996,
        'year-to': 2002,
      },
      {
        id: 'MOHAVES',
        name: 'Mohave',
        'cyrillic-name': 'Мохав',
        class: 'E',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'MORNING',
        name: 'Morning',
        'cyrillic-name': 'морнинг',
        class: 'A',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'NIRO',
        name: 'Niro',
        'cyrillic-name': 'Ниро',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'OPIRUS',
        name: 'Opirus',
        'cyrillic-name': 'Опирус',
        class: 'E',
        'year-from': 2003,
        'year-to': 2011,
      },
      {
        id: 'OPTIMA',
        name: 'Optima',
        'cyrillic-name': 'Оптима',
        class: 'D',
        'year-from': 2000,
        'year-to': 2020,
      },
      {
        id: 'PICANTO',
        name: 'Picanto',
        'cyrillic-name': 'Пиканто',
        class: 'A',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'POTENTIA',
        name: 'Potentia',
        'cyrillic-name': 'Потентиа',
        class: 'E',
        'year-from': 1992,
        'year-to': 2001,
      },
      {
        id: 'PREGIO',
        name: 'Pregio',
        'cyrillic-name': 'Преджио',
        class: 'M',
        'year-from': 1995,
        'year-to': 2007,
      },
      {
        id: 'PRIDE',
        name: 'Pride',
        'cyrillic-name': 'Прайд',
        class: 'B',
        'year-from': 1987,
        'year-to': 2017,
      },
      {
        id: 'PROCEED',
        name: 'Proceed',
        'cyrillic-name': 'Просид',
        class: 'C',
        'year-from': 2018,
        'year-to': 2021,
      },
      {
        id: 'QUANLIMA',
        name: 'Quanlima',
        'cyrillic-name': 'кванлима',
        class: 'B',
        'year-from': 2002,
        'year-to': 2006,
      },
      {
        id: 'QUORIS',
        name: 'Quoris',
        'cyrillic-name': 'Кворис',
        class: 'F',
        'year-from': 2012,
        'year-to': 2018,
      },
      {
        id: 'RAY',
        name: 'Ray',
        'cyrillic-name': 'Рэй',
        class: 'M',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'RETONA',
        name: 'Retona',
        'cyrillic-name': 'Ретона',
        class: 'J',
        'year-from': 1998,
        'year-to': 2003,
      },
      {
        id: 'RIO',
        name: 'Rio',
        'cyrillic-name': 'Рио',
        class: 'B',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'SEDONA',
        name: 'Sedona',
        'cyrillic-name': 'Седона',
        class: 'M',
        'year-from': 1998,
        'year-to': 2021,
      },
      {
        id: 'SELTOS',
        name: 'Seltos',
        'cyrillic-name': 'Селтос',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'SEPHIA',
        name: 'Sephia',
        'cyrillic-name': 'Сефия',
        class: 'C',
        'year-from': 1992,
        'year-to': 2004,
      },
      {
        id: 'SHUMA',
        name: 'Shuma',
        'cyrillic-name': 'Шума',
        class: 'C',
        'year-from': 1996,
        'year-to': 2004,
      },
      {
        id: 'SORENTO',
        name: 'Sorento',
        'cyrillic-name': 'Соренто',
        class: 'D',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'SOUL',
        name: 'Soul',
        'cyrillic-name': 'Соул',
        class: 'B',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'SOUL_EV',
        name: 'Soul EV',
        'cyrillic-name': 'Соул ИВ',
        class: 'B',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'SPECTRA',
        name: 'Spectra',
        'cyrillic-name': 'Спектра',
        class: 'C',
        'year-from': 2000,
        'year-to': 2011,
      },
      {
        id: 'SPORTAGE',
        name: 'Sportage',
        'cyrillic-name': 'Спортейдж',
        class: 'C',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'SPORTAGE_CHINA',
        name: 'Sportage (China)',
        'cyrillic-name': 'Спортейдж Китай',
        class: 'J',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'STINGER',
        name: 'Stinger',
        'cyrillic-name': 'Стингер',
        class: 'D',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'STONIC',
        name: 'Stonic',
        'cyrillic-name': 'Стоник',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'TELLURIDE',
        name: 'Telluride',
        'cyrillic-name': 'Телюрайд',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'TOWNER',
        name: 'Towner',
        'cyrillic-name': 'тоунер',
        class: 'M',
        'year-from': 1999,
        'year-to': 2002,
      },
      {
        id: 'VENGA',
        name: 'Venga',
        'cyrillic-name': 'Венга',
        class: 'M',
        'year-from': 2009,
        'year-to': 2018,
      },
      {
        id: 'VISTO',
        name: 'Visto',
        'cyrillic-name': 'Висто',
        class: 'A',
        'year-from': 1999,
        'year-to': 2004,
      },
      {
        id: 'X_TREK',
        name: 'X-Trek',
        'cyrillic-name': 'кс-трек',
        class: 'M',
        'year-from': 2003,
        'year-to': 2006,
      },
      {
        id: 'XCEED',
        name: 'XCeed',
        'cyrillic-name': 'Икс Сид',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'KOENIGSEGG',
    name: 'Koenigsegg',
    'cyrillic-name': 'Кёнигсегг',
    popular: false,
    country: 'Швеция',
    models: [
      {
        id: 'AGERA',
        name: 'Agera',
        'cyrillic-name': 'агера',
        class: 'S',
        'year-from': 2011,
        'year-to': 2018,
      },
      {
        id: 'CC8S',
        name: 'CC8S',
        'cyrillic-name': 'цц8с',
        class: 'S',
        'year-from': 1998,
        'year-to': 2004,
      },
      {
        id: 'CCR',
        name: 'CCR',
        'cyrillic-name': 'сср',
        class: 'S',
        'year-from': 2004,
        'year-to': 2006,
      },
      {
        id: 'CCX',
        name: 'CCX',
        'cyrillic-name': 'ссх',
        class: 'S',
        'year-from': 2006,
        'year-to': 2010,
      },
      {
        id: 'JESCO',
        name: 'Jesco',
        'cyrillic-name': 'Джеско',
        class: 'S',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'ONE_1',
        name: 'One:1',
        'cyrillic-name': 'уан:1',
        class: 'S',
        'year-from': 2014,
        'year-to': 2014,
      },
      {
        id: 'REGERA',
        name: 'Regera',
        'cyrillic-name': 'Регера',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
    ],
  },
  {
    id: 'KOMBAT',
    name: 'Комбат',
    'cyrillic-name': 'Комбат',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'T98',
        name: 'Т98',
        'cyrillic-name': 'Т98',
        class: 'J',
        'year-from': 2000,
        'year-to': null,
      },
    ],
  },
  {
    id: 'KTM',
    name: 'KTM AG',
    'cyrillic-name': 'КТМ АГ',
    popular: false,
    country: 'Австрия',
    models: [
      {
        id: 'XBOW',
        name: 'X-Bow',
        'cyrillic-name': 'икс-боу',
        class: 'S',
        'year-from': 2007,
        'year-to': null,
      },
    ],
  },
  {
    id: 'LAMBORGHINI',
    name: 'Lamborghini',
    'cyrillic-name': 'Ламборгини',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: '350_400_GT',
        name: '350/400 GT',
        'cyrillic-name': '350/400 гт',
        class: 'S',
        'year-from': 1964,
        'year-to': 1968,
      },
      {
        id: 'AVENTADOR',
        name: 'Aventador',
        'cyrillic-name': 'авентадор',
        class: 'S',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'CENTANARIO',
        name: 'Centenario',
        'cyrillic-name': 'центенарио',
        class: 'S',
        'year-from': 2016,
        'year-to': 2018,
      },
      {
        id: 'COUNTACH',
        name: 'Countach',
        'cyrillic-name': 'каунтач',
        class: 'S',
        'year-from': 1974,
        'year-to': 1991,
      },
      {
        id: 'COUNTACH_LPI_800_4',
        name: 'Countach LPI 800-4',
        'cyrillic-name': 'Каунтач ЛПИ 800-4',
        class: 'S',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'DIABLO',
        name: 'Diablo',
        'cyrillic-name': 'Диабло',
        class: 'S',
        'year-from': 1990,
        'year-to': 2001,
      },
      {
        id: 'EGOISTA',
        name: 'Egoista',
        'cyrillic-name': 'Эгоиста',
        class: 'S',
        'year-from': 2013,
        'year-to': 2013,
      },
      {
        id: 'ESPADA',
        name: 'Espada',
        'cyrillic-name': 'эспада',
        class: 'S',
        'year-from': 1968,
        'year-to': 1981,
      },
      {
        id: 'GALLARDO',
        name: 'Gallardo',
        'cyrillic-name': 'галлардо',
        class: 'S',
        'year-from': 2003,
        'year-to': 2013,
      },
      {
        id: 'HURACAN',
        name: 'Huracán',
        'cyrillic-name': 'Хуракан',
        class: 'S',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'ISLERO',
        name: 'Islero',
        'cyrillic-name': 'ислеро',
        class: 'S',
        'year-from': 1968,
        'year-to': 1969,
      },
      {
        id: 'JALPA',
        name: 'Jalpa',
        'cyrillic-name': 'ялпа',
        class: 'S',
        'year-from': 1981,
        'year-to': 1988,
      },
      {
        id: 'JARAMA',
        name: 'Jarama',
        'cyrillic-name': 'джарама',
        class: 'S',
        'year-from': 1968,
        'year-to': 1976,
      },
      {
        id: 'LM001',
        name: 'LM001',
        'cyrillic-name': 'лм001',
        class: 'J',
        'year-from': 1981,
        'year-to': 1981,
      },
      {
        id: 'LM002',
        name: 'LM002',
        'cyrillic-name': 'лм002',
        class: 'J',
        'year-from': 1986,
        'year-to': 1993,
      },
      {
        id: 'MIURA',
        name: 'Miura',
        'cyrillic-name': 'миура',
        class: 'S',
        'year-from': 1966,
        'year-to': 1973,
      },
      {
        id: 'MURCIELAGO',
        name: 'Murcielago',
        'cyrillic-name': 'мурселаго',
        class: 'S',
        'year-from': 2001,
        'year-to': 2010,
      },
      {
        id: 'REVENTON',
        name: 'Reventon',
        'cyrillic-name': 'Ревентон',
        class: 'S',
        'year-from': 2007,
        'year-to': 2010,
      },
      {
        id: 'SESTO_ELEMENTO',
        name: 'Sesto Elemento',
        'cyrillic-name': 'Сесто Элементо',
        class: 'S',
        'year-from': 2010,
        'year-to': 2011,
      },
      {
        id: 'SILHOUETTE',
        name: 'Silhouette',
        'cyrillic-name': 'силуэт',
        class: 'S',
        'year-from': 1976,
        'year-to': 1979,
      },
      {
        id: 'SIAN',
        name: 'Sián',
        'cyrillic-name': 'Сиан',
        class: 'S',
        'year-from': 2020,
        'year-to': 2020,
      },
      {
        id: 'URRACO',
        name: 'Urraco',
        'cyrillic-name': 'уррако',
        class: 'S',
        'year-from': 1972,
        'year-to': 1981,
      },
      {
        id: 'URUS',
        name: 'Urus',
        'cyrillic-name': 'урус',
        class: 'E',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'VENENO',
        name: 'Veneno',
        'cyrillic-name': 'Венено',
        class: 'S',
        'year-from': 2013,
        'year-to': 2013,
      },
    ],
  },
  {
    id: 'LANCIA',
    name: 'Lancia',
    'cyrillic-name': 'Лянча',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'A_112',
        name: 'A 112',
        'cyrillic-name': 'а 112',
        class: 'A',
        'year-from': 1982,
        'year-to': 1986,
      },
      {
        id: 'APPIA',
        name: 'Appia',
        'cyrillic-name': 'аппия',
        class: 'B',
        'year-from': 1953,
        'year-to': 1963,
      },
      {
        id: 'AURELIA',
        name: 'Aurelia',
        'cyrillic-name': 'аурелия',
        class: '',
        'year-from': 1950,
        'year-to': 1953,
      },
      {
        id: 'BETA',
        name: 'Beta',
        'cyrillic-name': 'Бета',
        class: 'D',
        'year-from': 1972,
        'year-to': 1984,
      },
      {
        id: 'DEDRA',
        name: 'Dedra',
        'cyrillic-name': 'Дедра',
        class: 'D',
        'year-from': 1989,
        'year-to': 2000,
      },
      {
        id: 'DELTA',
        name: 'Delta',
        'cyrillic-name': 'Дэльта',
        class: 'C',
        'year-from': 1979,
        'year-to': 2014,
      },
      {
        id: 'FLAMINIA',
        name: 'Flaminia',
        'cyrillic-name': 'фламиния',
        class: 'E',
        'year-from': 1952,
        'year-to': 1970,
      },
      {
        id: 'FLAVIA',
        name: 'Flavia',
        'cyrillic-name': 'Флавия',
        class: 'D',
        'year-from': 2012,
        'year-to': 2014,
      },
      {
        id: 'FULVIA',
        name: 'Fulvia',
        'cyrillic-name': 'Фульвия',
        class: 'D',
        'year-from': 1968,
        'year-to': 1975,
      },
      {
        id: 'GAMMA',
        name: 'Gamma',
        'cyrillic-name': 'Гамма',
        class: 'D',
        'year-from': 1976,
        'year-to': 1984,
      },
      {
        id: 'HYUENA',
        name: 'Hyena',
        'cyrillic-name': 'Гиена',
        class: 'C',
        'year-from': 1992,
        'year-to': 1996,
      },
      {
        id: 'KAPPA',
        name: 'Kappa',
        'cyrillic-name': 'Каппа',
        class: 'D',
        'year-from': 1994,
        'year-to': 2000,
      },
      {
        id: 'LAMBDA',
        name: 'Lambda',
        'cyrillic-name': 'лямбда',
        class: '',
        'year-from': 1922,
        'year-to': 1931,
      },
      {
        id: 'LYBRA',
        name: 'Lybra',
        'cyrillic-name': 'Либра',
        class: 'D',
        'year-from': 1999,
        'year-to': 2006,
      },
      {
        id: 'MONTECARLO',
        name: 'Monte Carlo',
        'cyrillic-name': 'Монте Карло',
        class: 'S',
        'year-from': 1975,
        'year-to': 1981,
      },
      {
        id: 'MUSA',
        name: 'Musa',
        'cyrillic-name': 'Муса',
        class: 'M',
        'year-from': 2004,
        'year-to': 2012,
      },
      {
        id: 'PHEDRA',
        name: 'Phedra',
        'cyrillic-name': 'Федра',
        class: 'M',
        'year-from': 2002,
        'year-to': 2010,
      },
      {
        id: 'PRISMA',
        name: 'Prisma',
        'cyrillic-name': 'Призма',
        class: 'C',
        'year-from': 1982,
        'year-to': 1989,
      },
      {
        id: 'RALLY_037',
        name: 'Rally 037',
        'cyrillic-name': 'ралли 037',
        class: 'S',
        'year-from': 1982,
        'year-to': 1983,
      },
      {
        id: 'STRATOS',
        name: 'Stratos',
        'cyrillic-name': 'стратос',
        class: 'S',
        'year-from': 1973,
        'year-to': 1976,
      },
      {
        id: 'THEMA',
        name: 'Thema',
        'cyrillic-name': 'Тема',
        class: 'E',
        'year-from': 1984,
        'year-to': 2014,
      },
      {
        id: 'THESIS',
        name: 'Thesis',
        'cyrillic-name': 'Тезис',
        class: 'E',
        'year-from': 2002,
        'year-to': 2009,
      },
      {
        id: 'TREVI',
        name: 'Trevi',
        'cyrillic-name': 'Треви',
        class: 'D',
        'year-from': 1980,
        'year-to': 1984,
      },
      {
        id: 'VOYAGER',
        name: 'Voyager',
        'cyrillic-name': 'вояджер',
        class: 'M',
        'year-from': 2011,
        'year-to': 2015,
      },
      {
        id: 'Y10',
        name: 'Y10',
        'cyrillic-name': 'Ю 10',
        class: 'A',
        'year-from': 1985,
        'year-to': 1995,
      },
      {
        id: 'YPSILON',
        name: 'Ypsilon',
        'cyrillic-name': 'Ипсилон',
        class: 'B',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'ZETA',
        name: 'Zeta',
        'cyrillic-name': 'Зета',
        class: 'M',
        'year-from': 1995,
        'year-to': 2002,
      },
    ],
  },
  {
    id: 'LANDWIND',
    name: 'Landwind',
    'cyrillic-name': 'Лендвинд',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'CV9',
        name: 'Fashion (CV9)',
        'cyrillic-name': 'Фэшн',
        class: 'M',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'FORWARD',
        name: 'Forward',
        'cyrillic-name': 'Форвард',
        class: 'C',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'X5',
        name: 'X5',
        'cyrillic-name': 'Х5',
        class: 'C',
        'year-from': 2012,
        'year-to': 2020,
      },
      {
        id: 'X6',
        name: 'X6',
        'cyrillic-name': 'кс6',
        class: 'J',
        'year-from': 2005,
        'year-to': 2016,
      },
      {
        id: 'X7',
        name: 'X7',
        'cyrillic-name': 'Х7',
        class: 'C',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'LW_X9',
        name: 'Х9',
        'cyrillic-name': 'х9',
        class: 'J',
        'year-from': 2005,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'LAND_ROVER',
    name: 'Land Rover',
    'cyrillic-name': 'Ленд Ровер',
    popular: true,
    country: 'Великобритания',
    models: [
      {
        id: 'DEFENDER',
        name: 'Defender',
        'cyrillic-name': 'Дефендер',
        class: 'J',
        'year-from': 1983,
        'year-to': null,
      },
      {
        id: 'DISCOVERY',
        name: 'Discovery',
        'cyrillic-name': 'Дискавери',
        class: 'J',
        'year-from': 1989,
        'year-to': null,
      },
      {
        id: 'DISCOVERY_SPORT',
        name: 'Discovery Sport',
        'cyrillic-name': 'Дискавери Спорт',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'FREELANDER',
        name: 'Freelander',
        'cyrillic-name': 'Фрилендер',
        class: 'C',
        'year-from': 1997,
        'year-to': 2014,
      },
      {
        id: 'RANGE_ROVER',
        name: 'Range Rover',
        'cyrillic-name': 'Рендж Ровер',
        class: 'J',
        'year-from': 1970,
        'year-to': null,
      },
      {
        id: 'EVOQUE',
        name: 'Range Rover Evoque',
        'cyrillic-name': 'Рендж Ровер Эвок',
        class: 'C',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'RANGE_ROVER_SPORT',
        name: 'Range Rover Sport',
        'cyrillic-name': 'Рендж Ровер Спорт',
        class: 'J',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'RANGE_ROVER_VELAR',
        name: 'Range Rover Velar',
        'cyrillic-name': 'Рендж Ровер Велар',
        class: 'D',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'SERIES_I',
        name: 'Series I',
        'cyrillic-name': 'Серия 1',
        class: 'J',
        'year-from': 1948,
        'year-to': 1956,
      },
      {
        id: 'SERIES_II',
        name: 'Series II',
        'cyrillic-name': 'серия 2',
        class: 'J',
        'year-from': 1958,
        'year-to': 1971,
      },
      {
        id: 'SERIES_III',
        name: 'Series III',
        'cyrillic-name': 'серия 3',
        class: 'J',
        'year-from': 1971,
        'year-to': 1985,
      },
    ],
  },
  {
    id: 'LEAPMOTOR',
    name: 'Leapmotor',
    'cyrillic-name': 'Липмотор',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'C11',
        name: 'C11',
        'cyrillic-name': 'С11',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'T03',
        name: 'T03',
        'cyrillic-name': 'Т03',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'LEXUS',
    name: 'Lexus',
    'cyrillic-name': 'Лексус',
    popular: true,
    country: 'Япония',
    models: [
      {
        id: 'CT',
        name: 'CT',
        'cyrillic-name': 'цт',
        class: 'C',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'ES',
        name: 'ES',
        'cyrillic-name': 'ес',
        class: 'E',
        'year-from': 1989,
        'year-to': null,
      },
      {
        id: 'GS',
        name: 'GS',
        'cyrillic-name': 'гс',
        class: 'E',
        'year-from': 1993,
        'year-to': 2018,
      },
      {
        id: 'GS_F',
        name: 'GS F',
        'cyrillic-name': 'Джи Эс Эф',
        class: 'E',
        'year-from': 2015,
        'year-to': 2018,
      },
      {
        id: 'GX',
        name: 'GX',
        'cyrillic-name': 'гкс',
        class: 'J',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'HS',
        name: 'HS',
        'cyrillic-name': 'хс',
        class: 'D',
        'year-from': 2009,
        'year-to': 2018,
      },
      {
        id: 'IS',
        name: 'IS',
        'cyrillic-name': 'ис',
        class: 'D',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'IS_F',
        name: 'IS F',
        'cyrillic-name': 'ис ф',
        class: 'C',
        'year-from': 2007,
        'year-to': 2014,
      },
      {
        id: 'LC',
        name: 'LC',
        'cyrillic-name': 'лц',
        class: 'S',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'LFA',
        name: 'LFA',
        'cyrillic-name': 'лфа',
        class: 'S',
        'year-from': 2010,
        'year-to': 2012,
      },
      {
        id: 'LM',
        name: 'LM',
        'cyrillic-name': 'ЛМ',
        class: 'M',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'LS',
        name: 'LS',
        'cyrillic-name': 'лс',
        class: 'F',
        'year-from': 1989,
        'year-to': null,
      },
      {
        id: 'LX',
        name: 'LX',
        'cyrillic-name': 'лкс',
        class: 'J',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'NX',
        name: 'NX',
        'cyrillic-name': 'Н-Икс',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'RC',
        name: 'RC',
        'cyrillic-name': 'РС',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'RC_F',
        name: 'RC F',
        'cyrillic-name': 'РС Ф',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'RX',
        name: 'RX',
        'cyrillic-name': 'ркс',
        class: 'E',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'RZ',
        name: 'RZ',
        'cyrillic-name': 'рз',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'SC',
        name: 'SC',
        'cyrillic-name': 'сц',
        class: 'D',
        'year-from': 1991,
        'year-to': 2010,
      },
      {
        id: 'UX',
        name: 'UX',
        'cyrillic-name': 'укс',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'LIEBAO',
    name: 'Liebao Motor',
    'cyrillic-name': 'Лиебао мотор',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'LEOPARD',
        name: 'Leopard',
        'cyrillic-name': 'Леопард',
        class: 'J',
        'year-from': 1999,
        'year-to': null,
      },
    ],
  },
  {
    id: 'LIFAN',
    name: 'Lifan',
    'cyrillic-name': 'Лифан',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: '650_EV',
        name: '650 EV',
        'cyrillic-name': '650 ЕВ',
        class: 'C',
        'year-from': 2018,
        'year-to': 2020,
      },
      {
        id: 'BREEZ',
        name: 'Breez (520)',
        'cyrillic-name': 'бриз',
        class: 'C',
        'year-from': 2007,
        'year-to': 2014,
      },
      {
        id: 'CEBRIUM',
        name: 'Cebrium (720)',
        'cyrillic-name': 'Цебриум',
        class: 'D',
        'year-from': 2014,
        'year-to': 2018,
      },
      {
        id: 'CELLIYA',
        name: 'Celliya (530)',
        'cyrillic-name': 'Селия',
        class: 'B',
        'year-from': 2014,
        'year-to': 2018,
      },
      {
        id: 'MURMAN',
        name: 'Murman (820)',
        'cyrillic-name': 'Мурман',
        class: 'D',
        'year-from': 2015,
        'year-to': 2020,
      },
      {
        id: 'MYWAY',
        name: 'Myway',
        'cyrillic-name': 'Майвей',
        class: 'C',
        'year-from': 2016,
        'year-to': 2020,
      },
      {
        id: 'SMILY',
        name: 'Smily',
        'cyrillic-name': 'Смайли',
        class: 'A',
        'year-from': 2008,
        'year-to': 2018,
      },
      {
        id: 'SOLANO',
        name: 'Solano',
        'cyrillic-name': 'Солано',
        class: 'C',
        'year-from': 2008,
        'year-to': 2018,
      },
      {
        id: 'X50',
        name: 'X50',
        'cyrillic-name': 'х50',
        class: 'B',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'X60',
        name: 'X60',
        'cyrillic-name': 'Х60',
        class: 'C',
        'year-from': 2011,
        'year-to': 2018,
      },
      {
        id: 'X70',
        name: 'X70',
        'cyrillic-name': 'Х70',
        class: 'C',
        'year-from': 2017,
        'year-to': 2020,
      },
    ],
  },
  {
    id: 'LIGIER',
    name: 'Ligier',
    'cyrillic-name': 'Лижье',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'JS_51',
        name: 'JS 51',
        'cyrillic-name': 'Джи Эс 51',
        class: 'S',
        'year-from': 2009,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'LINCOLN',
    name: 'Lincoln',
    'cyrillic-name': 'Линкольн',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'AVIATOR',
        name: 'Aviator',
        'cyrillic-name': 'авиатор',
        class: 'E',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'BLACKWOOD',
        name: 'Blackwood',
        'cyrillic-name': 'блэквуд',
        class: 'J',
        'year-from': 2001,
        'year-to': 2002,
      },
      {
        id: 'CAPRI',
        name: 'Capri',
        'cyrillic-name': 'капри',
        class: 'S',
        'year-from': 1952,
        'year-to': 1959,
      },
      {
        id: 'CONTINENTAL',
        name: 'Continental',
        'cyrillic-name': 'континенталь',
        class: 'F',
        'year-from': 1959,
        'year-to': 2020,
      },
      {
        id: 'CORSAIR',
        name: 'Corsair',
        'cyrillic-name': 'Корсэйр',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'LS',
        name: 'LS',
        'cyrillic-name': 'лс',
        class: 'E',
        'year-from': 1999,
        'year-to': 2006,
      },
      {
        id: 'MARK_III',
        name: 'Mark III',
        'cyrillic-name': 'марк иии',
        class: 'F',
        'year-from': 1968,
        'year-to': 1971,
      },
      {
        id: 'MARK_IV',
        name: 'Mark IV',
        'cyrillic-name': 'марк ив',
        class: 'F',
        'year-from': 1972,
        'year-to': 1976,
      },
      {
        id: 'MARK_LT',
        name: 'Mark LT',
        'cyrillic-name': 'марк лт',
        class: 'J',
        'year-from': 2005,
        'year-to': 2014,
      },
      {
        id: 'MARK_VII',
        name: 'Mark VII',
        'cyrillic-name': 'марк вии',
        class: 'F',
        'year-from': 1984,
        'year-to': 1992,
      },
      {
        id: 'MARK_VIII',
        name: 'Mark VIII',
        'cyrillic-name': 'марк виии',
        class: 'F',
        'year-from': 1992,
        'year-to': 1998,
      },
      {
        id: 'MKC',
        name: 'MKC',
        'cyrillic-name': 'мкц',
        class: 'C',
        'year-from': 2014,
        'year-to': 2019,
      },
      {
        id: 'MKS',
        name: 'MKS',
        'cyrillic-name': 'мкс',
        class: 'F',
        'year-from': 2008,
        'year-to': 2016,
      },
      {
        id: 'MKT',
        name: 'MKT',
        'cyrillic-name': 'мкт',
        class: 'F',
        'year-from': 2009,
        'year-to': 2019,
      },
      {
        id: 'MKX',
        name: 'MKX',
        'cyrillic-name': 'мкх',
        class: 'D',
        'year-from': 2006,
        'year-to': 2018,
      },
      {
        id: 'MKZ',
        name: 'MKZ',
        'cyrillic-name': 'мкз',
        class: 'E',
        'year-from': 2006,
        'year-to': 2020,
      },
      {
        id: 'NAUTILUS',
        name: 'Nautilus',
        'cyrillic-name': 'Наутилус',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'NAVIGATOR',
        name: 'Navigator',
        'cyrillic-name': 'навигатор',
        class: 'J',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'PREMIERE',
        name: 'Premiere',
        'cyrillic-name': 'премьер',
        class: '',
        'year-from': 1955,
        'year-to': 1960,
      },
      {
        id: 'TOWN_CAR',
        name: 'Town Car',
        'cyrillic-name': 'таун кар',
        class: 'F',
        'year-from': 1980,
        'year-to': 2011,
      },
      {
        id: 'VERSAILLES',
        name: 'Versailles',
        'cyrillic-name': 'Версайлс',
        class: 'F',
        'year-from': 1977,
        'year-to': 1980,
      },
      {
        id: 'ZEPHYR',
        name: 'Zephyr',
        'cyrillic-name': 'Зефир',
        class: 'F',
        'year-from': 1936,
        'year-to': 1942,
      },
    ],
  },
  {
    id: 'LIXIANG',
    name: 'LiXiang',
    'cyrillic-name': 'Лисян',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'L7',
        name: 'L7',
        'cyrillic-name': 'Л7',
        class: 'E',
        'year-from': 2023,
        'year-to': null,
      },
      {
        id: 'L8',
        name: 'L8',
        'cyrillic-name': 'Л8',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'L9',
        name: 'L9',
        'cyrillic-name': 'Л9',
        class: 'F',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'ONE',
        name: 'One',
        'cyrillic-name': 'Ван',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'LOGEM',
    name: 'Logem',
    'cyrillic-name': 'Логем',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'EC30',
        name: 'EC30',
        'cyrillic-name': 'ЕС30',
        class: 'M',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'LOTUS',
    name: 'Lotus',
    'cyrillic-name': 'Лотус',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '3_ELEVEN',
        name: '3-Eleven',
        'cyrillic-name': '3-Элевен',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: '340R',
        name: '340R',
        'cyrillic-name': '340р',
        class: 'S',
        'year-from': 2000,
        'year-to': 2000,
      },
      {
        id: 'ECLAT',
        name: 'Eclat',
        'cyrillic-name': 'Эклат',
        class: 'S',
        'year-from': 1975,
        'year-to': 1986,
      },
      {
        id: 'ELAN',
        name: 'Elan',
        'cyrillic-name': 'Илан',
        class: 'S',
        'year-from': 1989,
        'year-to': 1995,
      },
      {
        id: 'ELETRE',
        name: 'Eletre',
        'cyrillic-name': 'Элетре',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'ELISE',
        name: 'Elise',
        'cyrillic-name': 'Элис',
        class: 'S',
        'year-from': 1995,
        'year-to': 2021,
      },
      {
        id: 'ELITE',
        name: 'Elite',
        'cyrillic-name': 'Элит',
        class: 'S',
        'year-from': 1974,
        'year-to': 1982,
      },
      {
        id: 'EMIRA',
        name: 'Emira',
        'cyrillic-name': 'Эмира',
        class: 'S',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'ESPRIT',
        name: 'Esprit',
        'cyrillic-name': 'Эсприт',
        class: 'S',
        'year-from': 1976,
        'year-to': 2004,
      },
      {
        id: 'EUROPA',
        name: 'Europa',
        'cyrillic-name': 'Европа',
        class: 'S',
        'year-from': 1970,
        'year-to': 1976,
      },
      {
        id: 'EUROPA_S',
        name: 'Europa S',
        'cyrillic-name': 'Европа С',
        class: 'S',
        'year-from': 2006,
        'year-to': 2010,
      },
      {
        id: 'EVORA',
        name: 'Evora',
        'cyrillic-name': 'Эвора',
        class: 'S',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'EXCEL',
        name: 'Excel',
        'cyrillic-name': 'Эксель',
        class: 'S',
        'year-from': 1982,
        'year-to': 1992,
      },
      {
        id: 'EXIGE',
        name: 'Exige',
        'cyrillic-name': 'Эксиж',
        class: 'S',
        'year-from': 2001,
        'year-to': null,
      },
    ],
  },
  {
    id: 'LTI',
    name: 'LTI',
    'cyrillic-name': 'ЛТИ',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'TX',
        name: 'TX',
        'cyrillic-name': 'тх',
        class: 'D',
        'year-from': 1998,
        'year-to': null,
      },
    ],
  },
  {
    id: 'LUAZ',
    name: 'ЛуАЗ',
    'cyrillic-name': 'ЛУАЗ',
    popular: false,
    country: 'Украина',
    models: [
      {
        id: '1302',
        name: '1302 Волынь',
        'cyrillic-name': '1302 Волынь',
        class: 'J',
        'year-from': 1990,
        'year-to': 2001,
      },
      {
        id: '967',
        name: '967',
        'cyrillic-name': '967',
        class: 'J',
        'year-from': 1965,
        'year-to': 1989,
      },
      {
        id: '969',
        name: '969',
        'cyrillic-name': '969',
        class: 'J',
        'year-from': 1966,
        'year-to': 1992,
      },
    ],
  },
  {
    id: 'LUCID',
    name: 'Lucid',
    'cyrillic-name': 'Люсид',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'AIR',
        name: 'Air',
        'cyrillic-name': 'Эир',
        class: 'F',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'LUXGEN',
    name: 'Luxgen',
    'cyrillic-name': 'Люксген',
    popular: false,
    country: 'Тайвань',
    models: [
      {
        id: 'LUXGEN5',
        name: 'Luxgen5',
        'cyrillic-name': 'люксген5',
        class: 'D',
        'year-from': 2012,
        'year-to': 2020,
      },
      {
        id: '7_MPV',
        name: 'Luxgen7 MPV',
        'cyrillic-name': 'люксген7 мпв',
        class: 'M',
        'year-from': 2009,
        'year-to': 2014,
      },
      {
        id: '7_SUV',
        name: 'Luxgen7 SUV',
        'cyrillic-name': 'люксген7 сув',
        class: 'D',
        'year-from': 2013,
        'year-to': 2017,
      },
      {
        id: 'U6_TURBO',
        name: 'U6 Turbo',
        'cyrillic-name': 'Ю6-Турбо',
        class: 'C',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'U7_TURBO',
        name: 'U7 Turbo',
        'cyrillic-name': 'у7 турбо',
        class: 'D',
        'year-from': 2013,
        'year-to': 2020,
      },
    ],
  },
  {
    id: 'LYNK_CO',
    name: 'Lynk & Co',
    'cyrillic-name': 'Линк и ко',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: '01',
        name: '01',
        'cyrillic-name': '01',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: '02',
        name: '02',
        'cyrillic-name': '02',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: '03',
        name: '03',
        'cyrillic-name': '03',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: '05',
        name: '05',
        'cyrillic-name': '05',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: '06',
        name: '06',
        'cyrillic-name': '06',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: '09',
        name: '09',
        'cyrillic-name': '09',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'MAHINDRA',
    name: 'Mahindra',
    'cyrillic-name': 'Махиндра',
    popular: false,
    country: 'Индия',
    models: [
      {
        id: 'ARMADA',
        name: 'Armada',
        'cyrillic-name': 'Армада',
        class: 'J',
        'year-from': 1990,
        'year-to': 2005,
      },
      {
        id: 'BOLERO',
        name: 'Bolero',
        'cyrillic-name': 'Болеро',
        class: 'J',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'CJ_3',
        name: 'CJ-3',
        'cyrillic-name': 'Си-Джей 3',
        class: 'J',
        'year-from': 1988,
        'year-to': 1992,
      },
      {
        id: 'CL',
        name: 'CL',
        'cyrillic-name': 'сл',
        class: 'J',
        'year-from': 1993,
        'year-to': 2000,
      },
      {
        id: 'COMMANDER',
        name: 'Commander',
        'cyrillic-name': 'Коммандер',
        class: 'J',
        'year-from': 1990,
        'year-to': 2013,
      },
      {
        id: 'MARSHAL',
        name: 'Marshal',
        'cyrillic-name': 'Маршал',
        class: 'J',
        'year-from': 2002,
        'year-to': 2008,
      },
      {
        id: 'MM',
        name: 'MM',
        'cyrillic-name': 'ММ',
        class: 'J',
        'year-from': 1990,
        'year-to': 2000,
      },
      {
        id: 'NC_640_DP',
        name: 'NC 640 DP',
        'cyrillic-name': 'нс640дп',
        class: 'J',
        'year-from': 1985,
        'year-to': 2000,
      },
      {
        id: 'SCORPIO',
        name: 'Scorpio',
        'cyrillic-name': 'Скорпио',
        class: 'J',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'VERITO',
        name: 'Verito',
        'cyrillic-name': 'Верито',
        class: 'B',
        'year-from': 2011,
        'year-to': 2019,
      },
      {
        id: 'VOYAGER',
        name: 'Voyager',
        'cyrillic-name': 'вояджер',
        class: 'M',
        'year-from': 1997,
        'year-to': 2000,
      },
      {
        id: 'XYLO',
        name: 'Xylo',
        'cyrillic-name': 'Ксило',
        class: 'M',
        'year-from': 2009,
        'year-to': 2019,
      },
    ],
  },
  {
    id: 'MARCOS',
    name: 'Marcos',
    'cyrillic-name': 'Маркос',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'GTS',
        name: 'GTS',
        'cyrillic-name': 'гтс',
        class: 'S',
        'year-from': 1997,
        'year-to': 1999,
      },
      {
        id: 'LM400',
        name: 'LM 400',
        'cyrillic-name': 'лм400',
        class: 'S',
        'year-from': 1994,
        'year-to': 1998,
      },
      {
        id: 'LM500',
        name: 'LM 500',
        'cyrillic-name': 'лм500',
        class: 'S',
        'year-from': 1994,
        'year-to': 1998,
      },
      {
        id: 'MANTIS_GT',
        name: 'Mantis',
        'cyrillic-name': 'мантис',
        class: 'S',
        'year-from': 1997,
        'year-to': 1999,
      },
      {
        id: 'MARCASITE',
        name: 'Marcasite',
        'cyrillic-name': 'маркасит',
        class: 'S',
        'year-from': 2002,
        'year-to': 2007,
      },
    ],
  },
  {
    id: 'MARLIN',
    name: 'Marlin',
    'cyrillic-name': 'Марлин',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '5EXI',
        name: '5EXi',
        'cyrillic-name': 'файвэкси',
        class: 'S',
        'year-from': 2004,
        'year-to': 2019,
      },
      {
        id: 'SPORTSTER',
        name: 'Sportster',
        'cyrillic-name': 'Спортстер',
        class: 'S',
        'year-from': 2003,
        'year-to': 2019,
      },
    ],
  },
  {
    id: 'MARUSSIA',
    name: 'Marussia',
    'cyrillic-name': 'Маруся',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'B1',
        name: 'B1',
        'cyrillic-name': 'б1',
        class: 'S',
        'year-from': 2010,
        'year-to': 2014,
      },
      {
        id: 'B2',
        name: 'B2',
        'cyrillic-name': 'б2',
        class: 'S',
        'year-from': 2010,
        'year-to': 2014,
      },
    ],
  },
  {
    id: 'MARUTI',
    name: 'Maruti',
    'cyrillic-name': 'Марути',
    popular: false,
    country: 'Индия',
    models: [
      {
        id: '1000',
        name: '1000',
        'cyrillic-name': '1000',
        class: 'B',
        'year-from': 1990,
        'year-to': 2000,
      },
      {
        id: '800',
        name: '800',
        'cyrillic-name': '800',
        class: 'A',
        'year-from': 1983,
        'year-to': 2012,
      },
      {
        id: 'ALTO',
        name: 'Alto',
        'cyrillic-name': 'альто',
        class: 'B',
        'year-from': 2000,
        'year-to': 2012,
      },
      {
        id: 'BALENO',
        name: 'Baleno',
        'cyrillic-name': 'Балено',
        class: 'C',
        'year-from': 1999,
        'year-to': 2007,
      },
      {
        id: 'ESTEEM',
        name: 'Esteem',
        'cyrillic-name': 'эстим',
        class: 'C',
        'year-from': 1994,
        'year-to': 2007,
      },
      {
        id: 'GYPSY',
        name: 'Gypsy',
        'cyrillic-name': 'джипси',
        class: 'J',
        'year-from': 1983,
        'year-to': 2019,
      },
      {
        id: 'OMNI',
        name: 'Omni',
        'cyrillic-name': 'омни',
        class: 'M',
        'year-from': 1984,
        'year-to': 2019,
      },
      {
        id: 'VERSA',
        name: 'Versa',
        'cyrillic-name': 'верса',
        class: 'M',
        'year-from': 2001,
        'year-to': 2009,
      },
      {
        id: 'WAGON_R',
        name: 'Wagon R',
        'cyrillic-name': 'вагон р',
        class: 'M',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'ZEN',
        name: 'Zen',
        'cyrillic-name': 'зен',
        class: 'C',
        'year-from': 1993,
        'year-to': 2006,
      },
    ],
  },
  {
    id: 'MASERATI',
    name: 'Maserati',
    'cyrillic-name': 'Мазерати',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: '228',
        name: '228',
        'cyrillic-name': '228',
        class: 'S',
        'year-from': 1986,
        'year-to': 1992,
      },
      {
        id: '3200GT',
        name: '3200 GT',
        'cyrillic-name': '3200гт',
        class: 'S',
        'year-from': 1998,
        'year-to': 2002,
      },
      {
        id: '420',
        name: '420',
        'cyrillic-name': '420',
        class: 'E',
        'year-from': 1985,
        'year-to': 1994,
      },
      {
        id: '4200_GT',
        name: '4200 GT',
        'cyrillic-name': '4200 гт',
        class: 'S',
        'year-from': 2002,
        'year-to': 2007,
      },
      {
        id: 'BARCHETTA_STRADALE',
        name: 'Barchetta Stradale',
        'cyrillic-name': 'барчетта страдале',
        class: 'S',
        'year-from': 1991,
        'year-to': 1994,
      },
      {
        id: 'BITURBO',
        name: 'Biturbo',
        'cyrillic-name': 'битурбо',
        class: 'D',
        'year-from': 1981,
        'year-to': 1994,
      },
      {
        id: 'BORA',
        name: 'Bora',
        'cyrillic-name': 'бора',
        class: 'S',
        'year-from': 1971,
        'year-to': 1980,
      },
      {
        id: 'CHUBASCO',
        name: 'Chubasco',
        'cyrillic-name': 'чубаско',
        class: 'S',
        'year-from': 1990,
        'year-to': 1990,
      },
      {
        id: 'GHIBLI',
        name: 'Ghibli',
        'cyrillic-name': 'Гибли',
        class: 'E',
        'year-from': 1992,
        'year-to': null,
      },
      {
        id: 'GRAN_TURISMO',
        name: 'GranTurismo',
        'cyrillic-name': 'ГранТуризмо',
        class: 'S',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'GRECALE',
        name: 'Grecale',
        'cyrillic-name': 'Грекале',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'INDY',
        name: 'Indy',
        'cyrillic-name': 'инди',
        class: 'S',
        'year-from': 1969,
        'year-to': 1974,
      },
      {
        id: 'KARIF',
        name: 'Karif',
        'cyrillic-name': 'кариф',
        class: 'S',
        'year-from': 1988,
        'year-to': 2000,
      },
      {
        id: 'KHAMSIN',
        name: 'Khamsin',
        'cyrillic-name': 'хамсин',
        class: 'S',
        'year-from': 1974,
        'year-to': 1982,
      },
      {
        id: 'KYALAMI',
        name: 'Kyalami',
        'cyrillic-name': 'кьялами',
        class: 'S',
        'year-from': 1976,
        'year-to': 1985,
      },
      {
        id: 'LEVANTE',
        name: 'Levante',
        'cyrillic-name': 'Леванте',
        class: 'E',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'MC12',
        name: 'MC12',
        'cyrillic-name': 'мс12',
        class: 'S',
        'year-from': 2004,
        'year-to': 2006,
      },
      {
        id: 'MC20',
        name: 'MC20',
        'cyrillic-name': 'мс20',
        class: 'S',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'MERAK',
        name: 'Merak',
        'cyrillic-name': 'мерак',
        class: 'S',
        'year-from': 1975,
        'year-to': 1983,
      },
      {
        id: 'MEXICO',
        name: 'Mexico',
        'cyrillic-name': 'мехико',
        class: 'S',
        'year-from': 1967,
        'year-to': 1972,
      },
      {
        id: 'QUATTROPORTE',
        name: 'Quattroporte',
        'cyrillic-name': 'Кваттропорте',
        class: 'F',
        'year-from': 1979,
        'year-to': null,
      },
      {
        id: 'ROYALE',
        name: 'Royale',
        'cyrillic-name': 'рояле',
        class: 'F',
        'year-from': 1985,
        'year-to': 1993,
      },
      {
        id: 'SHAMAL',
        name: 'Shamal',
        'cyrillic-name': 'шамаль',
        class: 'S',
        'year-from': 1989,
        'year-to': 1995,
      },
    ],
  },
  {
    id: 'MATRA',
    name: 'Matra',
    'cyrillic-name': 'Матра',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'MURENA',
        name: 'Murena',
        'cyrillic-name': 'Мурена',
        class: 'B',
        'year-from': 1980,
        'year-to': 1983,
      },
    ],
  },
  {
    id: 'MAXUS',
    name: 'Maxus',
    'cyrillic-name': 'Максус',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'D60',
        name: 'D60',
        'cyrillic-name': 'Д60',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'D90_PRO',
        name: 'D90 Pro',
        'cyrillic-name': 'Д90 Про',
        class: 'J',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'G20',
        name: 'G20',
        'cyrillic-name': 'Джи20',
        class: 'M',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'G90',
        name: 'G90',
        'cyrillic-name': 'Джи90',
        class: 'M',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'MIFA_9',
        name: 'MIFA 9',
        'cyrillic-name': 'МИФА 9',
        class: 'M',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'TERRITORY',
        name: 'Territory',
        'cyrillic-name': 'территори',
        class: 'J',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'MAYBACH',
    name: 'Maybach',
    'cyrillic-name': 'Майбах',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: '57',
        name: '57',
        'cyrillic-name': '57',
        class: 'F',
        'year-from': 2002,
        'year-to': 2012,
      },
      {
        id: '62',
        name: '62',
        'cyrillic-name': '62',
        class: 'F',
        'year-from': 2002,
        'year-to': 2012,
      },
      {
        id: 'EXELERO',
        name: 'Exelero',
        'cyrillic-name': 'Экселеро',
        class: 'S',
        'year-from': 2005,
        'year-to': 2005,
      },
    ],
  },
  {
    id: 'MAZDA',
    name: 'Mazda',
    'cyrillic-name': 'Мазда',
    popular: true,
    country: 'Япония',
    models: [
      {
        id: '1000',
        name: '1000',
        'cyrillic-name': '1000',
        class: 'B',
        'year-from': 1967,
        'year-to': 1977,
      },
      {
        id: '121',
        name: '121',
        'cyrillic-name': '121',
        class: 'B',
        'year-from': 1987,
        'year-to': 2003,
      },
      {
        id: '1300',
        name: '1300',
        'cyrillic-name': '1300',
        class: 'C',
        'year-from': 1975,
        'year-to': 1977,
      },
      {
        id: '2',
        name: '2',
        'cyrillic-name': '2',
        class: 'B',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: '3',
        name: '3',
        'cyrillic-name': '3',
        class: 'C',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: '3MPS',
        name: '3 MPS',
        'cyrillic-name': '3 МПС',
        class: 'C',
        'year-from': 2006,
        'year-to': 2013,
      },
      {
        id: '323',
        name: '323',
        'cyrillic-name': '323',
        class: 'C',
        'year-from': 1977,
        'year-to': 2003,
      },
      {
        id: '5',
        name: '5',
        'cyrillic-name': '5',
        class: 'M',
        'year-from': 2005,
        'year-to': 2018,
      },
      {
        id: '6',
        name: '6',
        'cyrillic-name': '6',
        class: 'D',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: '6_MPS',
        name: '6 MPS',
        'cyrillic-name': '6 МПС',
        class: 'D',
        'year-from': 2005,
        'year-to': 2008,
      },
      {
        id: '616',
        name: '616',
        'cyrillic-name': '616',
        class: 'D',
        'year-from': 1970,
        'year-to': 1978,
      },
      {
        id: '626',
        name: '626',
        'cyrillic-name': '626',
        class: 'D',
        'year-from': 1979,
        'year-to': 2002,
      },
      {
        id: '818',
        name: '818',
        'cyrillic-name': '818',
        class: 'C',
        'year-from': 1974,
        'year-to': 1978,
      },
      {
        id: '929',
        name: '929',
        'cyrillic-name': '929',
        class: 'E',
        'year-from': 1972,
        'year-to': 1992,
      },
      {
        id: 'ATENZA',
        name: 'Atenza',
        'cyrillic-name': 'Атенза',
        class: 'D',
        'year-from': 2002,
        'year-to': 2019,
      },
      {
        id: 'AUTOZAM_AZ3',
        name: 'Autozam AZ-3',
        'cyrillic-name': 'Автозам АЗ-3',
        class: 'B',
        'year-from': 1991,
        'year-to': 1998,
      },
      {
        id: 'AUTOZAM_CLEF',
        name: 'Autozam Clef',
        'cyrillic-name': 'Автозам Клиф',
        class: 'C',
        'year-from': 1992,
        'year-to': 1994,
      },
      {
        id: 'AXELA',
        name: 'Axela',
        'cyrillic-name': 'Аксела',
        class: 'C',
        'year-from': 2003,
        'year-to': 2019,
      },
      {
        id: 'AUTOZAM_AZ1',
        name: 'AZ-1',
        'cyrillic-name': 'аз-1',
        class: 'A',
        'year-from': 1992,
        'year-to': 1998,
      },
      {
        id: 'AZ_OFFROAD',
        name: 'AZ-Offroad',
        'cyrillic-name': 'аз-оффроад',
        class: 'J',
        'year-from': 1998,
        'year-to': 2014,
      },
      {
        id: 'AZ_WAGON',
        name: 'AZ-Wagon',
        'cyrillic-name': 'аз-вагон',
        class: 'M',
        'year-from': 1994,
        'year-to': 2012,
      },
      {
        id: 'B_SERIES',
        name: 'B-series',
        'cyrillic-name': 'Б-серия',
        class: 'J',
        'year-from': 1985,
        'year-to': 2006,
      },
      {
        id: 'BIANTE',
        name: 'Biante',
        'cyrillic-name': 'Бианте',
        class: 'M',
        'year-from': 2008,
        'year-to': 2018,
      },
      {
        id: 'BONGO',
        name: 'Bongo',
        'cyrillic-name': 'Бонго',
        class: 'M',
        'year-from': 1966,
        'year-to': 2018,
      },
      {
        id: 'BONGO_FRIENDEE',
        name: 'Bongo Friendee',
        'cyrillic-name': 'Бонго Френди',
        class: 'M',
        'year-from': 1995,
        'year-to': 2005,
      },
      {
        id: 'BT_50',
        name: 'BT-50',
        'cyrillic-name': 'БТ-50',
        class: 'J',
        'year-from': 2006,
        'year-to': 2020,
      },
      {
        id: 'CAPELLA',
        name: 'Capella',
        'cyrillic-name': 'Капелла',
        class: 'D',
        'year-from': 1982,
        'year-to': 2002,
      },
      {
        id: 'CAROL',
        name: 'Carol',
        'cyrillic-name': 'Карол',
        class: 'A',
        'year-from': 1989,
        'year-to': null,
      },
      {
        id: 'CHANTEZ',
        name: 'Chantez',
        'cyrillic-name': 'шантез',
        class: 'A',
        'year-from': 1972,
        'year-to': 1976,
      },
      {
        id: 'COSMO',
        name: 'Cosmo',
        'cyrillic-name': 'Космо',
        class: 'D',
        'year-from': 1981,
        'year-to': 1985,
      },
      {
        id: 'CRONOS',
        name: 'Cronos',
        'cyrillic-name': 'Кронос',
        class: 'D',
        'year-from': 1991,
        'year-to': 1995,
      },
      {
        id: 'CX_3',
        name: 'CX-3',
        'cyrillic-name': 'сх-3',
        class: 'B',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'CX_30',
        name: 'CX-30',
        'cyrillic-name': 'сх-30',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'CX_4',
        name: 'CX-4',
        'cyrillic-name': 'СХ-4',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'CX_5',
        name: 'CX-5',
        'cyrillic-name': 'цкс-5',
        class: 'C',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'CX_60',
        name: 'CX-60',
        'cyrillic-name': 'ЦИкс-60',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'CX_7',
        name: 'CX-7',
        'cyrillic-name': 'цкс-7',
        class: 'D',
        'year-from': 2006,
        'year-to': 2012,
      },
      {
        id: 'CX_8',
        name: 'CX-8',
        'cyrillic-name': 'цкс-8',
        class: 'E',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'CX_9',
        name: 'CX-9',
        'cyrillic-name': 'цкс-9',
        class: 'E',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'DEMIO',
        name: 'Demio',
        'cyrillic-name': 'Демио',
        class: 'B',
        'year-from': 1996,
        'year-to': 2019,
      },
      {
        id: 'EFINI_MS_6',
        name: 'Efini MS-6',
        'cyrillic-name': 'Ефини МС-6',
        class: 'D',
        'year-from': 1991,
        'year-to': 1994,
      },
      {
        id: 'EFINI_MS_8',
        name: 'Efini MS-8',
        'cyrillic-name': 'Ефини МС-8',
        class: 'E',
        'year-from': 1992,
        'year-to': 1997,
      },
      {
        id: 'EFINI_MS_9',
        name: 'Efini MS-9',
        'cyrillic-name': 'Ефини МС-9',
        class: 'E',
        'year-from': 1991,
        'year-to': 1993,
      },
      {
        id: 'ETUDE',
        name: 'Etude',
        'cyrillic-name': 'этюд',
        class: 'C',
        'year-from': 1987,
        'year-to': 1989,
      },
      {
        id: 'EUNOS_100',
        name: 'Eunos 100',
        'cyrillic-name': 'еунос 100',
        class: 'C',
        'year-from': 1989,
        'year-to': 1994,
      },
      {
        id: 'EUNOS_300',
        name: 'Eunos 300',
        'cyrillic-name': 'Еунос 300',
        class: 'D',
        'year-from': 1989,
        'year-to': 1992,
      },
      {
        id: 'EUNOS_500',
        name: 'Eunos 500',
        'cyrillic-name': 'Еунос 500',
        class: 'D',
        'year-from': 1991,
        'year-to': 1996,
      },
      {
        id: 'EUNOS_800',
        name: 'Eunos 800',
        'cyrillic-name': 'Еунос 800',
        class: 'E',
        'year-from': 1993,
        'year-to': 1997,
      },
      {
        id: 'EUNOS_COSMO',
        name: 'Eunos Cosmo',
        'cyrillic-name': 'Космо',
        class: 'D',
        'year-from': 1990,
        'year-to': 1995,
      },
      {
        id: 'EUNOS_PRESSO',
        name: 'Eunos Presso',
        'cyrillic-name': 'Эунос Прессо',
        class: 'C',
        'year-from': 1991,
        'year-to': 1998,
      },
      {
        id: 'FAMILIA',
        name: 'Familia',
        'cyrillic-name': 'Фамилия',
        class: 'C',
        'year-from': 1985,
        'year-to': null,
      },
      {
        id: 'FLAIR',
        name: 'Flair',
        'cyrillic-name': 'флэир',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'FLAIR_CROSSOVER',
        name: 'Flair Crossover',
        'cyrillic-name': 'флэир кроссовер',
        class: 'M',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'FLAIR_WAGON',
        name: 'Flair Wagon',
        'cyrillic-name': 'Флэир Вэгон',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'LANTIS',
        name: 'Lantis',
        'cyrillic-name': 'Лантис',
        class: 'C',
        'year-from': 1993,
        'year-to': 1997,
      },
      {
        id: 'LAPUTA',
        name: 'Laputa',
        'cyrillic-name': 'Лапута',
        class: 'A',
        'year-from': 1998,
        'year-to': 2006,
      },
      {
        id: 'LUCE',
        name: 'Luce',
        'cyrillic-name': 'Люси',
        class: 'E',
        'year-from': 1977,
        'year-to': 1991,
      },
      {
        id: 'MILLENIA',
        name: 'Millenia',
        'cyrillic-name': 'Милления',
        class: 'E',
        'year-from': 1994,
        'year-to': 2003,
      },
      {
        id: 'MPV',
        name: 'MPV',
        'cyrillic-name': 'мпв',
        class: 'M',
        'year-from': 1988,
        'year-to': 2016,
      },
      {
        id: 'MX_3',
        name: 'MX-3',
        'cyrillic-name': 'мкс-3',
        class: 'S',
        'year-from': 1991,
        'year-to': 2000,
      },
      {
        id: 'MX_30',
        name: 'MX-30',
        'cyrillic-name': 'МХ-30',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'MX_5',
        name: 'MX-5',
        'cyrillic-name': 'мкс-5',
        class: 'S',
        'year-from': 1989,
        'year-to': null,
      },
      {
        id: 'MX_6',
        name: 'MX-6',
        'cyrillic-name': 'мкс-6',
        class: 'D',
        'year-from': 1991,
        'year-to': 1997,
      },
      {
        id: 'NAVAJO',
        name: 'Navajo',
        'cyrillic-name': 'Навайо',
        class: 'J',
        'year-from': 1990,
        'year-to': 1994,
      },
      {
        id: 'PERSONA',
        name: 'Persona',
        'cyrillic-name': 'Персона',
        class: 'D',
        'year-from': 1988,
        'year-to': 1992,
      },
      {
        id: 'PREMACY',
        name: 'Premacy',
        'cyrillic-name': 'Примаси',
        class: 'M',
        'year-from': 1999,
        'year-to': 2017,
      },
      {
        id: 'PROCEED',
        name: 'Proceed',
        'cyrillic-name': 'просид',
        class: 'J',
        'year-from': 1961,
        'year-to': 2006,
      },
      {
        id: 'PROCEED_LEVANTE',
        name: 'Proceed Levante',
        'cyrillic-name': 'Просид Леванте',
        class: 'J',
        'year-from': 1995,
        'year-to': 2001,
      },
      {
        id: 'PROCEED_MARVIE',
        name: 'Proceed Marvie',
        'cyrillic-name': 'Просид Марви',
        class: 'J',
        'year-from': 1990,
        'year-to': 1999,
      },
      {
        id: 'PROTEGE',
        name: 'Protege',
        'cyrillic-name': 'Протеж',
        class: 'C',
        'year-from': 1994,
        'year-to': 2004,
      },
      {
        id: 'R_360',
        name: 'R360',
        'cyrillic-name': 'р360',
        class: 'A',
        'year-from': 1960,
        'year-to': 1966,
      },
      {
        id: 'REVUE',
        name: 'Revue',
        'cyrillic-name': 'Ревю',
        class: 'B',
        'year-from': 1990,
        'year-to': 1998,
      },
      {
        id: 'ROADSTER',
        name: 'Roadster',
        'cyrillic-name': 'Родстер',
        class: 'S',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'RX_7',
        name: 'RX-7',
        'cyrillic-name': 'ркс-7',
        class: 'S',
        'year-from': 1979,
        'year-to': 2002,
      },
      {
        id: 'RX_8',
        name: 'RX-8',
        'cyrillic-name': 'ркс-8',
        class: 'S',
        'year-from': 2003,
        'year-to': 2012,
      },
      {
        id: 'SCRUM',
        name: 'Scrum',
        'cyrillic-name': 'Скрум',
        class: 'M',
        'year-from': 1991,
        'year-to': null,
      },
      {
        id: 'SENTIA',
        name: 'Sentia',
        'cyrillic-name': 'Сентия',
        class: 'E',
        'year-from': 1991,
        'year-to': 2000,
      },
      {
        id: 'SPIANO',
        name: 'Spiano',
        'cyrillic-name': 'Спиано',
        class: 'A',
        'year-from': 2002,
        'year-to': 2008,
      },
      {
        id: 'TRIBUTE',
        name: 'Tribute',
        'cyrillic-name': 'Трибьют',
        class: 'C',
        'year-from': 2000,
        'year-to': 2011,
      },
      {
        id: 'VERISA',
        name: 'Verisa',
        'cyrillic-name': 'Вериса',
        class: 'B',
        'year-from': 2004,
        'year-to': 2015,
      },
      {
        id: 'XEDOS_6',
        name: 'Xedos 6',
        'cyrillic-name': 'Кседос 6',
        class: 'D',
        'year-from': 1992,
        'year-to': 2000,
      },
      {
        id: 'XEDOS_9',
        name: 'Xedos 9',
        'cyrillic-name': 'Кседос 9',
        class: 'E',
        'year-from': 1993,
        'year-to': 2003,
      },
    ],
  },
  {
    id: 'MCLAREN',
    name: 'McLaren',
    'cyrillic-name': 'МакЛарен',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '540C',
        name: '540C',
        'cyrillic-name': '540с',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: '570GT',
        name: '570GT',
        'cyrillic-name': '570гт',
        class: 'S',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: '570S',
        name: '570S',
        'cyrillic-name': '570с',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: '600LT',
        name: '600LT',
        'cyrillic-name': '600лт',
        class: 'S',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: '650S',
        name: '650S',
        'cyrillic-name': '650с',
        class: 'S',
        'year-from': 2014,
        'year-to': 2017,
      },
      {
        id: '675LT',
        name: '675LT',
        'cyrillic-name': '657лт',
        class: 'S',
        'year-from': 2015,
        'year-to': 2017,
      },
      {
        id: '720S',
        name: '720S',
        'cyrillic-name': '720С',
        class: 'S',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: '765LT',
        name: '765LT',
        'cyrillic-name': '765лт',
        class: 'S',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'ARTURA',
        name: 'Artura',
        'cyrillic-name': 'Артура',
        class: 'S',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'F1',
        name: 'F1',
        'cyrillic-name': 'ф1',
        class: 'S',
        'year-from': 1992,
        'year-to': 2000,
      },
      {
        id: 'GT',
        name: 'GT',
        'cyrillic-name': 'ГТ',
        class: 'S',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: '12C',
        name: 'MP4-12C',
        'cyrillic-name': 'мп4-12с',
        class: 'S',
        'year-from': 2011,
        'year-to': 2014,
      },
      {
        id: 'P1',
        name: 'P1',
        'cyrillic-name': 'П1',
        class: 'S',
        'year-from': 2013,
        'year-to': 2015,
      },
      {
        id: 'SENNA',
        name: 'Senna',
        'cyrillic-name': 'Сенна',
        class: 'S',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'MEGA',
    name: 'Mega',
    'cyrillic-name': 'Мега',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'CLUB',
        name: 'Club',
        'cyrillic-name': 'клаб',
        class: 'B',
        'year-from': 1992,
        'year-to': 1999,
      },
      {
        id: 'MONTE_CARLO',
        name: 'Monte Carlo',
        'cyrillic-name': 'монте карло',
        class: 'S',
        'year-from': 1996,
        'year-to': 1999,
      },
      {
        id: 'TRACK',
        name: 'Track',
        'cyrillic-name': 'трек',
        class: 'S',
        'year-from': 1992,
        'year-to': 2000,
      },
    ],
  },
  {
    id: 'MERCEDES',
    name: 'Mercedes-Benz',
    'cyrillic-name': 'Мерседес-Бенц',
    popular: true,
    country: 'Германия',
    models: [
      {
        id: 'W201',
        name: '190 (W201)',
        'cyrillic-name': '190',
        class: 'D',
        'year-from': 1982,
        'year-to': 1993,
      },
      {
        id: '190_SL',
        name: '190 SL',
        'cyrillic-name': '190 сл',
        class: 'S',
        'year-from': 1955,
        'year-to': 1963,
      },
      {
        id: '220_W187',
        name: '220 (W187)',
        'cyrillic-name': '220 (В187)',
        class: 'S',
        'year-from': 1951,
        'year-to': 1955,
      },
      {
        id: 'A_KLASSE',
        name: 'A-Класс',
        'cyrillic-name': 'А-класс',
        class: 'C',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'A_KLASSE_AMG',
        name: 'A-Класс AMG',
        'cyrillic-name': 'А-класс АМГ',
        class: 'C',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'AMG_GT',
        name: 'AMG GT',
        'cyrillic-name': 'амг гт',
        class: 'E',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'AMG_ONE',
        name: 'AMG ONE',
        'cyrillic-name': 'АМГ УАН',
        class: 'S',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'B_KLASSE',
        name: 'B-Класс',
        'cyrillic-name': 'б-класс',
        class: 'C',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'C_KLASSE',
        name: 'C-Класс',
        'cyrillic-name': 'Ц-класс',
        class: 'D',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'C_KLASSE_AMG',
        name: 'C-Класс AMG',
        'cyrillic-name': 'Ц-класс АМГ',
        class: 'D',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'CITAN',
        name: 'Citan',
        'cyrillic-name': 'Цитан',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'CL_KLASSE',
        name: 'CL-Класс',
        'cyrillic-name': 'ЦЛ-класс',
        class: 'F',
        'year-from': 1992,
        'year-to': 2014,
      },
      {
        id: 'CL_KLASSE_AMG',
        name: 'CL-Класс AMG',
        'cyrillic-name': 'ЦЛ-класс АМГ',
        class: 'F',
        'year-from': 2000,
        'year-to': 2014,
      },
      {
        id: 'CLA_KLASSE',
        name: 'CLA',
        'cyrillic-name': 'ЦЛА-класс',
        class: 'C',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'CLA_KLASSE_AMG',
        name: 'CLA AMG',
        'cyrillic-name': 'ЦЛА-класс АМГ',
        class: 'C',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'CLC_KLASSE',
        name: 'CLC-Класс',
        'cyrillic-name': 'ЦЛЦ-класс',
        class: 'C',
        'year-from': 2008,
        'year-to': 2011,
      },
      {
        id: 'CLK_AMG_GTR',
        name: 'CLK AMG GTR',
        'cyrillic-name': 'ЦЛК АМГ ГТР',
        class: 'S',
        'year-from': 1997,
        'year-to': 1999,
      },
      {
        id: 'CLK_KLASSE',
        name: 'CLK-Класс',
        'cyrillic-name': 'ЦЛК-класс',
        class: 'D',
        'year-from': 1997,
        'year-to': 2010,
      },
      {
        id: 'CLK_KLASSE_AMG',
        name: 'CLK-Класс AMG',
        'cyrillic-name': 'ЦЛК-класс АМГ',
        class: 'D',
        'year-from': 1999,
        'year-to': 2010,
      },
      {
        id: 'CLS_KLASSE',
        name: 'CLS',
        'cyrillic-name': 'ЦЛС-класс',
        class: 'E',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'CLS_KLASSE_AMG',
        name: 'CLS AMG',
        'cyrillic-name': 'ЦЛС-класс АМГ',
        class: 'E',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'E_KLASSE',
        name: 'E-Класс',
        'cyrillic-name': 'Е-класс',
        class: 'E',
        'year-from': 1992,
        'year-to': null,
      },
      {
        id: 'E_KLASSE_AMG',
        name: 'E-Класс AMG',
        'cyrillic-name': 'Е-класс АМГ',
        class: 'E',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'EQA',
        name: 'EQA',
        'cyrillic-name': 'ЕКьюА',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'EQB',
        name: 'EQB',
        'cyrillic-name': 'ЕКьюБ',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'EQC',
        name: 'EQC',
        'cyrillic-name': 'ЕКьюС',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'EQE',
        name: 'EQE',
        'cyrillic-name': 'ЕКьюЕ',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'EQE_AMG',
        name: 'EQE AMG',
        'cyrillic-name': 'ЕКьюЕ АМГ',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'EQE_SUV',
        name: 'EQE SUV',
        'cyrillic-name': 'ЕКьюЕ СУВ',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'EQE_SUV_AMG',
        name: 'EQE SUV AMG',
        'cyrillic-name': 'ЕКьюЕ СУВ АМГ',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'EQS',
        name: 'EQS',
        'cyrillic-name': 'ЕКьюЭс',
        class: 'F',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'EQS_AMG',
        name: 'EQS AMG',
        'cyrillic-name': 'ЕКьюЭс АМГ',
        class: 'F',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'EQS_SUV',
        name: 'EQS SUV',
        'cyrillic-name': 'ЕКьюЭс СУВ',
        class: 'F',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'EQV',
        name: 'EQV',
        'cyrillic-name': 'ЕКьюВ',
        class: 'M',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'G_KLASSE',
        name: 'G-Класс',
        'cyrillic-name': 'г-класс',
        class: 'J',
        'year-from': 1979,
        'year-to': null,
      },
      {
        id: 'G_KLASSE_AMG',
        name: 'G-Класс AMG',
        'cyrillic-name': 'г-класс амг',
        class: 'J',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'G_KLASSE_AMG_6X6',
        name: 'G-Класс AMG 6x6',
        'cyrillic-name': 'г-класс амг 6кс6',
        class: 'J',
        'year-from': 2013,
        'year-to': 2015,
      },
      {
        id: 'GL_KLASSE',
        name: 'GL-Класс',
        'cyrillic-name': 'гл-класс',
        class: 'F',
        'year-from': 2006,
        'year-to': 2016,
      },
      {
        id: 'GL_KLASSE_AMG',
        name: 'GL-Класс AMG',
        'cyrillic-name': 'гл-класс амг',
        class: 'F',
        'year-from': 2012,
        'year-to': 2016,
      },
      {
        id: 'GLA_CLASS',
        name: 'GLA',
        'cyrillic-name': 'ГЛА-класс',
        class: 'C',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'GLA_CLASS_AMG',
        name: 'GLA AMG',
        'cyrillic-name': 'ГЛА-класс АМГ',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'GLB_KLASSE',
        name: 'GLB',
        'cyrillic-name': 'ГЛБ',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'GLB_AMG',
        name: 'GLB AMG',
        'cyrillic-name': 'ГЛБ АМГ',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'GLC_KLASSE',
        name: 'GLC',
        'cyrillic-name': 'ГЛЦ',
        class: 'D',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'GLC_KLASSE_AMG',
        name: 'GLC AMG',
        'cyrillic-name': 'ГЛЦ АМГ',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'GLC_COUPE',
        name: 'GLC Coupe',
        'cyrillic-name': 'ГЛЦ Купе',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'AMG_GLC_COUPE',
        name: 'GLC Coupe AMG',
        'cyrillic-name': 'глц купе амг',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'GLE_KLASSE',
        name: 'GLE',
        'cyrillic-name': 'ГЛЕ',
        class: 'E',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'GLE_KLASSE_AMG',
        name: 'GLE AMG',
        'cyrillic-name': 'ГЛЕ АМГ',
        class: 'E',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'GLE_KLASSE_COUPE',
        name: 'GLE Coupe',
        'cyrillic-name': 'ГЛЕ Купе',
        class: 'E',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'GLE_KLASSE_COUPE_AMG',
        name: 'GLE Coupe AMG',
        'cyrillic-name': 'ГЛЕ Купе АМГ',
        class: 'E',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'GLK_KLASSE',
        name: 'GLK-Класс',
        'cyrillic-name': 'глк-класс',
        class: 'D',
        'year-from': 2008,
        'year-to': 2015,
      },
      {
        id: 'GLS_KLASSE',
        name: 'GLS',
        'cyrillic-name': 'глс',
        class: 'F',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'GLS_KLASSE_AMG',
        name: 'GLS AMG',
        'cyrillic-name': 'глс амг',
        class: 'F',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'M_KLASSE',
        name: 'M-Класс',
        'cyrillic-name': 'м-класс',
        class: 'E',
        'year-from': 1997,
        'year-to': 2015,
      },
      {
        id: 'M_KLASSE_AMG',
        name: 'M-Класс AMG',
        'cyrillic-name': 'М-класс АМГ',
        class: 'E',
        'year-from': 2000,
        'year-to': 2015,
      },
      {
        id: 'MARCO_POLO',
        name: 'Marco Polo',
        'cyrillic-name': 'Марко Поло',
        class: 'M',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'MAYBACH_G_650',
        name: 'Maybach G 650 Landaulet',
        'cyrillic-name': 'Майбах Джи 650',
        class: 'M',
        'year-from': 2017,
        'year-to': 2018,
      },
      {
        id: 'MAYBACH_GLS',
        name: 'Maybach GLS',
        'cyrillic-name': 'Майбах ГЛС',
        class: 'F',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'S_CLASS_MAYBACH',
        name: 'Maybach S-Класс',
        'cyrillic-name': 'Майбах Эс-Класс',
        class: 'F',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'METRIS',
        name: 'Metris',
        'cyrillic-name': 'Метрис',
        class: 'M',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'R_KLASSE',
        name: 'R-Класс',
        'cyrillic-name': 'Р-класс',
        class: 'M',
        'year-from': 2005,
        'year-to': 2017,
      },
      {
        id: 'R_KLASSE_AMG',
        name: 'R-Класс AMG',
        'cyrillic-name': 'Р-класс АМГ',
        class: 'M',
        'year-from': 2006,
        'year-to': 2007,
      },
      {
        id: 'S_KLASSE',
        name: 'S-Класс',
        'cyrillic-name': 'с-класс',
        class: 'F',
        'year-from': 1965,
        'year-to': null,
      },
      {
        id: 'S_KLASSE_AMG',
        name: 'S-Класс AMG',
        'cyrillic-name': 'с-класс амг',
        class: 'F',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'SIMPLEX',
        name: 'Simplex',
        'cyrillic-name': 'Симплекс',
        class: 'S',
        'year-from': 1904,
        'year-to': 1909,
      },
      {
        id: 'SL_KLASSE',
        name: 'SL-Класс',
        'cyrillic-name': 'сл-класс',
        class: 'S',
        'year-from': 1954,
        'year-to': 2020,
      },
      {
        id: 'SL_KLASSE_AMG',
        name: 'SL-Класс AMG',
        'cyrillic-name': 'СЛ-класс АМГ',
        class: 'S',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'SLC_KLASSE',
        name: 'SLC',
        'cyrillic-name': 'слц',
        class: 'S',
        'year-from': 2016,
        'year-to': 2020,
      },
      {
        id: 'SLC_KLASSE_AMG',
        name: 'SLC AMG',
        'cyrillic-name': 'слц амг',
        class: 'S',
        'year-from': 2016,
        'year-to': 2020,
      },
      {
        id: 'SLK_KLASSE',
        name: 'SLK-Класс',
        'cyrillic-name': 'СЛК-класс',
        class: 'S',
        'year-from': 1996,
        'year-to': 2016,
      },
      {
        id: 'SLK_KLASSE_AMG',
        name: 'SLK-Класс AMG',
        'cyrillic-name': 'СЛК-класс АМГ',
        class: 'S',
        'year-from': 2001,
        'year-to': 2016,
      },
      {
        id: 'SLR_KLASSE',
        name: 'SLR McLaren',
        'cyrillic-name': 'слр мцларен',
        class: 'F',
        'year-from': 2003,
        'year-to': 2009,
      },
      {
        id: 'SLS_AMG',
        name: 'SLS AMG',
        'cyrillic-name': 'слс амг',
        class: 'S',
        'year-from': 2010,
        'year-to': 2014,
      },
      {
        id: 'T_KLASSE',
        name: 'T-Класс',
        'cyrillic-name': 'Т-класс',
        class: 'M',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'V_KLASSE',
        name: 'V-Класс',
        'cyrillic-name': 'в-класс',
        class: 'M',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'VANEO',
        name: 'Vaneo',
        'cyrillic-name': 'Ванео',
        class: 'M',
        'year-from': 2001,
        'year-to': 2005,
      },
      {
        id: 'VIANO',
        name: 'Viano',
        'cyrillic-name': 'Виано',
        class: 'M',
        'year-from': 2003,
        'year-to': 2014,
      },
      {
        id: 'VITO',
        name: 'Vito',
        'cyrillic-name': 'вито',
        class: '',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'W100',
        name: 'W100',
        'cyrillic-name': 'в100',
        class: 'F',
        'year-from': 1964,
        'year-to': 1981,
      },
      {
        id: 'W105',
        name: 'W105',
        'cyrillic-name': 'в105',
        class: 'E',
        'year-from': 1956,
        'year-to': 1959,
      },
      {
        id: 'W108',
        name: 'W108',
        'cyrillic-name': 'в108',
        class: 'F',
        'year-from': 1965,
        'year-to': 1972,
      },
      {
        id: 'W110',
        name: 'W110',
        'cyrillic-name': 'в110',
        class: 'D',
        'year-from': 1961,
        'year-to': 1968,
      },
      {
        id: 'W111',
        name: 'W111',
        'cyrillic-name': 'в111',
        class: 'F',
        'year-from': 1959,
        'year-to': 1971,
      },
      {
        id: 'W114',
        name: 'W114',
        'cyrillic-name': 'в114',
        class: 'E',
        'year-from': 1968,
        'year-to': 1977,
      },
      {
        id: 'W115',
        name: 'W115',
        'cyrillic-name': 'в115',
        class: 'F',
        'year-from': 1968,
        'year-to': 1977,
      },
      {
        id: 'W120',
        name: 'W120',
        'cyrillic-name': 'в120',
        class: 'C',
        'year-from': 1953,
        'year-to': 1962,
      },
      {
        id: 'W121',
        name: 'W121',
        'cyrillic-name': 'в121',
        class: 'D',
        'year-from': 1959,
        'year-to': 1961,
      },
      {
        id: 'W123',
        name: 'W123',
        'cyrillic-name': 'в123',
        class: 'E',
        'year-from': 1975,
        'year-to': 1985,
      },
      {
        id: 'W124',
        name: 'W124',
        'cyrillic-name': 'в124',
        class: 'E',
        'year-from': 1984,
        'year-to': 1993,
      },
      {
        id: 'W128',
        name: 'W128',
        'cyrillic-name': 'в128',
        class: 'F',
        'year-from': 1958,
        'year-to': 1960,
      },
      {
        id: 'W136',
        name: 'W136',
        'cyrillic-name': 'в136',
        class: 'D',
        'year-from': 1936,
        'year-to': 1955,
      },
      {
        id: 'W138',
        name: 'W138',
        'cyrillic-name': 'В138',
        class: 'F',
        'year-from': 1935,
        'year-to': 1940,
      },
      {
        id: 'W142',
        name: 'W142',
        'cyrillic-name': 'в142',
        class: 'S',
        'year-from': 1937,
        'year-to': 1942,
      },
      {
        id: 'W180',
        name: 'W180',
        'cyrillic-name': 'В180',
        class: 'F',
        'year-from': 1954,
        'year-to': 1959,
      },
      {
        id: 'W186',
        name: 'W186',
        'cyrillic-name': 'в186',
        class: 'E',
        'year-from': 1951,
        'year-to': 1957,
      },
      {
        id: 'W188',
        name: 'W188',
        'cyrillic-name': 'в188',
        class: 'F',
        'year-from': 1951,
        'year-to': 1958,
      },
      {
        id: 'W189',
        name: 'W189',
        'cyrillic-name': 'в189',
        class: 'F',
        'year-from': 1957,
        'year-to': 1962,
      },
      {
        id: 'W191',
        name: 'W191',
        'cyrillic-name': 'в191',
        class: 'E',
        'year-from': 1949,
        'year-to': 1952,
      },
      {
        id: 'W21',
        name: 'W21',
        'cyrillic-name': 'в21',
        class: 'D',
        'year-from': 1933,
        'year-to': 1936,
      },
      {
        id: 'W29',
        name: 'W29',
        'cyrillic-name': 'в29',
        class: 'S',
        'year-from': 1934,
        'year-to': 1936,
      },
      {
        id: 'X_KLASSE',
        name: 'X-Класс',
        'cyrillic-name': 'кс-класс',
        class: 'J',
        'year-from': 2017,
        'year-to': 2020,
      },
    ],
  },
  {
    id: 'MERCURY',
    name: 'Mercury',
    'cyrillic-name': 'Меркури',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'CAPRI',
        name: 'Capri',
        'cyrillic-name': 'Капри',
        class: 'C',
        'year-from': 1990,
        'year-to': 1995,
      },
      {
        id: 'COLONY_PARK',
        name: 'Colony Park',
        'cyrillic-name': 'Колони Парк',
        class: 'F',
        'year-from': 1969,
        'year-to': 1978,
      },
      {
        id: 'COUGAR',
        name: 'Cougar',
        'cyrillic-name': 'Когуар',
        class: 'D',
        'year-from': 1977,
        'year-to': 2002,
      },
      {
        id: 'EIGHT',
        name: 'Eight',
        'cyrillic-name': 'Эйт',
        class: '',
        'year-from': 1949,
        'year-to': 1951,
      },
      {
        id: 'GRAND_MARQUIS',
        name: 'Grand Marquis',
        'cyrillic-name': 'Гранд Маркиз',
        class: 'F',
        'year-from': 1983,
        'year-to': 2011,
      },
      {
        id: 'MARAUDER',
        name: 'Marauder',
        'cyrillic-name': 'Марадер',
        class: 'E',
        'year-from': 2002,
        'year-to': 2004,
      },
      {
        id: 'MARINER',
        name: 'Mariner',
        'cyrillic-name': 'Маринер',
        class: 'C',
        'year-from': 2004,
        'year-to': 2010,
      },
      {
        id: 'MARQUIES',
        name: 'Marquis',
        'cyrillic-name': 'Маркиз',
        class: 'E',
        'year-from': 1979,
        'year-to': 1986,
      },
      {
        id: 'MILAN',
        name: 'Milan',
        'cyrillic-name': 'Милан',
        class: 'E',
        'year-from': 2005,
        'year-to': 2010,
      },
      {
        id: 'MONTEGO',
        name: 'Montego',
        'cyrillic-name': 'Монтего',
        class: 'E',
        'year-from': 2004,
        'year-to': 2007,
      },
      {
        id: 'MONTEREY',
        name: 'Monterey',
        'cyrillic-name': 'Монтерей',
        class: 'M',
        'year-from': 1960,
        'year-to': 2007,
      },
      {
        id: 'MOUNTAINEER',
        name: 'Mountaineer',
        'cyrillic-name': 'Моунтайнер',
        class: 'J',
        'year-from': 1996,
        'year-to': 2010,
      },
      {
        id: 'MYSTIQUE',
        name: 'Mystique',
        'cyrillic-name': 'Мистик',
        class: 'D',
        'year-from': 1994,
        'year-to': 2000,
      },
      {
        id: 'SABLE',
        name: 'Sable',
        'cyrillic-name': 'Сабл',
        class: 'F',
        'year-from': 1986,
        'year-to': 2009,
      },
      {
        id: 'TOPAZ',
        name: 'Topaz',
        'cyrillic-name': 'Топаз',
        class: 'C',
        'year-from': 1983,
        'year-to': 1994,
      },
      {
        id: 'TRACER',
        name: 'Tracer',
        'cyrillic-name': 'Трейсер',
        class: 'C',
        'year-from': 1991,
        'year-to': 1999,
      },
      {
        id: 'VILLAGER',
        name: 'Villager',
        'cyrillic-name': 'Виладжер',
        class: 'M',
        'year-from': 1992,
        'year-to': 2002,
      },
    ],
  },
  {
    id: 'MESSERSCHMITT',
    name: 'Messerschmitt',
    'cyrillic-name': 'Мессершмитт',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'KR200',
        name: 'KR200',
        'cyrillic-name': 'КР200',
        class: 'A',
        'year-from': 1952,
        'year-to': 1964,
      },
    ],
  },
  {
    id: 'METROCAB',
    name: 'Metrocab',
    'cyrillic-name': 'Метрокэб',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'METROCAB_1',
        name: 'Metrocab I',
        'cyrillic-name': 'Метрокаб 1',
        class: 'E',
        'year-from': 1987,
        'year-to': 2000,
      },
      {
        id: 'METROCAB_II_TTT',
        name: 'Metrocab II (TTT)',
        'cyrillic-name': 'Метрокаб 2',
        class: 'E',
        'year-from': 2001,
        'year-to': 2006,
      },
    ],
  },
  {
    id: 'MG',
    name: 'MG',
    'cyrillic-name': 'Эм-Джи',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '3',
        name: '3',
        'cyrillic-name': '3',
        class: 'B',
        'year-from': 2011,
        'year-to': 2018,
      },
      {
        id: '350',
        name: '350',
        'cyrillic-name': '350',
        class: 'C',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: '4_EV',
        name: '4 EV',
        'cyrillic-name': '4 ЕВ',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: '5',
        name: '5',
        'cyrillic-name': '5',
        class: 'C',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: '5_EV',
        name: '5 EV',
        'cyrillic-name': '5 ЕВ',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: '550',
        name: '550',
        'cyrillic-name': '550',
        class: 'D',
        'year-from': 2009,
        'year-to': 2017,
      },
      {
        id: '6',
        name: '6',
        'cyrillic-name': '6',
        class: 'D',
        'year-from': 2010,
        'year-to': 2017,
      },
      {
        id: '750',
        name: '750',
        'cyrillic-name': '750',
        class: 'C',
        'year-from': 2006,
        'year-to': 2016,
      },
      {
        id: 'F',
        name: 'F',
        'cyrillic-name': 'ф',
        class: 'S',
        'year-from': 1995,
        'year-to': 2002,
      },
      {
        id: 'GS',
        name: 'GS',
        'cyrillic-name': 'Джи Эс',
        class: 'C',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'MAESTRO',
        name: 'Maestro',
        'cyrillic-name': 'Маэстро',
        class: 'C',
        'year-from': 1983,
        'year-to': 1990,
      },
      {
        id: 'METRO',
        name: 'Metro',
        'cyrillic-name': 'Метро',
        class: 'B',
        'year-from': 1982,
        'year-to': 1990,
      },
      {
        id: 'MGA',
        name: 'MGA',
        'cyrillic-name': 'МГА',
        class: 'S',
        'year-from': 1955,
        'year-to': 1962,
      },
      {
        id: 'MGB',
        name: 'MGB',
        'cyrillic-name': 'мгб',
        class: 'S',
        'year-from': 1966,
        'year-to': 1980,
      },
      {
        id: 'MIDGET',
        name: 'Midget',
        'cyrillic-name': 'Миджет',
        class: 'S',
        'year-from': 1964,
        'year-to': 1979,
      },
      {
        id: 'MONTEGO',
        name: 'Montego',
        'cyrillic-name': 'Монтего',
        class: 'C',
        'year-from': 1984,
        'year-to': 1990,
      },
      {
        id: 'RV8',
        name: 'RV8',
        'cyrillic-name': 'рв8',
        class: 'S',
        'year-from': 1992,
        'year-to': 1995,
      },
      {
        id: 'TD_MIDGET',
        name: 'TD Midget',
        'cyrillic-name': 'ТД-Миджет',
        class: 'C',
        'year-from': 1950,
        'year-to': 1953,
      },
      {
        id: 'TF',
        name: 'TF',
        'cyrillic-name': 'тф',
        class: 'S',
        'year-from': 2002,
        'year-to': 2005,
      },
      {
        id: 'XPOWER_SV',
        name: 'Xpower SV',
        'cyrillic-name': 'хпауер св',
        class: 'S',
        'year-from': 2003,
        'year-to': 2005,
      },
      {
        id: 'ZR',
        name: 'ZR',
        'cyrillic-name': 'зр',
        class: 'C',
        'year-from': 2001,
        'year-to': 2005,
      },
      {
        id: 'ZS',
        name: 'ZS',
        'cyrillic-name': 'зс',
        class: 'B',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'ZT',
        name: 'ZT',
        'cyrillic-name': 'ЗТ',
        class: 'D',
        'year-from': 2001,
        'year-to': 2005,
      },
    ],
  },
  {
    id: 'MICROCAR',
    name: 'Microcar',
    'cyrillic-name': 'Микрокар',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'F8C',
        name: 'F8C',
        'cyrillic-name': 'ф8с',
        class: 'A',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'MGO',
        name: 'M.Go',
        'cyrillic-name': 'м.го',
        class: 'A',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'M8',
        name: 'M8',
        'cyrillic-name': 'м8',
        class: 'A',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'MC',
        name: 'MC',
        'cyrillic-name': 'мс',
        class: 'A',
        'year-from': 2000,
        'year-to': 2008,
      },
      {
        id: 'VIRGO',
        name: 'Virgo',
        'cyrillic-name': 'вирго',
        class: 'A',
        'year-from': 1999,
        'year-to': 2003,
      },
    ],
  },
  {
    id: 'MINELLI',
    name: 'Minelli',
    'cyrillic-name': 'Минелли',
    popular: false,
    country: 'Швейцария',
    models: [
      {
        id: 'TF_1800',
        name: 'TF 1800',
        'cyrillic-name': 'тф 1800',
        class: 'S',
        'year-from': 1998,
        'year-to': 2001,
      },
    ],
  },
  {
    id: 'MINI',
    name: 'MINI',
    'cyrillic-name': 'Мини',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'CABRIO',
        name: 'Cabrio',
        'cyrillic-name': 'Кабрио',
        class: 'B',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'CLUBMAN',
        name: 'Clubman',
        'cyrillic-name': 'Клубмэн',
        class: 'B',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'COUNTRYMAN',
        name: 'Countryman',
        'cyrillic-name': 'Каунтримэн',
        class: 'B',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'COUPE',
        name: 'Coupe',
        'cyrillic-name': 'Купе',
        class: 'A',
        'year-from': 2011,
        'year-to': 2015,
      },
      {
        id: 'HATCH',
        name: 'Hatch',
        'cyrillic-name': 'Хэтч',
        class: 'B',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'PACEMAN',
        name: 'Paceman',
        'cyrillic-name': 'Пейсмэн',
        class: 'B',
        'year-from': 2012,
        'year-to': 2016,
      },
      {
        id: 'ROADSTER',
        name: 'Roadster',
        'cyrillic-name': 'Родстер',
        class: 'B',
        'year-from': 2012,
        'year-to': 2015,
      },
    ],
  },
  {
    id: 'MITSUBISHI',
    name: 'Mitsubishi',
    'cyrillic-name': 'Митсубиси',
    popular: true,
    country: 'Япония',
    models: [
      {
        id: '3000_GT',
        name: '3000 GT',
        'cyrillic-name': '3000',
        class: 'D',
        'year-from': 1990,
        'year-to': 2001,
      },
      {
        id: '500',
        name: '500',
        'cyrillic-name': '500',
        class: 'A',
        'year-from': 1960,
        'year-to': 1962,
      },
      {
        id: 'AIRTREK',
        name: 'Airtrek',
        'cyrillic-name': 'Аиртрек',
        class: 'J',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'ASPIRE',
        name: 'Aspire',
        'cyrillic-name': 'Аспайр',
        class: 'D',
        'year-from': 1998,
        'year-to': 2003,
      },
      {
        id: 'ASX',
        name: 'ASX',
        'cyrillic-name': 'аскс',
        class: 'C',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'ATTRAGE',
        name: 'Attrage',
        'cyrillic-name': 'Аттраж',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'BRABO',
        name: 'Bravo',
        'cyrillic-name': 'Браво',
        class: 'M',
        'year-from': 1991,
        'year-to': 1999,
      },
      {
        id: 'CARISMA',
        name: 'Carisma',
        'cyrillic-name': 'Каризма',
        class: 'D',
        'year-from': 1995,
        'year-to': 2004,
      },
      {
        id: 'CELESTE',
        name: 'Celeste',
        'cyrillic-name': 'Селест',
        class: 'C',
        'year-from': 1975,
        'year-to': 1981,
      },
      {
        id: 'CHALLENGER',
        name: 'Challenger',
        'cyrillic-name': 'Челленджер',
        class: 'J',
        'year-from': 1996,
        'year-to': 2015,
      },
      {
        id: 'CHARIOT',
        name: 'Chariot',
        'cyrillic-name': 'Шариот',
        class: 'M',
        'year-from': 1983,
        'year-to': 2003,
      },
      {
        id: 'COLT',
        name: 'Colt',
        'cyrillic-name': 'Кольт',
        class: 'B',
        'year-from': 1978,
        'year-to': 2012,
      },
      {
        id: 'CORDIA',
        name: 'Cordia',
        'cyrillic-name': 'Кордия',
        class: 'B',
        'year-from': 1982,
        'year-to': 1990,
      },
      {
        id: 'DEBONAIR',
        name: 'Debonair',
        'cyrillic-name': 'дебонаир',
        class: 'E',
        'year-from': 1986,
        'year-to': 1999,
      },
      {
        id: 'DELICA',
        name: 'Delica',
        'cyrillic-name': 'Делика',
        class: 'M',
        'year-from': 1979,
        'year-to': null,
      },
      {
        id: 'DELICA_D2',
        name: 'Delica D:2',
        'cyrillic-name': 'Делика Д:2',
        class: 'M',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'DELICA_D3',
        name: 'Delica D:3',
        'cyrillic-name': 'Делика Д:3',
        class: 'M',
        'year-from': 2011,
        'year-to': 2019,
      },
      {
        id: 'DELICA_D_5',
        name: 'Delica D:5',
        'cyrillic-name': 'Дулика Д:5',
        class: 'M',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'DIAMANTE',
        name: 'Diamante',
        'cyrillic-name': 'Диамант',
        class: 'E',
        'year-from': 1990,
        'year-to': 2005,
      },
      {
        id: 'DIGNITY',
        name: 'Dignity',
        'cyrillic-name': 'Дигнити',
        class: 'F',
        'year-from': 1999,
        'year-to': 2016,
      },
      {
        id: 'DINGO',
        name: 'Dingo',
        'cyrillic-name': 'Динго',
        class: 'M',
        'year-from': 1998,
        'year-to': 2003,
      },
      {
        id: 'DION',
        name: 'Dion',
        'cyrillic-name': 'Дион',
        class: 'M',
        'year-from': 2000,
        'year-to': 2005,
      },
      {
        id: 'ECLIPSE',
        name: 'Eclipse',
        'cyrillic-name': 'Эклипс',
        class: 'S',
        'year-from': 1989,
        'year-to': 2011,
      },
      {
        id: 'ECLIPSE_CROSS',
        name: 'Eclipse Cross',
        'cyrillic-name': 'Эклипс Кросс',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'EK_ACTIVE',
        name: 'eK Active',
        'cyrillic-name': 'еК Актив',
        class: 'B',
        'year-from': 2004,
        'year-to': 2006,
      },
      {
        id: 'EK_CLASSIC',
        name: 'eK Classic',
        'cyrillic-name': 'еК Классик',
        class: 'A',
        'year-from': 2003,
        'year-to': 2005,
      },
      {
        id: 'EK_CUSTOM',
        name: 'eK Custom',
        'cyrillic-name': 'еК Кастом',
        class: 'A',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'EK_SPACE',
        name: 'eK Space',
        'cyrillic-name': 'еК Спейс',
        class: 'A',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'EK_SPORT',
        name: 'eK Sport',
        'cyrillic-name': 'еК Спорт',
        class: 'A',
        'year-from': 2002,
        'year-to': 2013,
      },
      {
        id: 'EK_WAGON',
        name: 'eK Wagon',
        'cyrillic-name': 'ек вагон',
        class: 'A',
        'year-from': 2001,
        'year-to': 2019,
      },
      {
        id: 'EMERAUDE',
        name: 'Emeraude',
        'cyrillic-name': 'Эмерауд',
        class: 'D',
        'year-from': 1992,
        'year-to': 1996,
      },
      {
        id: 'ENDEAVOR',
        name: 'Endeavor',
        'cyrillic-name': 'Эндевор',
        class: 'E',
        'year-from': 2002,
        'year-to': 2011,
      },
      {
        id: 'ETERNA',
        name: 'Eterna',
        'cyrillic-name': 'Этерна',
        class: 'D',
        'year-from': 1983,
        'year-to': 1996,
      },
      {
        id: 'FREECA',
        name: 'Freeca',
        'cyrillic-name': 'фриса',
        class: 'M',
        'year-from': 1997,
        'year-to': 2009,
      },
      {
        id: 'FTO',
        name: 'FTO',
        'cyrillic-name': 'фто',
        class: 'C',
        'year-from': 1994,
        'year-to': 2001,
      },
      {
        id: 'GALANT',
        name: 'Galant',
        'cyrillic-name': 'Галант',
        class: 'E',
        'year-from': 1976,
        'year-to': 2012,
      },
      {
        id: 'GALANT_FORTIS',
        name: 'Galant Fortis',
        'cyrillic-name': 'Галант Фортис',
        class: 'C',
        'year-from': 2007,
        'year-to': 2015,
      },
      {
        id: 'GRANDIS',
        name: 'Grandis',
        'cyrillic-name': 'Грандис',
        class: 'M',
        'year-from': 2003,
        'year-to': 2011,
      },
      {
        id: 'GTO',
        name: 'GTO',
        'cyrillic-name': 'гто',
        class: 'S',
        'year-from': 1990,
        'year-to': 2005,
      },
      {
        id: 'I',
        name: 'i',
        'cyrillic-name': 'и',
        class: 'A',
        'year-from': 2006,
        'year-to': 2013,
      },
      {
        id: 'I_MIEV',
        name: 'i-MiEV',
        'cyrillic-name': 'и-миев',
        class: 'A',
        'year-from': 2009,
        'year-to': 2015,
      },
      {
        id: 'JEEP_J',
        name: 'Jeep J',
        'cyrillic-name': 'Джип',
        class: 'J',
        'year-from': 1953,
        'year-to': 1998,
      },
      {
        id: 'L200',
        name: 'L200',
        'cyrillic-name': 'Л200',
        class: 'J',
        'year-from': 1986,
        'year-to': null,
      },
      {
        id: 'L300',
        name: 'L300',
        'cyrillic-name': 'л300',
        class: 'M',
        'year-from': 1979,
        'year-to': 1999,
      },
      {
        id: 'L400',
        name: 'L400',
        'cyrillic-name': 'л400',
        class: 'M',
        'year-from': 1995,
        'year-to': 2006,
      },
      {
        id: 'LANCER',
        name: 'Lancer',
        'cyrillic-name': 'Лансер',
        class: 'C',
        'year-from': 1973,
        'year-to': 2017,
      },
      {
        id: 'LANCER_CARGO',
        name: 'Lancer Cargo',
        'cyrillic-name': 'Лансер Карго',
        class: 'C',
        'year-from': 2003,
        'year-to': 2019,
      },
      {
        id: 'LANCER_EVOLUTION',
        name: 'Lancer Evolution',
        'cyrillic-name': 'Лансер Эволюшн',
        class: 'C',
        'year-from': 1992,
        'year-to': 2016,
      },
      {
        id: 'LANCER_RALLIART',
        name: 'Lancer Ralliart',
        'cyrillic-name': 'Лансер Раллиарт',
        class: 'C',
        'year-from': 2003,
        'year-to': 2012,
      },
      {
        id: 'LEGNUM',
        name: 'Legnum',
        'cyrillic-name': 'Легнум',
        class: 'D',
        'year-from': 1996,
        'year-to': 2002,
      },
      {
        id: 'LIBERO',
        name: 'Libero',
        'cyrillic-name': 'Либеро',
        class: 'C',
        'year-from': 1992,
        'year-to': 2003,
      },
      {
        id: 'MINICA',
        name: 'Minica',
        'cyrillic-name': 'Миника',
        class: 'A',
        'year-from': 1984,
        'year-to': 2011,
      },
      {
        id: 'MINICAB',
        name: 'Minicab',
        'cyrillic-name': 'Миникэб',
        class: 'M',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'MIRAGE',
        name: 'Mirage',
        'cyrillic-name': 'Мираж',
        class: 'B',
        'year-from': 1978,
        'year-to': null,
      },
      {
        id: 'MONTERO',
        name: 'Montero',
        'cyrillic-name': 'Монтеро',
        class: 'J',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'MONTERO_SPORT',
        name: 'Montero Sport',
        'cyrillic-name': 'Монтеро Спорт',
        class: 'J',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'OUTLANDER',
        name: 'Outlander',
        'cyrillic-name': 'Аутлендер',
        class: 'D',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'OUTLANDER_SPORT',
        name: 'Outlander Sport',
        'cyrillic-name': 'Аутлендер Спорт',
        class: 'C',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'PAJERO',
        name: 'Pajero',
        'cyrillic-name': 'Паджеро',
        class: 'J',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'PAJERO_IO',
        name: 'Pajero iO',
        'cyrillic-name': 'пайеро ио',
        class: 'J',
        'year-from': 1998,
        'year-to': 2007,
      },
      {
        id: 'PAJERO_JUNIOR',
        name: 'Pajero Junior',
        'cyrillic-name': 'Паджеро Джуниор',
        class: 'J',
        'year-from': 1995,
        'year-to': 1998,
      },
      {
        id: 'PAJERO_MINI',
        name: 'Pajero Mini',
        'cyrillic-name': 'Паджеро Мини',
        class: 'J',
        'year-from': 1994,
        'year-to': 2012,
      },
      {
        id: 'PAJERO_PININ',
        name: 'Pajero Pinin',
        'cyrillic-name': 'Паджеро Пинин',
        class: 'J',
        'year-from': 1998,
        'year-to': 2006,
      },
      {
        id: 'PAJERO_SPORT',
        name: 'Pajero Sport',
        'cyrillic-name': 'Паджеро Спорт',
        class: 'J',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'PISTACHIO',
        name: 'Pistachio',
        'cyrillic-name': 'Писташио',
        class: 'A',
        'year-from': 1999,
        'year-to': 2000,
      },
      {
        id: 'PROUDIA',
        name: 'Proudia',
        'cyrillic-name': 'Прудия',
        class: 'F',
        'year-from': 1999,
        'year-to': 2016,
      },
      {
        id: 'RAIDER',
        name: 'Raider',
        'cyrillic-name': 'Рэйдер',
        class: 'J',
        'year-from': 2006,
        'year-to': 2009,
      },
      {
        id: 'RVR',
        name: 'RVR',
        'cyrillic-name': 'РВР',
        class: 'C',
        'year-from': 1991,
        'year-to': null,
      },
      {
        id: 'SAPPORO',
        name: 'Sapporo',
        'cyrillic-name': 'Саппоро',
        class: 'D',
        'year-from': 1978,
        'year-to': 1990,
      },
      {
        id: 'SAVRIN',
        name: 'Savrin',
        'cyrillic-name': 'саврин',
        class: 'M',
        'year-from': 2001,
        'year-to': 2014,
      },
      {
        id: 'SIGMA',
        name: 'Sigma',
        'cyrillic-name': 'Сигма',
        class: 'D',
        'year-from': 1990,
        'year-to': 1996,
      },
      {
        id: 'SPACE_GEAR',
        name: 'Space Gear',
        'cyrillic-name': 'Спайс Гир',
        class: 'M',
        'year-from': 1994,
        'year-to': 2007,
      },
      {
        id: 'SPACE_RUNNER',
        name: 'Space Runner',
        'cyrillic-name': 'Спайс Раннер',
        class: 'M',
        'year-from': 1991,
        'year-to': 2002,
      },
      {
        id: 'SPACE_STAR',
        name: 'Space Star',
        'cyrillic-name': 'Спайс Стар',
        class: 'B',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'SPACE_WAGON',
        name: 'Space Wagon',
        'cyrillic-name': 'Спайс Вагон',
        class: 'M',
        'year-from': 1984,
        'year-to': 2004,
      },
      {
        id: 'STARION',
        name: 'Starion',
        'cyrillic-name': 'Старион',
        class: 'D',
        'year-from': 1982,
        'year-to': 1990,
      },
      {
        id: 'STRADA',
        name: 'Strada',
        'cyrillic-name': 'Страда',
        class: 'J',
        'year-from': 1991,
        'year-to': 1999,
      },
      {
        id: 'TOPPO',
        name: 'Toppo',
        'cyrillic-name': 'Топпо',
        class: 'A',
        'year-from': 1990,
        'year-to': 2013,
      },
      {
        id: 'TOWN_BOX',
        name: 'Town Box',
        'cyrillic-name': 'Таун Бокс',
        class: 'M',
        'year-from': 1999,
        'year-to': 2011,
      },
      {
        id: 'TREDIA',
        name: 'Tredia',
        'cyrillic-name': 'Тредия',
        class: 'C',
        'year-from': 1982,
        'year-to': 1987,
      },
      {
        id: 'TRITON',
        name: 'Triton',
        'cyrillic-name': 'Тритон',
        class: 'J',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'XPANDER',
        name: 'Xpander',
        'cyrillic-name': 'хпандер',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
    ],
  },
  {
    id: 'MITSUOKA',
    name: 'Mitsuoka',
    'cyrillic-name': 'Мицуока',
    popular: false,
    country: 'Япония',
    models: [
      {
        id: 'GALUE',
        name: 'Galue',
        'cyrillic-name': 'Галю',
        class: 'E',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'GALUE_204',
        name: 'Galue 204',
        'cyrillic-name': 'Галю 204',
        class: 'D',
        'year-from': 2008,
        'year-to': 2014,
      },
      {
        id: 'HIMIKO',
        name: 'Himiko',
        'cyrillic-name': 'Химико',
        class: 'S',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'LE_SEYDE',
        name: 'Le-Seyde',
        'cyrillic-name': 'Ле-Сейд',
        class: 'F',
        'year-from': 1990,
        'year-to': 2004,
      },
      {
        id: 'LIKE',
        name: 'Like',
        'cyrillic-name': 'лайк',
        class: 'A',
        'year-from': 2010,
        'year-to': 2012,
      },
      {
        id: 'MC_1',
        name: 'MC-1',
        'cyrillic-name': 'мс 1',
        class: 'A',
        'year-from': 1998,
        'year-to': 2007,
      },
      {
        id: 'NOUERA',
        name: 'Nouera',
        'cyrillic-name': 'Ноуера',
        class: 'D',
        'year-from': 2003,
        'year-to': 2012,
      },
      {
        id: 'OROCHI',
        name: 'Orochi',
        'cyrillic-name': 'Орочи',
        class: 'S',
        'year-from': 2006,
        'year-to': 2014,
      },
      {
        id: 'RAY',
        name: 'Ray',
        'cyrillic-name': 'Рэй',
        class: 'A',
        'year-from': 1996,
        'year-to': 2004,
      },
      {
        id: 'ROCK_STAR',
        name: 'Rock Star',
        'cyrillic-name': 'Рок Стар',
        class: 'S',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'RYOGA',
        name: 'Ryoga',
        'cyrillic-name': 'Риога',
        class: 'D',
        'year-from': 1998,
        'year-to': 2004,
      },
      {
        id: 'RYUGI',
        name: 'Ryugi',
        'cyrillic-name': 'Рууги',
        class: 'D',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'VIEWT',
        name: 'Viewt',
        'cyrillic-name': 'Вьювт',
        class: 'C',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'YUGA',
        name: 'Yuga',
        'cyrillic-name': 'Юга',
        class: 'M',
        'year-from': 2000,
        'year-to': 2002,
      },
      {
        id: 'ZERO_ONE',
        name: 'Zero 1',
        'cyrillic-name': 'зеро 1',
        class: 'S',
        'year-from': 1996,
        'year-to': 2000,
      },
    ],
  },
  {
    id: 'MOBILIZE',
    name: 'Mobilize',
    'cyrillic-name': 'Мобилайз',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'LIMO',
        name: 'Limo',
        'cyrillic-name': 'Лимо',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'MORGAN',
    name: 'Morgan',
    'cyrillic-name': 'Морган',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '3_WHEELER',
        name: '3 Wheeler',
        'cyrillic-name': '3 вилер',
        class: 'S',
        'year-from': 2011,
        'year-to': 2021,
      },
      {
        id: '4_SEATER',
        name: '4 Seater',
        'cyrillic-name': '4 ситер',
        class: 'S',
        'year-from': 2004,
        'year-to': 2016,
      },
      {
        id: '4_4',
        name: '4/4',
        'cyrillic-name': '4/4',
        class: 'S',
        'year-from': 1962,
        'year-to': 2019,
      },
      {
        id: 'AERO_8',
        name: 'Aero 8',
        'cyrillic-name': 'Аэро 8',
        class: 'S',
        'year-from': 2001,
        'year-to': 2010,
      },
      {
        id: 'AERO_COUPE',
        name: 'Aero Coupe',
        'cyrillic-name': 'Аэрокупе',
        class: 'S',
        'year-from': 2011,
        'year-to': 2016,
      },
      {
        id: 'AERO_SUPERSPORTS',
        name: 'Aero SuperSports',
        'cyrillic-name': 'Аэро Суперспорт',
        class: 'S',
        'year-from': 2009,
        'year-to': 2016,
      },
      {
        id: 'AEROMAX',
        name: 'AeroMax',
        'cyrillic-name': 'Аэромакс',
        class: 'S',
        'year-from': 2008,
        'year-to': 2010,
      },
      {
        id: 'PLUS_4',
        name: 'Plus 4',
        'cyrillic-name': 'Плюс 4',
        class: 'S',
        'year-from': 1950,
        'year-to': null,
      },
      {
        id: 'PLUS_8',
        name: 'Plus 8',
        'cyrillic-name': 'Плюс 8',
        class: 'S',
        'year-from': 1968,
        'year-to': 2018,
      },
      {
        id: 'ROADSTER',
        name: 'Roadster',
        'cyrillic-name': 'родстер',
        class: 'S',
        'year-from': 2004,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'MORRIS',
    name: 'Morris',
    'cyrillic-name': 'Моррис',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'EIGHT',
        name: 'Eight',
        'cyrillic-name': 'Эйт',
        class: 'B',
        'year-from': 1935,
        'year-to': 1937,
      },
      {
        id: 'MARINA',
        name: 'Marina',
        'cyrillic-name': 'Марина',
        class: 'C',
        'year-from': 1971,
        'year-to': 1980,
      },
    ],
  },
  {
    id: 'MOSCVICH',
    name: 'Москвич',
    'cyrillic-name': 'Москвич',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: '2136',
        name: '2136',
        'cyrillic-name': '2136',
        class: 'C',
        'year-from': 1976,
        'year-to': 1981,
      },
      {
        id: '2137',
        name: '2137',
        'cyrillic-name': '2137',
        class: 'C',
        'year-from': 1976,
        'year-to': 1985,
      },
      {
        id: '2138',
        name: '2138',
        'cyrillic-name': '2138',
        class: 'C',
        'year-from': 1976,
        'year-to': 1982,
      },
      {
        id: '2140',
        name: '2140',
        'cyrillic-name': '2140',
        class: 'C',
        'year-from': 1976,
        'year-to': 1988,
      },
      {
        id: '2141',
        name: '2141',
        'cyrillic-name': '2141',
        class: 'D',
        'year-from': 1986,
        'year-to': 1998,
      },
      {
        id: '2142',
        name: '2142',
        'cyrillic-name': '2142',
        class: 'D',
        'year-from': 1990,
        'year-to': 2002,
      },
      {
        id: '3',
        name: '3',
        'cyrillic-name': '3',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: '3E',
        name: '3е',
        'cyrillic-name': '3е',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: '400',
        name: '400',
        'cyrillic-name': '400',
        class: 'C',
        'year-from': 1946,
        'year-to': 1956,
      },
      {
        id: '401',
        name: '401',
        'cyrillic-name': '401',
        class: 'C',
        'year-from': 1954,
        'year-to': 1956,
      },
      {
        id: '402',
        name: '402',
        'cyrillic-name': '402',
        class: 'C',
        'year-from': 1956,
        'year-to': 1958,
      },
      {
        id: '403',
        name: '403',
        'cyrillic-name': '403',
        class: 'B',
        'year-from': 1962,
        'year-to': 1965,
      },
      {
        id: '407',
        name: '407',
        'cyrillic-name': '407',
        class: 'C',
        'year-from': 1958,
        'year-to': 1963,
      },
      {
        id: '408',
        name: '408',
        'cyrillic-name': '408',
        class: 'C',
        'year-from': 1964,
        'year-to': 1975,
      },
      {
        id: '410',
        name: '410',
        'cyrillic-name': '410',
        class: 'C',
        'year-from': 1957,
        'year-to': 1961,
      },
      {
        id: '411',
        name: '411',
        'cyrillic-name': '411',
        class: 'C',
        'year-from': 1959,
        'year-to': 1961,
      },
      {
        id: '412',
        name: '412',
        'cyrillic-name': '412',
        class: 'C',
        'year-from': 1967,
        'year-to': 1977,
      },
      {
        id: '423',
        name: '423',
        'cyrillic-name': '423',
        class: 'C',
        'year-from': 1957,
        'year-to': 1963,
      },
      {
        id: '424',
        name: '424',
        'cyrillic-name': '424',
        class: 'C',
        'year-from': 1963,
        'year-to': 1965,
      },
      {
        id: '426',
        name: '426',
        'cyrillic-name': '426',
        class: 'C',
        'year-from': 1967,
        'year-to': 1976,
      },
      {
        id: '427',
        name: '427',
        'cyrillic-name': '427',
        class: 'C',
        'year-from': 1967,
        'year-to': 1976,
      },
      {
        id: '430',
        name: '430',
        'cyrillic-name': '430',
        class: 'C',
        'year-from': 1958,
        'year-to': 1963,
      },
      {
        id: '434P',
        name: '434П',
        'cyrillic-name': '434П',
        class: 'J',
        'year-from': 1968,
        'year-to': 1973,
      },
      {
        id: 'DUET',
        name: 'Дуэт',
        'cyrillic-name': 'Дуэт',
        class: 'D',
        'year-from': 1999,
        'year-to': 2001,
      },
      {
        id: 'IVAN_KALITA',
        name: 'Иван Калита',
        'cyrillic-name': 'Иван Калита',
        class: 'E',
        'year-from': 1998,
        'year-to': 2001,
      },
      {
        id: 'KNYAZ_VLADIMIR',
        name: 'Князь Владимир',
        'cyrillic-name': 'Князь Владимир',
        class: 'D',
        'year-from': 1997,
        'year-to': 2002,
      },
      {
        id: 'SVYATOGOR',
        name: 'Святогор',
        'cyrillic-name': 'Святогор',
        class: 'D',
        'year-from': 1997,
        'year-to': 2002,
      },
      {
        id: 'YURI_DOLGORUKIY',
        name: 'Юрий Долгорукий',
        'cyrillic-name': 'Юрий Долгорукий',
        class: 'D',
        'year-from': 1997,
        'year-to': 2001,
      },
    ],
  },
  {
    id: 'NASH',
    name: 'Nash',
    'cyrillic-name': 'Нэш',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'AMBASSADOR',
        name: 'Ambassador',
        'cyrillic-name': 'Амбассадор',
        class: 'S',
        'year-from': 1932,
        'year-to': 1942,
      },
    ],
  },
  {
    id: 'NIO',
    name: 'Nio',
    'cyrillic-name': 'Нио',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'EC6',
        name: 'EC6',
        'cyrillic-name': 'ец6',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'EC7',
        name: 'EC7',
        'cyrillic-name': 'ЕЦ7',
        class: 'E',
        'year-from': 2023,
        'year-to': null,
      },
      {
        id: 'ES6',
        name: 'ES6',
        'cyrillic-name': 'ес6',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'ES8',
        name: 'ES8',
        'cyrillic-name': 'ЕС8',
        class: 'E',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'ET5',
        name: 'ET5',
        'cyrillic-name': 'ет5',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'ET7',
        name: 'ET7',
        'cyrillic-name': 'ет7',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'NISSAN',
    name: 'Nissan',
    'cyrillic-name': 'Ниссан',
    popular: true,
    country: 'Япония',
    models: [
      {
        id: '100NX',
        name: '100NX',
        'cyrillic-name': '100нкс',
        class: 'S',
        'year-from': 1990,
        'year-to': 1996,
      },
      {
        id: '180SX',
        name: '180SX',
        'cyrillic-name': '180скс',
        class: 'S',
        'year-from': 1988,
        'year-to': 1998,
      },
      {
        id: '200SX',
        name: '200SX',
        'cyrillic-name': '200скс',
        class: 'S',
        'year-from': 1983,
        'year-to': 2000,
      },
      {
        id: '240SX',
        name: '240SX',
        'cyrillic-name': '240скс',
        class: 'S',
        'year-from': 1989,
        'year-to': 1999,
      },
      {
        id: '280ZX',
        name: '280ZX',
        'cyrillic-name': '280зкс',
        class: 'S',
        'year-from': 1978,
        'year-to': 1984,
      },
      {
        id: '300ZX',
        name: '300ZX',
        'cyrillic-name': '300зкс',
        class: 'S',
        'year-from': 1983,
        'year-to': 2000,
      },
      {
        id: '350Z',
        name: '350Z',
        'cyrillic-name': '350з',
        class: 'S',
        'year-from': 2002,
        'year-to': 2009,
      },
      {
        id: '370Z',
        name: '370Z',
        'cyrillic-name': '370з',
        class: 'S',
        'year-from': 2008,
        'year-to': 2020,
      },
      {
        id: 'AD',
        name: 'AD',
        'cyrillic-name': 'ад',
        class: 'C',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'ALMERA',
        name: 'Almera',
        'cyrillic-name': 'Альмера',
        class: 'B',
        'year-from': 1995,
        'year-to': 2018,
      },
      {
        id: 'ALMERA_CLASSIC',
        name: 'Almera Classic',
        'cyrillic-name': 'Альмера Классик',
        class: 'C',
        'year-from': 2006,
        'year-to': 2013,
      },
      {
        id: 'ALMERA_TINO',
        name: 'Almera Tino',
        'cyrillic-name': 'Альмера Тино',
        class: 'M',
        'year-from': 2000,
        'year-to': 2006,
      },
      {
        id: 'ALTIMA',
        name: 'Altima',
        'cyrillic-name': 'Альтима',
        class: 'D',
        'year-from': 1992,
        'year-to': null,
      },
      {
        id: 'ARIYA',
        name: 'Ariya',
        'cyrillic-name': 'Ария',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'ARMADA',
        name: 'Armada',
        'cyrillic-name': 'Армада',
        class: 'J',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'AUSTER',
        name: 'Auster',
        'cyrillic-name': 'Аустер',
        class: 'D',
        'year-from': 1985,
        'year-to': 1990,
      },
      {
        id: 'AVENIR',
        name: 'Avenir',
        'cyrillic-name': 'Авенир',
        class: 'C',
        'year-from': 1990,
        'year-to': 2005,
      },
      {
        id: 'BASSARA',
        name: 'Bassara',
        'cyrillic-name': 'Бассара',
        class: 'M',
        'year-from': 1999,
        'year-to': 2003,
      },
      {
        id: 'BE_1',
        name: 'BE-1',
        'cyrillic-name': 'бе-1',
        class: 'A',
        'year-from': 1987,
        'year-to': 1989,
      },
      {
        id: 'BLUEBIRD',
        name: 'Bluebird',
        'cyrillic-name': 'Блюбёрд',
        class: 'D',
        'year-from': 1971,
        'year-to': 2001,
      },
      {
        id: 'BLUEBIRD_MAXIMA',
        name: 'Bluebird Maxima',
        'cyrillic-name': 'Блюберд Максима',
        class: 'D',
        'year-from': 1984,
        'year-to': 1988,
      },
      {
        id: 'BLUEBIRD_SYLPHY',
        name: 'Bluebird Sylphy',
        'cyrillic-name': 'Блюбёрд Силфи',
        class: 'C',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'CARAVAN_COACH',
        name: 'Caravan',
        'cyrillic-name': 'Караван',
        class: 'M',
        'year-from': 1980,
        'year-to': 2012,
      },
      {
        id: 'CEDRIC',
        name: 'Cedric',
        'cyrillic-name': 'Цедрик',
        class: 'E',
        'year-from': 1971,
        'year-to': 2014,
      },
      {
        id: 'CEFIRO',
        name: 'Cefiro',
        'cyrillic-name': 'Цефиро',
        class: 'D',
        'year-from': 1988,
        'year-to': 2008,
      },
      {
        id: 'CHERRY',
        name: 'Cherry',
        'cyrillic-name': 'Черри',
        class: 'C',
        'year-from': 1970,
        'year-to': 1986,
      },
      {
        id: 'CIMA',
        name: 'Cima',
        'cyrillic-name': 'Сима',
        class: 'E',
        'year-from': 1988,
        'year-to': null,
      },
      {
        id: 'CLIPPER_RIO',
        name: 'Clipper Rio',
        'cyrillic-name': 'клиппер рио',
        class: 'M',
        'year-from': 2003,
        'year-to': 2012,
      },
      {
        id: 'CREW',
        name: 'Crew',
        'cyrillic-name': 'Крю',
        class: 'D',
        'year-from': 1993,
        'year-to': 2009,
      },
      {
        id: 'CUBE',
        name: 'Cube',
        'cyrillic-name': 'Куб',
        class: 'M',
        'year-from': 1998,
        'year-to': 2020,
      },
      {
        id: 'DATSUN',
        name: 'Datsun',
        'cyrillic-name': 'Датсан',
        class: 'J',
        'year-from': 1985,
        'year-to': 2002,
      },
      {
        id: 'DAYZ',
        name: 'Dayz',
        'cyrillic-name': 'Дайз',
        class: 'A',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'DAYZ_ROOX',
        name: 'Dayz Roox',
        'cyrillic-name': 'Дейз Рукс',
        class: 'A',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'DUALIS',
        name: 'Dualis',
        'cyrillic-name': 'Дуалис',
        class: 'C',
        'year-from': 2007,
        'year-to': 2014,
      },
      {
        id: 'ELGRAND',
        name: 'Elgrand',
        'cyrillic-name': 'Элгранд',
        class: 'M',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'EXA',
        name: 'Exa',
        'cyrillic-name': 'еха',
        class: 'S',
        'year-from': 1986,
        'year-to': 1990,
      },
      {
        id: 'EXPERT',
        name: 'Expert',
        'cyrillic-name': 'Эксперт',
        class: 'D',
        'year-from': 1999,
        'year-to': 2007,
      },
      {
        id: 'FAIRLADY_Z',
        name: 'Fairlady Z',
        'cyrillic-name': 'Файрледи',
        class: 'S',
        'year-from': 1969,
        'year-to': 2021,
      },
      {
        id: 'FIGARO',
        name: 'Figaro',
        'cyrillic-name': 'Фигаро',
        class: 'A',
        'year-from': 1991,
        'year-to': 1992,
      },
      {
        id: 'FRONTIER',
        name: 'Frontier',
        'cyrillic-name': 'Фронтир',
        class: 'J',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'FUGA',
        name: 'Fuga',
        'cyrillic-name': 'Фуга',
        class: 'E',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'GLORIA',
        name: 'Gloria',
        'cyrillic-name': 'Глория',
        class: 'E',
        'year-from': 1962,
        'year-to': 2004,
      },
      {
        id: 'GT_R',
        name: 'GT-R',
        'cyrillic-name': 'гт-р',
        class: 'S',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'HOMY',
        name: 'Homy',
        'cyrillic-name': 'Хоми',
        class: 'M',
        'year-from': 1986,
        'year-to': 1997,
      },
      {
        id: 'HYPERMINI',
        name: 'Hypermini',
        'cyrillic-name': 'гипермини',
        class: 'A',
        'year-from': 1999,
        'year-to': 2001,
      },
      {
        id: 'JUKE',
        name: 'Juke',
        'cyrillic-name': 'Джук',
        class: 'B',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'JUKE_NISMO',
        name: 'Juke Nismo',
        'cyrillic-name': 'Джук Нисмо',
        class: 'B',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'KICKS',
        name: 'Kicks',
        'cyrillic-name': 'Кикс',
        class: 'B',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'KIX',
        name: 'Kix',
        'cyrillic-name': 'Кикс',
        class: 'J',
        'year-from': 2008,
        'year-to': 2012,
      },
      {
        id: 'LAFESTA',
        name: 'Lafesta',
        'cyrillic-name': 'Лафеста',
        class: 'M',
        'year-from': 2004,
        'year-to': 2018,
      },
      {
        id: 'LANGLEY',
        name: 'Langley',
        'cyrillic-name': 'Лэнгли',
        class: 'C',
        'year-from': 1982,
        'year-to': 1990,
      },
      {
        id: 'LARGO',
        name: 'Largo',
        'cyrillic-name': 'Ларго',
        class: 'M',
        'year-from': 1986,
        'year-to': 1999,
      },
      {
        id: 'LATIO',
        name: 'Latio',
        'cyrillic-name': 'Латио',
        class: 'C',
        'year-from': 2012,
        'year-to': 2016,
      },
      {
        id: 'LAUREL',
        name: 'Laurel',
        'cyrillic-name': 'Лаурель',
        class: 'E',
        'year-from': 1977,
        'year-to': 2002,
      },
      {
        id: 'LEAF',
        name: 'Leaf',
        'cyrillic-name': 'лиф',
        class: 'C',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'LEOPARD',
        name: 'Leopard',
        'cyrillic-name': 'Леопард',
        class: 'E',
        'year-from': 1980,
        'year-to': 2000,
      },
      {
        id: 'LIBERTA_VILLA',
        name: 'Liberta Villa',
        'cyrillic-name': 'Либерта Вилла',
        class: 'C',
        'year-from': 1982,
        'year-to': 1990,
      },
      {
        id: 'LIBERTY',
        name: 'Liberty',
        'cyrillic-name': 'Либерти',
        class: 'M',
        'year-from': 1998,
        'year-to': 2004,
      },
      {
        id: 'LIVINA',
        name: 'Livina',
        'cyrillic-name': 'ливина',
        class: 'M',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'LUCINO',
        name: 'Lucino',
        'cyrillic-name': 'Люсино',
        class: 'C',
        'year-from': 1994,
        'year-to': 1999,
      },
      {
        id: 'MARCH',
        name: 'March',
        'cyrillic-name': 'Марч',
        class: 'B',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'MAXIMA',
        name: 'Maxima',
        'cyrillic-name': 'Максима',
        class: 'D',
        'year-from': 1981,
        'year-to': null,
      },
      {
        id: 'MICRA',
        name: 'Micra',
        'cyrillic-name': 'Микра',
        class: 'B',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'MISTRAL',
        name: 'Mistral',
        'cyrillic-name': 'Мистраль',
        class: 'J',
        'year-from': 1994,
        'year-to': 1999,
      },
      {
        id: 'MOCO',
        name: 'Moco',
        'cyrillic-name': 'Моко',
        class: 'A',
        'year-from': 2001,
        'year-to': 2016,
      },
      {
        id: 'MURANO',
        name: 'Murano',
        'cyrillic-name': 'Мурано',
        class: 'E',
        'year-from': 2002,
        'year-to': 2022,
      },
      {
        id: 'NAVARA',
        name: 'Navara (Frontier)',
        'cyrillic-name': 'Навара',
        class: 'J',
        'year-from': 1985,
        'year-to': null,
      },
      {
        id: 'NOTE',
        name: 'Note',
        'cyrillic-name': 'Ноут',
        class: 'B',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'NP300',
        name: 'NP300',
        'cyrillic-name': 'нп300',
        class: 'J',
        'year-from': 2008,
        'year-to': 2015,
      },
      {
        id: 'CLIPPER',
        name: 'NV100 Clipper',
        'cyrillic-name': 'клиппер',
        class: 'M',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'NV200',
        name: 'NV200',
        'cyrillic-name': 'нв200',
        class: 'M',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'NV300',
        name: 'NV300',
        'cyrillic-name': 'НВ300',
        class: 'M',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'NV350_CARAVAN',
        name: 'NV350 Caravan',
        'cyrillic-name': 'нв350 цараван',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'NX_COUPE',
        name: 'NX Coupe',
        'cyrillic-name': 'нх купе',
        class: 'C',
        'year-from': 1990,
        'year-to': 1994,
      },
      {
        id: 'OTTI',
        name: 'Otti',
        'cyrillic-name': 'Отти',
        class: 'A',
        'year-from': 2005,
        'year-to': 2013,
      },
      {
        id: 'PAO',
        name: 'Pao',
        'cyrillic-name': 'Пао',
        class: 'B',
        'year-from': 1989,
        'year-to': 1991,
      },
      {
        id: 'PATHFINDER',
        name: 'Pathfinder',
        'cyrillic-name': 'Патфайндер',
        class: 'E',
        'year-from': 1985,
        'year-to': null,
      },
      {
        id: 'PATROL',
        name: 'Patrol',
        'cyrillic-name': 'Патрол',
        class: 'J',
        'year-from': 1980,
        'year-to': null,
      },
      {
        id: 'PINO',
        name: 'Pino',
        'cyrillic-name': 'Пино',
        class: 'A',
        'year-from': 2007,
        'year-to': 2010,
      },
      {
        id: 'PIXO',
        name: 'Pixo',
        'cyrillic-name': 'пиксо',
        class: 'A',
        'year-from': 2008,
        'year-to': 2013,
      },
      {
        id: 'PRAIRIE',
        name: 'Prairie',
        'cyrillic-name': 'Прэри',
        class: 'M',
        'year-from': 1982,
        'year-to': 2004,
      },
      {
        id: 'PRESAGE',
        name: 'Presage',
        'cyrillic-name': 'Пресаж',
        class: 'M',
        'year-from': 1998,
        'year-to': 2009,
      },
      {
        id: 'PRESEA',
        name: 'Presea',
        'cyrillic-name': 'Преси',
        class: 'C',
        'year-from': 1990,
        'year-to': 2000,
      },
      {
        id: 'PRESIDENT',
        name: 'President',
        'cyrillic-name': 'Президент',
        class: 'F',
        'year-from': 1973,
        'year-to': 2010,
      },
      {
        id: 'PRIMASTAR',
        name: 'Primastar',
        'cyrillic-name': 'примастар',
        class: 'M',
        'year-from': 2002,
        'year-to': 2014,
      },
      {
        id: 'PRIMERA',
        name: 'Primera',
        'cyrillic-name': 'Примера',
        class: 'D',
        'year-from': 1990,
        'year-to': 2008,
      },
      {
        id: 'PULSAR',
        name: 'Pulsar',
        'cyrillic-name': 'Пульсар',
        class: 'C',
        'year-from': 1982,
        'year-to': 2018,
      },
      {
        id: 'QASHQAI',
        name: 'Qashqai',
        'cyrillic-name': 'Кашкай',
        class: 'C',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'QASHQAI_PLUS_2',
        name: 'Qashqai+2',
        'cyrillic-name': 'Кашкай+2',
        class: 'C',
        'year-from': 2008,
        'year-to': 2013,
      },
      {
        id: 'QUEST',
        name: 'Quest',
        'cyrillic-name': 'Квест',
        class: 'M',
        'year-from': 1992,
        'year-to': 2018,
      },
      {
        id: 'RNESSA',
        name: "R'nessa",
        'cyrillic-name': 'Р Несса',
        class: 'D',
        'year-from': 1997,
        'year-to': 2001,
      },
      {
        id: 'RASHEEN',
        name: 'Rasheen',
        'cyrillic-name': 'Рашин',
        class: 'J',
        'year-from': 1995,
        'year-to': 2000,
      },
      {
        id: 'ROGUE',
        name: 'Rogue',
        'cyrillic-name': 'Рог',
        class: 'D',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'ROGUE_SPORT',
        name: 'Rogue Sport',
        'cyrillic-name': 'Рог Спорт',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'ROOX',
        name: 'Roox',
        'cyrillic-name': 'Рукс',
        class: 'M',
        'year-from': 2009,
        'year-to': 2013,
      },
      {
        id: 'SAFARI',
        name: 'Safari',
        'cyrillic-name': 'Сафари',
        class: 'J',
        'year-from': 1987,
        'year-to': 2013,
      },
      {
        id: 'SENTRA',
        name: 'Sentra',
        'cyrillic-name': 'Сентра',
        class: 'C',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'SERENA',
        name: 'Serena',
        'cyrillic-name': 'Серена',
        class: 'M',
        'year-from': 1991,
        'year-to': null,
      },
      {
        id: 'SILVIA',
        name: 'Silvia',
        'cyrillic-name': 'Сильвия',
        class: 'S',
        'year-from': 1979,
        'year-to': 2002,
      },
      {
        id: 'SKYLINE',
        name: 'Skyline',
        'cyrillic-name': 'Скайлайн',
        class: 'E',
        'year-from': 1968,
        'year-to': null,
      },
      {
        id: 'SKYLINE_CROSSOVER',
        name: 'Skyline Crossover',
        'cyrillic-name': 'Скайлайн Кроссовер',
        class: 'D',
        'year-from': 2009,
        'year-to': 2016,
      },
      {
        id: 'STAGEA',
        name: 'Stagea',
        'cyrillic-name': 'Стайджиа',
        class: 'D',
        'year-from': 1996,
        'year-to': 2007,
      },
      {
        id: 'STANZA',
        name: 'Stanza',
        'cyrillic-name': 'Станза',
        class: 'D',
        'year-from': 1981,
        'year-to': 1992,
      },
      {
        id: 'SUNNY',
        name: 'Sunny',
        'cyrillic-name': 'Санни',
        class: 'C',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'SYLPHY_ZERO_EMISSION',
        name: 'Sylphy Zero Emission',
        'cyrillic-name': 'Сильфи Зеро Эмиссион',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'TEANA',
        name: 'Teana',
        'cyrillic-name': 'Тиана',
        class: 'D',
        'year-from': 2003,
        'year-to': 2020,
      },
      {
        id: 'TERRA',
        name: 'Terra',
        'cyrillic-name': 'Терра',
        class: 'J',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'TERRANO',
        name: 'Terrano',
        'cyrillic-name': 'Террано',
        class: 'B',
        'year-from': 1985,
        'year-to': 2022,
      },
      {
        id: 'TERRANO_REGULUS',
        name: 'Terrano Regulus',
        'cyrillic-name': 'Террано Регулус',
        class: 'J',
        'year-from': 1996,
        'year-to': 2002,
      },
      {
        id: 'TIIDA',
        name: 'Tiida',
        'cyrillic-name': 'Тиида',
        class: 'C',
        'year-from': 2004,
        'year-to': 2018,
      },
      {
        id: 'TINO',
        name: 'Tino',
        'cyrillic-name': 'Тино',
        class: 'M',
        'year-from': 1998,
        'year-to': 2003,
      },
      {
        id: 'TITAN',
        name: 'Titan',
        'cyrillic-name': 'Титан',
        class: 'J',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'URVAN',
        name: 'Urvan',
        'cyrillic-name': 'урван',
        class: 'M',
        'year-from': 1986,
        'year-to': 2012,
      },
      {
        id: 'VANETTE',
        name: 'Vanette',
        'cyrillic-name': 'Ванэт',
        class: 'M',
        'year-from': 1978,
        'year-to': 2017,
      },
      {
        id: 'VERSA',
        name: 'Versa',
        'cyrillic-name': 'верса',
        class: 'C',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'WINGROAD',
        name: 'Wingroad',
        'cyrillic-name': 'Вингроуд',
        class: 'C',
        'year-from': 1996,
        'year-to': 2018,
      },
      {
        id: 'X_TERRA',
        name: 'X-Terra',
        'cyrillic-name': 'Икс-Терра',
        class: 'J',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'X_TRAIL',
        name: 'X-Trail',
        'cyrillic-name': 'кс-траил',
        class: 'D',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'XTERRA',
        name: 'Xterra',
        'cyrillic-name': 'кстерра',
        class: 'J',
        'year-from': 1999,
        'year-to': 2015,
      },
      {
        id: 'Z',
        name: 'Z',
        'cyrillic-name': 'зет',
        class: 'S',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'NOBLE',
    name: 'Noble',
    'cyrillic-name': 'Нобл',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'M12_GTO',
        name: 'M12 GTO',
        'cyrillic-name': 'м12 гто',
        class: 'S',
        'year-from': 2000,
        'year-to': 2007,
      },
      {
        id: 'M15',
        name: 'M15',
        'cyrillic-name': 'М15',
        class: 'S',
        'year-from': 2006,
        'year-to': 2011,
      },
      {
        id: 'M600',
        name: 'M600',
        'cyrillic-name': 'м600',
        class: 'S',
        'year-from': 2010,
        'year-to': 2018,
      },
    ],
  },
  {
    id: 'OLDSMOBILE',
    name: 'Oldsmobile',
    'cyrillic-name': 'Олдсмобиль',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'ACHIEVA',
        name: 'Achieva',
        'cyrillic-name': 'Ачива',
        class: 'D',
        'year-from': 1991,
        'year-to': 1997,
      },
      {
        id: 'ALERO',
        name: 'Alero',
        'cyrillic-name': 'Алеро',
        class: 'D',
        'year-from': 1999,
        'year-to': 2004,
      },
      {
        id: 'AURORA',
        name: 'Aurora',
        'cyrillic-name': 'Аврора',
        class: 'E',
        'year-from': 1994,
        'year-to': 2003,
      },
      {
        id: 'BRAVADA',
        name: 'Bravada',
        'cyrillic-name': 'Бравада',
        class: 'J',
        'year-from': 1990,
        'year-to': 2004,
      },
      {
        id: 'CUTLASS',
        name: 'Cutlass',
        'cyrillic-name': 'Катлас',
        class: 'D',
        'year-from': 1968,
        'year-to': 1999,
      },
      {
        id: 'CUTLASS_CALAIS',
        name: 'Cutlass Calais',
        'cyrillic-name': 'Катлас Коле',
        class: 'C',
        'year-from': 1984,
        'year-to': 1991,
      },
      {
        id: 'CUTLASS_CIERA',
        name: 'Cutlass Ciera',
        'cyrillic-name': 'Катлас  Цира',
        class: 'D',
        'year-from': 1981,
        'year-to': 1996,
      },
      {
        id: 'CUTLASS_SUPREME',
        name: 'Cutlass Supreme',
        'cyrillic-name': 'Катлас Суприм',
        class: 'D',
        'year-from': 1988,
        'year-to': 1997,
      },
      {
        id: 'EIGHTY_EIGHT',
        name: 'Eighty-Eight',
        'cyrillic-name': '88',
        class: 'E',
        'year-from': 1957,
        'year-to': 1999,
      },
      {
        id: 'FIRENZA',
        name: 'Firenza',
        'cyrillic-name': 'фиренца',
        class: 'C',
        'year-from': 1982,
        'year-to': 1988,
      },
      {
        id: 'INTRIGUE',
        name: 'Intrigue',
        'cyrillic-name': 'Интриг',
        class: 'E',
        'year-from': 1997,
        'year-to': 2002,
      },
      {
        id: 'NINETY_EIGHT',
        name: 'Ninety-Eight',
        'cyrillic-name': '89',
        class: 'E',
        'year-from': 1977,
        'year-to': 1996,
      },
      {
        id: 'OMEGA',
        name: 'Omega',
        'cyrillic-name': 'Омега',
        class: 'C',
        'year-from': 1979,
        'year-to': 1984,
      },
      {
        id: 'SERIES_60',
        name: 'Series 60',
        'cyrillic-name': 'Серия 60',
        class: '',
        'year-from': 1939,
        'year-to': 1948,
      },
      {
        id: 'SERIES_70',
        name: 'Series 70',
        'cyrillic-name': 'Серия 70',
        class: '',
        'year-from': 1939,
        'year-to': 1950,
      },
      {
        id: 'SILHOUETTE',
        name: 'Silhouette',
        'cyrillic-name': 'Силуэт',
        class: 'M',
        'year-from': 1989,
        'year-to': 2004,
      },
      {
        id: 'STARFIRE',
        name: 'Starfire',
        'cyrillic-name': 'Старфайер',
        class: 'C',
        'year-from': 1961,
        'year-to': 1980,
      },
      {
        id: 'TORONADO',
        name: 'Toronado',
        'cyrillic-name': 'Торонадо',
        class: 'S',
        'year-from': 1966,
        'year-to': 1992,
      },
      {
        id: 'VISTA_CRUISER',
        name: 'Vista Cruiser',
        'cyrillic-name': 'Виста Круизер',
        class: 'F',
        'year-from': 1964,
        'year-to': 1977,
      },
    ],
  },
  {
    id: 'OMODA',
    name: 'OMODA',
    'cyrillic-name': 'Омода',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'C5',
        name: 'C5',
        'cyrillic-name': 'С5',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'S5',
        name: 'S5',
        'cyrillic-name': 'С5',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'OPEL',
    name: 'Opel',
    'cyrillic-name': 'Опель',
    popular: true,
    country: 'Германия',
    models: [
      {
        id: 'ADAM',
        name: 'Adam',
        'cyrillic-name': 'адам',
        class: 'A',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'ADMIRAL',
        name: 'Admiral',
        'cyrillic-name': 'Адмирал',
        class: 'E',
        'year-from': 1937,
        'year-to': 1978,
      },
      {
        id: 'AGILA',
        name: 'Agila',
        'cyrillic-name': 'Агила',
        class: 'A',
        'year-from': 2000,
        'year-to': 2014,
      },
      {
        id: 'AMPERA',
        name: 'Ampera',
        'cyrillic-name': 'Ампера',
        class: 'B',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'ANTARA',
        name: 'Antara',
        'cyrillic-name': 'Антара',
        class: 'C',
        'year-from': 2006,
        'year-to': 2017,
      },
      {
        id: 'ASCONA',
        name: 'Ascona',
        'cyrillic-name': 'Аскона',
        class: 'D',
        'year-from': 1970,
        'year-to': 1988,
      },
      {
        id: 'ASTRA',
        name: 'Astra',
        'cyrillic-name': 'Астра',
        class: 'C',
        'year-from': 1991,
        'year-to': null,
      },
      {
        id: 'ASTRA_OPC',
        name: 'Astra OPC',
        'cyrillic-name': 'астра опс',
        class: 'C',
        'year-from': 1999,
        'year-to': 2015,
      },
      {
        id: 'CALIBRA',
        name: 'Calibra',
        'cyrillic-name': 'Калибра',
        class: 'C',
        'year-from': 1990,
        'year-to': 1997,
      },
      {
        id: 'CAMPO',
        name: 'Campo',
        'cyrillic-name': 'Кэмпо',
        class: 'J',
        'year-from': 1991,
        'year-to': 2000,
      },
      {
        id: 'CASCADA',
        name: 'Cascada',
        'cyrillic-name': 'Каскада',
        class: 'C',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'COMBO',
        name: 'Combo',
        'cyrillic-name': 'Комбо',
        class: '',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'COMMODORE',
        name: 'Commodore',
        'cyrillic-name': 'Коммодор',
        class: 'D',
        'year-from': 1967,
        'year-to': 1982,
      },
      {
        id: 'CORSA',
        name: 'Corsa',
        'cyrillic-name': 'Корса',
        class: 'B',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'CORSA_OPC',
        name: 'Corsa OPC',
        'cyrillic-name': 'корса опс',
        class: 'B',
        'year-from': 2007,
        'year-to': 2018,
      },
      {
        id: 'CROSSLAND_X',
        name: 'Crossland X',
        'cyrillic-name': 'Кросленд Х',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'DIPLOMAT',
        name: 'Diplomat',
        'cyrillic-name': 'Дипломат',
        class: 'E',
        'year-from': 1964,
        'year-to': 1978,
      },
      {
        id: 'FRONTERA',
        name: 'Frontera',
        'cyrillic-name': 'Фронтера',
        class: 'J',
        'year-from': 1991,
        'year-to': 2004,
      },
      {
        id: 'GRANDLAND_X',
        name: 'Grandland X',
        'cyrillic-name': 'грандланд кс',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'GT',
        name: 'GT',
        'cyrillic-name': 'гт',
        class: 'S',
        'year-from': 1968,
        'year-to': 2009,
      },
      {
        id: 'INSIGNIA',
        name: 'Insignia',
        'cyrillic-name': 'Инсигния',
        class: 'D',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'INSIGNIA_OPC',
        name: 'Insignia OPC',
        'cyrillic-name': 'инсигния опс',
        class: 'D',
        'year-from': 2009,
        'year-to': 2017,
      },
      {
        id: 'KADETT',
        name: 'Kadett',
        'cyrillic-name': 'Кадет',
        class: 'C',
        'year-from': 1937,
        'year-to': 1993,
      },
      {
        id: 'KAPITAN',
        name: 'Kapitan',
        'cyrillic-name': 'Капитан',
        class: 'E',
        'year-from': 1938,
        'year-to': 1970,
      },
      {
        id: 'KARL',
        name: 'Karl',
        'cyrillic-name': 'карл',
        class: 'A',
        'year-from': 2015,
        'year-to': 2019,
      },
      {
        id: 'MANTA',
        name: 'Manta',
        'cyrillic-name': 'Манта',
        class: 'S',
        'year-from': 1970,
        'year-to': 1988,
      },
      {
        id: 'MERIVA',
        name: 'Meriva',
        'cyrillic-name': 'Мерива',
        class: 'M',
        'year-from': 2003,
        'year-to': 2018,
      },
      {
        id: 'MERIVA_OPC',
        name: 'Meriva OPC',
        'cyrillic-name': 'мерива опц',
        class: 'M',
        'year-from': 2006,
        'year-to': 2010,
      },
      {
        id: 'MOKKA',
        name: 'Mokka',
        'cyrillic-name': 'Мокка',
        class: 'B',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'MONTEREY',
        name: 'Monterey',
        'cyrillic-name': 'Монтерей',
        class: 'J',
        'year-from': 1992,
        'year-to': 1999,
      },
      {
        id: 'MONZA',
        name: 'Monza',
        'cyrillic-name': 'монза',
        class: 'D',
        'year-from': 1978,
        'year-to': 1986,
      },
      {
        id: 'OLYMPIA',
        name: 'Olympia',
        'cyrillic-name': 'олимпия',
        class: 'C',
        'year-from': 1935,
        'year-to': 1970,
      },
      {
        id: 'OMEGA',
        name: 'Omega',
        'cyrillic-name': 'Омега',
        class: 'E',
        'year-from': 1984,
        'year-to': 2004,
      },
      {
        id: 'P4',
        name: 'P4',
        'cyrillic-name': 'П4',
        class: '',
        'year-from': 1935,
        'year-to': 1937,
      },
      {
        id: 'REKORD',
        name: 'Rekord',
        'cyrillic-name': 'Рекорд',
        class: 'E',
        'year-from': 1963,
        'year-to': 1986,
      },
      {
        id: 'SENATOR',
        name: 'Senator',
        'cyrillic-name': 'Сенатор',
        class: 'E',
        'year-from': 1978,
        'year-to': 1993,
      },
      {
        id: 'SIGNUM',
        name: 'Signum',
        'cyrillic-name': 'Сигнум',
        class: 'E',
        'year-from': 2003,
        'year-to': 2008,
      },
      {
        id: 'SINTRA',
        name: 'Sintra',
        'cyrillic-name': 'Синтра',
        class: 'M',
        'year-from': 1996,
        'year-to': 1999,
      },
      {
        id: 'SPEEDSTER',
        name: 'Speedster',
        'cyrillic-name': 'Спидстер',
        class: 'S',
        'year-from': 2000,
        'year-to': 2005,
      },
      {
        id: 'SUPER_SIX',
        name: 'Super Six',
        'cyrillic-name': 'Супер 6',
        class: '',
        'year-from': 1936,
        'year-to': 1938,
      },
      {
        id: 'TIGRA',
        name: 'Tigra',
        'cyrillic-name': 'Тигра',
        class: 'B',
        'year-from': 1994,
        'year-to': 2009,
      },
      {
        id: 'VECTRA',
        name: 'Vectra',
        'cyrillic-name': 'Вектра',
        class: 'D',
        'year-from': 1988,
        'year-to': 2008,
      },
      {
        id: 'VECTRA_OPC',
        name: 'Vectra OPC',
        'cyrillic-name': 'вектра опс',
        class: 'D',
        'year-from': 2005,
        'year-to': 2008,
      },
      {
        id: 'VITA',
        name: 'Vita',
        'cyrillic-name': 'Вита',
        class: 'B',
        'year-from': 1995,
        'year-to': 2004,
      },
      {
        id: 'VIVARO',
        name: 'Vivaro',
        'cyrillic-name': 'Виваро',
        class: 'M',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'ZAFIRA',
        name: 'Zafira',
        'cyrillic-name': 'Зафира',
        class: 'M',
        'year-from': 1999,
        'year-to': 2019,
      },
      {
        id: 'ZAFIRA_LIFE',
        name: 'Zafira Life',
        'cyrillic-name': 'Зафира Лайф',
        class: 'M',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'ZAFIRA_OPC',
        name: 'Zafira OPC',
        'cyrillic-name': 'зафира опс',
        class: 'M',
        'year-from': 2001,
        'year-to': 2011,
      },
    ],
  },
  {
    id: 'ORA',
    name: 'ORA',
    'cyrillic-name': 'Ора',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'BALLET_CAT',
        name: 'Ballet Cat',
        'cyrillic-name': 'Баллет Кэт',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'BLACK_CAT',
        name: 'Black Cat',
        'cyrillic-name': 'Блэк Кэт',
        class: 'A',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'GOOD_CAT',
        name: 'Good Cat',
        'cyrillic-name': 'Гуд Кэт',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'LIGHTNING_CAT',
        name: 'Lightning Cat',
        'cyrillic-name': 'Лайтнинг Кэт',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'WHITE_CAT',
        name: 'White Cat',
        'cyrillic-name': 'Вайт Кэт',
        class: 'A',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'OSCA',
    name: 'Osca',
    'cyrillic-name': 'Оска',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: '2500_GT',
        name: '2500 GT',
        'cyrillic-name': '2500 гт',
        class: 'S',
        'year-from': 1999,
        'year-to': 2001,
      },
    ],
  },
  {
    id: 'OSHAN',
    name: 'Oshan',
    'cyrillic-name': 'Ошан',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'X5',
        name: 'X5',
        'cyrillic-name': 'Икс 5',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'X7',
        name: 'X7',
        'cyrillic-name': 'Икс 7',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'X7_PLUS',
        name: 'X7 Plus',
        'cyrillic-name': 'Икс 7 Плюс',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'Z6',
        name: 'Z6',
        'cyrillic-name': 'Зет6',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'PACKARD',
    name: 'Packard',
    'cyrillic-name': 'Паккард',
    popular: false,
    country: 'США',
    models: [
      {
        id: '200_250',
        name: '200/250',
        'cyrillic-name': '200/250',
        class: 'F',
        'year-from': 1951,
        'year-to': 1952,
      },
      {
        id: 'CLIPPER',
        name: 'Clipper',
        'cyrillic-name': 'клиппер',
        class: '',
        'year-from': 1941,
        'year-to': 1947,
      },
      {
        id: 'CUSTOM_EIGHT',
        name: 'Custom Eight',
        'cyrillic-name': 'Кастом Эйт',
        class: 'F',
        'year-from': 1948,
        'year-to': 1950,
      },
      {
        id: 'ONE_TWENTY',
        name: 'One-Twenty',
        'cyrillic-name': 'уан-твенти',
        class: '',
        'year-from': 1935,
        'year-to': 1941,
      },
      {
        id: 'SIX',
        name: 'Six',
        'cyrillic-name': 'Сикс',
        class: '',
        'year-from': 1912,
        'year-to': 1939,
      },
      {
        id: 'TWELVE',
        name: 'Twelve',
        'cyrillic-name': 'твелв',
        class: 'S',
        'year-from': 1932,
        'year-to': 1939,
      },
    ],
  },
  {
    id: 'PAGANI',
    name: 'Pagani',
    'cyrillic-name': 'Пагани',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'HUAYRA',
        name: 'Huayra',
        'cyrillic-name': 'Уайра',
        class: 'S',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'UTOPIA',
        name: 'Utopia',
        'cyrillic-name': 'Утопия',
        class: 'S',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'ZONDA',
        name: 'Zonda',
        'cyrillic-name': 'Зонда',
        class: 'S',
        'year-from': 1999,
        'year-to': 2013,
      },
    ],
  },
  {
    id: 'PANOZ',
    name: 'Panoz',
    'cyrillic-name': 'Паноз',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'ESPERANTE',
        name: 'Esperante',
        'cyrillic-name': 'Эсперанте',
        class: 'S',
        'year-from': 2000,
        'year-to': 2007,
      },
      {
        id: 'ROADSTER',
        name: 'Roadster',
        'cyrillic-name': 'Родстер',
        class: 'S',
        'year-from': 1992,
        'year-to': 1999,
      },
    ],
  },
  {
    id: 'PERODUA',
    name: 'Perodua',
    'cyrillic-name': 'Перодуа',
    popular: false,
    country: 'Малайзия',
    models: [
      {
        id: 'ALZA',
        name: 'Alza',
        'cyrillic-name': 'Альза',
        class: 'M',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'KANCIL',
        name: 'Kancil',
        'cyrillic-name': 'кансил',
        class: 'A',
        'year-from': 1994,
        'year-to': 2009,
      },
      {
        id: 'KELISA',
        name: 'Kelisa',
        'cyrillic-name': 'Келиса',
        class: 'A',
        'year-from': 2001,
        'year-to': 2007,
      },
      {
        id: 'KEMBARA',
        name: 'Kembara',
        'cyrillic-name': 'кембара',
        class: 'B',
        'year-from': 1998,
        'year-to': 2008,
      },
      {
        id: 'KENARI',
        name: 'Kenari',
        'cyrillic-name': 'кенари',
        class: 'M',
        'year-from': 2000,
        'year-to': 2008,
      },
      {
        id: 'MYVI',
        name: 'MyVi',
        'cyrillic-name': 'майви',
        class: 'B',
        'year-from': 2005,
        'year-to': 2011,
      },
      {
        id: 'NAUTICA',
        name: 'Nautica',
        'cyrillic-name': 'наутика',
        class: 'B',
        'year-from': 2008,
        'year-to': 2010,
      },
      {
        id: 'VIVA',
        name: 'Viva',
        'cyrillic-name': 'Вива',
        class: 'B',
        'year-from': 2007,
        'year-to': 2014,
      },
    ],
  },
  {
    id: 'PEUGEOT',
    name: 'Peugeot',
    'cyrillic-name': 'Пежо',
    popular: true,
    country: 'Франция',
    models: [
      {
        id: '1007',
        name: '1007',
        'cyrillic-name': '1007',
        class: 'B',
        'year-from': 2005,
        'year-to': 2009,
      },
      {
        id: '104',
        name: '104',
        'cyrillic-name': '104',
        class: 'B',
        'year-from': 1972,
        'year-to': 1988,
      },
      {
        id: '106',
        name: '106',
        'cyrillic-name': '106',
        class: 'A',
        'year-from': 1991,
        'year-to': 2004,
      },
      {
        id: '107',
        name: '107',
        'cyrillic-name': '107',
        class: 'A',
        'year-from': 2005,
        'year-to': 2014,
      },
      {
        id: '108',
        name: '108',
        'cyrillic-name': '108',
        class: 'A',
        'year-from': 2014,
        'year-to': 2021,
      },
      {
        id: '2008',
        name: '2008',
        'cyrillic-name': '2008',
        class: 'B',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: '201',
        name: '201',
        'cyrillic-name': '201',
        class: '',
        'year-from': 1929,
        'year-to': 1937,
      },
      {
        id: '202',
        name: '202',
        'cyrillic-name': '202',
        class: '',
        'year-from': 1938,
        'year-to': 1948,
      },
      {
        id: '203',
        name: '203',
        'cyrillic-name': '203',
        class: '',
        'year-from': 1948,
        'year-to': 1960,
      },
      {
        id: '204',
        name: '204',
        'cyrillic-name': '204',
        class: 'B',
        'year-from': 1965,
        'year-to': 1977,
      },
      {
        id: '205',
        name: '205',
        'cyrillic-name': '205',
        class: 'B',
        'year-from': 1983,
        'year-to': 1998,
      },
      {
        id: '205_GTI',
        name: '205 GTi',
        'cyrillic-name': '205 гти',
        class: 'B',
        'year-from': 1983,
        'year-to': 1998,
      },
      {
        id: '206',
        name: '206',
        'cyrillic-name': '206',
        class: 'B',
        'year-from': 1998,
        'year-to': 2012,
      },
      {
        id: '207',
        name: '207',
        'cyrillic-name': '207',
        class: 'B',
        'year-from': 2006,
        'year-to': 2015,
      },
      {
        id: '208',
        name: '208',
        'cyrillic-name': '208',
        class: 'B',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: '208_GTI',
        name: '208 GTi',
        'cyrillic-name': '208 гти',
        class: 'B',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: '3008',
        name: '3008',
        'cyrillic-name': '3008',
        class: 'C',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: '301',
        name: '301',
        'cyrillic-name': '301',
        class: 'B',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: '304',
        name: '304',
        'cyrillic-name': '304',
        class: 'C',
        'year-from': 1969,
        'year-to': 1980,
      },
      {
        id: '305',
        name: '305',
        'cyrillic-name': '305',
        class: 'C',
        'year-from': 1977,
        'year-to': 1990,
      },
      {
        id: '306',
        name: '306',
        'cyrillic-name': '306',
        class: 'C',
        'year-from': 1993,
        'year-to': 2002,
      },
      {
        id: '307',
        name: '307',
        'cyrillic-name': '307',
        class: 'C',
        'year-from': 2001,
        'year-to': 2008,
      },
      {
        id: '308',
        name: '308',
        'cyrillic-name': '308',
        class: 'C',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: '308_GTI',
        name: '308 GTi',
        'cyrillic-name': '308 гти',
        class: 'C',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: '309',
        name: '309',
        'cyrillic-name': '309',
        class: 'C',
        'year-from': 1985,
        'year-to': 1993,
      },
      {
        id: '4007',
        name: '4007',
        'cyrillic-name': '4007',
        class: 'D',
        'year-from': 2007,
        'year-to': 2012,
      },
      {
        id: '4008',
        name: '4008',
        'cyrillic-name': '4008',
        class: 'C',
        'year-from': 2012,
        'year-to': 2017,
      },
      {
        id: '402',
        name: '402',
        'cyrillic-name': '402',
        class: '',
        'year-from': 1935,
        'year-to': 1942,
      },
      {
        id: '403',
        name: '403',
        'cyrillic-name': '403',
        class: 'C',
        'year-from': 1955,
        'year-to': 1966,
      },
      {
        id: '404',
        name: '404',
        'cyrillic-name': '404',
        class: 'C',
        'year-from': 1960,
        'year-to': 1975,
      },
      {
        id: '405',
        name: '405',
        'cyrillic-name': '405',
        class: 'C',
        'year-from': 1987,
        'year-to': 2014,
      },
      {
        id: '406',
        name: '406',
        'cyrillic-name': '406',
        class: 'D',
        'year-from': 1995,
        'year-to': 2005,
      },
      {
        id: '407',
        name: '407',
        'cyrillic-name': '407',
        class: 'D',
        'year-from': 2004,
        'year-to': 2011,
      },
      {
        id: '408',
        name: '408',
        'cyrillic-name': '408',
        class: 'C',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: '5008',
        name: '5008',
        'cyrillic-name': '5008',
        class: 'D',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: '504',
        name: '504',
        'cyrillic-name': '504',
        class: 'D',
        'year-from': 1968,
        'year-to': 1996,
      },
      {
        id: '505',
        name: '505',
        'cyrillic-name': '505',
        class: 'D',
        'year-from': 1979,
        'year-to': 1992,
      },
      {
        id: '508',
        name: '508',
        'cyrillic-name': '508',
        class: 'D',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: '604',
        name: '604',
        'cyrillic-name': '604',
        class: 'E',
        'year-from': 1977,
        'year-to': 1987,
      },
      {
        id: '605',
        name: '605',
        'cyrillic-name': '605',
        class: 'E',
        'year-from': 1989,
        'year-to': 1999,
      },
      {
        id: '607',
        name: '607',
        'cyrillic-name': '607',
        class: 'F',
        'year-from': 2000,
        'year-to': 2010,
      },
      {
        id: '806',
        name: '806',
        'cyrillic-name': '806',
        class: 'M',
        'year-from': 1994,
        'year-to': 2002,
      },
      {
        id: '807',
        name: '807',
        'cyrillic-name': '807',
        class: 'M',
        'year-from': 2002,
        'year-to': 2014,
      },
      {
        id: 'BIPPER',
        name: 'Bipper',
        'cyrillic-name': 'Биппер',
        class: 'M',
        'year-from': 2008,
        'year-to': 2018,
      },
      {
        id: 'EXPERT',
        name: 'Expert',
        'cyrillic-name': 'Эксперт',
        class: 'M',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'ION',
        name: 'iOn',
        'cyrillic-name': 'ион',
        class: 'A',
        'year-from': 2010,
        'year-to': 2020,
      },
      {
        id: 'PARTNER',
        name: 'Partner',
        'cyrillic-name': 'Партнер',
        class: 'M',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'RCZ',
        name: 'RCZ',
        'cyrillic-name': 'рцз',
        class: 'C',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'RIFTER',
        name: 'Rifter',
        'cyrillic-name': 'Рифтер',
        class: 'M',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'TRAVELLER',
        name: 'Traveller',
        'cyrillic-name': 'Травелер',
        class: 'M',
        'year-from': 2016,
        'year-to': null,
      },
    ],
  },
  {
    id: 'PGO',
    name: 'PGO',
    'cyrillic-name': 'ПГО',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: 'CEVENNES',
        name: 'Cevennes',
        'cyrillic-name': 'Севеннес',
        class: 'S',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'HEMERA',
        name: 'Hemera',
        'cyrillic-name': 'Хемера',
        class: 'S',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'SPEEDSTER_II',
        name: 'Speedster II',
        'cyrillic-name': 'Спидстер 2',
        class: 'S',
        'year-from': 2005,
        'year-to': null,
      },
    ],
  },
  {
    id: 'PIAGGIO',
    name: 'Piaggio',
    'cyrillic-name': 'Пьяджо',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'PORTER',
        name: 'Porter',
        'cyrillic-name': 'Портер',
        class: 'M',
        'year-from': 1992,
        'year-to': null,
      },
    ],
  },
  {
    id: 'PIERCE_ARROW',
    name: 'Pierce-Arrow',
    'cyrillic-name': 'Пирс-Арроу',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'TWELVE',
        name: 'Twelve',
        'cyrillic-name': 'Твелв',
        class: 'F',
        'year-from': 1932,
        'year-to': 1938,
      },
    ],
  },
  {
    id: 'PLYMOUTH',
    name: 'Plymouth',
    'cyrillic-name': 'Плимут',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'ACCLAIM',
        name: 'Acclaim',
        'cyrillic-name': 'Эклайм',
        class: 'D',
        'year-from': 1989,
        'year-to': 1995,
      },
      {
        id: 'BARRACUDA',
        name: 'Barracuda',
        'cyrillic-name': 'барракуда',
        class: 'S',
        'year-from': 1964,
        'year-to': 1974,
      },
      {
        id: 'BREEZE',
        name: 'Breeze',
        'cyrillic-name': 'Бриз',
        class: 'D',
        'year-from': 1995,
        'year-to': 2000,
      },
      {
        id: 'CARAVELLE',
        name: 'Caravelle',
        'cyrillic-name': 'Каравелла',
        class: 'D',
        'year-from': 1983,
        'year-to': 1988,
      },
      {
        id: 'COLT_VISTA',
        name: 'Colt Vista',
        'cyrillic-name': 'Кольт Виста',
        class: 'M',
        'year-from': 1983,
        'year-to': 1991,
      },
      {
        id: 'CRANBROOK',
        name: 'Cranbrook',
        'cyrillic-name': 'Крэнбрук',
        class: 'E',
        'year-from': 1951,
        'year-to': 1953,
      },
      {
        id: 'FURY',
        name: 'Fury',
        'cyrillic-name': 'фьюри',
        class: 'F',
        'year-from': 1969,
        'year-to': 1978,
      },
      {
        id: 'HORIZON',
        name: 'Horizon',
        'cyrillic-name': 'Хорайзон',
        class: 'B',
        'year-from': 1977,
        'year-to': 1990,
      },
      {
        id: 'LASER',
        name: 'Laser',
        'cyrillic-name': 'Лазер',
        class: 'C',
        'year-from': 1989,
        'year-to': 1994,
      },
      {
        id: 'NEON',
        name: 'Neon',
        'cyrillic-name': 'Неон',
        class: 'C',
        'year-from': 1993,
        'year-to': 2001,
      },
      {
        id: 'PROWLER',
        name: 'Prowler',
        'cyrillic-name': 'Проулер',
        class: 'S',
        'year-from': 1997,
        'year-to': 2002,
      },
      {
        id: 'RELIANT',
        name: 'Reliant',
        'cyrillic-name': 'релиант',
        class: 'D',
        'year-from': 1981,
        'year-to': 1989,
      },
      {
        id: 'ROAD_RUNNER',
        name: 'Road Runner',
        'cyrillic-name': 'роад раннер',
        class: '',
        'year-from': 1968,
        'year-to': 1970,
      },
      {
        id: 'SATELLITE',
        name: 'Satellite',
        'cyrillic-name': 'Сателит',
        class: 'F',
        'year-from': 1970,
        'year-to': 1974,
      },
      {
        id: 'SUNDANCE',
        name: 'Sundance',
        'cyrillic-name': 'Сандэнс',
        class: 'C',
        'year-from': 1986,
        'year-to': 1994,
      },
      {
        id: 'TURISMO',
        name: 'Turismo',
        'cyrillic-name': 'Туризмо',
        class: 'D',
        'year-from': 1983,
        'year-to': 1987,
      },
      {
        id: 'VALIANT',
        name: 'Valiant',
        'cyrillic-name': 'валиант',
        class: 'D',
        'year-from': 1967,
        'year-to': 1973,
      },
      {
        id: 'VOLARE',
        name: 'Volare',
        'cyrillic-name': 'Волар',
        class: 'E',
        'year-from': 1975,
        'year-to': 1980,
      },
      {
        id: 'VOYAGER',
        name: 'Voyager',
        'cyrillic-name': 'Вояджер',
        class: 'M',
        'year-from': 1984,
        'year-to': 2000,
      },
    ],
  },
  {
    id: 'POLESTAR',
    name: 'Polestar',
    'cyrillic-name': 'Полестар',
    popular: false,
    country: 'Швеция',
    models: [
      {
        id: '1',
        name: '1',
        'cyrillic-name': '1',
        class: 'S',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: '2',
        name: '2',
        'cyrillic-name': '2',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'PONTIAC',
    name: 'Pontiac',
    'cyrillic-name': 'Понтиак',
    popular: false,
    country: 'США',
    models: [
      {
        id: '6000',
        name: '6000',
        'cyrillic-name': '6000',
        class: 'D',
        'year-from': 1982,
        'year-to': 1991,
      },
      {
        id: 'AZTEK',
        name: 'Aztek',
        'cyrillic-name': 'Ацтек',
        class: 'D',
        'year-from': 2001,
        'year-to': 2005,
      },
      {
        id: 'BONNEVILLE',
        name: 'Bonneville',
        'cyrillic-name': 'Бонневиль',
        class: 'E',
        'year-from': 1965,
        'year-to': 2005,
      },
      {
        id: 'CATALINA',
        name: 'Catalina',
        'cyrillic-name': 'Каталина',
        class: 'F',
        'year-from': 1959,
        'year-to': 1981,
      },
      {
        id: 'FIERO',
        name: 'Fiero',
        'cyrillic-name': 'Фиеро',
        class: 'S',
        'year-from': 1984,
        'year-to': 1988,
      },
      {
        id: 'FIREBIRD',
        name: 'Firebird',
        'cyrillic-name': 'Фаербёрд',
        class: 'S',
        'year-from': 1967,
        'year-to': 2002,
      },
      {
        id: 'G4',
        name: 'G4',
        'cyrillic-name': 'г4',
        class: 'C',
        'year-from': 2005,
        'year-to': 2010,
      },
      {
        id: 'G5',
        name: 'G5',
        'cyrillic-name': 'г5',
        class: 'C',
        'year-from': 2004,
        'year-to': 2010,
      },
      {
        id: 'G6',
        name: 'G6',
        'cyrillic-name': 'г6',
        class: 'D',
        'year-from': 2004,
        'year-to': 2009,
      },
      {
        id: 'G8',
        name: 'G8',
        'cyrillic-name': 'г8',
        class: 'F',
        'year-from': 2007,
        'year-to': 2009,
      },
      {
        id: 'GRAND_AM',
        name: 'Grand AM',
        'cyrillic-name': 'Гранд АМ',
        class: 'D',
        'year-from': 1984,
        'year-to': 2005,
      },
      {
        id: 'GRAND_PRIX',
        name: 'Grand Prix',
        'cyrillic-name': 'Гран При',
        class: 'D',
        'year-from': 1962,
        'year-to': 2008,
      },
      {
        id: 'GTO',
        name: 'GTO',
        'cyrillic-name': 'гто',
        class: 'S',
        'year-from': 1964,
        'year-to': 2006,
      },
      {
        id: 'LAURENTIAN',
        name: 'Laurentian',
        'cyrillic-name': 'Лаурентиан',
        class: 'E',
        'year-from': 1955,
        'year-to': 1957,
      },
      {
        id: 'LEMANS',
        name: 'LeMans',
        'cyrillic-name': 'ЛеМан',
        class: 'C',
        'year-from': 1964,
        'year-to': 1993,
      },
      {
        id: 'MONTANA',
        name: 'Montana',
        'cyrillic-name': 'Монтана',
        class: 'M',
        'year-from': 1997,
        'year-to': 2009,
      },
      {
        id: 'PARISIENNE',
        name: 'Parisienne',
        'cyrillic-name': 'паризьен',
        class: 'E',
        'year-from': 1971,
        'year-to': 1986,
      },
      {
        id: 'PHOENIX',
        name: 'Phoenix',
        'cyrillic-name': 'Феникс',
        class: 'C',
        'year-from': 1977,
        'year-to': 1984,
      },
      {
        id: 'SOLSTICE',
        name: 'Solstice',
        'cyrillic-name': 'Солстайс',
        class: 'B',
        'year-from': 2005,
        'year-to': 2009,
      },
      {
        id: 'SUNBIRD',
        name: 'Sunbird',
        'cyrillic-name': 'Санбёрд',
        class: 'C',
        'year-from': 1975,
        'year-to': 1994,
      },
      {
        id: 'SUNFIRE',
        name: 'Sunfire',
        'cyrillic-name': 'Санфаер',
        class: 'C',
        'year-from': 1995,
        'year-to': 2005,
      },
      {
        id: 'SUNRUNNER',
        name: 'Sunrunner',
        'cyrillic-name': 'Санраннер',
        class: 'J',
        'year-from': 1994,
        'year-to': 1998,
      },
      {
        id: 'TEMPEST',
        name: 'Tempest',
        'cyrillic-name': 'Темпест',
        class: 'C',
        'year-from': 1961,
        'year-to': 1991,
      },
      {
        id: 'TORPEDO',
        name: 'Torpedo',
        'cyrillic-name': 'Торпедо',
        class: '',
        'year-from': 1939,
        'year-to': 1948,
      },
      {
        id: 'TORRENT',
        name: 'Torrent',
        'cyrillic-name': 'Торрент',
        class: 'E',
        'year-from': 2005,
        'year-to': 2009,
      },
      {
        id: 'TRANS_SPORT',
        name: 'Trans Sport',
        'cyrillic-name': 'Транс Спорт',
        class: 'M',
        'year-from': 1989,
        'year-to': 1999,
      },
      {
        id: 'VIBE',
        name: 'Vibe',
        'cyrillic-name': 'Вайб',
        class: 'M',
        'year-from': 2002,
        'year-to': 2010,
      },
      {
        id: 'WAVE',
        name: 'Wave',
        'cyrillic-name': 'Вейв',
        class: 'B',
        'year-from': 2004,
        'year-to': 2009,
      },
    ],
  },
  {
    id: 'PORSCHE',
    name: 'Porsche',
    'cyrillic-name': 'Порше',
    popular: true,
    country: 'Германия',
    models: [
      {
        id: '356',
        name: '356',
        'cyrillic-name': '356',
        class: 'S',
        'year-from': 1948,
        'year-to': 1965,
      },
      {
        id: '718_SPYDER',
        name: '718 Spyder',
        'cyrillic-name': '718 Спайдер',
        class: 'S',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: '911',
        name: '911',
        'cyrillic-name': '911',
        class: 'S',
        'year-from': 1963,
        'year-to': null,
      },
      {
        id: '911_GT2',
        name: '911 GT2',
        'cyrillic-name': '911 гт2',
        class: 'S',
        'year-from': 1995,
        'year-to': 2019,
      },
      {
        id: '911_GT3',
        name: '911 GT3',
        'cyrillic-name': '911 гт3',
        class: 'S',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: '911_R',
        name: '911 R',
        'cyrillic-name': '911 р',
        class: 'S',
        'year-from': 2016,
        'year-to': 2019,
      },
      {
        id: '912',
        name: '912',
        'cyrillic-name': '912',
        class: 'S',
        'year-from': 1965,
        'year-to': 1976,
      },
      {
        id: '914',
        name: '914',
        'cyrillic-name': '914',
        class: 'S',
        'year-from': 1969,
        'year-to': 1976,
      },
      {
        id: '918_SPYDER',
        name: '918 Spyder',
        'cyrillic-name': '918 Спайдер',
        class: 'S',
        'year-from': 2013,
        'year-to': 2015,
      },
      {
        id: '924',
        name: '924',
        'cyrillic-name': '924',
        class: 'S',
        'year-from': 1975,
        'year-to': 1988,
      },
      {
        id: '928',
        name: '928',
        'cyrillic-name': '928',
        class: 'S',
        'year-from': 1977,
        'year-to': 1995,
      },
      {
        id: '944',
        name: '944',
        'cyrillic-name': '944',
        class: 'S',
        'year-from': 1981,
        'year-to': 1991,
      },
      {
        id: '959',
        name: '959',
        'cyrillic-name': '959',
        class: 'S',
        'year-from': 1986,
        'year-to': 1991,
      },
      {
        id: '968',
        name: '968',
        'cyrillic-name': '968',
        class: 'S',
        'year-from': 1991,
        'year-to': 1995,
      },
      {
        id: 'BOXSTER',
        name: 'Boxster',
        'cyrillic-name': 'Бокстер',
        class: 'S',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'CARRERA_GT',
        name: 'Carrera GT',
        'cyrillic-name': 'царрера гт',
        class: 'S',
        'year-from': 2003,
        'year-to': 2007,
      },
      {
        id: 'CAYENNE',
        name: 'Cayenne',
        'cyrillic-name': 'Кайен',
        class: 'E',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'CAYMAN',
        name: 'Cayman',
        'cyrillic-name': 'Кайман',
        class: 'S',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'CAYMAN_GT4',
        name: 'Cayman GT4',
        'cyrillic-name': 'Кайман Джи-Ти 4',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'MACAN',
        name: 'Macan',
        'cyrillic-name': 'Макан',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'PANAMERA',
        name: 'Panamera',
        'cyrillic-name': 'Панамера',
        class: 'F',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'TAYCAN',
        name: 'Taycan',
        'cyrillic-name': 'Тайкан',
        class: 'F',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'PREMIER',
    name: 'Premier',
    'cyrillic-name': 'Премьер',
    popular: false,
    country: 'Индия',
    models: [
      {
        id: '118NE',
        name: '118NE',
        'cyrillic-name': '118 не',
        class: 'C',
        'year-from': 1985,
        'year-to': 2001,
      },
      {
        id: 'PADMINI',
        name: 'Padmini',
        'cyrillic-name': 'падмини',
        class: 'B',
        'year-from': 1964,
        'year-to': 2000,
      },
    ],
  },
  {
    id: 'PROMO_AUTO',
    name: 'Спортивные авто и Реплики',
    'cyrillic-name': 'Спортивные авто и Реплики',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'GT_TOURING',
        name: 'GT & Touring',
        'cyrillic-name': 'ГТ и Туринг',
        class: 'S',
        'year-from': 1950,
        'year-to': null,
      },
      {
        id: 'OFFROAD',
        name: 'Offroad',
        'cyrillic-name': 'Оффроуд',
        class: 'J',
        'year-from': 1950,
        'year-to': null,
      },
      {
        id: 'SHORTCUT',
        name: 'Shortcut',
        'cyrillic-name': 'Шорткат',
        class: 'S',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'BEACH_BUGGY_TYPE1',
        name: 'Багги Type 1',
        'cyrillic-name': 'Пляжный багги тип 1',
        class: '',
        'year-from': 1964,
        'year-to': null,
      },
      {
        id: 'DRAGSTER',
        name: 'Драгстер',
        'cyrillic-name': 'Драгстер',
        class: 'S',
        'year-from': 1950,
        'year-to': null,
      },
      {
        id: 'DRIFT',
        name: 'Дрифт-кар',
        'cyrillic-name': 'Дрифт',
        class: 'S',
        'year-from': 1950,
        'year-to': null,
      },
      {
        id: 'REPLICA_I_SAMODELKI',
        name: 'Самоделки',
        'cyrillic-name': 'Самоделки',
        class: 'S',
        'year-from': 1943,
        'year-to': null,
      },
      {
        id: 'PROTOTYPE',
        name: 'Спортпрототип',
        'cyrillic-name': 'Спортпрототип',
        class: 'S',
        'year-from': 1950,
        'year-to': null,
      },
      {
        id: 'FORMULA',
        name: 'Формула',
        'cyrillic-name': 'Формула',
        class: 'S',
        'year-from': 1950,
        'year-to': null,
      },
      {
        id: 'HOT_ROD_CUSTOM',
        name: 'Хот-род и Кастом',
        'cyrillic-name': 'Хот-род и Кастом',
        class: 'S',
        'year-from': 1950,
        'year-to': null,
      },
    ],
  },
  {
    id: 'PROTON',
    name: 'Proton',
    'cyrillic-name': 'Протон',
    popular: false,
    country: 'Малайзия',
    models: [
      {
        id: 'ARENA',
        name: 'Arena',
        'cyrillic-name': 'арена',
        class: 'J',
        'year-from': 2002,
        'year-to': 2010,
      },
      {
        id: 'EXORA',
        name: 'Exora',
        'cyrillic-name': 'ехора',
        class: 'M',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'GEN_2',
        name: 'Gen-2',
        'cyrillic-name': 'ген-2',
        class: 'C',
        'year-from': 2004,
        'year-to': 2012,
      },
      {
        id: 'INSPIRA',
        name: 'Inspira',
        'cyrillic-name': 'инспира',
        class: 'C',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'IRIZ',
        name: 'Iriz',
        'cyrillic-name': 'ириз',
        class: 'B',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'JUARA',
        name: 'Juara',
        'cyrillic-name': 'жуара',
        class: 'M',
        'year-from': 2001,
        'year-to': 2003,
      },
      {
        id: 'PERDANA',
        name: 'Perdana',
        'cyrillic-name': 'пердана',
        class: 'D',
        'year-from': 1995,
        'year-to': 2010,
      },
      {
        id: 'PERSONA',
        name: 'Persona',
        'cyrillic-name': 'персона',
        class: 'B',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'PREVE',
        name: 'Preve',
        'cyrillic-name': 'преве',
        class: 'C',
        'year-from': 2011,
        'year-to': 2020,
      },
      {
        id: 'PUTRA',
        name: 'Putra',
        'cyrillic-name': 'путра',
        class: 'S',
        'year-from': 1996,
        'year-to': 2004,
      },
      {
        id: 'SAGA',
        name: 'Saga',
        'cyrillic-name': 'Сага',
        class: 'C',
        'year-from': 1985,
        'year-to': null,
      },
      {
        id: 'SATRIA',
        name: 'Satria',
        'cyrillic-name': 'сатрия',
        class: 'B',
        'year-from': 1996,
        'year-to': 2015,
      },
      {
        id: 'SAVVY',
        name: 'Savvy',
        'cyrillic-name': 'савви',
        class: 'B',
        'year-from': 2005,
        'year-to': 2011,
      },
      {
        id: 'TIARA',
        name: 'Tiara',
        'cyrillic-name': 'Тиара',
        class: 'B',
        'year-from': 1996,
        'year-to': 2000,
      },
      {
        id: 'WAJA',
        name: 'Waja',
        'cyrillic-name': 'важа',
        class: 'C',
        'year-from': 2000,
        'year-to': 2011,
      },
      {
        id: 'WIRA',
        name: 'Wira (400 Series)',
        'cyrillic-name': 'вира',
        class: 'C',
        'year-from': 1993,
        'year-to': 2009,
      },
      {
        id: 'X50',
        name: 'X50',
        'cyrillic-name': 'Икс50',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'X70',
        name: 'X70',
        'cyrillic-name': 'икс70',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'PUCH',
    name: 'PUCH',
    'cyrillic-name': 'Пух',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'G_MODELL',
        name: 'G-modell',
        'cyrillic-name': 'г-модель',
        class: 'J',
        'year-from': 1979,
        'year-to': 2000,
      },
      {
        id: 'PINZGAUER',
        name: 'Pinzgauer',
        'cyrillic-name': 'Пинцгауэр',
        class: 'J',
        'year-from': 1971,
        'year-to': 2000,
      },
    ],
  },
  {
    id: 'PUMA',
    name: 'Puma',
    'cyrillic-name': 'Пума',
    popular: false,
    country: 'Бразилия',
    models: [
      {
        id: 'GTB',
        name: 'GTB',
        'cyrillic-name': 'гтб',
        class: 'S',
        'year-from': 1973,
        'year-to': 1984,
      },
      {
        id: 'GTE',
        name: 'GTE',
        'cyrillic-name': 'гте',
        class: 'S',
        'year-from': 1967,
        'year-to': 1995,
      },
    ],
  },
  {
    id: 'QOROS',
    name: 'Qoros',
    'cyrillic-name': 'Куорос',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: '3',
        name: '3',
        'cyrillic-name': '3',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: '5',
        name: '5',
        'cyrillic-name': '5',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
    ],
  },
  {
    id: 'QVALE',
    name: 'Qvale',
    'cyrillic-name': 'Куали',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'MANGUSTA',
        name: 'Mangusta',
        'cyrillic-name': 'Мангуста',
        class: 'S',
        'year-from': 1999,
        'year-to': 2002,
      },
    ],
  },
  {
    id: 'RAM',
    name: 'RAM',
    'cyrillic-name': 'Рам',
    popular: false,
    country: 'США',
    models: [
      {
        id: '1500',
        name: '1500',
        'cyrillic-name': '1500',
        class: 'J',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'PROMASTER_CITY',
        name: 'ProMaster City',
        'cyrillic-name': 'Промастер Сити',
        class: 'M',
        'year-from': 2014,
        'year-to': null,
      },
    ],
  },
  {
    id: 'RAVON',
    name: 'Ravon',
    'cyrillic-name': 'Равон',
    popular: false,
    country: 'Узбекистан',
    models: [
      {
        id: 'GENTRA',
        name: 'Gentra',
        'cyrillic-name': 'Джентра',
        class: 'C',
        'year-from': 2015,
        'year-to': 2018,
      },
      {
        id: 'MATIZ',
        name: 'Matiz',
        'cyrillic-name': 'Матиз',
        class: 'A',
        'year-from': 2015,
        'year-to': 2016,
      },
      {
        id: 'NEXIA_R3',
        name: 'Nexia R3',
        'cyrillic-name': 'Нексия Р3',
        class: 'B',
        'year-from': 2015,
        'year-to': 2020,
      },
      {
        id: 'R2',
        name: 'R2',
        'cyrillic-name': 'р2',
        class: 'A',
        'year-from': 2016,
        'year-to': 2020,
      },
      {
        id: 'R4',
        name: 'R4',
        'cyrillic-name': 'Р4',
        class: 'B',
        'year-from': 2016,
        'year-to': 2020,
      },
    ],
  },
  {
    id: 'RELIANT',
    name: 'Reliant',
    'cyrillic-name': 'Релайент',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'SCIMITAR',
        name: 'Scimitar Sabre',
        'cyrillic-name': 'скимитар сабре',
        class: 'S',
        'year-from': 1984,
        'year-to': 1992,
      },
    ],
  },
  {
    id: 'RENAISSANCE_CARS',
    name: 'Renaissance',
    'cyrillic-name': 'Ренессанс',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'TROPICA_ROADSTER',
        name: 'Tropica Roadster',
        'cyrillic-name': 'Тропика Родстер',
        class: 'S',
        'year-from': 1995,
        'year-to': 1995,
      },
    ],
  },
  {
    id: 'RENAULT',
    name: 'Renault',
    'cyrillic-name': 'Рено',
    popular: true,
    country: 'Франция',
    models: [
      {
        id: '10',
        name: '10',
        'cyrillic-name': '10',
        class: 'B',
        'year-from': 1962,
        'year-to': 1973,
      },
      {
        id: '11',
        name: '11',
        'cyrillic-name': '11',
        class: 'C',
        'year-from': 1983,
        'year-to': 1989,
      },
      {
        id: '12',
        name: '12',
        'cyrillic-name': '12',
        class: 'C',
        'year-from': 1969,
        'year-to': 1980,
      },
      {
        id: '14',
        name: '14',
        'cyrillic-name': '14',
        class: 'C',
        'year-from': 1976,
        'year-to': 1983,
      },
      {
        id: '15',
        name: '15',
        'cyrillic-name': '15',
        class: 'C',
        'year-from': 1972,
        'year-to': 1980,
      },
      {
        id: '16',
        name: '16',
        'cyrillic-name': '16',
        class: 'D',
        'year-from': 1965,
        'year-to': 1980,
      },
      {
        id: '17',
        name: '17',
        'cyrillic-name': '17',
        class: 'D',
        'year-from': 1972,
        'year-to': 1980,
      },
      {
        id: '18',
        name: '18',
        'cyrillic-name': '18',
        class: 'D',
        'year-from': 1978,
        'year-to': 1986,
      },
      {
        id: '19',
        name: '19',
        'cyrillic-name': '19',
        class: 'C',
        'year-from': 1988,
        'year-to': 2002,
      },
      {
        id: '20',
        name: '20',
        'cyrillic-name': '20',
        class: 'E',
        'year-from': 1975,
        'year-to': 1983,
      },
      {
        id: '21',
        name: '21',
        'cyrillic-name': '21',
        class: 'D',
        'year-from': 1986,
        'year-to': 1995,
      },
      {
        id: '25',
        name: '25',
        'cyrillic-name': '25',
        class: 'E',
        'year-from': 1983,
        'year-to': 1992,
      },
      {
        id: '30',
        name: '30',
        'cyrillic-name': '30',
        class: 'D',
        'year-from': 1975,
        'year-to': 1986,
      },
      {
        id: '4',
        name: '4',
        'cyrillic-name': '4',
        class: 'B',
        'year-from': 1962,
        'year-to': 1991,
      },
      {
        id: '4CV',
        name: '4CV',
        'cyrillic-name': '4св',
        class: 'B',
        'year-from': 1947,
        'year-to': 1961,
      },
      {
        id: '5',
        name: '5',
        'cyrillic-name': '5',
        class: 'B',
        'year-from': 1972,
        'year-to': 2002,
      },
      {
        id: '6',
        name: '6',
        'cyrillic-name': '6',
        class: 'C',
        'year-from': 1970,
        'year-to': 1987,
      },
      {
        id: '8',
        name: '8',
        'cyrillic-name': '8',
        class: 'B',
        'year-from': 1962,
        'year-to': 1973,
      },
      {
        id: '9',
        name: '9',
        'cyrillic-name': '9',
        class: 'C',
        'year-from': 1981,
        'year-to': 1989,
      },
      {
        id: 'ALASKAN',
        name: 'Alaskan',
        'cyrillic-name': 'Аласкан',
        class: 'J',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'ARKANA',
        name: 'Arkana',
        'cyrillic-name': 'Аркана',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'AUSTRAL',
        name: 'Austral',
        'cyrillic-name': 'Аустрал',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'AVANTIME',
        name: 'Avantime',
        'cyrillic-name': 'Авантайм',
        class: 'M',
        'year-from': 2001,
        'year-to': 2003,
      },
      {
        id: 'CAPTUR',
        name: 'Captur',
        'cyrillic-name': 'Каптюр',
        class: 'B',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'CARAVELLE',
        name: 'Caravelle',
        'cyrillic-name': 'Каравелла',
        class: 'S',
        'year-from': 1958,
        'year-to': 1968,
      },
      {
        id: 'CITY_K_ZE',
        name: 'City K-ZE',
        'cyrillic-name': 'Сити К-ЗЕ',
        class: 'A',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'CLIO',
        name: 'Clio',
        'cyrillic-name': 'Клио',
        class: 'B',
        'year-from': 1990,
        'year-to': null,
      },
      {
        id: 'CLIO_RS',
        name: 'Clio RS',
        'cyrillic-name': 'Клио РС',
        class: 'B',
        'year-from': 2000,
        'year-to': 2019,
      },
      {
        id: 'CLIO_V6',
        name: 'Clio V6',
        'cyrillic-name': 'Клио В6',
        class: 'B',
        'year-from': 2001,
        'year-to': 2005,
      },
      {
        id: 'DAUPHINE',
        name: 'Dauphine',
        'cyrillic-name': 'дауфине',
        class: 'B',
        'year-from': 1956,
        'year-to': 1967,
      },
      {
        id: 'DOKKER',
        name: 'Dokker',
        'cyrillic-name': 'доккер',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'DUSTER',
        name: 'Duster',
        'cyrillic-name': 'Дастер',
        class: 'B',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'ESPACE',
        name: 'Espace',
        'cyrillic-name': 'Эспэйс',
        class: 'M',
        'year-from': 1984,
        'year-to': null,
      },
      {
        id: 'FLORIDE',
        name: 'Floride',
        'cyrillic-name': 'Флорид',
        class: 'S',
        'year-from': 1958,
        'year-to': 1968,
      },
      {
        id: 'FLUENCE',
        name: 'Fluence',
        'cyrillic-name': 'Флюенс',
        class: 'C',
        'year-from': 2009,
        'year-to': 2017,
      },
      {
        id: 'FREGATE',
        name: 'Fregate',
        'cyrillic-name': 'Фрегат',
        class: 'S',
        'year-from': 1951,
        'year-to': 1960,
      },
      {
        id: 'FUEGO',
        name: 'Fuego',
        'cyrillic-name': 'Фуего',
        class: 'C',
        'year-from': 1980,
        'year-to': 1985,
      },
      {
        id: 'KADJAR',
        name: 'Kadjar',
        'cyrillic-name': 'Каджар',
        class: 'C',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'KANGOO',
        name: 'Kangoo',
        'cyrillic-name': 'Кэнгу',
        class: 'M',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'KAPTUR',
        name: 'Kaptur',
        'cyrillic-name': 'Каптюр',
        class: 'B',
        'year-from': 2016,
        'year-to': 2022,
      },
      {
        id: 'KOLEOS',
        name: 'Koleos',
        'cyrillic-name': 'Колеос',
        class: 'D',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'KWID',
        name: 'KWID',
        'cyrillic-name': 'квид',
        class: 'A',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'LAGUNA',
        name: 'Laguna',
        'cyrillic-name': 'Лагуна',
        class: 'D',
        'year-from': 1993,
        'year-to': 2015,
      },
      {
        id: 'LATITUDE',
        name: 'Latitude',
        'cyrillic-name': 'Латитюд',
        class: 'D',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'LODGY',
        name: 'Lodgy',
        'cyrillic-name': 'Лоджи',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'LOGAN',
        name: 'Logan',
        'cyrillic-name': 'Логан',
        class: 'B',
        'year-from': 2004,
        'year-to': 2022,
      },
      {
        id: 'MEGANE',
        name: 'Megane',
        'cyrillic-name': 'Меган',
        class: 'C',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'MEGANE_E_TECH',
        name: 'Megane E-Tech',
        'cyrillic-name': 'Меган Е Тех',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'MEGANE_RS',
        name: 'Megane RS',
        'cyrillic-name': 'Меган РС',
        class: 'C',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'MODUS',
        name: 'Modus',
        'cyrillic-name': 'Модус',
        class: 'M',
        'year-from': 2004,
        'year-to': 2012,
      },
      {
        id: 'RODEO',
        name: 'Rodeo',
        'cyrillic-name': 'Родео',
        class: 'J',
        'year-from': 1971,
        'year-to': 1987,
      },
      {
        id: 'SAFRANE',
        name: 'Safrane',
        'cyrillic-name': 'Сафран',
        class: 'E',
        'year-from': 1992,
        'year-to': 2010,
      },
      {
        id: 'SANDERO',
        name: 'Sandero',
        'cyrillic-name': 'Сандеро',
        class: 'B',
        'year-from': 2009,
        'year-to': 2022,
      },
      {
        id: 'SANDERO_RS',
        name: 'Sandero RS',
        'cyrillic-name': 'Сандеро РС',
        class: 'B',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'SCENIC',
        name: 'Scenic',
        'cyrillic-name': 'Сценик',
        class: 'M',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'SPORT_SPYDER',
        name: 'Sport Spider',
        'cyrillic-name': 'Спорт Спайдер',
        class: 'S',
        'year-from': 1995,
        'year-to': 2000,
      },
      {
        id: 'CLIO_SYMBOL',
        name: 'Symbol',
        'cyrillic-name': 'Симбол',
        class: 'B',
        'year-from': 1999,
        'year-to': 2012,
      },
      {
        id: 'TALISMAN',
        name: 'Talisman',
        'cyrillic-name': 'Талисман',
        class: 'D',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'TRAFIC',
        name: 'Trafic',
        'cyrillic-name': 'трафик',
        class: 'M',
        'year-from': 1980,
        'year-to': null,
      },
      {
        id: 'TWINGO',
        name: 'Twingo',
        'cyrillic-name': 'Твинго',
        class: 'A',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'TWIZY',
        name: 'Twizy',
        'cyrillic-name': 'Твизи',
        class: 'A',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'VEL_SATIS',
        name: 'Vel Satis',
        'cyrillic-name': 'Вел Сатиз',
        class: 'E',
        'year-from': 2002,
        'year-to': 2009,
      },
      {
        id: 'VIVASTELLA',
        name: 'Vivastella',
        'cyrillic-name': 'вивастелла',
        class: '',
        'year-from': 1929,
        'year-to': 1939,
      },
      {
        id: 'WIND',
        name: 'Wind',
        'cyrillic-name': 'Винд',
        class: 'B',
        'year-from': 2010,
        'year-to': 2013,
      },
      {
        id: 'ZOE',
        name: 'ZOE',
        'cyrillic-name': 'ЗОЕ',
        class: 'B',
        'year-from': 2012,
        'year-to': null,
      },
    ],
  },
  {
    id: 'REZVANI',
    name: 'Rezvani',
    'cyrillic-name': 'резвани',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'BEAST',
        name: 'Beast',
        'cyrillic-name': 'Бист',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'TANK',
        name: 'Tank',
        'cyrillic-name': 'Танк',
        class: 'J',
        'year-from': 2017,
        'year-to': null,
      },
    ],
  },
  {
    id: 'RIMAC',
    name: 'Rimac',
    'cyrillic-name': 'Римак',
    popular: false,
    country: 'Хорватия',
    models: [
      {
        id: 'C_TWO',
        name: 'C Two',
        'cyrillic-name': 'си ту',
        class: 'S',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'CONCEPT_ONE',
        name: 'Concept_One',
        'cyrillic-name': 'концепт ван',
        class: 'S',
        'year-from': 2013,
        'year-to': 2016,
      },
      {
        id: 'NEVERA',
        name: 'Nevera',
        'cyrillic-name': 'Невера',
        class: 'S',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'RINSPEED',
    name: 'Rinspeed',
    'cyrillic-name': 'Ринспид',
    popular: false,
    country: 'Швейцария',
    models: [
      {
        id: 'CHOPSTER',
        name: 'Chopster',
        'cyrillic-name': 'Чопстер',
        class: 'E',
        'year-from': 2004,
        'year-to': 2005,
      },
    ],
  },
  {
    id: 'RISING_AUTO',
    name: 'Rising Auto',
    'cyrillic-name': 'Райзинг Авто',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'MARVEL_R',
        name: 'Marvel R',
        'cyrillic-name': 'Марвел Р',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'R7',
        name: 'R7',
        'cyrillic-name': 'Р7',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'RIVIAN',
    name: 'Rivian',
    'cyrillic-name': 'Ривиан',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'R1S',
        name: 'R1S',
        'cyrillic-name': 'Р1С',
        class: 'J',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'R1T',
        name: 'R1T',
        'cyrillic-name': 'Р1Т',
        class: 'J',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ROEWE',
    name: 'Roewe',
    'cyrillic-name': 'роеве',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'CLEVER',
        name: 'Clever',
        'cyrillic-name': 'Клевер',
        class: 'A',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'E50',
        name: 'E50',
        'cyrillic-name': 'Е50',
        class: 'A',
        'year-from': 2012,
        'year-to': 2016,
      },
      {
        id: 'EI5',
        name: 'Ei5',
        'cyrillic-name': 'Еи5',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'I5',
        name: 'i5',
        'cyrillic-name': 'ай5',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'I6',
        name: 'i6',
        'cyrillic-name': 'ай6',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'I6_MAX',
        name: 'i6 Max',
        'cyrillic-name': 'ай6 макс',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'IMAX8',
        name: 'iMAX8',
        'cyrillic-name': 'аймакс8',
        class: 'M',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'MARVEL_X',
        name: 'Marvel X',
        'cyrillic-name': 'Марвел Икс',
        class: 'C',
        'year-from': 2018,
        'year-to': 2021,
      },
      {
        id: 'RX3',
        name: 'RX3',
        'cyrillic-name': 'РХ3',
        class: 'C',
        'year-from': 2017,
        'year-to': 2021,
      },
      {
        id: 'RX3_PRO',
        name: 'RX3 Pro',
        'cyrillic-name': 'РХ3 Про',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'RX5',
        name: 'RX5',
        'cyrillic-name': 'рикс5',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'RX5_MAX',
        name: 'RX5 Max',
        'cyrillic-name': 'рикс5 макс',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'RX8',
        name: 'RX8',
        'cyrillic-name': 'РХ8',
        class: 'E',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'RX9',
        name: 'RX9',
        'cyrillic-name': 'ркс9',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ROLLS_ROYCE',
    name: 'Rolls-Royce',
    'cyrillic-name': 'Роллс-Ройс',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '20_25',
        name: '20/25',
        'cyrillic-name': '20/25',
        class: 'S',
        'year-from': 1929,
        'year-to': 1936,
      },
      {
        id: 'CAMARGUE',
        name: 'Camargue',
        'cyrillic-name': 'камарг',
        class: 'F',
        'year-from': 1975,
        'year-to': 1986,
      },
      {
        id: 'CORNICHE',
        name: 'Corniche',
        'cyrillic-name': 'корниш',
        class: 'F',
        'year-from': 1971,
        'year-to': 2002,
      },
      {
        id: 'CULLINAN',
        name: 'Cullinan',
        'cyrillic-name': 'Куллинан',
        class: 'F',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'DAWN',
        name: 'Dawn',
        'cyrillic-name': 'давн',
        class: 'F',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'GHOST',
        name: 'Ghost',
        'cyrillic-name': 'гост',
        class: 'F',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'PARK_WARD',
        name: 'Park Ward',
        'cyrillic-name': 'парк вард',
        class: 'F',
        'year-from': 2000,
        'year-to': 2002,
      },
      {
        id: 'PHANTOM',
        name: 'Phantom',
        'cyrillic-name': 'Фантом',
        class: 'F',
        'year-from': 1925,
        'year-to': null,
      },
      {
        id: 'SILVER_CLOUD',
        name: 'Silver Cloud',
        'cyrillic-name': 'сильвер клауд',
        class: 'F',
        'year-from': 1955,
        'year-to': 1966,
      },
      {
        id: 'SILVER_GHOST',
        name: 'Silver Ghost',
        'cyrillic-name': 'сильвер гост',
        class: 'S',
        'year-from': 1906,
        'year-to': 1926,
      },
      {
        id: 'SILVER_SERAPH',
        name: 'Silver Seraph',
        'cyrillic-name': 'сильвер сераф',
        class: 'F',
        'year-from': 1998,
        'year-to': 2002,
      },
      {
        id: 'SILVER_SHADOW',
        name: 'Silver Shadow',
        'cyrillic-name': 'Сильвер шедоу',
        class: 'F',
        'year-from': 1965,
        'year-to': 1980,
      },
      {
        id: 'SILVER_SPIRIT',
        name: 'Silver Spirit',
        'cyrillic-name': 'Сильвер Спирит',
        class: 'F',
        'year-from': 1980,
        'year-to': 1997,
      },
      {
        id: 'SILVER_SPUR',
        name: 'Silver Spur',
        'cyrillic-name': 'сильвер спур',
        class: 'F',
        'year-from': 1980,
        'year-to': 1999,
      },
      {
        id: 'SILVER_WRAITH',
        name: 'Silver Wraith',
        'cyrillic-name': 'сильвер рейс',
        class: '',
        'year-from': 1946,
        'year-to': 1959,
      },
      {
        id: 'SPECTRE',
        name: 'Spectre',
        'cyrillic-name': 'Спектр',
        class: 'F',
        'year-from': 2023,
        'year-to': null,
      },
      {
        id: 'WRAITH',
        name: 'Wraith',
        'cyrillic-name': 'рейс',
        class: 'F',
        'year-from': 2013,
        'year-to': null,
      },
    ],
  },
  {
    id: 'RONART',
    name: 'Ronart',
    'cyrillic-name': 'Ронарт',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'LIGHTING',
        name: 'Lightning',
        'cyrillic-name': 'лайтнинг',
        class: 'S',
        'year-from': 2000,
        'year-to': 2013,
      },
    ],
  },
  {
    id: 'ROVER',
    name: 'Rover',
    'cyrillic-name': 'Ровер',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '100',
        name: '100',
        'cyrillic-name': '100',
        class: 'B',
        'year-from': 1994,
        'year-to': 2000,
      },
      {
        id: '14',
        name: '14',
        'cyrillic-name': '14',
        class: '',
        'year-from': 1933,
        'year-to': 1948,
      },
      {
        id: '200',
        name: '200',
        'cyrillic-name': '200',
        class: 'C',
        'year-from': 1984,
        'year-to': 1999,
      },
      {
        id: '25',
        name: '25',
        'cyrillic-name': '25',
        class: 'C',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: '400',
        name: '400',
        'cyrillic-name': '400',
        class: 'C',
        'year-from': 1990,
        'year-to': 2000,
      },
      {
        id: '45',
        name: '45',
        'cyrillic-name': '45',
        class: 'D',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: '600',
        name: '600',
        'cyrillic-name': '600',
        class: 'D',
        'year-from': 1993,
        'year-to': 1999,
      },
      {
        id: '75',
        name: '75',
        'cyrillic-name': '75',
        class: 'E',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: '800',
        name: '800',
        'cyrillic-name': '800',
        class: 'D',
        'year-from': 1986,
        'year-to': 1999,
      },
      {
        id: 'MAESTRO',
        name: 'Maestro',
        'cyrillic-name': 'Маэстро',
        class: 'C',
        'year-from': 1991,
        'year-to': 1997,
      },
      {
        id: 'METRO',
        name: 'Metro',
        'cyrillic-name': 'Метро',
        class: 'B',
        'year-from': 1987,
        'year-to': 1994,
      },
      {
        id: 'MINI',
        name: 'Mini',
        'cyrillic-name': 'мини',
        class: 'A',
        'year-from': 1989,
        'year-to': 2000,
      },
      {
        id: 'MONTEGO',
        name: 'Montego',
        'cyrillic-name': 'Монтего',
        class: 'C',
        'year-from': 1988,
        'year-to': 1994,
      },
      {
        id: 'P3',
        name: 'P3',
        'cyrillic-name': 'п3',
        class: '',
        'year-from': 1948,
        'year-to': 1949,
      },
      {
        id: 'P4',
        name: 'P4',
        'cyrillic-name': 'п4',
        class: '',
        'year-from': 1949,
        'year-to': 1964,
      },
      {
        id: 'P6',
        name: 'P6',
        'cyrillic-name': 'п6',
        class: 'D',
        'year-from': 1963,
        'year-to': 1977,
      },
      {
        id: 'SD1',
        name: 'SD1',
        'cyrillic-name': 'сд1',
        class: 'E',
        'year-from': 1976,
        'year-to': 1986,
      },
      {
        id: 'STREETWISE',
        name: 'Streetwise',
        'cyrillic-name': 'Стритвайз',
        class: 'C',
        'year-from': 2003,
        'year-to': 2005,
      },
    ],
  },
  {
    id: 'SAAB',
    name: 'Saab',
    'cyrillic-name': 'Сааб',
    popular: false,
    country: 'Швеция',
    models: [
      {
        id: '600',
        name: '600',
        'cyrillic-name': '600',
        class: 'B',
        'year-from': 1980,
        'year-to': 1982,
      },
      {
        id: '9_2X',
        name: '9-2X',
        'cyrillic-name': '9-2кс',
        class: 'C',
        'year-from': 2004,
        'year-to': 2006,
      },
      {
        id: '9_3',
        name: '9-3',
        'cyrillic-name': '9-3',
        class: 'D',
        'year-from': 1998,
        'year-to': 2014,
      },
      {
        id: '9_4X',
        name: '9-4X',
        'cyrillic-name': '9-4кс',
        class: 'E',
        'year-from': 2011,
        'year-to': 2011,
      },
      {
        id: '9_5',
        name: '9-5',
        'cyrillic-name': '9-5',
        class: 'F',
        'year-from': 1997,
        'year-to': 2012,
      },
      {
        id: '9_7X',
        name: '9-7X',
        'cyrillic-name': '9-7кс',
        class: 'E',
        'year-from': 2005,
        'year-to': 2009,
      },
      {
        id: '90',
        name: '90',
        'cyrillic-name': '90',
        class: 'C',
        'year-from': 1984,
        'year-to': 1987,
      },
      {
        id: '900',
        name: '900',
        'cyrillic-name': '900',
        class: 'D',
        'year-from': 1978,
        'year-to': 1998,
      },
      {
        id: '9000',
        name: '9000',
        'cyrillic-name': '9000',
        class: 'D',
        'year-from': 1984,
        'year-to': 1998,
      },
      {
        id: '93',
        name: '93',
        'cyrillic-name': '93',
        class: 'S',
        'year-from': 1956,
        'year-to': 1960,
      },
      {
        id: '95',
        name: '95',
        'cyrillic-name': '95',
        class: 'C',
        'year-from': 1959,
        'year-to': 1978,
      },
      {
        id: '96',
        name: '96',
        'cyrillic-name': '96',
        class: 'C',
        'year-from': 1960,
        'year-to': 1980,
      },
      {
        id: '99',
        name: '99',
        'cyrillic-name': '99',
        class: 'C',
        'year-from': 1967,
        'year-to': 1984,
      },
      {
        id: 'SONETT',
        name: 'Sonett',
        'cyrillic-name': 'сонет',
        class: 'S',
        'year-from': 1970,
        'year-to': 1974,
      },
    ],
  },
  {
    id: 'SAIPA',
    name: 'Saipa',
    'cyrillic-name': 'Сайпа',
    popular: false,
    country: 'Иран',
    models: [
      {
        id: 'QUICK',
        name: 'Quick',
        'cyrillic-name': 'Квик',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'SAINA',
        name: 'Saina',
        'cyrillic-name': 'Сайна',
        class: 'B',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'SHAHIN',
        name: 'Shahin',
        'cyrillic-name': 'шахин',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'TIBA',
        name: 'Tiba',
        'cyrillic-name': 'Тиба',
        class: 'B',
        'year-from': 2009,
        'year-to': null,
      },
    ],
  },
  {
    id: 'SALEEN',
    name: 'Saleen',
    'cyrillic-name': 'Салин',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'S7',
        name: 'S7',
        'cyrillic-name': 'с7',
        class: 'S',
        'year-from': 2000,
        'year-to': 2006,
      },
    ],
  },
  {
    id: 'SAMSUNG',
    name: 'Renault Samsung',
    'cyrillic-name': 'Рено Самсунг',
    popular: false,
    country: 'Южная Корея',
    models: [
      {
        id: 'QM3',
        name: 'QM3',
        'cyrillic-name': 'куэм3',
        class: 'B',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'QM5',
        name: 'QM5',
        'cyrillic-name': 'куэм5',
        class: 'D',
        'year-from': 2007,
        'year-to': 2016,
      },
      {
        id: 'QM6',
        name: 'QM6',
        'cyrillic-name': 'куэм6',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'SM3',
        name: 'SM3',
        'cyrillic-name': 'см3',
        class: 'C',
        'year-from': 2002,
        'year-to': 2020,
      },
      {
        id: 'SM5',
        name: 'SM5',
        'cyrillic-name': 'см5',
        class: 'D',
        'year-from': 1998,
        'year-to': 2019,
      },
      {
        id: 'SM6',
        name: 'SM6',
        'cyrillic-name': 'СМ6',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'SM7',
        name: 'SM7',
        'cyrillic-name': 'см7',
        class: 'F',
        'year-from': 2004,
        'year-to': 2011,
      },
      {
        id: 'XM3',
        name: 'XM3',
        'cyrillic-name': 'ИксЭм3',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'SANTANA',
    name: 'Santana',
    'cyrillic-name': 'Сантана',
    popular: false,
    country: 'Испания',
    models: [
      {
        id: 'PS_10',
        name: 'PS-10',
        'cyrillic-name': 'пс-10',
        class: 'J',
        'year-from': 2003,
        'year-to': 2011,
      },
    ],
  },
  {
    id: 'SATURN',
    name: 'Saturn',
    'cyrillic-name': 'Сатурн',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'ASTRA',
        name: 'Astra',
        'cyrillic-name': 'астра',
        class: 'C',
        'year-from': 2008,
        'year-to': 2009,
      },
      {
        id: 'AURA',
        name: 'Aura',
        'cyrillic-name': 'Аура',
        class: 'E',
        'year-from': 2006,
        'year-to': 2010,
      },
      {
        id: 'ION',
        name: 'ION',
        'cyrillic-name': 'Ион',
        class: 'D',
        'year-from': 2003,
        'year-to': 2007,
      },
      {
        id: 'LS',
        name: 'LS',
        'cyrillic-name': 'лс',
        class: 'D',
        'year-from': 1998,
        'year-to': 2004,
      },
      {
        id: 'LW',
        name: 'LW',
        'cyrillic-name': 'лв',
        class: 'D',
        'year-from': 1998,
        'year-to': 2004,
      },
      {
        id: 'OUTLOOK',
        name: 'Outlook',
        'cyrillic-name': 'Аутлук',
        class: 'F',
        'year-from': 2006,
        'year-to': 2010,
      },
      {
        id: 'RELAY',
        name: 'Relay',
        'cyrillic-name': 'Релей',
        class: 'M',
        'year-from': 2005,
        'year-to': 2007,
      },
      {
        id: 'SC',
        name: 'SC',
        'cyrillic-name': 'сц',
        class: 'C',
        'year-from': 1990,
        'year-to': 2002,
      },
      {
        id: 'SKY',
        name: 'Sky',
        'cyrillic-name': 'Скай',
        class: 'B',
        'year-from': 2006,
        'year-to': 2009,
      },
      {
        id: 'SL',
        name: 'SL',
        'cyrillic-name': 'сл',
        class: 'C',
        'year-from': 1990,
        'year-to': 2002,
      },
      {
        id: 'SW',
        name: 'SW',
        'cyrillic-name': 'св',
        class: 'C',
        'year-from': 1993,
        'year-to': 2001,
      },
      {
        id: 'VUE',
        name: 'VUE',
        'cyrillic-name': 'Вью',
        class: 'C',
        'year-from': 2001,
        'year-to': 2009,
      },
    ],
  },
  {
    id: 'SCION',
    name: 'Scion',
    'cyrillic-name': 'Сайон',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'FR_S',
        name: 'FR-S',
        'cyrillic-name': 'фр-с',
        class: 'S',
        'year-from': 2012,
        'year-to': 2016,
      },
      {
        id: 'IA',
        name: 'iA',
        'cyrillic-name': 'айа',
        class: 'B',
        'year-from': 2015,
        'year-to': 2016,
      },
      {
        id: 'IM',
        name: 'iM',
        'cyrillic-name': 'айм',
        class: 'C',
        'year-from': 2015,
        'year-to': 2016,
      },
      {
        id: 'IQQ',
        name: 'iQ',
        'cyrillic-name': 'айку',
        class: 'A',
        'year-from': 2011,
        'year-to': 2016,
      },
      {
        id: 'TC',
        name: 'tC',
        'cyrillic-name': 'тс',
        class: 'S',
        'year-from': 2004,
        'year-to': 2016,
      },
      {
        id: 'XA',
        name: 'xA',
        'cyrillic-name': 'ха',
        class: 'B',
        'year-from': 2003,
        'year-to': 2006,
      },
      {
        id: 'XB',
        name: 'xB',
        'cyrillic-name': 'хб',
        class: 'M',
        'year-from': 2003,
        'year-to': 2015,
      },
      {
        id: 'XD',
        name: 'xD',
        'cyrillic-name': 'хд',
        class: 'B',
        'year-from': 2008,
        'year-to': 2014,
      },
    ],
  },
  {
    id: 'SEARS',
    name: 'Sears',
    'cyrillic-name': 'Сирс',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'MODEL_J',
        name: 'Model J',
        'cyrillic-name': 'Модел Джи',
        class: '',
        'year-from': 1908,
        'year-to': 1912,
      },
    ],
  },
  {
    id: 'SEAT',
    name: 'SEAT',
    'cyrillic-name': 'Сеат',
    popular: false,
    country: 'Испания',
    models: [
      {
        id: '133',
        name: '133',
        'cyrillic-name': '133',
        class: 'A',
        'year-from': 1974,
        'year-to': 1979,
      },
      {
        id: 'ALHAMBRA',
        name: 'Alhambra',
        'cyrillic-name': 'Альхамбра',
        class: 'M',
        'year-from': 1996,
        'year-to': 2020,
      },
      {
        id: 'ALTEA',
        name: 'Altea',
        'cyrillic-name': 'Альтеа',
        class: 'M',
        'year-from': 2004,
        'year-to': 2015,
      },
      {
        id: 'ARONA',
        name: 'Arona',
        'cyrillic-name': 'Арона',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'AROSA',
        name: 'Arosa',
        'cyrillic-name': 'Ароса',
        class: 'A',
        'year-from': 1997,
        'year-to': 2004,
      },
      {
        id: 'ATECA',
        name: 'Ateca',
        'cyrillic-name': 'Атека',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'CORDOBA',
        name: 'Cordoba',
        'cyrillic-name': 'Кордоба',
        class: 'C',
        'year-from': 1993,
        'year-to': 2009,
      },
      {
        id: 'EXEO',
        name: 'Exeo',
        'cyrillic-name': 'Эксео',
        class: 'D',
        'year-from': 2008,
        'year-to': 2013,
      },
      {
        id: 'FURA',
        name: 'Fura',
        'cyrillic-name': 'Фура',
        class: 'B',
        'year-from': 1982,
        'year-to': 1986,
      },
      {
        id: 'IBIZA',
        name: 'Ibiza',
        'cyrillic-name': 'Ибица',
        class: 'B',
        'year-from': 1984,
        'year-to': null,
      },
      {
        id: 'IBIZA_CUPRA',
        name: 'Ibiza Cupra',
        'cyrillic-name': 'Ибица Купра',
        class: 'B',
        'year-from': 1996,
        'year-to': 2018,
      },
      {
        id: 'INCA',
        name: 'Inca',
        'cyrillic-name': 'ИНКА',
        class: 'M',
        'year-from': 1995,
        'year-to': 2003,
      },
      {
        id: 'LEON',
        name: 'Leon',
        'cyrillic-name': 'Леон',
        class: 'C',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'LEON_CUPRA',
        name: 'Leon Cupra',
        'cyrillic-name': 'Леон Купра',
        class: 'C',
        'year-from': 1999,
        'year-to': 2020,
      },
      {
        id: 'MALAGA',
        name: 'Malaga',
        'cyrillic-name': 'Малага',
        class: 'C',
        'year-from': 1985,
        'year-to': 1993,
      },
      {
        id: 'MARBELLA',
        name: 'Marbella',
        'cyrillic-name': 'Марбелла',
        class: 'A',
        'year-from': 1986,
        'year-to': 1998,
      },
      {
        id: 'MII',
        name: 'Mii',
        'cyrillic-name': 'мии',
        class: 'A',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'RONDA',
        name: 'Ronda',
        'cyrillic-name': 'Ронда',
        class: 'B',
        'year-from': 1982,
        'year-to': 1988,
      },
      {
        id: 'TARRACO',
        name: 'Tarraco',
        'cyrillic-name': 'Таррако',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'TOLEDO',
        name: 'Toledo',
        'cyrillic-name': 'Толедо',
        class: 'B',
        'year-from': 1991,
        'year-to': 2019,
      },
    ],
  },
  {
    id: 'SERES',
    name: 'Seres',
    'cyrillic-name': 'Серес',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'SF5',
        name: 'SF5',
        'cyrillic-name': 'СФ5',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'SHANGHAI_MAPLE',
    name: 'Shanghai Maple',
    'cyrillic-name': 'Шанхай Мапл',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'C31',
        name: 'C31',
        'cyrillic-name': 'Ц31',
        class: 'B',
        'year-from': 2004,
        'year-to': 2009,
      },
      {
        id: 'C32',
        name: 'C32',
        'cyrillic-name': 'с32',
        class: 'C',
        'year-from': 2007,
        'year-to': 2010,
      },
      {
        id: 'C51',
        name: 'C51',
        'cyrillic-name': 'Ц51',
        class: 'C',
        'year-from': 2005,
        'year-to': 2009,
      },
      {
        id: 'C52',
        name: 'C52',
        'cyrillic-name': 'Ц52',
        class: 'C',
        'year-from': 2007,
        'year-to': 2010,
      },
      {
        id: 'C61',
        name: 'C61',
        'cyrillic-name': 'с61',
        class: 'C',
        'year-from': 2007,
        'year-to': 2010,
      },
      {
        id: 'C81',
        name: 'C81',
        'cyrillic-name': 'Ц81',
        class: 'C',
        'year-from': 2005,
        'year-to': 2010,
      },
    ],
  },
  {
    id: 'SHUANGHUAN',
    name: 'ShuangHuan',
    'cyrillic-name': 'Шунган',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'NOBLE',
        name: 'Noble',
        'cyrillic-name': 'Ноубл',
        class: 'A',
        'year-from': 2006,
        'year-to': 2016,
      },
      {
        id: 'SCEO',
        name: 'Sceo',
        'cyrillic-name': 'сцео',
        class: 'D',
        'year-from': 2006,
        'year-to': 2011,
      },
    ],
  },
  {
    id: 'SIMCA',
    name: 'Simca',
    'cyrillic-name': 'Симка',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: '1300_1500',
        name: '1300/1500',
        'cyrillic-name': '1300/1500',
        class: 'D',
        'year-from': 1963,
        'year-to': 1976,
      },
      {
        id: '1307',
        name: '1307',
        'cyrillic-name': '1307',
        class: 'D',
        'year-from': 1975,
        'year-to': 1979,
      },
    ],
  },
  {
    id: 'SKODA',
    name: 'Skoda',
    'cyrillic-name': 'Шкода',
    popular: true,
    country: 'Чехия',
    models: [
      {
        id: '100_SERIES',
        name: '100 Series',
        'cyrillic-name': '100 серия',
        class: 'C',
        'year-from': 1969,
        'year-to': 1991,
      },
      {
        id: '120',
        name: '105, 120',
        'cyrillic-name': '105, 120',
        class: 'B',
        'year-from': 1976,
        'year-to': 1990,
      },
      {
        id: '1200',
        name: '1200',
        'cyrillic-name': '1200',
        class: '',
        'year-from': 1952,
        'year-to': 1973,
      },
      {
        id: 'CITIGO',
        name: 'Citigo',
        'cyrillic-name': 'Ситиго',
        class: 'A',
        'year-from': 2011,
        'year-to': 2020,
      },
      {
        id: 'ENYAQ',
        name: 'Enyaq',
        'cyrillic-name': 'Эниак',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'ENYAQ_COUPE',
        name: 'Enyaq Coupe',
        'cyrillic-name': 'Эниак Купе',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'ENYAQ_COUPE_RS',
        name: 'Enyaq Coupe RS',
        'cyrillic-name': 'Эниак Купе РС',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'ENYAQ_RS',
        name: 'Enyaq RS',
        'cyrillic-name': 'Эниак РС',
        class: 'C',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'FABIA',
        name: 'Fabia',
        'cyrillic-name': 'Фабия',
        class: 'B',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'FABIA_RS',
        name: 'Fabia RS',
        'cyrillic-name': 'Фабия РС',
        class: 'B',
        'year-from': 2003,
        'year-to': 2014,
      },
      {
        id: 'FAVORIT',
        name: 'Favorit',
        'cyrillic-name': 'Фаворит',
        class: 'B',
        'year-from': 1989,
        'year-to': 2000,
      },
      {
        id: 'FELICIA',
        name: 'Felicia',
        'cyrillic-name': 'Фелиция',
        class: 'B',
        'year-from': 1959,
        'year-to': 2001,
      },
      {
        id: 'FORMAN',
        name: 'Forman',
        'cyrillic-name': 'форман',
        class: 'C',
        'year-from': 1990,
        'year-to': 1995,
      },
      {
        id: 'KAMIQ',
        name: 'Kamiq',
        'cyrillic-name': 'Камик',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'KAROQ',
        name: 'Karoq',
        'cyrillic-name': 'Карок',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'KODIAQ',
        name: 'Kodiaq',
        'cyrillic-name': 'Кодиак',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'KODIAQ_RS',
        name: 'Kodiaq RS',
        'cyrillic-name': 'Кодиак РС',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'OCTAVIA',
        name: 'Octavia',
        'cyrillic-name': 'Октавия',
        class: 'C',
        'year-from': 1959,
        'year-to': null,
      },
      {
        id: 'OCTAVIA_RS',
        name: 'Octavia RS',
        'cyrillic-name': 'Октавия РС',
        class: 'C',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'POPULAR',
        name: 'Popular',
        'cyrillic-name': 'популяр',
        class: '',
        'year-from': 1934,
        'year-to': 1946,
      },
      {
        id: 'RAPID',
        name: 'Rapid',
        'cyrillic-name': 'Рапид',
        class: 'B',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'ROOMSTER',
        name: 'Roomster',
        'cyrillic-name': 'Румстер',
        class: 'M',
        'year-from': 2006,
        'year-to': 2015,
      },
      {
        id: 'SCALA',
        name: 'Scala',
        'cyrillic-name': 'Скала',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'SUPERB',
        name: 'Superb',
        'cyrillic-name': 'Суперб',
        class: 'D',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'YETI',
        name: 'Yeti',
        'cyrillic-name': 'Йети',
        class: 'B',
        'year-from': 2009,
        'year-to': 2018,
      },
    ],
  },
  {
    id: 'SKYWELL',
    name: 'Skywell',
    'cyrillic-name': 'Скайвэлл',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'ET5',
        name: 'ET5',
        'cyrillic-name': 'ЕТ5',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'SMART',
    name: 'Smart',
    'cyrillic-name': 'Смарт',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'FORFOUR',
        name: 'Forfour',
        'cyrillic-name': 'Фофо',
        class: 'A',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'FORTWO',
        name: 'Fortwo',
        'cyrillic-name': 'Фоту',
        class: 'A',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'ROADSTER',
        name: 'Roadster',
        'cyrillic-name': 'роадстер',
        class: 'A',
        'year-from': 2002,
        'year-to': 2006,
      },
    ],
  },
  {
    id: 'SMZ',
    name: 'СМЗ',
    'cyrillic-name': 'СМЗ',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'S1L',
        name: 'С-1Л',
        'cyrillic-name': 'с-1л',
        class: 'A',
        'year-from': 1952,
        'year-to': 1956,
      },
      {
        id: 'S3A',
        name: 'С-3А',
        'cyrillic-name': 'с-3а',
        class: 'A',
        'year-from': 1958,
        'year-to': 1970,
      },
      {
        id: 'S3D',
        name: 'С-3Д',
        'cyrillic-name': 'с-3д',
        class: 'A',
        'year-from': 1970,
        'year-to': 1997,
      },
      {
        id: 'S3L',
        name: 'С-3Л',
        'cyrillic-name': 'с-3л',
        class: 'A',
        'year-from': 1956,
        'year-to': 1958,
      },
    ],
  },
  {
    id: 'SOUEAST',
    name: 'Soueast',
    'cyrillic-name': 'Соуист',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'LIONCEL',
        name: 'Lioncel',
        'cyrillic-name': 'лайонсел',
        class: 'B',
        'year-from': 2005,
        'year-to': 2010,
      },
    ],
  },
  {
    id: 'SPECTRE',
    name: 'Spectre',
    'cyrillic-name': 'Спектр',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'R42',
        name: 'R42',
        'cyrillic-name': 'р42',
        class: 'S',
        'year-from': 1996,
        'year-to': 1997,
      },
    ],
  },
  {
    id: 'SPYKER',
    name: 'Spyker',
    'cyrillic-name': 'Спайкер',
    popular: false,
    country: 'Дания',
    models: [
      {
        id: 'C12',
        name: 'C12',
        'cyrillic-name': 'с12',
        class: 'S',
        'year-from': 2006,
        'year-to': 2008,
      },
      {
        id: 'C8',
        name: 'C8',
        'cyrillic-name': 'с8',
        class: 'S',
        'year-from': 2001,
        'year-to': null,
      },
    ],
  },
  {
    id: 'SSANG_YONG',
    name: 'SsangYong',
    'cyrillic-name': 'Ссанъён',
    popular: false,
    country: 'Южная Корея',
    models: [
      {
        id: 'ACTYON',
        name: 'Actyon',
        'cyrillic-name': 'Актион',
        class: 'C',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'ACTYON_SPORT',
        name: 'Actyon Sports',
        'cyrillic-name': 'Актион Спортс',
        class: 'J',
        'year-from': 2006,
        'year-to': 2016,
      },
      {
        id: 'CHAIRMAN',
        name: 'Chairman',
        'cyrillic-name': 'Чиамэн',
        class: 'F',
        'year-from': 1997,
        'year-to': 2017,
      },
      {
        id: 'ISTANA',
        name: 'Istana',
        'cyrillic-name': 'истана',
        class: 'M',
        'year-from': 1995,
        'year-to': 2003,
      },
      {
        id: 'KALLISTA',
        name: 'Kallista',
        'cyrillic-name': 'Калиста',
        class: 'S',
        'year-from': 1992,
        'year-to': 1994,
      },
      {
        id: 'KORANDO',
        name: 'Korando',
        'cyrillic-name': 'Корандо',
        class: 'C',
        'year-from': 1988,
        'year-to': null,
      },
      {
        id: 'KORANDO_FAMILY',
        name: 'Korando Family',
        'cyrillic-name': 'Корандо Фэмили',
        class: 'J',
        'year-from': 1987,
        'year-to': 1998,
      },
      {
        id: 'KORANDO_SPORTS',
        name: 'Korando Sports',
        'cyrillic-name': 'Корандо Спортс',
        class: 'J',
        'year-from': 2011,
        'year-to': 2017,
      },
      {
        id: 'KORANDO_TURISMO',
        name: 'Korando Turismo',
        'cyrillic-name': 'корандо туризмо',
        class: 'M',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'KYRON',
        name: 'Kyron',
        'cyrillic-name': 'Кайрон',
        class: 'J',
        'year-from': 2005,
        'year-to': 2015,
      },
      {
        id: 'MUSSO',
        name: 'Musso',
        'cyrillic-name': 'Муссо',
        class: 'J',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'NOMAD',
        name: 'Nomad',
        'cyrillic-name': 'Номад',
        class: 'J',
        'year-from': 2013,
        'year-to': 2017,
      },
      {
        id: 'REXTON',
        name: 'Rexton',
        'cyrillic-name': 'Рекстон',
        class: 'J',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'REXTON_SPORTS',
        name: 'Rexton Sports',
        'cyrillic-name': 'Рекстон Спортс',
        class: 'J',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'RODIUS',
        name: 'Rodius',
        'cyrillic-name': 'Родиус',
        class: 'M',
        'year-from': 2004,
        'year-to': 2019,
      },
      {
        id: 'STAVIC',
        name: 'Stavic',
        'cyrillic-name': 'Ставик',
        class: 'M',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'TIVOLI',
        name: 'Tivoli',
        'cyrillic-name': 'Тиволи',
        class: 'B',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'TORRES',
        name: 'Torres',
        'cyrillic-name': 'Торрес',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'TIVOLI_XLV',
        name: 'XLV',
        'cyrillic-name': 'ХЛВ',
        class: 'C',
        'year-from': 2016,
        'year-to': null,
      },
    ],
  },
  {
    id: 'STEYR',
    name: 'Steyr',
    'cyrillic-name': 'Штайр',
    popular: false,
    country: 'Австрия',
    models: [
      {
        id: '1500',
        name: '1500',
        'cyrillic-name': '1500',
        class: 'J',
        'year-from': 1941,
        'year-to': 1944,
      },
    ],
  },
  {
    id: 'STUDEBAKER',
    name: 'Studebaker',
    'cyrillic-name': 'Студебейкер',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'GOLDEN_HAWK',
        name: 'Golden Hawk',
        'cyrillic-name': 'Голден Хоук',
        class: 'E',
        'year-from': 1956,
        'year-to': 1958,
      },
    ],
  },
  {
    id: 'SUBARU',
    name: 'Subaru',
    'cyrillic-name': 'Субару',
    popular: true,
    country: 'Япония',
    models: [
      {
        id: '1000',
        name: '1000',
        'cyrillic-name': '1000',
        class: 'B',
        'year-from': 1965,
        'year-to': 1969,
      },
      {
        id: '360',
        name: '360',
        'cyrillic-name': '360',
        class: 'A',
        'year-from': 1958,
        'year-to': 1971,
      },
      {
        id: 'ALCYONE',
        name: 'Alcyone',
        'cyrillic-name': 'Альциона',
        class: 'D',
        'year-from': 1985,
        'year-to': 1996,
      },
      {
        id: 'ASCENT',
        name: 'Ascent',
        'cyrillic-name': 'асцент',
        class: 'E',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'BAJA',
        name: 'Baja',
        'cyrillic-name': 'Байя',
        class: 'D',
        'year-from': 2002,
        'year-to': 2006,
      },
      {
        id: 'BIGHORN',
        name: 'Bighorn',
        'cyrillic-name': 'бигхорн',
        class: 'J',
        'year-from': 1990,
        'year-to': 1992,
      },
      {
        id: 'BISTRO',
        name: 'Bistro',
        'cyrillic-name': 'бистро',
        class: 'A',
        'year-from': 1995,
        'year-to': 1998,
      },
      {
        id: 'BRAT',
        name: 'Brat',
        'cyrillic-name': 'брат',
        class: 'J',
        'year-from': 1978,
        'year-to': 1994,
      },
      {
        id: 'BRZ',
        name: 'BRZ',
        'cyrillic-name': 'брз',
        class: 'S',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'CROSSTREK',
        name: 'Crosstrek',
        'cyrillic-name': 'Кросстрек',
        class: 'C',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'DEX',
        name: 'Dex',
        'cyrillic-name': 'Декс',
        class: 'B',
        'year-from': 2008,
        'year-to': 2010,
      },
      {
        id: 'DIAS_WAGON',
        name: 'Dias Wagon',
        'cyrillic-name': 'диас вагон',
        class: 'M',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'DOMINGO',
        name: 'Domingo',
        'cyrillic-name': 'Доминго',
        class: 'M',
        'year-from': 1983,
        'year-to': 1998,
      },
      {
        id: 'EXIGA',
        name: 'Exiga',
        'cyrillic-name': 'Эксига',
        class: 'D',
        'year-from': 2008,
        'year-to': 2018,
      },
      {
        id: 'FORESTER',
        name: 'Forester',
        'cyrillic-name': 'Форестер',
        class: 'D',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'IMPREZA',
        name: 'Impreza',
        'cyrillic-name': 'Импреза',
        class: 'C',
        'year-from': 1992,
        'year-to': null,
      },
      {
        id: 'IMPREZA_WRX',
        name: 'Impreza WRX',
        'cyrillic-name': 'импреза вркс',
        class: 'C',
        'year-from': 1992,
        'year-to': 2014,
      },
      {
        id: 'IMPREZA_WRX_STI',
        name: 'Impreza WRX STi',
        'cyrillic-name': 'импреза врх сти',
        class: 'C',
        'year-from': 1994,
        'year-to': 2014,
      },
      {
        id: 'JUSTY',
        name: 'Justy',
        'cyrillic-name': 'Джасти',
        class: 'M',
        'year-from': 1984,
        'year-to': null,
      },
      {
        id: 'LEGACY',
        name: 'Legacy',
        'cyrillic-name': 'Легаси',
        class: 'D',
        'year-from': 1989,
        'year-to': null,
      },
      {
        id: 'LEGACY_LANCASTER',
        name: 'Legacy Lancaster',
        'cyrillic-name': 'Легаси Ланкастер',
        class: 'D',
        'year-from': 1995,
        'year-to': 2003,
      },
      {
        id: 'LEONE',
        name: 'Leone',
        'cyrillic-name': 'Леон',
        class: 'C',
        'year-from': 1979,
        'year-to': 1994,
      },
      {
        id: 'LEVORG',
        name: 'Levorg',
        'cyrillic-name': 'Леворг',
        class: 'D',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'LIBERO',
        name: 'Libero',
        'cyrillic-name': 'Либеро',
        class: 'M',
        'year-from': 1984,
        'year-to': 1998,
      },
      {
        id: 'LUCRA',
        name: 'Lucra',
        'cyrillic-name': 'Лукра',
        class: 'A',
        'year-from': 2010,
        'year-to': 2015,
      },
      {
        id: 'OUTBACK',
        name: 'Outback',
        'cyrillic-name': 'Аутбек',
        class: 'D',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'PLEO',
        name: 'Pleo',
        'cyrillic-name': 'Плео',
        class: 'A',
        'year-from': 1998,
        'year-to': 2018,
      },
      {
        id: 'PLEO_PLUS',
        name: 'Pleo Plus',
        'cyrillic-name': 'Плео Плюс',
        class: 'A',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'R1',
        name: 'R1',
        'cyrillic-name': 'р1',
        class: 'A',
        'year-from': 2005,
        'year-to': 2010,
      },
      {
        id: 'R2',
        name: 'R2',
        'cyrillic-name': 'р2',
        class: 'A',
        'year-from': 2003,
        'year-to': 2010,
      },
      {
        id: 'REX',
        name: 'Rex',
        'cyrillic-name': 'рекс',
        class: 'A',
        'year-from': 1972,
        'year-to': 1992,
      },
      {
        id: 'SAMBAR',
        name: 'Sambar',
        'cyrillic-name': 'Самбар',
        class: 'M',
        'year-from': 1990,
        'year-to': null,
      },
      {
        id: 'SOLTERRA',
        name: 'Solterra',
        'cyrillic-name': 'Солтерра',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'STELLA',
        name: 'Stella',
        'cyrillic-name': 'Стелла',
        class: 'M',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'SVX',
        name: 'SVX',
        'cyrillic-name': 'свкс',
        class: 'D',
        'year-from': 1991,
        'year-to': 1997,
      },
      {
        id: 'TRAVIQ',
        name: 'Traviq',
        'cyrillic-name': 'Трэвик',
        class: 'M',
        'year-from': 2001,
        'year-to': 2004,
      },
      {
        id: 'TREZIA',
        name: 'Trezia',
        'cyrillic-name': 'Трэзия',
        class: 'B',
        'year-from': 2010,
        'year-to': 2016,
      },
      {
        id: 'B9_TRIBECA',
        name: 'Tribeca',
        'cyrillic-name': 'Трибека',
        class: 'E',
        'year-from': 2004,
        'year-to': 2014,
      },
      {
        id: 'VIVIO',
        name: 'Vivio',
        'cyrillic-name': 'Вивио',
        class: 'A',
        'year-from': 1992,
        'year-to': 1998,
      },
      {
        id: 'WRX',
        name: 'WRX',
        'cyrillic-name': 'вркс',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'WRX_STI',
        name: 'WRX STi',
        'cyrillic-name': 'вркс сти',
        class: 'C',
        'year-from': 2014,
        'year-to': 2021,
      },
      {
        id: 'XT',
        name: 'XT',
        'cyrillic-name': 'кст',
        class: 'S',
        'year-from': 1987,
        'year-to': 1992,
      },
      {
        id: 'XV',
        name: 'XV',
        'cyrillic-name': 'ксв',
        class: 'C',
        'year-from': 2011,
        'year-to': null,
      },
    ],
  },
  {
    id: 'SUZUKI',
    name: 'Suzuki',
    'cyrillic-name': 'Сузуки',
    popular: true,
    country: 'Япония',
    models: [
      {
        id: 'ACROSS',
        name: 'Across',
        'cyrillic-name': 'Акросс',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'AERIO',
        name: 'Aerio',
        'cyrillic-name': 'Аэрио',
        class: 'C',
        'year-from': 2001,
        'year-to': 2007,
      },
      {
        id: 'ALTO',
        name: 'Alto',
        'cyrillic-name': 'Альто',
        class: 'A',
        'year-from': 1979,
        'year-to': null,
      },
      {
        id: 'ALTO_LAPIN',
        name: 'Alto Lapin',
        'cyrillic-name': 'альто лапин',
        class: 'A',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'APV',
        name: 'APV',
        'cyrillic-name': 'АПВ',
        class: 'M',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'BALENO',
        name: 'Baleno',
        'cyrillic-name': 'Балено',
        class: 'B',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'CAPPUCCINO',
        name: 'Cappuccino',
        'cyrillic-name': 'Каппучино',
        class: 'A',
        'year-from': 1990,
        'year-to': 1997,
      },
      {
        id: 'CARA',
        name: 'Cara',
        'cyrillic-name': 'кара',
        class: 'S',
        'year-from': 1993,
        'year-to': 1995,
      },
      {
        id: 'CARRY',
        name: 'Carry',
        'cyrillic-name': 'карри',
        class: 'M',
        'year-from': 1979,
        'year-to': 1998,
      },
      {
        id: 'CELERIO',
        name: 'Celerio',
        'cyrillic-name': 'Целерио',
        class: 'A',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'CERVO_CLASSIC',
        name: 'Cervo',
        'cyrillic-name': 'Серво',
        class: 'A',
        'year-from': 1977,
        'year-to': 2011,
      },
      {
        id: 'CIAZ',
        name: 'Ciaz',
        'cyrillic-name': 'Циаз',
        class: 'B',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'CULTUS',
        name: 'Cultus',
        'cyrillic-name': 'Культус',
        class: 'C',
        'year-from': 1983,
        'year-to': 2002,
      },
      {
        id: 'DZIRE',
        name: 'DZire',
        'cyrillic-name': 'ДЗайр',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'EQUATOR',
        name: 'Equator',
        'cyrillic-name': 'Экватор',
        class: 'J',
        'year-from': 2008,
        'year-to': 2012,
      },
      {
        id: 'ERTIGA',
        name: 'Ertiga',
        'cyrillic-name': 'Эртига',
        class: 'M',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'ESCUDO',
        name: 'Escudo',
        'cyrillic-name': 'Эскудо',
        class: 'B',
        'year-from': 1988,
        'year-to': null,
      },
      {
        id: 'ESTEEM',
        name: 'Esteem',
        'cyrillic-name': 'эстим',
        class: 'C',
        'year-from': 1995,
        'year-to': 2004,
      },
      {
        id: 'EVERY',
        name: 'Every',
        'cyrillic-name': 'Эвери',
        class: 'M',
        'year-from': 1985,
        'year-to': null,
      },
      {
        id: 'FORENZA',
        name: 'Forenza',
        'cyrillic-name': 'форенза',
        class: 'C',
        'year-from': 2003,
        'year-to': 2008,
      },
      {
        id: 'FRONTE',
        name: 'Fronte',
        'cyrillic-name': 'Фронт',
        class: 'A',
        'year-from': 1986,
        'year-to': 1988,
      },
      {
        id: 'GRAND_VITARA',
        name: 'Grand Vitara',
        'cyrillic-name': 'Гранд Витара',
        class: 'J',
        'year-from': 1997,
        'year-to': 2015,
      },
      {
        id: 'HUSTLER',
        name: 'Hustler',
        'cyrillic-name': 'Хастлер',
        class: 'A',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'IGNIS',
        name: 'Ignis',
        'cyrillic-name': 'Игнис',
        class: 'B',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'JIMNY',
        name: 'Jimny',
        'cyrillic-name': 'Джимни',
        class: 'J',
        'year-from': 1970,
        'year-to': null,
      },
      {
        id: 'KEI',
        name: 'Kei',
        'cyrillic-name': 'Кей',
        class: 'A',
        'year-from': 1998,
        'year-to': 2009,
      },
      {
        id: 'KIZASHI',
        name: 'Kizashi',
        'cyrillic-name': 'Кизаши',
        class: 'D',
        'year-from': 2009,
        'year-to': 2014,
      },
      {
        id: 'LANDY',
        name: 'Landy',
        'cyrillic-name': 'Лэнди',
        class: 'M',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'LIANA',
        name: 'Liana',
        'cyrillic-name': 'Лиана',
        class: 'C',
        'year-from': 2001,
        'year-to': 2008,
      },
      {
        id: 'MR_WAGON',
        name: 'MR Wagon',
        'cyrillic-name': 'Мр Вагон',
        class: 'M',
        'year-from': 2001,
        'year-to': 2016,
      },
      {
        id: 'PALETTE',
        name: 'Palette',
        'cyrillic-name': 'Палетт',
        class: 'M',
        'year-from': 2008,
        'year-to': 2013,
      },
      {
        id: 'RENO',
        name: 'Reno',
        'cyrillic-name': 'Рено',
        class: 'C',
        'year-from': 2004,
        'year-to': 2008,
      },
      {
        id: 'S_PRESSO',
        name: 'S-Presso',
        'cyrillic-name': 'Эс-Прессо',
        class: 'A',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'SAMURAI',
        name: 'Samurai',
        'cyrillic-name': 'Самурай',
        class: 'J',
        'year-from': 1981,
        'year-to': 2003,
      },
      {
        id: 'SIDEKICK',
        name: 'Sidekick',
        'cyrillic-name': 'Сайдкик',
        class: 'J',
        'year-from': 1988,
        'year-to': 1998,
      },
      {
        id: 'SOLIO',
        name: 'Solio',
        'cyrillic-name': 'Солио',
        class: 'M',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'SPACIA',
        name: 'Spacia',
        'cyrillic-name': 'Спасиа',
        class: 'A',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'SPLASH',
        name: 'Splash',
        'cyrillic-name': 'Сплэш',
        class: 'A',
        'year-from': 2008,
        'year-to': 2015,
      },
      {
        id: 'SWACE',
        name: 'Swace',
        'cyrillic-name': 'Свайс',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'SWIFT',
        name: 'Swift',
        'cyrillic-name': 'Свифт',
        class: 'B',
        'year-from': 1983,
        'year-to': null,
      },
      {
        id: 'SX4',
        name: 'SX4',
        'cyrillic-name': 'скс4',
        class: 'B',
        'year-from': 2006,
        'year-to': 2022,
      },
      {
        id: 'TWIN',
        name: 'Twin',
        'cyrillic-name': 'Твин',
        class: 'A',
        'year-from': 2003,
        'year-to': 2005,
      },
      {
        id: 'VERONA',
        name: 'Verona',
        'cyrillic-name': 'Верона',
        class: 'D',
        'year-from': 2003,
        'year-to': 2006,
      },
      {
        id: 'VITARA',
        name: 'Vitara',
        'cyrillic-name': 'Витара',
        class: 'B',
        'year-from': 1988,
        'year-to': null,
      },
      {
        id: 'WAGON_R',
        name: 'Wagon R',
        'cyrillic-name': 'Вагон Р',
        class: 'A',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'WAGON_R_PLUS',
        name: 'Wagon R+',
        'cyrillic-name': 'Вагон Р+',
        class: 'M',
        'year-from': 1997,
        'year-to': 2008,
      },
      {
        id: 'X_90',
        name: 'X-90',
        'cyrillic-name': 'кс-90',
        class: 'A',
        'year-from': 1995,
        'year-to': 2000,
      },
      {
        id: 'XBEE',
        name: 'Xbee',
        'cyrillic-name': 'Иксби',
        class: 'A',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'XL_7',
        name: 'XL7',
        'cyrillic-name': 'ксл7',
        class: 'E',
        'year-from': 2007,
        'year-to': 2009,
      },
    ],
  },
  {
    id: 'TAGAZ',
    name: 'ТагАЗ',
    'cyrillic-name': 'ТагАЗ',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'AQUILA',
        name: 'Aquila',
        'cyrillic-name': 'Аквила',
        class: 'C',
        'year-from': 2012,
        'year-to': 2014,
      },
      {
        id: 'C30',
        name: 'C-30',
        'cyrillic-name': 'с-30',
        class: 'C',
        'year-from': 2011,
        'year-to': 2011,
      },
      {
        id: 'C10',
        name: 'C10',
        'cyrillic-name': 'с10',
        class: 'B',
        'year-from': 2011,
        'year-to': 2013,
      },
      {
        id: 'C190',
        name: 'C190',
        'cyrillic-name': 'с190',
        class: 'C',
        'year-from': 2011,
        'year-to': 2013,
      },
      {
        id: 'ROAD_PARTNER',
        name: 'Road Partner',
        'cyrillic-name': 'Роуд Партнер',
        class: 'J',
        'year-from': 2008,
        'year-to': 2011,
      },
      {
        id: 'TAGER',
        name: 'Tager',
        'cyrillic-name': 'Тагер',
        class: 'J',
        'year-from': 2008,
        'year-to': 2012,
      },
      {
        id: 'C_100',
        name: 'Vega',
        'cyrillic-name': 'Вега',
        class: 'C',
        'year-from': 2009,
        'year-to': 2010,
      },
    ],
  },
  {
    id: 'TALBOT',
    name: 'Talbot',
    'cyrillic-name': 'Толбет',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '1510',
        name: '1510',
        'cyrillic-name': '1510',
        class: 'D',
        'year-from': 1980,
        'year-to': 1984,
      },
      {
        id: 'AVENGER',
        name: 'Avenger',
        'cyrillic-name': 'Эвенджер',
        class: 'C',
        'year-from': 1970,
        'year-to': 1981,
      },
      {
        id: 'HORIZON',
        name: 'Horizon',
        'cyrillic-name': 'Горизон',
        class: 'B',
        'year-from': 1978,
        'year-to': 1986,
      },
      {
        id: 'RANCHO',
        name: 'Rancho',
        'cyrillic-name': 'ранчо',
        class: 'J',
        'year-from': 1977,
        'year-to': 1984,
      },
      {
        id: 'SAMBA',
        name: 'Samba',
        'cyrillic-name': 'Самба',
        class: 'B',
        'year-from': 1981,
        'year-to': 1986,
      },
      {
        id: 'SOLARA',
        name: 'Solara',
        'cyrillic-name': 'Солара',
        class: 'D',
        'year-from': 1980,
        'year-to': 1986,
      },
      {
        id: 'TAGORA',
        name: 'Tagora',
        'cyrillic-name': 'Тагора',
        class: 'E',
        'year-from': 1980,
        'year-to': 1987,
      },
    ],
  },
  {
    id: 'TANK',
    name: 'Tank',
    'cyrillic-name': 'Танк',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: '300',
        name: '300',
        'cyrillic-name': '300',
        class: 'J',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: '500',
        name: '500',
        'cyrillic-name': '500',
        class: 'J',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'TATA',
    name: 'TATA',
    'cyrillic-name': 'ТАТА',
    popular: false,
    country: 'Индия',
    models: [
      {
        id: 'ARIA',
        name: 'Aria',
        'cyrillic-name': 'Ария',
        class: 'D',
        'year-from': 2010,
        'year-to': 2017,
      },
      {
        id: 'ESTATE',
        name: 'Estate',
        'cyrillic-name': 'Эстейт',
        class: 'C',
        'year-from': 1993,
        'year-to': 2000,
      },
      {
        id: 'INDICA',
        name: 'Indica',
        'cyrillic-name': 'Индика',
        class: 'B',
        'year-from': 1998,
        'year-to': 2018,
      },
      {
        id: 'INDIGO',
        name: 'Indigo',
        'cyrillic-name': 'Индиго',
        class: 'C',
        'year-from': 2002,
        'year-to': 2016,
      },
      {
        id: 'NANO',
        name: 'Nano',
        'cyrillic-name': 'Нано',
        class: 'A',
        'year-from': 2008,
        'year-to': 2018,
      },
      {
        id: 'SAFARI',
        name: 'Safari',
        'cyrillic-name': 'Сафари',
        class: 'J',
        'year-from': 1998,
        'year-to': 2019,
      },
      {
        id: 'SIERRA',
        name: 'Sierra',
        'cyrillic-name': 'Сьерра',
        class: 'J',
        'year-from': 1993,
        'year-to': 2001,
      },
      {
        id: 'SUMO',
        name: 'Sumo',
        'cyrillic-name': 'Сумо',
        class: 'J',
        'year-from': 1996,
        'year-to': 2004,
      },
      {
        id: 'SUMO_GRANDE',
        name: 'Sumo Grande',
        'cyrillic-name': 'сумо гранде',
        class: 'J',
        'year-from': 2008,
        'year-to': 2016,
      },
      {
        id: 'TELCOLINE',
        name: 'Telcoline',
        'cyrillic-name': 'Тэлколайн',
        class: 'J',
        'year-from': 2005,
        'year-to': 2007,
      },
      {
        id: 'XENON',
        name: 'Xenon',
        'cyrillic-name': 'Ксенон',
        class: 'J',
        'year-from': 2007,
        'year-to': null,
      },
    ],
  },
  {
    id: 'TATRA',
    name: 'Tatra',
    'cyrillic-name': 'Татра',
    popular: false,
    country: 'Чехия',
    models: [
      {
        id: '57',
        name: '57',
        'cyrillic-name': '57',
        class: '',
        'year-from': 1932,
        'year-to': 1949,
      },
      {
        id: '77',
        name: '77',
        'cyrillic-name': '77',
        class: '',
        'year-from': 1934,
        'year-to': 1938,
      },
      {
        id: '80',
        name: '80',
        'cyrillic-name': '80',
        class: '',
        'year-from': 1931,
        'year-to': 1935,
      },
      {
        id: '87',
        name: '87',
        'cyrillic-name': '87',
        class: '',
        'year-from': 1936,
        'year-to': 1950,
      },
      {
        id: 'T600',
        name: 'T600',
        'cyrillic-name': 'т600',
        class: 'D',
        'year-from': 1946,
        'year-to': 1952,
      },
      {
        id: 'T603',
        name: 'T603',
        'cyrillic-name': 'т603',
        class: 'F',
        'year-from': 1956,
        'year-to': 1975,
      },
      {
        id: 'T613',
        name: 'T613',
        'cyrillic-name': 'т613',
        class: 'E',
        'year-from': 1973,
        'year-to': 1996,
      },
      {
        id: 'T700',
        name: 'T700',
        'cyrillic-name': 'т700',
        class: 'E',
        'year-from': 1996,
        'year-to': 1999,
      },
    ],
  },
  {
    id: 'TAZZARI',
    name: 'Tazzari',
    'cyrillic-name': 'Таззари',
    popular: false,
    country: 'Италия',
    models: [
      {
        id: 'ZERO',
        name: 'Zero',
        'cyrillic-name': 'зеро',
        class: 'A',
        'year-from': 2009,
        'year-to': null,
      },
    ],
  },
  {
    id: 'TESLA',
    name: 'Tesla',
    'cyrillic-name': 'Тесла',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'CYBERTRUCK',
        name: 'Cybertruck',
        'cyrillic-name': 'Кибертрак',
        class: 'J',
        'year-from': 2021,
        'year-to': 2021,
      },
      {
        id: 'MODEL_3',
        name: 'Model 3',
        'cyrillic-name': 'Модел 3',
        class: 'D',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'MODEL_S',
        name: 'Model S',
        'cyrillic-name': 'модел с',
        class: 'F',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'MODEL_X',
        name: 'Model X',
        'cyrillic-name': 'Модел Х',
        class: 'E',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'MODEL_Y',
        name: 'Model Y',
        'cyrillic-name': 'модел ы',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'ROADSTER',
        name: 'Roadster',
        'cyrillic-name': 'Родстер',
        class: 'S',
        'year-from': 2008,
        'year-to': 2017,
      },
    ],
  },
  {
    id: 'THINK',
    name: 'Think',
    'cyrillic-name': 'Синк',
    popular: false,
    country: 'Норвегия',
    models: [
      {
        id: 'CITY',
        name: 'City',
        'cyrillic-name': 'Сити',
        class: 'A',
        'year-from': 2008,
        'year-to': 2012,
      },
    ],
  },
  {
    id: 'TIANMA',
    name: 'Tianma',
    'cyrillic-name': 'Тианма',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'CENTURY',
        name: 'Century',
        'cyrillic-name': 'центури',
        class: 'J',
        'year-from': 2005,
        'year-to': 2008,
      },
      {
        id: 'DRAGON',
        name: 'Dragon',
        'cyrillic-name': 'Драгон',
        class: 'J',
        'year-from': 2005,
        'year-to': 2015,
      },
    ],
  },
  {
    id: 'TIANYE',
    name: 'Tianye',
    'cyrillic-name': 'Тианье',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'ADMIRAL',
        name: 'Admiral',
        'cyrillic-name': 'адмирал',
        class: 'J',
        'year-from': 2001,
        'year-to': 2007,
      },
    ],
  },
  {
    id: 'TOFAS',
    name: 'Tofas',
    'cyrillic-name': 'Тофаш',
    popular: false,
    country: 'Турция',
    models: [
      {
        id: 'KARTAL',
        name: 'Kartal',
        'cyrillic-name': 'Картал',
        class: 'B',
        'year-from': 1985,
        'year-to': 2003,
      },
      {
        id: 'MURAT_124',
        name: 'Murat 124',
        'cyrillic-name': 'Мурат 124',
        class: 'B',
        'year-from': 1971,
        'year-to': 1977,
      },
      {
        id: 'MURAT_131',
        name: 'Murat 131',
        'cyrillic-name': 'Мурат 131',
        class: 'C',
        'year-from': 1985,
        'year-to': 1995,
      },
      {
        id: 'SAHIN',
        name: 'Sahin',
        'cyrillic-name': 'сахин',
        class: 'B',
        'year-from': 1990,
        'year-to': 2002,
      },
      {
        id: 'SERCE',
        name: 'Serce',
        'cyrillic-name': 'серсе',
        class: 'B',
        'year-from': 1985,
        'year-to': 1996,
      },
    ],
  },
  {
    id: 'TOYOTA',
    name: 'Toyota',
    'cyrillic-name': 'Тойота',
    popular: true,
    country: 'Япония',
    models: [
      {
        id: '2000GT',
        name: '2000GT',
        'cyrillic-name': '2000гт',
        class: 'S',
        'year-from': 1967,
        'year-to': 1970,
      },
      {
        id: '4RUNNER',
        name: '4Runner',
        'cyrillic-name': 'Фораннер',
        class: 'J',
        'year-from': 1984,
        'year-to': null,
      },
      {
        id: 'ALLEX',
        name: 'Allex',
        'cyrillic-name': 'Аллекс',
        class: 'C',
        'year-from': 2001,
        'year-to': 2006,
      },
      {
        id: 'ALLION',
        name: 'Allion',
        'cyrillic-name': 'Аллион',
        class: 'D',
        'year-from': 2001,
        'year-to': 2021,
      },
      {
        id: 'ALPHARD',
        name: 'Alphard',
        'cyrillic-name': 'Альфард',
        class: 'M',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'ALTEZZA',
        name: 'Altezza',
        'cyrillic-name': 'Альтеза',
        class: 'D',
        'year-from': 1998,
        'year-to': 2005,
      },
      {
        id: 'AQUA',
        name: 'Aqua',
        'cyrillic-name': 'Аква',
        class: 'B',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'ARISTO',
        name: 'Aristo',
        'cyrillic-name': 'Аристо',
        class: 'E',
        'year-from': 1991,
        'year-to': 2004,
      },
      {
        id: 'AURION',
        name: 'Aurion',
        'cyrillic-name': 'Аурион',
        class: 'E',
        'year-from': 2006,
        'year-to': 2017,
      },
      {
        id: 'AURIS',
        name: 'Auris',
        'cyrillic-name': 'Аурис',
        class: 'C',
        'year-from': 2006,
        'year-to': 2018,
      },
      {
        id: 'AVALON',
        name: 'Avalon',
        'cyrillic-name': 'Авалон',
        class: 'E',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'AVANZA',
        name: 'Avanza',
        'cyrillic-name': 'аванза',
        class: 'M',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'AVENSIS',
        name: 'Avensis',
        'cyrillic-name': 'Авенсис',
        class: 'D',
        'year-from': 1997,
        'year-to': 2018,
      },
      {
        id: 'AVENSIS_VERSO',
        name: 'Avensis Verso',
        'cyrillic-name': 'Авенсис Версо',
        class: 'M',
        'year-from': 2001,
        'year-to': 2009,
      },
      {
        id: 'AYGO',
        name: 'Aygo',
        'cyrillic-name': 'Айго',
        class: 'A',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'AYGO_X',
        name: 'Aygo X',
        'cyrillic-name': 'Айго Икс',
        class: 'A',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'BB',
        name: 'bB',
        'cyrillic-name': 'бб',
        class: 'M',
        'year-from': 2000,
        'year-to': 2016,
      },
      {
        id: 'BELTA',
        name: 'Belta',
        'cyrillic-name': 'Бельта',
        class: 'B',
        'year-from': 2005,
        'year-to': 2012,
      },
      {
        id: 'BLADE',
        name: 'Blade',
        'cyrillic-name': 'Блейд',
        class: 'C',
        'year-from': 2006,
        'year-to': 2012,
      },
      {
        id: 'BLIZZARD',
        name: 'Blizzard',
        'cyrillic-name': 'Близзард',
        class: 'J',
        'year-from': 1980,
        'year-to': 1994,
      },
      {
        id: 'BREVIS',
        name: 'Brevis',
        'cyrillic-name': 'Бревис',
        class: 'D',
        'year-from': 2001,
        'year-to': 2007,
      },
      {
        id: 'BZ4X',
        name: 'bZ4X',
        'cyrillic-name': 'бЗ4Х',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'C_HR',
        name: 'C-HR',
        'cyrillic-name': 'ц-хр',
        class: 'B',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'CALDINA',
        name: 'Caldina',
        'cyrillic-name': 'Калдина',
        class: 'D',
        'year-from': 1992,
        'year-to': 2007,
      },
      {
        id: 'CAMI',
        name: 'Cami',
        'cyrillic-name': 'Ками',
        class: 'B',
        'year-from': 1999,
        'year-to': 2006,
      },
      {
        id: 'CAMRY',
        name: 'Camry',
        'cyrillic-name': 'Камри',
        class: 'D',
        'year-from': 1980,
        'year-to': null,
      },
      {
        id: 'CAMRY_SOLARA',
        name: 'Camry Solara',
        'cyrillic-name': 'Камри Соляра',
        class: 'E',
        'year-from': 1998,
        'year-to': 2009,
      },
      {
        id: 'CARINA',
        name: 'Carina',
        'cyrillic-name': 'Карина',
        class: 'C',
        'year-from': 1973,
        'year-to': 2001,
      },
      {
        id: 'CARINA_E',
        name: 'Carina E',
        'cyrillic-name': 'Карина Е',
        class: 'D',
        'year-from': 1992,
        'year-to': 1998,
      },
      {
        id: 'CARINA_ED',
        name: 'Carina ED',
        'cyrillic-name': 'царина ед',
        class: 'D',
        'year-from': 1985,
        'year-to': 1998,
      },
      {
        id: 'CAVALIER',
        name: 'Cavalier',
        'cyrillic-name': 'Кавалер',
        class: 'C',
        'year-from': 1995,
        'year-to': 2000,
      },
      {
        id: 'CELICA',
        name: 'Celica',
        'cyrillic-name': 'Селика',
        class: 'C',
        'year-from': 1970,
        'year-to': 2006,
      },
      {
        id: 'CELSIOR',
        name: 'Celsior',
        'cyrillic-name': 'Целсиор',
        class: 'F',
        'year-from': 1989,
        'year-to': 2006,
      },
      {
        id: 'CENTURY',
        name: 'Century',
        'cyrillic-name': 'Сентури',
        class: 'F',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'CHASER',
        name: 'Chaser',
        'cyrillic-name': 'Чайзер',
        class: 'E',
        'year-from': 1977,
        'year-to': 2001,
      },
      {
        id: 'CLASSIC',
        name: 'Classic',
        'cyrillic-name': 'Классик',
        class: 'E',
        'year-from': 1996,
        'year-to': 1997,
      },
      {
        id: 'COMFORT',
        name: 'Comfort',
        'cyrillic-name': 'комфорт',
        class: 'D',
        'year-from': 1995,
        'year-to': 2017,
      },
      {
        id: 'COMS',
        name: 'COMS',
        'cyrillic-name': 'КОМС',
        class: 'A',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'COROLLA',
        name: 'Corolla',
        'cyrillic-name': 'Королла',
        class: 'C',
        'year-from': 1966,
        'year-to': null,
      },
      {
        id: 'COROLLA_CROSS',
        name: 'Corolla Cross',
        'cyrillic-name': 'Королла Кросс',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'COROLLA_II',
        name: 'Corolla II',
        'cyrillic-name': 'королла 2',
        class: 'B',
        'year-from': 1978,
        'year-to': 1999,
      },
      {
        id: 'COROLLA_LEVIN',
        name: 'Corolla Levin',
        'cyrillic-name': 'Королла Левин',
        class: 'C',
        'year-from': 1979,
        'year-to': 2000,
      },
      {
        id: 'COROLLA_RUMION',
        name: 'Corolla Rumion',
        'cyrillic-name': 'Королла Румион',
        class: 'C',
        'year-from': 2007,
        'year-to': 2016,
      },
      {
        id: 'COROLLA_SPACIO',
        name: 'Corolla Spacio',
        'cyrillic-name': 'Королла Спасио',
        class: 'M',
        'year-from': 1997,
        'year-to': 2007,
      },
      {
        id: 'COROLLA_VERSO',
        name: 'Corolla Verso',
        'cyrillic-name': 'Королла Версо',
        class: 'M',
        'year-from': 2001,
        'year-to': 2009,
      },
      {
        id: 'CORONA',
        name: 'Corona',
        'cyrillic-name': 'Корона',
        class: 'D',
        'year-from': 1973,
        'year-to': 2001,
      },
      {
        id: 'CORONA_EXIV',
        name: 'Corona EXiV',
        'cyrillic-name': 'корона эксив',
        class: 'D',
        'year-from': 1989,
        'year-to': 1998,
      },
      {
        id: 'CORSA',
        name: 'Corsa',
        'cyrillic-name': 'Корса',
        class: 'B',
        'year-from': 1982,
        'year-to': 1999,
      },
      {
        id: 'CRESSIDA',
        name: 'Cressida',
        'cyrillic-name': 'Крессида',
        class: 'D',
        'year-from': 1977,
        'year-to': 1996,
      },
      {
        id: 'CRESTA',
        name: 'Cresta',
        'cyrillic-name': 'Креста',
        class: 'E',
        'year-from': 1980,
        'year-to': 2001,
      },
      {
        id: 'CROWN',
        name: 'Crown',
        'cyrillic-name': 'Краун',
        class: 'J',
        'year-from': 1967,
        'year-to': null,
      },
      {
        id: 'CROWN_KLUGER',
        name: 'Crown Kluger',
        'cyrillic-name': 'Краун Клагер',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'CROWN_MAJESTA',
        name: 'Crown Majesta',
        'cyrillic-name': 'Краун Маджеста',
        class: 'F',
        'year-from': 1991,
        'year-to': 2018,
      },
      {
        id: 'CURREN',
        name: 'Curren',
        'cyrillic-name': 'Каррен',
        class: 'C',
        'year-from': 1994,
        'year-to': 1999,
      },
      {
        id: 'CYNOS',
        name: 'Cynos',
        'cyrillic-name': 'Цинос',
        class: 'C',
        'year-from': 1991,
        'year-to': 1999,
      },
      {
        id: 'DUET',
        name: 'Duet',
        'cyrillic-name': 'Дуэт',
        class: 'B',
        'year-from': 1998,
        'year-to': 2004,
      },
      {
        id: 'ECHO',
        name: 'Echo',
        'cyrillic-name': 'Эхо',
        class: 'B',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: 'ESQUIRE',
        name: 'Esquire',
        'cyrillic-name': 'эсквайр',
        class: 'M',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'ESTIMA',
        name: 'Estima',
        'cyrillic-name': 'Эстима',
        class: 'M',
        'year-from': 1990,
        'year-to': 2019,
      },
      {
        id: 'ETIOS',
        name: 'Etios',
        'cyrillic-name': 'этиос',
        class: 'C',
        'year-from': 2010,
        'year-to': 2021,
      },
      {
        id: 'FJ_CRUISER',
        name: 'FJ Cruiser',
        'cyrillic-name': 'ФДжи Крузер',
        class: 'J',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'FORTUNER',
        name: 'Fortuner',
        'cyrillic-name': 'Фортунер',
        class: 'J',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'FRONTLANDER',
        name: 'Frontlander',
        'cyrillic-name': 'Фронтлендер',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'FUNCARGO',
        name: 'FunCargo',
        'cyrillic-name': 'Фанкарго',
        class: 'M',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: 'GAIA',
        name: 'Gaia',
        'cyrillic-name': 'Гайя',
        class: 'M',
        'year-from': 1998,
        'year-to': 2004,
      },
      {
        id: 'GR86',
        name: 'GR86',
        'cyrillic-name': 'ГР86',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'GRAND_HIACE',
        name: 'Grand HiAce',
        'cyrillic-name': 'гранд хайс',
        class: 'M',
        'year-from': 1999,
        'year-to': 2002,
      },
      {
        id: 'GRANVIA',
        name: 'Granvia',
        'cyrillic-name': 'Гранвиа',
        class: 'M',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'GT86',
        name: 'GT86',
        'cyrillic-name': 'гт86',
        class: 'S',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'HARRIER',
        name: 'Harrier',
        'cyrillic-name': 'Харриер',
        class: 'D',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'HIACE',
        name: 'HiAce',
        'cyrillic-name': 'Хайс',
        class: 'M',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'HIGHLANDER',
        name: 'Highlander',
        'cyrillic-name': 'Хайлендер',
        class: 'E',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'HILUX',
        name: 'Hilux',
        'cyrillic-name': 'Хайлюкс',
        class: 'J',
        'year-from': 1968,
        'year-to': null,
      },
      {
        id: 'HILUX_SURF',
        name: 'Hilux Surf',
        'cyrillic-name': 'Хайлюкс Сурф',
        class: 'J',
        'year-from': 1984,
        'year-to': 2009,
      },
      {
        id: 'INNOVA',
        name: 'Innova',
        'cyrillic-name': 'Иннова',
        class: 'M',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'IPSUM',
        name: 'Ipsum',
        'cyrillic-name': 'Ипсум',
        class: 'M',
        'year-from': 1995,
        'year-to': 2009,
      },
      {
        id: 'IQ',
        name: 'iQ',
        'cyrillic-name': 'ик',
        class: 'A',
        'year-from': 2008,
        'year-to': 2011,
      },
      {
        id: 'ISIS',
        name: 'ISis',
        'cyrillic-name': 'исис',
        class: 'M',
        'year-from': 2004,
        'year-to': 2017,
      },
      {
        id: 'IST',
        name: 'Ist',
        'cyrillic-name': 'Ист',
        class: 'C',
        'year-from': 2001,
        'year-to': 2016,
      },
      {
        id: 'IZOA',
        name: 'Izoa',
        'cyrillic-name': 'Изоа',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'KLUGER',
        name: 'Kluger',
        'cyrillic-name': 'Клюгер',
        class: 'E',
        'year-from': 2000,
        'year-to': 2013,
      },
      {
        id: 'LAND_CRUISER',
        name: 'Land Cruiser',
        'cyrillic-name': 'Ленд Крузер',
        class: 'J',
        'year-from': 1960,
        'year-to': null,
      },
      {
        id: 'LAND_CRUISER_PRADO',
        name: 'Land Cruiser Prado',
        'cyrillic-name': 'Ленд Крузер Прадо',
        class: 'J',
        'year-from': 1987,
        'year-to': null,
      },
      {
        id: 'LEVIN',
        name: 'Levin',
        'cyrillic-name': 'Левин',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'LITE_ACE',
        name: 'Lite Ace',
        'cyrillic-name': 'ЛайтЭйс',
        class: 'M',
        'year-from': 1979,
        'year-to': 2020,
      },
      {
        id: 'MARK_II',
        name: 'Mark II',
        'cyrillic-name': 'Марк 2',
        class: 'E',
        'year-from': 1968,
        'year-to': 2007,
      },
      {
        id: 'MARK_X',
        name: 'Mark X',
        'cyrillic-name': 'марк кс',
        class: 'E',
        'year-from': 2004,
        'year-to': 2019,
      },
      {
        id: 'MARK_X_ZIO',
        name: 'Mark X ZiO',
        'cyrillic-name': 'марк кс зио',
        class: 'M',
        'year-from': 2007,
        'year-to': 2013,
      },
      {
        id: 'MASTER_ACE_SURF',
        name: 'MasterAce Surf',
        'cyrillic-name': 'мастер айс сурф',
        class: 'M',
        'year-from': 1982,
        'year-to': 1991,
      },
      {
        id: 'MATRIX',
        name: 'Matrix',
        'cyrillic-name': 'Матрикс',
        class: 'M',
        'year-from': 2002,
        'year-to': 2014,
      },
      {
        id: 'MEGA_CRUISER',
        name: 'Mega Cruiser',
        'cyrillic-name': 'Мега Крузер',
        class: 'J',
        'year-from': 1995,
        'year-to': 2001,
      },
      {
        id: 'MIRAI',
        name: 'Mirai',
        'cyrillic-name': 'Мирай',
        class: 'D',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'MODEL_F',
        name: 'Model F',
        'cyrillic-name': 'модель ф',
        class: 'M',
        'year-from': 1982,
        'year-to': 1992,
      },
      {
        id: 'MR_S',
        name: 'MR-S',
        'cyrillic-name': 'МР-С',
        class: 'S',
        'year-from': 1999,
        'year-to': 2007,
      },
      {
        id: 'MR2',
        name: 'MR2',
        'cyrillic-name': 'МР 2',
        class: 'S',
        'year-from': 1984,
        'year-to': 2007,
      },
      {
        id: 'NADIA',
        name: 'Nadia',
        'cyrillic-name': 'Надя',
        class: 'M',
        'year-from': 1998,
        'year-to': 2003,
      },
      {
        id: 'NOAH',
        name: 'Noah',
        'cyrillic-name': 'Ноа',
        class: 'M',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'OPA',
        name: 'Opa',
        'cyrillic-name': 'Опа',
        class: 'C',
        'year-from': 2000,
        'year-to': 2005,
      },
      {
        id: 'ORIGIN',
        name: 'Origin',
        'cyrillic-name': 'Ориджин',
        class: 'E',
        'year-from': 2000,
        'year-to': 2001,
      },
      {
        id: 'PASEO',
        name: 'Paseo',
        'cyrillic-name': 'Пасео',
        class: 'C',
        'year-from': 1991,
        'year-to': 1999,
      },
      {
        id: 'PASSO',
        name: 'Passo',
        'cyrillic-name': 'Пассо',
        class: 'A',
        'year-from': 2004,
        'year-to': null,
      },
      {
        id: 'PASSO_SETTE',
        name: 'Passo Sette',
        'cyrillic-name': 'Пассо Сетте',
        class: 'M',
        'year-from': 2008,
        'year-to': 2012,
      },
      {
        id: 'PICNIC',
        name: 'Picnic',
        'cyrillic-name': 'Пикник',
        class: 'M',
        'year-from': 1996,
        'year-to': 2009,
      },
      {
        id: 'PIXIS_EPOCH',
        name: 'Pixis Epoch',
        'cyrillic-name': 'Пиксис Эпоч',
        class: 'A',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'PIXIS_JOY',
        name: 'Pixis Joy',
        'cyrillic-name': 'Пиксис Джой',
        class: 'A',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'PIXIS_MEGA',
        name: 'Pixis Mega',
        'cyrillic-name': 'Пиксис Мега',
        class: 'A',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'PIXIS_SPACE',
        name: 'Pixis Space',
        'cyrillic-name': 'Пиксис Спэйс',
        class: 'A',
        'year-from': 2011,
        'year-to': 2017,
      },
      {
        id: 'PIXIS_VAN',
        name: 'Pixis Van',
        'cyrillic-name': 'Пиксис Ван',
        class: 'M',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'PLATZ',
        name: 'Platz',
        'cyrillic-name': 'Платз',
        class: 'B',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: 'PORTE',
        name: 'Porte',
        'cyrillic-name': 'Порте',
        class: 'M',
        'year-from': 2004,
        'year-to': 2020,
      },
      {
        id: 'PREMIO',
        name: 'Premio',
        'cyrillic-name': 'Премио',
        class: 'C',
        'year-from': 2001,
        'year-to': 2021,
      },
      {
        id: 'PREVIA',
        name: 'Previa',
        'cyrillic-name': 'Превиа',
        class: 'M',
        'year-from': 1990,
        'year-to': 2019,
      },
      {
        id: 'PRIUS',
        name: 'Prius',
        'cyrillic-name': 'Приус',
        class: 'C',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'PRIUS_ALPHA',
        name: 'Prius Alpha',
        'cyrillic-name': 'Приус Альфа',
        class: 'M',
        'year-from': 2011,
        'year-to': 2021,
      },
      {
        id: 'PRIUS_C',
        name: 'Prius c',
        'cyrillic-name': 'Приус си',
        class: 'C',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'PRIUSPLUS',
        name: 'Prius v (+)',
        'cyrillic-name': 'приус в (+)',
        class: 'M',
        'year-from': 2011,
        'year-to': 2021,
      },
      {
        id: 'PROACE',
        name: 'ProAce',
        'cyrillic-name': 'ПроЭйс',
        class: 'M',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'PROACE_CITY',
        name: 'ProAce City',
        'cyrillic-name': 'ПроЭйс Сити',
        class: 'M',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'PROBOX',
        name: 'Probox',
        'cyrillic-name': 'Пробокс',
        class: 'C',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'PROGRES',
        name: 'Progres',
        'cyrillic-name': 'Прогрес',
        class: 'E',
        'year-from': 1998,
        'year-to': 2007,
      },
      {
        id: 'PRONARD',
        name: 'Pronard',
        'cyrillic-name': 'Пронард',
        class: 'E',
        'year-from': 2000,
        'year-to': 2004,
      },
      {
        id: 'PUBLICA',
        name: 'Publica',
        'cyrillic-name': 'публика',
        class: 'B',
        'year-from': 1961,
        'year-to': 1978,
      },
      {
        id: 'RACTIS',
        name: 'Ractis',
        'cyrillic-name': 'Рактис',
        class: 'M',
        'year-from': 2005,
        'year-to': 2016,
      },
      {
        id: 'RAIZE',
        name: 'Raize',
        'cyrillic-name': 'Райз',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'RAUM',
        name: 'Raum',
        'cyrillic-name': 'Раум',
        class: 'M',
        'year-from': 1997,
        'year-to': 2011,
      },
      {
        id: 'RAV_4',
        name: 'RAV4',
        'cyrillic-name': 'Рав4',
        class: 'C',
        'year-from': 1994,
        'year-to': null,
      },
      {
        id: 'REGIUS',
        name: 'Regius',
        'cyrillic-name': 'Региус',
        class: 'M',
        'year-from': 1997,
        'year-to': 2002,
      },
      {
        id: 'REGIUSACE',
        name: 'RegiusAce',
        'cyrillic-name': 'Региус Эйс',
        class: 'M',
        'year-from': 1998,
        'year-to': 2010,
      },
      {
        id: 'ROOMY',
        name: 'Roomy',
        'cyrillic-name': 'Руми',
        class: 'M',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'RUSH',
        name: 'Rush',
        'cyrillic-name': 'Раш',
        class: 'B',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'SAI',
        name: 'Sai',
        'cyrillic-name': 'сай',
        class: 'D',
        'year-from': 2009,
        'year-to': 2017,
      },
      {
        id: 'SCEPTER_SEDAN',
        name: 'Scepter',
        'cyrillic-name': 'Сцептер',
        class: 'E',
        'year-from': 1992,
        'year-to': 1996,
      },
      {
        id: 'SEQUOIA',
        name: 'Sequoia',
        'cyrillic-name': 'Секвойя',
        class: 'J',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'SERA',
        name: 'Sera',
        'cyrillic-name': 'Сера',
        class: 'C',
        'year-from': 1990,
        'year-to': 1994,
      },
      {
        id: 'SIENNA',
        name: 'Sienna',
        'cyrillic-name': 'Сиенна',
        class: 'M',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'SIENTA',
        name: 'Sienta',
        'cyrillic-name': 'Сиента',
        class: 'M',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'SOARER',
        name: 'Soarer',
        'cyrillic-name': 'Соарер',
        class: 'D',
        'year-from': 1981,
        'year-to': 2005,
      },
      {
        id: 'SOLUNA',
        name: 'Soluna',
        'cyrillic-name': 'Солуна',
        class: 'B',
        'year-from': 1996,
        'year-to': 2003,
      },
      {
        id: 'SPADE',
        name: 'Spade',
        'cyrillic-name': 'Спейд',
        class: 'M',
        'year-from': 2012,
        'year-to': 2020,
      },
      {
        id: 'SPARKY',
        name: 'Sparky',
        'cyrillic-name': 'Спарки',
        class: 'M',
        'year-from': 2000,
        'year-to': 2003,
      },
      {
        id: 'SPORTS_800',
        name: 'Sports 800',
        'cyrillic-name': 'Спортс 800',
        class: 'S',
        'year-from': 1965,
        'year-to': 1969,
      },
      {
        id: 'SPRINTER',
        name: 'Sprinter',
        'cyrillic-name': 'Спринтер',
        class: 'C',
        'year-from': 1979,
        'year-to': 2002,
      },
      {
        id: 'SPRINTER_CARIB',
        name: 'Sprinter Carib',
        'cyrillic-name': 'Спринтер Кариб',
        class: 'C',
        'year-from': 1982,
        'year-to': 2002,
      },
      {
        id: 'SPRINTER_MARINO',
        name: 'Sprinter Marino',
        'cyrillic-name': 'Спринтер Марино',
        class: 'C',
        'year-from': 1992,
        'year-to': 1998,
      },
      {
        id: 'SPRINTER_TRUENO',
        name: 'Sprinter Trueno',
        'cyrillic-name': 'Спринтер Труэно',
        class: 'C',
        'year-from': 1983,
        'year-to': 2000,
      },
      {
        id: 'STARLET',
        name: 'Starlet',
        'cyrillic-name': 'Старлет',
        class: 'B',
        'year-from': 1978,
        'year-to': 1999,
      },
      {
        id: 'SUCCEED',
        name: 'Succeed',
        'cyrillic-name': 'Саксид',
        class: 'C',
        'year-from': 2002,
        'year-to': 2020,
      },
      {
        id: 'SUPRA',
        name: 'Supra',
        'cyrillic-name': 'Супра',
        class: 'S',
        'year-from': 1986,
        'year-to': null,
      },
      {
        id: 'TACOMA',
        name: 'Tacoma',
        'cyrillic-name': 'Такома',
        class: 'J',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'TANK',
        name: 'Tank',
        'cyrillic-name': 'Танк',
        class: 'M',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'TERCEL',
        name: 'Tercel',
        'cyrillic-name': 'Терсел',
        class: 'B',
        'year-from': 1978,
        'year-to': 1999,
      },
      {
        id: 'TOURING_HIACE',
        name: 'Touring HiAce',
        'cyrillic-name': 'Туринг Хайэс',
        class: 'M',
        'year-from': 1999,
        'year-to': 2002,
      },
      {
        id: 'TOWN_ACE',
        name: 'Town Ace',
        'cyrillic-name': 'Таун Эйс',
        class: 'M',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'TUNDRA',
        name: 'Tundra',
        'cyrillic-name': 'Тундра',
        class: 'J',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'URBAN_CRUISER',
        name: 'Urban Cruiser',
        'cyrillic-name': 'Урбан Крузер',
        class: 'C',
        'year-from': 2009,
        'year-to': 2014,
      },
      {
        id: 'VANGUARD',
        name: 'Vanguard',
        'cyrillic-name': 'Вангуард',
        class: 'C',
        'year-from': 2007,
        'year-to': 2013,
      },
      {
        id: 'VELLFIRE',
        name: 'Vellfire',
        'cyrillic-name': 'Веллфайр',
        class: 'M',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'VENZA',
        name: 'Venza',
        'cyrillic-name': 'Венза',
        class: 'D',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'VEROSSA',
        name: 'Verossa',
        'cyrillic-name': 'Веросса',
        class: 'E',
        'year-from': 2001,
        'year-to': 2004,
      },
      {
        id: 'VERSO',
        name: 'Verso',
        'cyrillic-name': 'Версо',
        class: 'M',
        'year-from': 2009,
        'year-to': 2018,
      },
      {
        id: 'VERSO_S',
        name: 'Verso-S',
        'cyrillic-name': 'Версо-С',
        class: 'M',
        'year-from': 2010,
        'year-to': 2018,
      },
      {
        id: 'VIOS',
        name: 'Vios',
        'cyrillic-name': 'Виос',
        class: 'C',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'VISTA',
        name: 'Vista',
        'cyrillic-name': 'Виста',
        class: 'E',
        'year-from': 1982,
        'year-to': 2003,
      },
      {
        id: 'VITZ',
        name: 'Vitz',
        'cyrillic-name': 'Витц',
        class: 'B',
        'year-from': 1999,
        'year-to': 2020,
      },
      {
        id: 'VOLTZ',
        name: 'Voltz',
        'cyrillic-name': 'Вольтз',
        class: 'C',
        'year-from': 2002,
        'year-to': 2004,
      },
      {
        id: 'VOXY',
        name: 'Voxy',
        'cyrillic-name': 'Вокси',
        class: 'M',
        'year-from': 2001,
        'year-to': null,
      },
      {
        id: 'WIGO',
        name: 'Wigo',
        'cyrillic-name': 'Виго',
        class: 'A',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'WILDLANDER',
        name: 'Wildlander',
        'cyrillic-name': 'Вайлдлендер',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'WILL',
        name: 'WiLL',
        'cyrillic-name': 'Вилл',
        class: 'C',
        'year-from': 2000,
        'year-to': 2004,
      },
      {
        id: 'WILL_CYPHA',
        name: 'WiLL Cypha',
        'cyrillic-name': 'вилл сифа',
        class: 'C',
        'year-from': 2002,
        'year-to': 2005,
      },
      {
        id: 'WINDOM',
        name: 'Windom',
        'cyrillic-name': 'Виндом',
        class: 'E',
        'year-from': 1991,
        'year-to': 2006,
      },
      {
        id: 'WISH',
        name: 'Wish',
        'cyrillic-name': 'Виш',
        class: 'M',
        'year-from': 2003,
        'year-to': 2017,
      },
      {
        id: 'YARIS',
        name: 'Yaris',
        'cyrillic-name': 'Ярис',
        class: 'B',
        'year-from': 1999,
        'year-to': null,
      },
      {
        id: 'YARIS_CROSS',
        name: 'Yaris Cross',
        'cyrillic-name': 'Ярис Кросс',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'YARIS_VERSO',
        name: 'Yaris Verso',
        'cyrillic-name': 'Ярис Версо',
        class: 'M',
        'year-from': 1999,
        'year-to': 2006,
      },
      {
        id: 'ZELAS',
        name: 'Zelas',
        'cyrillic-name': 'Зелас',
        class: 'C',
        'year-from': 2010,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'TRABANT',
    name: 'Trabant',
    'cyrillic-name': 'Трабант',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: '1_1',
        name: '1.1',
        'cyrillic-name': '1.1',
        class: 'B',
        'year-from': 1990,
        'year-to': 1991,
      },
      {
        id: '600',
        name: '600',
        'cyrillic-name': '600',
        class: 'B',
        'year-from': 1962,
        'year-to': 1964,
      },
      {
        id: '601',
        name: 'P 601',
        'cyrillic-name': 'П 601',
        class: 'B',
        'year-from': 1963,
        'year-to': 1990,
      },
      {
        id: 'P50',
        name: 'P50',
        'cyrillic-name': 'п50',
        class: 'A',
        'year-from': 1958,
        'year-to': 1962,
      },
    ],
  },
  {
    id: 'TRAMONTANA',
    name: 'Tramontana',
    'cyrillic-name': 'Трамонтана',
    popular: false,
    country: 'Испания',
    models: [
      {
        id: 'TRAMONTANA',
        name: 'Tramontana',
        'cyrillic-name': 'Трамонтана',
        class: 'S',
        'year-from': 2007,
        'year-to': null,
      },
    ],
  },
  {
    id: 'TRIUMPH',
    name: 'Triumph',
    'cyrillic-name': 'Триумф',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'ACCLAIM',
        name: 'Acclaim',
        'cyrillic-name': 'Акклейм',
        class: 'B',
        'year-from': 1981,
        'year-to': 1984,
      },
      {
        id: 'SPITFIRE',
        name: 'Spitfire',
        'cyrillic-name': 'Спитфайр',
        class: 'S',
        'year-from': 1965,
        'year-to': 1980,
      },
      {
        id: 'STAG',
        name: 'Stag',
        'cyrillic-name': 'стаг',
        class: 'S',
        'year-from': 1970,
        'year-to': 1977,
      },
      {
        id: 'TR3',
        name: 'TR3',
        'cyrillic-name': 'тр3',
        class: '',
        'year-from': 1957,
        'year-to': 1963,
      },
      {
        id: 'TR4',
        name: 'TR4',
        'cyrillic-name': 'тр4',
        class: 'S',
        'year-from': 1961,
        'year-to': 1967,
      },
      {
        id: 'TR6',
        name: 'TR6',
        'cyrillic-name': 'тр6',
        class: 'S',
        'year-from': 1968,
        'year-to': 1976,
      },
      {
        id: 'TR7',
        name: 'TR7',
        'cyrillic-name': 'тр7',
        class: 'S',
        'year-from': 1975,
        'year-to': 1981,
      },
      {
        id: 'TR8',
        name: 'TR8',
        'cyrillic-name': 'тр8',
        class: 'S',
        'year-from': 1980,
        'year-to': 1981,
      },
    ],
  },
  {
    id: 'TRUMPCHI',
    name: 'Trumpchi',
    'cyrillic-name': 'Трампчи',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'EMKOO',
        name: 'Emkoo',
        'cyrillic-name': 'Эмкоо',
        class: 'D',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'EMPOW',
        name: 'Empow',
        'cyrillic-name': 'Емпов',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'GA4_PLUS',
        name: 'GA4 Plus',
        'cyrillic-name': 'ГА4 Плюс',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'GA6',
        name: 'GA6',
        'cyrillic-name': 'ГА6',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'GA8',
        name: 'GA8',
        'cyrillic-name': 'ГА8',
        class: 'E',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'GS3_POWER',
        name: 'GS3 Power',
        'cyrillic-name': 'ГС3 Повер',
        class: 'B',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'GS4',
        name: 'GS4',
        'cyrillic-name': 'ГС4',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'GS4_PLUS',
        name: 'GS4 Plus',
        'cyrillic-name': 'ГС4 Плюс',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'GS8',
        name: 'GS8',
        'cyrillic-name': 'ГС8',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'M6',
        name: 'M6',
        'cyrillic-name': 'М6',
        class: 'M',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'M6_PRO',
        name: 'M6 Pro',
        'cyrillic-name': 'М6 Про',
        class: 'M',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'M8',
        name: 'M8',
        'cyrillic-name': 'М8',
        class: 'M',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'TVR',
    name: 'TVR',
    'cyrillic-name': 'ТВР',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: '280',
        name: '280',
        'cyrillic-name': '280',
        class: 'S',
        'year-from': 1980,
        'year-to': 1986,
      },
      {
        id: '350',
        name: '350',
        'cyrillic-name': '350',
        class: 'S',
        'year-from': 1983,
        'year-to': 1989,
      },
      {
        id: '390',
        name: '390',
        'cyrillic-name': '390',
        class: 'S',
        'year-from': 1984,
        'year-to': 1989,
      },
      {
        id: '400',
        name: '400',
        'cyrillic-name': '400',
        class: 'S',
        'year-from': 1989,
        'year-to': 1993,
      },
      {
        id: '420',
        name: '420',
        'cyrillic-name': '420',
        class: 'S',
        'year-from': 1984,
        'year-to': 1989,
      },
      {
        id: '450',
        name: '450',
        'cyrillic-name': '450',
        class: 'S',
        'year-from': 1989,
        'year-to': 1993,
      },
      {
        id: 'CERBERA',
        name: 'Cerbera',
        'cyrillic-name': 'цербера',
        class: 'S',
        'year-from': 1994,
        'year-to': 2003,
      },
      {
        id: 'CHIMAERA',
        name: 'Chimaera',
        'cyrillic-name': 'химера',
        class: 'S',
        'year-from': 1992,
        'year-to': 2003,
      },
      {
        id: 'GRIFFITH',
        name: 'Griffith',
        'cyrillic-name': 'гриффит',
        class: 'S',
        'year-from': 1991,
        'year-to': 2002,
      },
      {
        id: 'S_SERIES',
        name: 'S-Series',
        'cyrillic-name': 'с-серия',
        class: 'S',
        'year-from': 1986,
        'year-to': 1996,
      },
      {
        id: 'SAGARIS',
        name: 'Sagaris',
        'cyrillic-name': 'сагарис',
        class: 'S',
        'year-from': 2004,
        'year-to': 2006,
      },
      {
        id: 'TAIMAR',
        name: 'Taimar',
        'cyrillic-name': 'таймар',
        class: 'S',
        'year-from': 1976,
        'year-to': 1979,
      },
      {
        id: 'TAMORA',
        name: 'Tamora',
        'cyrillic-name': 'тамора',
        class: 'S',
        'year-from': 2002,
        'year-to': 2006,
      },
      {
        id: 'TASMIN',
        name: 'Tasmin',
        'cyrillic-name': 'тасмин',
        class: 'S',
        'year-from': 1980,
        'year-to': 1987,
      },
      {
        id: 'TUSCAN',
        name: 'Tuscan',
        'cyrillic-name': 'тускан',
        class: 'S',
        'year-from': 1999,
        'year-to': 2006,
      },
    ],
  },
  {
    id: 'UAZ',
    name: 'УАЗ',
    'cyrillic-name': 'УАЗ',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: '3151',
        name: '3151',
        'cyrillic-name': '3151',
        class: 'J',
        'year-from': 1985,
        'year-to': 2013,
      },
      {
        id: '3153',
        name: '3153',
        'cyrillic-name': '3153',
        class: 'J',
        'year-from': 1996,
        'year-to': 2006,
      },
      {
        id: '3159',
        name: '3159',
        'cyrillic-name': '3159 Барс',
        class: 'J',
        'year-from': 1999,
        'year-to': 2010,
      },
      {
        id: '3160',
        name: '3160',
        'cyrillic-name': '3160',
        class: 'J',
        'year-from': 1997,
        'year-to': 2004,
      },
      {
        id: '3162',
        name: '3162 Simbir',
        'cyrillic-name': '3162 Симбир',
        class: 'J',
        'year-from': 1999,
        'year-to': 2005,
      },
      {
        id: '469',
        name: '469',
        'cyrillic-name': '469',
        class: 'J',
        'year-from': 1972,
        'year-to': 2011,
      },
      {
        id: 'HUNTER',
        name: 'Hunter',
        'cyrillic-name': 'Хантер',
        class: 'J',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'PATRIOT',
        name: 'Patriot',
        'cyrillic-name': 'Патриот',
        class: 'J',
        'year-from': 2005,
        'year-to': null,
      },
      {
        id: 'PICKUP',
        name: 'Pickup',
        'cyrillic-name': 'Пикап',
        class: 'J',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'ASTERO',
        name: 'Астеро',
        'cyrillic-name': 'Астеро',
        class: 'J',
        'year-from': 1997,
        'year-to': 1999,
      },
    ],
  },
  {
    id: 'ULTIMA',
    name: 'Ultima',
    'cyrillic-name': 'Ультима',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'CAN_AM',
        name: 'Can-Am',
        'cyrillic-name': 'Кан-Ам',
        class: 'S',
        'year-from': 2001,
        'year-to': 2016,
      },
      {
        id: 'GTR',
        name: 'GTR',
        'cyrillic-name': 'ГТР',
        class: 'S',
        'year-from': 1999,
        'year-to': 2016,
      },
      {
        id: 'RS',
        name: 'RS',
        'cyrillic-name': 'РС',
        class: 'S',
        'year-from': 2019,
        'year-to': null,
      },
    ],
  },
  {
    id: 'VAUXHALL',
    name: 'Vauxhall',
    'cyrillic-name': 'Воксхолл',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'ADAM',
        name: 'Adam',
        'cyrillic-name': 'Адам',
        class: 'A',
        'year-from': 2013,
        'year-to': 2019,
      },
      {
        id: 'AMPERA',
        name: 'Ampera',
        'cyrillic-name': 'Ампера',
        class: 'C',
        'year-from': 2011,
        'year-to': 2015,
      },
      {
        id: 'ASTRA',
        name: 'Astra',
        'cyrillic-name': 'астра',
        class: 'C',
        'year-from': 1979,
        'year-to': 2015,
      },
      {
        id: 'CARLTON',
        name: 'Carlton',
        'cyrillic-name': 'карлтон',
        class: 'D',
        'year-from': 1984,
        'year-to': 1994,
      },
      {
        id: 'CAVALIER',
        name: 'Cavalier',
        'cyrillic-name': 'Кавалер',
        class: 'D',
        'year-from': 1975,
        'year-to': 1981,
      },
      {
        id: 'CHEVETTE',
        name: 'Chevette',
        'cyrillic-name': 'шеветт',
        class: 'B',
        'year-from': 1975,
        'year-to': 1984,
      },
      {
        id: 'CORSA',
        name: 'Corsa',
        'cyrillic-name': 'Корса',
        class: 'B',
        'year-from': 1993,
        'year-to': null,
      },
      {
        id: 'FIRENZA',
        name: 'Firenza',
        'cyrillic-name': 'фиренза',
        class: 'S',
        'year-from': 1970,
        'year-to': 1975,
      },
      {
        id: 'FRONTERA',
        name: 'Frontera',
        'cyrillic-name': 'Фронтера',
        class: 'J',
        'year-from': 1991,
        'year-to': 2004,
      },
      {
        id: 'INSIGNIA',
        name: 'Insignia',
        'cyrillic-name': 'Инсигния',
        class: 'D',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'MERIVA',
        name: 'Meriva',
        'cyrillic-name': 'Мерива',
        class: 'M',
        'year-from': 2003,
        'year-to': 2018,
      },
      {
        id: 'MOKKA',
        name: 'Mokka',
        'cyrillic-name': 'Мокка',
        class: 'B',
        'year-from': 2012,
        'year-to': 2019,
      },
      {
        id: 'MONARO',
        name: 'Monaro',
        'cyrillic-name': 'Монаро',
        class: 'S',
        'year-from': 2001,
        'year-to': 2007,
      },
      {
        id: 'OMEGA',
        name: 'Omega',
        'cyrillic-name': 'омега',
        class: 'E',
        'year-from': 1994,
        'year-to': 2003,
      },
      {
        id: 'ROYALE',
        name: 'Royale',
        'cyrillic-name': 'рояле',
        class: 'D',
        'year-from': 1978,
        'year-to': 1987,
      },
      {
        id: 'TIGRA',
        name: 'Tigra',
        'cyrillic-name': 'Тигра',
        class: 'B',
        'year-from': 1994,
        'year-to': 2009,
      },
      {
        id: 'VECTRA',
        name: 'Vectra',
        'cyrillic-name': 'вектра',
        class: 'D',
        'year-from': 1995,
        'year-to': 2008,
      },
      {
        id: 'VELOX',
        name: 'Velox',
        'cyrillic-name': 'Велокс',
        class: 'D',
        'year-from': 1948,
        'year-to': 1965,
      },
      {
        id: 'VENTORA',
        name: 'Ventora',
        'cyrillic-name': 'вентора',
        class: 'D',
        'year-from': 1969,
        'year-to': 1976,
      },
      {
        id: 'VICEROY',
        name: 'Viceroy',
        'cyrillic-name': 'Вайсрой',
        class: 'E',
        'year-from': 1978,
        'year-to': 1982,
      },
      {
        id: 'VICTOR',
        name: 'Victor',
        'cyrillic-name': 'виктор',
        class: 'D',
        'year-from': 1963,
        'year-to': 1978,
      },
      {
        id: 'VIVA',
        name: 'Viva',
        'cyrillic-name': 'вива',
        class: 'C',
        'year-from': 1963,
        'year-to': 1979,
      },
      {
        id: 'VXR8',
        name: 'VXR8',
        'cyrillic-name': 'вхр8',
        class: 'S',
        'year-from': 2007,
        'year-to': 2009,
      },
      {
        id: 'ZAFIRA',
        name: 'Zafira',
        'cyrillic-name': 'Зафира',
        class: 'M',
        'year-from': 1999,
        'year-to': 2018,
      },
    ],
  },
  {
    id: 'VAZ',
    name: 'LADA (ВАЗ)',
    'cyrillic-name': 'Лада',
    popular: true,
    country: 'Россия',
    models: [
      {
        id: '1111',
        name: '1111 Ока',
        'cyrillic-name': 'Ока',
        class: 'A',
        'year-from': 1987,
        'year-to': 2008,
      },
      {
        id: '2101',
        name: '2101',
        'cyrillic-name': '2101',
        class: 'B',
        'year-from': 1970,
        'year-to': 1988,
      },
      {
        id: '2102',
        name: '2102',
        'cyrillic-name': '2102',
        class: 'B',
        'year-from': 1971,
        'year-to': 1986,
      },
      {
        id: '2103',
        name: '2103',
        'cyrillic-name': '2103',
        class: 'B',
        'year-from': 1972,
        'year-to': 1984,
      },
      {
        id: '2104',
        name: '2104',
        'cyrillic-name': '2104',
        class: 'B',
        'year-from': 1984,
        'year-to': 2012,
      },
      {
        id: '2105',
        name: '2105',
        'cyrillic-name': '2105',
        class: 'C',
        'year-from': 1979,
        'year-to': 2011,
      },
      {
        id: '2106',
        name: '2106',
        'cyrillic-name': '2106',
        class: 'B',
        'year-from': 1976,
        'year-to': 2006,
      },
      {
        id: '2107',
        name: '2107',
        'cyrillic-name': '2107',
        class: 'B',
        'year-from': 1982,
        'year-to': 2012,
      },
      {
        id: '2108',
        name: '2108',
        'cyrillic-name': '2108',
        class: 'B',
        'year-from': 1984,
        'year-to': 2005,
      },
      {
        id: '2109',
        name: '2109',
        'cyrillic-name': '2109',
        class: 'B',
        'year-from': 1987,
        'year-to': 2006,
      },
      {
        id: '21099',
        name: '21099',
        'cyrillic-name': '21099',
        class: 'B',
        'year-from': 1990,
        'year-to': 2011,
      },
      {
        id: '2110',
        name: '2110',
        'cyrillic-name': '2110',
        class: 'C',
        'year-from': 1995,
        'year-to': 2014,
      },
      {
        id: '2111',
        name: '2111',
        'cyrillic-name': '2111',
        class: 'C',
        'year-from': 1997,
        'year-to': 2009,
      },
      {
        id: '2112',
        name: '2112',
        'cyrillic-name': '2112',
        class: 'B',
        'year-from': 1998,
        'year-to': 2009,
      },
      {
        id: '2113',
        name: '2113',
        'cyrillic-name': '2113',
        class: 'B',
        'year-from': 2004,
        'year-to': 2013,
      },
      {
        id: '2114',
        name: '2114',
        'cyrillic-name': '2114',
        class: 'B',
        'year-from': 2001,
        'year-to': 2013,
      },
      {
        id: '2115',
        name: '2115',
        'cyrillic-name': '2115',
        class: 'B',
        'year-from': 1997,
        'year-to': 2012,
      },
      {
        id: '2120',
        name: '2120 Надежда',
        'cyrillic-name': '2120 Надежда',
        class: 'M',
        'year-from': 1998,
        'year-to': 2006,
      },
      {
        id: '2121',
        name: '2121 (4x4)',
        'cyrillic-name': '2121 (4кс4)',
        class: 'J',
        'year-from': 1977,
        'year-to': 2021,
      },
      {
        id: '2123',
        name: '2123',
        'cyrillic-name': '2123',
        class: 'J',
        'year-from': 1998,
        'year-to': 2002,
      },
      {
        id: '2129',
        name: '2129',
        'cyrillic-name': '2129',
        class: 'J',
        'year-from': 1992,
        'year-to': 1996,
      },
      {
        id: '2131_4X4',
        name: '2131 (4x4)',
        'cyrillic-name': '2131 (4кс4)',
        class: 'J',
        'year-from': 1993,
        'year-to': 2021,
      },
      {
        id: '2328',
        name: '2328',
        'cyrillic-name': '2328',
        class: 'J',
        'year-from': 1995,
        'year-to': 1997,
      },
      {
        id: '2329',
        name: '2329',
        'cyrillic-name': '2329',
        class: 'J',
        'year-from': 1995,
        'year-to': 2019,
      },
      {
        id: 'ELLADA',
        name: 'EL Lada',
        'cyrillic-name': 'Эллада',
        class: 'B',
        'year-from': 2012,
        'year-to': 2013,
      },
      {
        id: 'GRANTA',
        name: 'Granta',
        'cyrillic-name': 'Гранта',
        class: 'B',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'KALINA',
        name: 'Kalina',
        'cyrillic-name': 'Калина',
        class: 'B',
        'year-from': 2004,
        'year-to': 2018,
      },
      {
        id: 'LARGUS',
        name: 'Largus',
        'cyrillic-name': 'Ларгус',
        class: 'C',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'NIVA',
        name: 'Niva',
        'cyrillic-name': 'Нива',
        class: 'J',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'NIVA_LEGEND',
        name: 'Niva Legend',
        'cyrillic-name': 'Нива Легенд',
        class: 'J',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: '2170',
        name: 'Priora',
        'cyrillic-name': 'Приора',
        class: 'B',
        'year-from': 2007,
        'year-to': 2018,
      },
      {
        id: 'REVOLUTION',
        name: 'Revolution',
        'cyrillic-name': 'Революшин',
        class: 'S',
        'year-from': 2003,
        'year-to': 2006,
      },
      {
        id: 'VESTA',
        name: 'Vesta',
        'cyrillic-name': 'Веста',
        class: 'B',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'XRAY',
        name: 'XRAY',
        'cyrillic-name': 'Икс-рэй',
        class: 'B',
        'year-from': 2015,
        'year-to': null,
      },
    ],
  },
  {
    id: 'VECTOR',
    name: 'Vector',
    'cyrillic-name': 'Вектор',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'M12',
        name: 'M12',
        'cyrillic-name': 'м12',
        class: 'S',
        'year-from': 1996,
        'year-to': 2000,
      },
      {
        id: 'W8',
        name: 'W8 Twin Turbo',
        'cyrillic-name': 'дабл ю 8 твин турбо',
        class: 'S',
        'year-from': 1989,
        'year-to': 1994,
      },
    ],
  },
  {
    id: 'VENTURI',
    name: 'Venturi',
    'cyrillic-name': 'Вентури',
    popular: false,
    country: 'Франция',
    models: [
      {
        id: '210',
        name: '210',
        'cyrillic-name': '210',
        class: 'S',
        'year-from': 1984,
        'year-to': 1995,
      },
      {
        id: '260_LM',
        name: '260 LM',
        'cyrillic-name': '260 лм',
        class: 'S',
        'year-from': 1989,
        'year-to': 1995,
      },
      {
        id: '300_ATLANTIQUE',
        name: '300 Atlantique',
        'cyrillic-name': '300 атлантик',
        class: 'S',
        'year-from': 1994,
        'year-to': 2000,
      },
      {
        id: '400_GT',
        name: '400 GT',
        'cyrillic-name': '400 гт',
        class: 'S',
        'year-from': 1994,
        'year-to': 1998,
      },
    ],
  },
  {
    id: 'VOLKSWAGEN',
    name: 'Volkswagen',
    'cyrillic-name': 'Фольксваген',
    popular: true,
    country: 'Германия',
    models: [
      {
        id: '181',
        name: '181',
        'cyrillic-name': '181',
        class: 'C',
        'year-from': 1969,
        'year-to': 1979,
      },
      {
        id: 'AMAROK',
        name: 'Amarok',
        'cyrillic-name': 'Амарок',
        class: 'J',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'ARTEON',
        name: 'Arteon',
        'cyrillic-name': 'Артеон',
        class: 'D',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'ARTEON_R',
        name: 'Arteon R',
        'cyrillic-name': 'Артеон Р',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'ATLAS',
        name: 'Atlas',
        'cyrillic-name': 'Атлас',
        class: 'E',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'ATLAS_CROSS_SPORT',
        name: 'Atlas Cross Sport',
        'cyrillic-name': 'Атлас Кросс Спорт',
        class: 'E',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'BEETLE',
        name: 'Beetle',
        'cyrillic-name': 'Битл',
        class: 'C',
        'year-from': 1997,
        'year-to': 2019,
      },
      {
        id: 'BORA',
        name: 'Bora',
        'cyrillic-name': 'Бора',
        class: 'C',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'CADDY',
        name: 'Caddy',
        'cyrillic-name': 'Кадди',
        class: 'M',
        'year-from': 1979,
        'year-to': null,
      },
      {
        id: 'CALIFORNIA',
        name: 'California',
        'cyrillic-name': 'Калифорния',
        class: 'M',
        'year-from': 1991,
        'year-to': null,
      },
      {
        id: 'CARAVELLE',
        name: 'Caravelle',
        'cyrillic-name': 'Каравелла',
        class: 'M',
        'year-from': 1980,
        'year-to': null,
      },
      {
        id: 'CORRADO',
        name: 'Corrado',
        'cyrillic-name': 'Коррадо',
        class: 'S',
        'year-from': 1988,
        'year-to': 1995,
      },
      {
        id: 'DERBY',
        name: 'Derby',
        'cyrillic-name': 'Дерби',
        class: 'B',
        'year-from': 1977,
        'year-to': 1984,
      },
      {
        id: 'EOS',
        name: 'Eos',
        'cyrillic-name': 'Эос',
        class: 'C',
        'year-from': 2006,
        'year-to': 2015,
      },
      {
        id: 'EUROVAN',
        name: 'EuroVan',
        'cyrillic-name': 'Евровэн',
        class: 'M',
        'year-from': 1992,
        'year-to': 2003,
      },
      {
        id: 'FOX',
        name: 'Fox',
        'cyrillic-name': 'Фокс',
        class: 'A',
        'year-from': 2003,
        'year-to': 2011,
      },
      {
        id: 'GOL',
        name: 'Gol',
        'cyrillic-name': 'гол',
        class: 'B',
        'year-from': 1980,
        'year-to': 2013,
      },
      {
        id: 'GOLF',
        name: 'Golf',
        'cyrillic-name': 'Гольф',
        class: 'C',
        'year-from': 1974,
        'year-to': null,
      },
      {
        id: 'GOLF_COUNTRY',
        name: 'Golf Country',
        'cyrillic-name': 'Гольф Кантри',
        class: 'C',
        'year-from': 1990,
        'year-to': 1991,
      },
      {
        id: 'GOLF_GTI',
        name: 'Golf GTI',
        'cyrillic-name': 'голф гти',
        class: 'C',
        'year-from': 1976,
        'year-to': null,
      },
      {
        id: 'GOLF_PLUS',
        name: 'Golf Plus',
        'cyrillic-name': 'Гольф Плюс',
        class: 'M',
        'year-from': 2005,
        'year-to': 2014,
      },
      {
        id: 'GOLF_R',
        name: 'Golf R',
        'cyrillic-name': 'Гольф Р',
        class: 'C',
        'year-from': 2009,
        'year-to': null,
      },
      {
        id: 'GOLF_R32',
        name: 'Golf R32',
        'cyrillic-name': 'Гольф Р32',
        class: 'C',
        'year-from': 2002,
        'year-to': 2008,
      },
      {
        id: 'GOLF_SPORTSVAN',
        name: 'Golf Sportsvan',
        'cyrillic-name': 'Гольф Спортсвэн',
        class: 'M',
        'year-from': 2014,
        'year-to': 2020,
      },
      {
        id: 'ID3',
        name: 'ID.3',
        'cyrillic-name': 'ид3',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'ID4',
        name: 'ID.4',
        'cyrillic-name': 'ид4',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'ID5',
        name: 'ID.5',
        'cyrillic-name': 'Ид5',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'ID6',
        name: 'ID.6',
        'cyrillic-name': 'Ид6',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'IDBUZZ',
        name: 'ID.Buzz',
        'cyrillic-name': 'идбузз',
        class: 'M',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'ILTIS',
        name: 'Iltis',
        'cyrillic-name': 'Илтис',
        class: 'J',
        'year-from': 1978,
        'year-to': 1988,
      },
      {
        id: 'JETTA',
        name: 'Jetta',
        'cyrillic-name': 'Джетта',
        class: 'C',
        'year-from': 1978,
        'year-to': null,
      },
      {
        id: 'K70',
        name: 'K70',
        'cyrillic-name': 'к70',
        class: 'C',
        'year-from': 1970,
        'year-to': 1974,
      },
      {
        id: 'KARMANN_GHIA',
        name: 'Karmann-Ghia',
        'cyrillic-name': 'карманн-гиа',
        class: 'S',
        'year-from': 1955,
        'year-to': 1974,
      },
      {
        id: 'LAMANDO',
        name: 'Lamando',
        'cyrillic-name': 'Ламандо',
        class: 'C',
        'year-from': 2014,
        'year-to': null,
      },
      {
        id: 'LAVIDA',
        name: 'Lavida',
        'cyrillic-name': 'Лавида',
        class: 'C',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'LUPO',
        name: 'Lupo',
        'cyrillic-name': 'Лупо',
        class: 'A',
        'year-from': 1998,
        'year-to': 2005,
      },
      {
        id: 'LUPO_GTI',
        name: 'Lupo GTI',
        'cyrillic-name': 'лупо гти',
        class: 'A',
        'year-from': 2000,
        'year-to': 2005,
      },
      {
        id: 'MAGOTAN',
        name: 'Magotan',
        'cyrillic-name': 'Маготан',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'MULTIVAN',
        name: 'Multivan',
        'cyrillic-name': 'Мультивэн',
        class: 'M',
        'year-from': 1984,
        'year-to': null,
      },
      {
        id: 'PARATI',
        name: 'Parati',
        'cyrillic-name': 'парати',
        class: 'C',
        'year-from': 2005,
        'year-to': 2012,
      },
      {
        id: 'PASSAT',
        name: 'Passat',
        'cyrillic-name': 'Пассат',
        class: 'D',
        'year-from': 1973,
        'year-to': null,
      },
      {
        id: 'PASSAT_NA',
        name: 'Passat (North America and China)',
        'cyrillic-name': 'пассат (северная америка и китай)',
        class: 'D',
        'year-from': 2011,
        'year-to': null,
      },
      {
        id: 'PASSAT_CC',
        name: 'Passat CC',
        'cyrillic-name': 'Пассат СС',
        class: 'E',
        'year-from': 2008,
        'year-to': 2017,
      },
      {
        id: 'PHAETON',
        name: 'Phaeton',
        'cyrillic-name': 'Фаетон',
        class: 'F',
        'year-from': 2002,
        'year-to': 2016,
      },
      {
        id: 'PHIDEON',
        name: 'Phideon',
        'cyrillic-name': 'Фидеон',
        class: 'E',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'POINTER',
        name: 'Pointer',
        'cyrillic-name': 'Поинтер',
        class: 'B',
        'year-from': 2003,
        'year-to': 2006,
      },
      {
        id: 'POLO',
        name: 'Polo',
        'cyrillic-name': 'Поло',
        class: 'B',
        'year-from': 1975,
        'year-to': null,
      },
      {
        id: 'POLO_GTI',
        name: 'Polo GTI',
        'cyrillic-name': 'поло гти',
        class: 'B',
        'year-from': 1998,
        'year-to': null,
      },
      {
        id: 'POLO_R_WRC',
        name: 'Polo R WRC',
        'cyrillic-name': 'поло р врц',
        class: 'S',
        'year-from': 2013,
        'year-to': 2016,
      },
      {
        id: 'QUANTUM',
        name: 'Quantum',
        'cyrillic-name': 'квантум',
        class: 'D',
        'year-from': 1985,
        'year-to': 2003,
      },
      {
        id: 'ROUTAN',
        name: 'Routan',
        'cyrillic-name': 'Рутан',
        class: 'M',
        'year-from': 2008,
        'year-to': 2012,
      },
      {
        id: 'SAGITAR',
        name: 'Sagitar',
        'cyrillic-name': 'Сагитар',
        class: 'C',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'SANTANA',
        name: 'Santana',
        'cyrillic-name': 'Сантана',
        class: 'D',
        'year-from': 1981,
        'year-to': 1988,
      },
      {
        id: 'SCIROCCO',
        name: 'Scirocco',
        'cyrillic-name': 'Сирокко',
        class: 'C',
        'year-from': 1974,
        'year-to': 2017,
      },
      {
        id: 'SCIROCCO_R',
        name: 'Scirocco R',
        'cyrillic-name': 'Сирокко Р',
        class: 'C',
        'year-from': 2009,
        'year-to': 2017,
      },
      {
        id: 'SHARAN',
        name: 'Sharan',
        'cyrillic-name': 'Шаран',
        class: 'M',
        'year-from': 1995,
        'year-to': null,
      },
      {
        id: 'SPACEFOX',
        name: 'SpaceFox',
        'cyrillic-name': 'спейсфокс',
        class: 'C',
        'year-from': 2006,
        'year-to': null,
      },
      {
        id: 'T_CROSS',
        name: 'T-Cross',
        'cyrillic-name': 'Т-Кросс',
        class: 'B',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'T_ROC',
        name: 'T-Roc',
        'cyrillic-name': 'т-рок',
        class: 'B',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'T_ROC_R',
        name: 'T-Roc R',
        'cyrillic-name': 'Т-Рок Р',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'TACQUA',
        name: 'Tacqua',
        'cyrillic-name': 'Таква',
        class: 'B',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'TAIGO',
        name: 'Taigo',
        'cyrillic-name': 'Тайго',
        class: 'B',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'TALAGON',
        name: 'Talagon',
        'cyrillic-name': 'Талагон',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'TAOS',
        name: 'Taos',
        'cyrillic-name': 'Таос',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'TARO',
        name: 'Taro',
        'cyrillic-name': 'Таро',
        class: 'J',
        'year-from': 1989,
        'year-to': 1997,
      },
      {
        id: 'TAVENDOR',
        name: 'Tavendor',
        'cyrillic-name': 'Тавендор',
        class: 'E',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'TAYRON',
        name: 'Tayron',
        'cyrillic-name': 'Тайрон',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'TERAMONT',
        name: 'Teramont',
        'cyrillic-name': 'Терамонт',
        class: 'E',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'THARU',
        name: 'Tharu',
        'cyrillic-name': 'Тару',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'TIGUAN',
        name: 'Tiguan',
        'cyrillic-name': 'Тигуан',
        class: 'C',
        'year-from': 2007,
        'year-to': null,
      },
      {
        id: 'TIGUAN_R',
        name: 'Tiguan R',
        'cyrillic-name': 'Тигуан Р',
        class: 'C',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'TOUAREG',
        name: 'Touareg',
        'cyrillic-name': 'Туарег',
        class: 'E',
        'year-from': 2002,
        'year-to': null,
      },
      {
        id: 'TOURAN',
        name: 'Touran',
        'cyrillic-name': 'Туран',
        class: 'M',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'TRANSPORTER',
        name: 'Transporter',
        'cyrillic-name': 'Транспортер',
        class: 'M',
        'year-from': 1979,
        'year-to': null,
      },
      {
        id: 'TYPE_1',
        name: 'Type 1',
        'cyrillic-name': 'тайп 1',
        class: 'C',
        'year-from': 1938,
        'year-to': 2003,
      },
      {
        id: 'TYPE_166',
        name: 'Type 166',
        'cyrillic-name': 'Тайп 166',
        class: '',
        'year-from': 1942,
        'year-to': 1944,
      },
      {
        id: 'TYPE_2',
        name: 'Type 2',
        'cyrillic-name': 'тайп 2',
        class: 'M',
        'year-from': 1950,
        'year-to': 1979,
      },
      {
        id: 'TYPE_3',
        name: 'Type 3',
        'cyrillic-name': 'тайп 3',
        class: 'C',
        'year-from': 1961,
        'year-to': 1973,
      },
      {
        id: 'TYPE_4',
        name: 'Type 4',
        'cyrillic-name': 'тайп 4',
        class: 'D',
        'year-from': 1968,
        'year-to': 1975,
      },
      {
        id: 'TYPE_82',
        name: 'Type 82',
        'cyrillic-name': 'Тайп 82',
        class: 'J',
        'year-from': 1940,
        'year-to': 1945,
      },
      {
        id: 'UP',
        name: 'up!',
        'cyrillic-name': 'Ап',
        class: 'A',
        'year-from': 2012,
        'year-to': null,
      },
      {
        id: 'VENTO',
        name: 'Vento',
        'cyrillic-name': 'Венто',
        class: 'C',
        'year-from': 1991,
        'year-to': 1998,
      },
      {
        id: 'VILORAN',
        name: 'Viloran',
        'cyrillic-name': 'Вилоран',
        class: 'M',
        'year-from': 2020,
        'year-to': null,
      },
      {
        id: 'XL1',
        name: 'XL1',
        'cyrillic-name': 'хл1',
        class: 'C',
        'year-from': 2013,
        'year-to': 2015,
      },
    ],
  },
  {
    id: 'VOLVO',
    name: 'Volvo',
    'cyrillic-name': 'Вольво',
    popular: true,
    country: 'Швеция',
    models: [
      {
        id: '120_SERIES',
        name: '120 Series',
        'cyrillic-name': '120 Серия',
        class: 'C',
        'year-from': 1956,
        'year-to': 1970,
      },
      {
        id: '140',
        name: '140 Series',
        'cyrillic-name': '140 Серия',
        class: 'D',
        'year-from': 1966,
        'year-to': 1975,
      },
      {
        id: '164',
        name: '164',
        'cyrillic-name': '164',
        class: 'D',
        'year-from': 1968,
        'year-to': 1974,
      },
      {
        id: '240_SERIES',
        name: '240 Series',
        'cyrillic-name': '240 Серия',
        class: 'E',
        'year-from': 1974,
        'year-to': 1993,
      },
      {
        id: '260',
        name: '260 Series',
        'cyrillic-name': '260 Серия',
        class: 'E',
        'year-from': 1974,
        'year-to': 1982,
      },
      {
        id: '300_SERIES',
        name: '300 Series',
        'cyrillic-name': '300 Серия',
        class: 'C',
        'year-from': 1975,
        'year-to': 1991,
      },
      {
        id: '440',
        name: '440',
        'cyrillic-name': '440',
        class: 'C',
        'year-from': 1988,
        'year-to': 1997,
      },
      {
        id: '460',
        name: '460',
        'cyrillic-name': '460',
        class: 'C',
        'year-from': 1988,
        'year-to': 1997,
      },
      {
        id: '480',
        name: '480',
        'cyrillic-name': '480',
        class: 'C',
        'year-from': 1986,
        'year-to': 1996,
      },
      {
        id: '66',
        name: '66',
        'cyrillic-name': '66',
        class: 'C',
        'year-from': 1975,
        'year-to': 1979,
      },
      {
        id: '740',
        name: '740',
        'cyrillic-name': '740',
        class: 'E',
        'year-from': 1983,
        'year-to': 1992,
      },
      {
        id: '760',
        name: '760',
        'cyrillic-name': '760',
        class: 'E',
        'year-from': 1982,
        'year-to': 1992,
      },
      {
        id: '780',
        name: '780',
        'cyrillic-name': '780',
        class: 'E',
        'year-from': 1986,
        'year-to': 1991,
      },
      {
        id: '850',
        name: '850',
        'cyrillic-name': '850',
        class: 'D',
        'year-from': 1991,
        'year-to': 1997,
      },
      {
        id: '940',
        name: '940',
        'cyrillic-name': '940',
        class: 'E',
        'year-from': 1988,
        'year-to': 1998,
      },
      {
        id: '960',
        name: '960',
        'cyrillic-name': '960',
        class: 'E',
        'year-from': 1990,
        'year-to': 1997,
      },
      {
        id: 'C30',
        name: 'C30',
        'cyrillic-name': 'ц30',
        class: 'C',
        'year-from': 2006,
        'year-to': 2013,
      },
      {
        id: 'C40',
        name: 'C40',
        'cyrillic-name': 'Си40',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'C70',
        name: 'C70',
        'cyrillic-name': 'ц70',
        class: 'D',
        'year-from': 1997,
        'year-to': 2013,
      },
      {
        id: 'EX90',
        name: 'EX90',
        'cyrillic-name': 'ЕХ90',
        class: 'J',
        'year-from': 2023,
        'year-to': null,
      },
      {
        id: 'LAPLANDER',
        name: 'Laplander',
        'cyrillic-name': 'Лаплендер',
        class: 'J',
        'year-from': 1974,
        'year-to': 1987,
      },
      {
        id: 'P1800',
        name: 'P1800',
        'cyrillic-name': 'Р1800',
        class: 'S',
        'year-from': 1961,
        'year-to': 1973,
      },
      {
        id: 'P1900',
        name: 'P1900',
        'cyrillic-name': 'п1900',
        class: 'S',
        'year-from': 1956,
        'year-to': 1957,
      },
      {
        id: 'PV444',
        name: 'PV444',
        'cyrillic-name': 'ПВ444',
        class: 'D',
        'year-from': 1947,
        'year-to': 1958,
      },
      {
        id: 'PV544',
        name: 'PV544',
        'cyrillic-name': 'ПВ544',
        class: 'D',
        'year-from': 1958,
        'year-to': 1965,
      },
      {
        id: 'S40',
        name: 'S40',
        'cyrillic-name': 'с40',
        class: 'C',
        'year-from': 1995,
        'year-to': 2012,
      },
      {
        id: 'S60',
        name: 'S60',
        'cyrillic-name': 'с60',
        class: 'D',
        'year-from': 2000,
        'year-to': null,
      },
      {
        id: 'S60_CROSS_COUNTRY',
        name: 'S60 Cross Country',
        'cyrillic-name': 'с60 цросс цоунтры',
        class: 'D',
        'year-from': 2015,
        'year-to': 2018,
      },
      {
        id: 'S70',
        name: 'S70',
        'cyrillic-name': 'с70',
        class: 'E',
        'year-from': 1997,
        'year-to': 2000,
      },
      {
        id: 'S80',
        name: 'S80',
        'cyrillic-name': 'с80',
        class: 'E',
        'year-from': 1998,
        'year-to': 2016,
      },
      {
        id: 'S90',
        name: 'S90',
        'cyrillic-name': 'с90',
        class: 'E',
        'year-from': 1996,
        'year-to': null,
      },
      {
        id: 'V40',
        name: 'V40',
        'cyrillic-name': 'в40',
        class: 'C',
        'year-from': 1995,
        'year-to': 2019,
      },
      {
        id: 'V40_CC',
        name: 'V40 Cross Country',
        'cyrillic-name': 'в40 цросс цоунтры',
        class: 'C',
        'year-from': 2012,
        'year-to': 2019,
      },
      {
        id: 'V50',
        name: 'V50',
        'cyrillic-name': 'в50',
        class: 'D',
        'year-from': 2004,
        'year-to': 2012,
      },
      {
        id: 'V60',
        name: 'V60',
        'cyrillic-name': 'в60',
        class: 'D',
        'year-from': 2010,
        'year-to': null,
      },
      {
        id: 'V60_CROSS_COUNTRY',
        name: 'V60 Cross Country',
        'cyrillic-name': 'В60 Кросс Кантри',
        class: 'D',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'V70',
        name: 'V70',
        'cyrillic-name': 'в70',
        class: 'E',
        'year-from': 1997,
        'year-to': 2016,
      },
      {
        id: 'V90',
        name: 'V90',
        'cyrillic-name': 'в90',
        class: 'E',
        'year-from': 1997,
        'year-to': null,
      },
      {
        id: 'V90_CROSS_COUNTRY',
        name: 'V90 Cross Country',
        'cyrillic-name': 'В90 Кросс Кантри',
        class: 'E',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'XC40',
        name: 'XC40',
        'cyrillic-name': 'ксц40',
        class: 'C',
        'year-from': 2017,
        'year-to': null,
      },
      {
        id: 'XC60',
        name: 'XC60',
        'cyrillic-name': 'ксц60',
        class: 'D',
        'year-from': 2008,
        'year-to': null,
      },
      {
        id: 'XC70',
        name: 'XC70',
        'cyrillic-name': 'ксц70',
        class: 'D',
        'year-from': 2000,
        'year-to': 2016,
      },
      {
        id: 'XC90',
        name: 'XC90',
        'cyrillic-name': 'ксц90',
        class: 'E',
        'year-from': 2002,
        'year-to': null,
      },
    ],
  },
  {
    id: 'VORTEX',
    name: 'Vortex',
    'cyrillic-name': 'Вортекс',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: 'CORDA',
        name: 'Corda',
        'cyrillic-name': 'корда',
        class: 'C',
        'year-from': 2010,
        'year-to': 2012,
      },
      {
        id: 'ESTINA',
        name: 'Estina',
        'cyrillic-name': 'эстина',
        class: 'C',
        'year-from': 2008,
        'year-to': 2013,
      },
      {
        id: 'TINGO',
        name: 'Tingo',
        'cyrillic-name': 'Тинго',
        class: 'C',
        'year-from': 2010,
        'year-to': 2014,
      },
    ],
  },
  {
    id: 'VOYAH',
    name: 'Voyah',
    'cyrillic-name': 'Воя',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'DREAM',
        name: 'Dream',
        'cyrillic-name': 'Дрим',
        class: 'M',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'FREE',
        name: 'Free',
        'cyrillic-name': 'Фри',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'VUHL',
    name: 'VUHL',
    'cyrillic-name': 'Вухл',
    popular: false,
    country: 'Мексика',
    models: [
      {
        id: '05',
        name: '05',
        'cyrillic-name': '05',
        class: 'S',
        'year-from': 2013,
        'year-to': null,
      },
    ],
  },
  {
    id: 'WANDERER',
    name: 'Wanderer',
    'cyrillic-name': 'Вандерер',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'W23',
        name: 'W23',
        'cyrillic-name': 'в23',
        class: 'F',
        'year-from': 1936,
        'year-to': 1941,
      },
      {
        id: 'W50',
        name: 'W50',
        'cyrillic-name': 'в50',
        class: 'F',
        'year-from': 1936,
        'year-to': 1938,
      },
    ],
  },
  {
    id: 'WARTBURG',
    name: 'Wartburg',
    'cyrillic-name': 'Вартбург',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: '1_3',
        name: '1.3',
        'cyrillic-name': '1.3',
        class: 'C',
        'year-from': 1988,
        'year-to': 1991,
      },
      {
        id: '353',
        name: '353',
        'cyrillic-name': '353',
        class: 'C',
        'year-from': 1966,
        'year-to': 1989,
      },
    ],
  },
  {
    id: 'WELTMEISTER',
    name: 'Weltmeister',
    'cyrillic-name': 'велтмейстер',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'E5',
        name: 'E5',
        'cyrillic-name': 'е5',
        class: 'C',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'EX5',
        name: 'EX5',
        'cyrillic-name': 'Экс 5',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'EX6_PLUS',
        name: 'EX6 Plus',
        'cyrillic-name': 'ЕХ6 Плюс',
        class: 'D',
        'year-from': 2019,
        'year-to': null,
      },
      {
        id: 'W6',
        name: 'W6',
        'cyrillic-name': 'В6',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'WESTFIELD',
    name: 'Westfield',
    'cyrillic-name': 'Вестфилд',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'SEI_SPORT',
        name: 'SEi & Sport',
        'cyrillic-name': 'сей и спорт',
        class: 'S',
        'year-from': 1982,
        'year-to': null,
      },
      {
        id: 'SEIGHT',
        name: 'SEiGHT',
        'cyrillic-name': 'сейгт',
        class: 'S',
        'year-from': 1991,
        'year-to': 2010,
      },
    ],
  },
  {
    id: 'WEY',
    name: 'WEY',
    'cyrillic-name': 'Вей',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'COFFEE_01',
        name: 'Coffee 01',
        'cyrillic-name': 'Кофе 01',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'COFFEE_02',
        name: 'Coffee 02',
        'cyrillic-name': 'Кофе 02',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
    ],
  },
  {
    id: 'WIESMANN',
    name: 'Wiesmann',
    'cyrillic-name': 'Вайсман',
    popular: false,
    country: 'Германия',
    models: [
      {
        id: 'GT',
        name: 'GT',
        'cyrillic-name': 'гт',
        class: 'S',
        'year-from': 2003,
        'year-to': 2013,
      },
      {
        id: 'ROADSTER',
        name: 'Roadster',
        'cyrillic-name': 'Родстер',
        class: 'S',
        'year-from': 1996,
        'year-to': 2013,
      },
    ],
  },
  {
    id: 'WILLIS',
    name: 'Willys',
    'cyrillic-name': 'Виллис',
    popular: false,
    country: 'США',
    models: [
      {
        id: 'CJ',
        name: 'CJ',
        'cyrillic-name': 'СЖ',
        class: 'J',
        'year-from': 1944,
        'year-to': 1968,
      },
      {
        id: 'JEEPSTER',
        name: 'Jeepster',
        'cyrillic-name': 'Джипстер',
        class: '',
        'year-from': 1948,
        'year-to': 1951,
      },
      {
        id: 'MODEL_20',
        name: 'Knight Model 20',
        'cyrillic-name': 'кнайт модель 20',
        class: 'F',
        'year-from': 1920,
        'year-to': 1923,
      },
      {
        id: 'MB',
        name: 'MB',
        'cyrillic-name': 'МБ',
        class: 'J',
        'year-from': 1941,
        'year-to': 1945,
      },
    ],
  },
  {
    id: 'W_MOTORS',
    name: 'W Motors',
    'cyrillic-name': 'дабл-ю моторс',
    popular: false,
    country: 'Объединённые Арабские Эмираты',
    models: [
      {
        id: 'FENYR_SUPERSPORT',
        name: 'Fenyr Supersport',
        'cyrillic-name': 'Фенир Суперспорт',
        class: 'S',
        'year-from': 2015,
        'year-to': null,
      },
      {
        id: 'LYKAN_HYPERSPORT',
        name: 'Lykan Hypersport',
        'cyrillic-name': 'Ликан Гиперспорт',
        class: 'S',
        'year-from': 2013,
        'year-to': 2017,
      },
    ],
  },
  {
    id: 'XINKAI',
    name: 'Xin Kai',
    'cyrillic-name': 'Ксин Кай',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'PICKUP_X3',
        name: 'Pickup X3',
        'cyrillic-name': 'Пикап Икс-3',
        class: 'J',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'SR_V_X3',
        name: 'SR-V X3',
        'cyrillic-name': 'СР-В Икс-3',
        class: 'J',
        'year-from': 2003,
        'year-to': null,
      },
      {
        id: 'SUV_X3',
        name: 'SUV X3',
        'cyrillic-name': 'СУВ Икс-3',
        class: 'J',
        'year-from': 2003,
        'year-to': null,
      },
    ],
  },
  {
    id: 'XPENG',
    name: 'Xpeng',
    'cyrillic-name': 'кспенг',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'G3',
        name: 'G3',
        'cyrillic-name': 'Г3',
        class: 'C',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'G9',
        name: 'G9',
        'cyrillic-name': 'Г9',
        class: 'J',
        'year-from': 2022,
        'year-to': null,
      },
      {
        id: 'P5',
        name: 'P5',
        'cyrillic-name': 'П5',
        class: 'D',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: 'P7',
        name: 'P7',
        'cyrillic-name': 'П7',
        class: 'D',
        'year-from': 2020,
        'year-to': null,
      },
    ],
  },
  {
    id: 'YULON',
    name: 'Yulon',
    'cyrillic-name': 'Юлон',
    popular: false,
    country: 'Тайвань',
    models: [
      {
        id: 'FEELING',
        name: 'Feeling',
        'cyrillic-name': 'Филлинг',
        class: 'C',
        'year-from': 1986,
        'year-to': 1995,
      },
    ],
  },
  {
    id: 'ZASTAVA',
    name: 'Zastava',
    'cyrillic-name': 'Застава',
    popular: false,
    country: 'Сербия',
    models: [
      {
        id: '10',
        name: '10',
        'cyrillic-name': '10',
        class: 'B',
        'year-from': 2005,
        'year-to': 2008,
      },
      {
        id: 'FLORIDA',
        name: 'Florida',
        'cyrillic-name': 'Флорида',
        class: 'C',
        'year-from': 1990,
        'year-to': 2008,
      },
      {
        id: 'SKALA',
        name: 'Skala',
        'cyrillic-name': 'Скала',
        class: 'C',
        'year-from': 1973,
        'year-to': 2008,
      },
      {
        id: 'YUGO',
        name: 'Yugo',
        'cyrillic-name': 'Юго',
        class: 'B',
        'year-from': 1990,
        'year-to': 2008,
      },
    ],
  },
  {
    id: 'ZAZ',
    name: 'ЗАЗ',
    'cyrillic-name': 'ЗАЗ',
    popular: false,
    country: 'Украина',
    models: [
      {
        id: 'TAVRIA',
        name: '1102 «Таврия»',
        'cyrillic-name': '1102 Таврия',
        class: 'B',
        'year-from': 1988,
        'year-to': 2009,
      },
      {
        id: 'SLAVUTA',
        name: '1103 «Славута»',
        'cyrillic-name': '1103 Славута',
        class: 'B',
        'year-from': 1999,
        'year-to': 2011,
      },
      {
        id: 'DANA',
        name: '1105 «Дана»',
        'cyrillic-name': '1105 Дана',
        class: 'B',
        'year-from': 1994,
        'year-to': 2011,
      },
      {
        id: '965',
        name: '965',
        'cyrillic-name': '965',
        class: 'A',
        'year-from': 1960,
        'year-to': 1970,
      },
      {
        id: '966',
        name: '966',
        'cyrillic-name': '966',
        class: 'A',
        'year-from': 1967,
        'year-to': 1972,
      },
      {
        id: '968',
        name: '968',
        'cyrillic-name': '968',
        class: 'B',
        'year-from': 1972,
        'year-to': 1994,
      },
      {
        id: 'CHANCE',
        name: 'Chance',
        'cyrillic-name': 'шанс',
        class: 'C',
        'year-from': 2009,
        'year-to': 2014,
      },
      {
        id: 'FORZA',
        name: 'Forza',
        'cyrillic-name': 'форза',
        class: 'B',
        'year-from': 2011,
        'year-to': 2014,
      },
      {
        id: 'ZAZ_LANOS',
        name: 'Lanos',
        'cyrillic-name': 'ланос',
        class: 'B',
        'year-from': 2004,
        'year-to': 2015,
      },
      {
        id: 'SENS',
        name: 'Sens',
        'cyrillic-name': 'сенс',
        class: 'B',
        'year-from': 2004,
        'year-to': 2017,
      },
      {
        id: 'VIDA',
        name: 'Vida',
        'cyrillic-name': 'Вида',
        class: 'B',
        'year-from': 2012,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'ZEEKR',
    name: 'Zeekr',
    'cyrillic-name': 'Зикр',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: '001',
        name: '001',
        'cyrillic-name': '001',
        class: 'E',
        'year-from': 2021,
        'year-to': null,
      },
      {
        id: '009',
        name: '009',
        'cyrillic-name': '009',
        class: 'M',
        'year-from': 2022,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ZENOS',
    name: 'Zenos',
    'cyrillic-name': 'Зенос',
    popular: false,
    country: 'Великобритания',
    models: [
      {
        id: 'E10',
        name: 'E10',
        'cyrillic-name': 'Е10',
        class: 'S',
        'year-from': 2014,
        'year-to': 2016,
      },
    ],
  },
  {
    id: 'ZENVO',
    name: 'Zenvo',
    'cyrillic-name': 'Зенво',
    popular: false,
    country: 'Дания',
    models: [
      {
        id: 'ST1',
        name: 'ST1',
        'cyrillic-name': 'СТ1',
        class: 'S',
        'year-from': 2009,
        'year-to': 2010,
      },
      {
        id: 'TSR_S',
        name: 'TSR-S',
        'cyrillic-name': 'ТСР-С',
        class: 'S',
        'year-from': 2018,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ZIBAR',
    name: 'Zibar',
    'cyrillic-name': 'Зибар',
    popular: false,
    country: 'Израиль',
    models: [
      {
        id: 'MK2',
        name: 'MK2',
        'cyrillic-name': 'мк2',
        class: 'J',
        'year-from': 2010,
        'year-to': null,
      },
    ],
  },
  {
    id: 'ZIL',
    name: 'ЗИЛ',
    'cyrillic-name': 'ЗИЛ',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: '111',
        name: '111',
        'cyrillic-name': '111',
        class: 'F',
        'year-from': 1959,
        'year-to': 1967,
      },
      {
        id: '114',
        name: '114',
        'cyrillic-name': '114',
        class: 'F',
        'year-from': 1967,
        'year-to': 1978,
      },
      {
        id: '117',
        name: '117',
        'cyrillic-name': '117',
        class: 'F',
        'year-from': 1971,
        'year-to': 1978,
      },
      {
        id: '4104',
        name: '4104',
        'cyrillic-name': '4104',
        class: 'F',
        'year-from': 1978,
        'year-to': 2002,
      },
    ],
  },
  {
    id: 'ZIS',
    name: 'ЗиС',
    'cyrillic-name': 'ЗиС',
    popular: false,
    country: 'Россия',
    models: [
      {
        id: '101',
        name: '101',
        'cyrillic-name': '101',
        class: '',
        'year-from': 1936,
        'year-to': 1941,
      },
      {
        id: '110',
        name: '110',
        'cyrillic-name': '110',
        class: '',
        'year-from': 1945,
        'year-to': 1958,
      },
    ],
  },
  {
    id: 'ZOTYE',
    name: 'Zotye',
    'cyrillic-name': 'Зоти',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'COUPA',
        name: 'Coupa',
        'cyrillic-name': 'Купа',
        class: 'D',
        'year-from': 2018,
        'year-to': null,
      },
      {
        id: 'E200',
        name: 'E200',
        'cyrillic-name': 'Е200',
        class: 'A',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'NOMAD',
        name: 'Nomad (RX6400)',
        'cyrillic-name': 'Номад',
        class: 'B',
        'year-from': 2005,
        'year-to': 2016,
      },
      {
        id: 'SR9',
        name: 'SR9',
        'cyrillic-name': 'ср9',
        class: 'D',
        'year-from': 2016,
        'year-to': null,
      },
      {
        id: 'T600',
        name: 'T600',
        'cyrillic-name': 'т600',
        class: 'D',
        'year-from': 2013,
        'year-to': null,
      },
      {
        id: 'Z100',
        name: 'Z100',
        'cyrillic-name': 'з100',
        class: 'A',
        'year-from': 2013,
        'year-to': 2017,
      },
      {
        id: 'Z300',
        name: 'Z300',
        'cyrillic-name': 'з300',
        class: 'C',
        'year-from': 2012,
        'year-to': 2017,
      },
    ],
  },
  {
    id: 'ZX',
    name: 'ZX',
    'cyrillic-name': 'ЗХ',
    popular: false,
    country: 'Китай',
    models: [
      {
        id: 'ADMIRAL',
        name: 'Admiral',
        'cyrillic-name': 'Адмирал',
        class: 'J',
        'year-from': 2005,
        'year-to': 2009,
      },
      {
        id: 'GRAND_TIGER',
        name: 'Grand Tiger',
        'cyrillic-name': 'ГрандТайгер',
        class: 'J',
        'year-from': 2007,
        'year-to': 2013,
      },
      {
        id: 'LANDMARK',
        name: 'Landmark',
        'cyrillic-name': 'Лендмарк',
        class: 'J',
        'year-from': 2005,
        'year-to': 2011,
      },
    ],
  },
];
